(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './androidx-collection-collection.js', './compose-multiplatform-core-compose-ui-ui-unit.js', './compose-multiplatform-core-compose-ui-ui-graphics.js', './compose-multiplatform-core-compose-ui-ui-geometry.js', './compose-multiplatform-core-compose-ui-ui-util.js', './androidx-compose-runtime-runtime-saveable.js', './kotlinx-coroutines-core.js', './androidx-compose-runtime-runtime.js', './kotlinx-atomicfu.js', './skiko-kjs.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./androidx-collection-collection.js'), require('./compose-multiplatform-core-compose-ui-ui-unit.js'), require('./compose-multiplatform-core-compose-ui-ui-graphics.js'), require('./compose-multiplatform-core-compose-ui-ui-geometry.js'), require('./compose-multiplatform-core-compose-ui-ui-util.js'), require('./androidx-compose-runtime-runtime-saveable.js'), require('./kotlinx-coroutines-core.js'), require('./androidx-compose-runtime-runtime.js'), require('./kotlinx-atomicfu.js'), require('./skiko-kjs.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui-text'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'compose-multiplatform-core-compose-ui-ui-text'.");
    }
    if (typeof globalThis['androidx-collection-collection'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui-text'. Its dependency 'androidx-collection-collection' was not found. Please, check whether 'androidx-collection-collection' is loaded prior to 'compose-multiplatform-core-compose-ui-ui-text'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-unit'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui-text'. Its dependency 'compose-multiplatform-core-compose-ui-ui-unit' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-unit' is loaded prior to 'compose-multiplatform-core-compose-ui-ui-text'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-graphics'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui-text'. Its dependency 'compose-multiplatform-core-compose-ui-ui-graphics' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-graphics' is loaded prior to 'compose-multiplatform-core-compose-ui-ui-text'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-geometry'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui-text'. Its dependency 'compose-multiplatform-core-compose-ui-ui-geometry' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-geometry' is loaded prior to 'compose-multiplatform-core-compose-ui-ui-text'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-util'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui-text'. Its dependency 'compose-multiplatform-core-compose-ui-ui-util' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-util' is loaded prior to 'compose-multiplatform-core-compose-ui-ui-text'.");
    }
    if (typeof globalThis['androidx-compose-runtime-runtime-saveable'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui-text'. Its dependency 'androidx-compose-runtime-runtime-saveable' was not found. Please, check whether 'androidx-compose-runtime-runtime-saveable' is loaded prior to 'compose-multiplatform-core-compose-ui-ui-text'.");
    }
    if (typeof globalThis['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui-text'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'compose-multiplatform-core-compose-ui-ui-text'.");
    }
    if (typeof globalThis['androidx-compose-runtime-runtime'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui-text'. Its dependency 'androidx-compose-runtime-runtime' was not found. Please, check whether 'androidx-compose-runtime-runtime' is loaded prior to 'compose-multiplatform-core-compose-ui-ui-text'.");
    }
    if (typeof globalThis['kotlinx-atomicfu'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui-text'. Its dependency 'kotlinx-atomicfu' was not found. Please, check whether 'kotlinx-atomicfu' is loaded prior to 'compose-multiplatform-core-compose-ui-ui-text'.");
    }
    if (typeof globalThis['skiko-kjs'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui-text'. Its dependency 'skiko-kjs' was not found. Please, check whether 'skiko-kjs' is loaded prior to 'compose-multiplatform-core-compose-ui-ui-text'.");
    }
    globalThis['compose-multiplatform-core-compose-ui-ui-text'] = factory(typeof globalThis['compose-multiplatform-core-compose-ui-ui-text'] === 'undefined' ? {} : globalThis['compose-multiplatform-core-compose-ui-ui-text'], globalThis['kotlin-kotlin-stdlib'], globalThis['androidx-collection-collection'], globalThis['compose-multiplatform-core-compose-ui-ui-unit'], globalThis['compose-multiplatform-core-compose-ui-ui-graphics'], globalThis['compose-multiplatform-core-compose-ui-ui-geometry'], globalThis['compose-multiplatform-core-compose-ui-ui-util'], globalThis['androidx-compose-runtime-runtime-saveable'], globalThis['kotlinx-coroutines-core'], globalThis['androidx-compose-runtime-runtime'], globalThis['kotlinx-atomicfu'], globalThis['skiko-kjs']);
  }
}(function (_, kotlin_kotlin, kotlin_androidx_collection_collection, kotlin_org_jetbrains_compose_ui_ui_unit, kotlin_org_jetbrains_compose_ui_ui_graphics, kotlin_org_jetbrains_compose_ui_ui_geometry, kotlin_org_jetbrains_compose_ui_ui_util, kotlin_androidx_compose_runtime_runtime_saveable, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_androidx_compose_runtime_runtime, kotlin_org_jetbrains_kotlinx_atomicfu, kotlin_org_jetbrains_skiko_skiko) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var protoOf = kotlin_kotlin.$_$.eh;
  var objectCreate = kotlin_kotlin.$_$.dh;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var VOID = kotlin_kotlin.$_$.d;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var toString = kotlin_kotlin.$_$.hp;
  var hashCode = kotlin_kotlin.$_$.bg;
  var getStringHashCode = kotlin_kotlin.$_$.ag;
  var equals = kotlin_kotlin.$_$.sf;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.a4;
  var emptyList = kotlin_kotlin.$_$.c9;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.v4;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.z3;
  var addAll = kotlin_kotlin.$_$.o7;
  var FunctionAdapter = kotlin_kotlin.$_$.cf;
  var isInterface = kotlin_kotlin.$_$.rg;
  var Comparator = kotlin_kotlin.$_$.bn;
  var compareValues = kotlin_kotlin.$_$.ad;
  var ensureNotNull = kotlin_kotlin.$_$.lo;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var sortedWith = kotlin_kotlin.$_$.yb;
  var first = kotlin_kotlin.$_$.o9;
  var mutableIntListOf = kotlin_androidx_collection_collection.$_$.z;
  var charCodeAt = kotlin_kotlin.$_$.jf;
  var substring = kotlin_kotlin.$_$.pl;
  var KtList = kotlin_kotlin.$_$.e7;
  var CharSequence = kotlin_kotlin.$_$.xm;
  var coerceIn = kotlin_kotlin.$_$.ei;
  var ArrayDeque_init_$Create$ = kotlin_kotlin.$_$.x3;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.n5;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var charSequenceLength = kotlin_kotlin.$_$.lf;
  var _Constraints___get_minWidth__impl__hi9lfi = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.e2;
  var _Constraints___get_minHeight__impl__ev4bgx = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.d2;
  var _Constraints___get_maxWidth__impl__uuyqc = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.c2;
  var _Constraints___get_maxHeight__impl__dt3e8z = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.b2;
  var coerceAtLeast = kotlin_kotlin.$_$.wh;
  var _Constraints___get_hasBoundedHeight__impl__bsh4rw = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.w1;
  var Constraints = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.a;
  var get_lastIndex = kotlin_kotlin.$_$.fa;
  var plus = kotlin_kotlin.$_$.ib;
  var last = kotlin_kotlin.$_$.na;
  var Companion_getInstance = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.g4;
  var Companion_getInstance_0 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.a4;
  var Color = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.y;
  var BlendMode = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.q;
  var Path = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.k1;
  var _Offset___get_packedValue__impl__xh2k8q = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.y;
  var Long = kotlin_kotlin.$_$.kn;
  var bitwiseAnd = kotlin_kotlin.$_$.ge;
  var convertToInt = kotlin_kotlin.$_$.le;
  var FloatCompanionObject_instance = kotlin_kotlin.$_$.v2;
  var floatFromBits = kotlin_kotlin.$_$.uf;
  var shiftRight = kotlin_kotlin.$_$.ze;
  var toRawBits = kotlin_kotlin.$_$.fp;
  var fromInt = kotlin_kotlin.$_$.pe;
  var shiftLeft = kotlin_kotlin.$_$.xe;
  var bitwiseOr = kotlin_kotlin.$_$.he;
  var _Offset___init__impl__c168vi = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.r;
  var toString_0 = kotlin_kotlin.$_$.hh;
  var getNumberHashCode = kotlin_kotlin.$_$.xf;
  var fastJoinToString = kotlin_org_jetbrains_compose_ui_ui_util.$_$.c;
  var compareTo = kotlin_kotlin.$_$.nf;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var LazyThreadSafetyMode_NONE_getInstance = kotlin_kotlin.$_$.u3;
  var lazy = kotlin_kotlin.$_$.so;
  var KProperty1 = kotlin_kotlin.$_$.yi;
  var getPropertyCallableRef = kotlin_kotlin.$_$.zf;
  var numberToInt = kotlin_kotlin.$_$.ch;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var Companion_getInstance_1 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.h4;
  var _TextUnit___get_value__impl__hpbx0k = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.p3;
  var TextUnit = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.w;
  var TextUnit__hashCode_impl_qsmeov = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.i3;
  var StringBuilder_init_$Create$_0 = kotlin_kotlin.$_$.w4;
  var TextUnit__toString_impl_51ghw0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.n3;
  var _TextUnit___get_rawType__impl__tu8yq5 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.m3;
  var equalsLong = kotlin_kotlin.$_$.oe;
  var Enum = kotlin_kotlin.$_$.en;
  var Saver = kotlin_androidx_compose_runtime_runtime_saveable.$_$.e;
  var arrayListOf = kotlin_kotlin.$_$.r7;
  var UnsupportedOperationException_init_$Create$ = kotlin_kotlin.$_$.n6;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.uo;
  var Companion_getInstance_2 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.o4;
  var Shadow = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.n1;
  var Offset = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.c;
  var Companion_getInstance_3 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.l1;
  var _Color___get_value__impl__1pls5m = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.d3;
  var _ULong___init__impl__c78o9k = kotlin_kotlin.$_$.w1;
  var toArgb = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.p2;
  var Color_0 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.v;
  var _TextUnit___get_type__impl__uc2olt = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.o3;
  var TextUnitType = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.u;
  var Companion_getInstance_4 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.i4;
  var TextUnit_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.v;
  var Saver_0 = kotlin_androidx_compose_runtime_runtime_saveable.$_$.d;
  var Color__hashCode_impl_vjyivj = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.a3;
  var Color__toString_impl_hpzmaq = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.c3;
  var lerp = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.i2;
  var isNaN_0 = kotlin_kotlin.$_$.qo;
  var Fill_getInstance = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.b4;
  var lerp_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.g1;
  var lerp_1 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.h2;
  var Color__copy$default_impl_ectz3s = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.x3;
  var get_sp = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.q1;
  var _IntSize___get_packedValue__impl__uho7jf = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.f3;
  var IntSize = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.t;
  var IntSize__hashCode_impl_gm9mta = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.e3;
  var IntSize__toString_impl_54w9zl = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.g3;
  var getBooleanHashCode = kotlin_kotlin.$_$.vf;
  var Constraints__hashCode_impl_ij7484 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.a2;
  var Constraints__toString_impl_37yskr = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.f2;
  var _Constraints___get_hasBoundedWidth__impl__7hd0wr = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.x1;
  var Companion_instance = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.a4;
  var _IntSize___init__impl__emcjft = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.d3;
  var constrain = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.e1;
  var Constraints_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.b;
  var LruCache = kotlin_androidx_collection_collection.$_$.c;
  var _Size___init__impl__aywn0g = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.c1;
  var Rect = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.e;
  var asList = kotlin_kotlin.$_$.s7;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.y5;
  var Exception = kotlin_kotlin.$_$.gn;
  var IllegalStateException_init_$Create$_0 = kotlin_kotlin.$_$.w5;
  var CoroutineImpl = kotlin_kotlin.$_$.xd;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.gd;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.eg;
  var mutableScatterMapOf = kotlin_androidx_collection_collection.$_$.j1;
  var KMutableProperty1 = kotlin_kotlin.$_$.wi;
  var initMetadataForLambda = kotlin_kotlin.$_$.hg;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.y2;
  var get_indices = kotlin_kotlin.$_$.z9;
  var yield_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.d1;
  var get_isActive = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.n3;
  var withTimeoutOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.b1;
  var Key_instance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.f;
  var CancellationException = kotlin_kotlin.$_$.fd;
  var mutableStateOf = kotlin_androidx_compose_runtime_runtime.$_$.b2;
  var AbstractCoroutineContextElement = kotlin_kotlin.$_$.md;
  var Element = kotlin_kotlin.$_$.vd;
  var EmptyCoroutineContext_getInstance = kotlin_kotlin.$_$.q2;
  var Key_instance_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.j;
  var SupervisorJob = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.g3;
  var CoroutineScope_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.x2;
  var CoroutineStart_UNDISPATCHED_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.o;
  var launch = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q3;
  var to = kotlin_kotlin.$_$.ip;
  var mutableListOf = kotlin_kotlin.$_$.cb;
  var Companion_instance_0 = kotlin_kotlin.$_$.j3;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.z;
  var createFailure = kotlin_kotlin.$_$.ko;
  var _Result___get_value__impl__bjfvqg = kotlin_kotlin.$_$.d1;
  var _Result___get_isFailure__impl__jpiriv = kotlin_kotlin.$_$.b1;
  var toList = kotlin_kotlin.$_$.lc;
  var arrayConcat = kotlin_kotlin.$_$.a;
  var listOf = kotlin_kotlin.$_$.ta;
  var Comparable = kotlin_kotlin.$_$.an;
  var lerp_2 = kotlin_org_jetbrains_compose_ui_ui_util.$_$.e;
  var getKClassFromExpression = kotlin_kotlin.$_$.ri;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.q;
  var joinTo = kotlin_kotlin.$_$.ca;
  var RuntimeException_init_$Create$ = kotlin_kotlin.$_$.l6;
  var IndexOutOfBoundsException_init_$Create$ = kotlin_kotlin.$_$.a6;
  var IllegalArgumentException_init_$Create$_0 = kotlin_kotlin.$_$.p5;
  var charArray = kotlin_kotlin.$_$.if;
  var arrayCopy = kotlin_kotlin.$_$.q7;
  var toString_1 = kotlin_kotlin.$_$.y;
  var repeat = kotlin_kotlin.$_$.uk;
  var Char__hashCode_impl_otmys = kotlin_kotlin.$_$.s;
  var Collection = kotlin_kotlin.$_$.y6;
  var Dispatchers_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.h;
  var lerp_3 = kotlin_org_jetbrains_compose_ui_ui_util.$_$.d;
  var ShaderBrush = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.m1;
  var SolidColor = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.q1;
  var _Color___get_alpha__impl__wcfyv1 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.v2;
  var atomic$ref$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.d;
  var CharDirection_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.b;
  var until = kotlin_kotlin.$_$.mi;
  var subtract = kotlin_kotlin.$_$.af;
  var compare = kotlin_kotlin.$_$.je;
  var currentNanoTime = kotlin_org_jetbrains_skiko_skiko.$_$.h6;
  var HashMap_init_$Create$ = kotlin_kotlin.$_$.d4;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.j4;
  var Companion_getInstance_5 = kotlin_org_jetbrains_skiko_skiko.$_$.e;
  var charSequenceGet = kotlin_kotlin.$_$.kf;
  var Companion_getInstance_6 = kotlin_kotlin.$_$.h3;
  var isLowSurrogate = kotlin_kotlin.$_$.hk;
  var isHighSurrogate = kotlin_kotlin.$_$.fk;
  var Char__toInt_impl_vasixd = kotlin_kotlin.$_$.x;
  var sequence = kotlin_kotlin.$_$.hj;
  var Char__minus_impl_a2frrh = kotlin_kotlin.$_$.t;
  var SequenceScope = kotlin_kotlin.$_$.aj;
  var numberRangeToNumber = kotlin_kotlin.$_$.yg;
  var lazy_0 = kotlin_kotlin.$_$.to;
  var FontEdging_ALIAS_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.o3;
  var FontEdging_ANTI_ALIAS_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.p3;
  var FontEdging_SUBPIXEL_ANTI_ALIAS_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.q3;
  var FontHinting_NONE_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.s3;
  var FontHinting_SLIGHT_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.u3;
  var FontHinting_NORMAL_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.t3;
  var FontHinting_FULL_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.r3;
  var binarySearch = kotlin_kotlin.$_$.x7;
  var get_lastIndex_0 = kotlin_kotlin.$_$.ga;
  var coerceAtMost = kotlin_kotlin.$_$.bi;
  var RectHeightMode_STRUT_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.s1;
  var RectWidthMode_TIGHT_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.t1;
  var firstOrNull = kotlin_kotlin.$_$.n9;
  var first_0 = kotlin_kotlin.$_$.q9;
  var Rect_0 = kotlin_org_jetbrains_skiko_skiko.$_$.d6;
  var TextBox = kotlin_org_jetbrains_skiko_skiko.$_$.p5;
  var get_lastIndex_1 = kotlin_kotlin.$_$.kk;
  var lastOrNull = kotlin_kotlin.$_$.la;
  var toComposeRect = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.r2;
  var RectHeightMode_MAX_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.r1;
  var PathBuilder_init_$Create$ = kotlin_org_jetbrains_skiko_skiko.$_$.c5;
  var asComposePath = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.y1;
  var coerceAtMost_0 = kotlin_kotlin.$_$.yh;
  var Rect_1 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.f;
  var getOrNull = kotlin_kotlin.$_$.s9;
  var Direction_RTL_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.i1;
  var Direction_LTR_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.h1;
  var isWhitespace = kotlin_kotlin.$_$.jk;
  var get_skiaCanvas = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.m2;
  var LineMetrics = kotlin_org_jetbrains_skiko_skiko.$_$.k5;
  var UnsupportedOperationException_init_$Create$_0 = kotlin_kotlin.$_$.o6;
  var Companion_getInstance_7 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.n1;
  var TextStyle_init_$Create$ = kotlin_org_jetbrains_skiko_skiko.$_$.r4;
  var PaintMode_FILL_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.z3;
  var Paint_init_$Create$ = kotlin_org_jetbrains_skiko_skiko.$_$.a5;
  var Companion_getInstance_8 = kotlin_org_jetbrains_skiko_skiko.$_$.k;
  var copyToArray = kotlin_kotlin.$_$.x8;
  var Size__toString_impl_o87ni8 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.i1;
  var BlendMode__toString_impl_uuibkd = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.t2;
  var Size__hashCode_impl_2h1qpd = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.d1;
  var BlendMode__hashCode_impl_93ceri = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.s2;
  var Companion_getInstance_9 = kotlin_org_jetbrains_skiko_skiko.$_$.m;
  var DecorationLineStyle_SOLID_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.f1;
  var DecorationStyle = kotlin_org_jetbrains_skiko_skiko.$_$.j5;
  var Shadow_0 = kotlin_org_jetbrains_skiko_skiko.$_$.o5;
  var _TextUnit___get_isSp__impl__8c3r6q = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.k3;
  var _TextUnit___get_isEm__impl__esrmtl = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.j3;
  var DecorationLineStyle_WAVY_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.g1;
  var DecorationLineStyle_DASHED_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.c1;
  var DecorationLineStyle_DOTTED_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.d1;
  var DecorationLineStyle_DOUBLE_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.e1;
  var KProperty0 = kotlin_kotlin.$_$.xi;
  var throwUninitializedPropertyAccessException = kotlin_kotlin.$_$.ce;
  var sortWith = kotlin_kotlin.$_$.wb;
  var ParagraphStyle = kotlin_org_jetbrains_skiko_skiko.$_$.m5;
  var HeightMode_DISABLE_ALL_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.k1;
  var TextIndent = kotlin_org_jetbrains_skiko_skiko.$_$.q5;
  var Font_init_$Create$ = kotlin_org_jetbrains_skiko_skiko.$_$.x4;
  var ParagraphBuilder = kotlin_org_jetbrains_skiko_skiko.$_$.l5;
  var BaselineMode_ALPHABETIC_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.b1;
  var PlaceholderStyle = kotlin_org_jetbrains_skiko_skiko.$_$.n5;
  var checkArithmetic = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.a1;
  var pack = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.k1;
  var PlaceholderAlignment_MIDDLE_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.p1;
  var PlaceholderAlignment_BOTTOM_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.o1;
  var PlaceholderAlignment_TOP_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.q1;
  var PlaceholderAlignment_ABOVE_BASELINE_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.n1;
  var Alignment_START_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.a1;
  var Alignment_END_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.w;
  var Alignment_JUSTIFY_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.x;
  var Alignment_CENTER_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.v;
  var Alignment_RIGHT_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.z;
  var Alignment_LEFT_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.y;
  var HeightMode_ALL_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.j1;
  var HeightMode_DISABLE_LAST_DESCENT_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.m1;
  var HeightMode_DISABLE_FIRST_ASCENT_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.l1;
  var _Size___get_packedValue__impl__7rlt1o = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.g1;
  var listOf_0 = kotlin_kotlin.$_$.sa;
  var FontCollection_init_$Create$ = kotlin_org_jetbrains_skiko_skiko.$_$.q4;
  var TypefaceFontProviderWithFallback_init_$Create$ = kotlin_org_jetbrains_skiko_skiko.$_$.s4;
  var HashSet_init_$Create$ = kotlin_kotlin.$_$.g4;
  var FontMgrWithFallback = kotlin_org_jetbrains_skiko_skiko.$_$.w5;
  var FontVariation_init_$Create$ = kotlin_org_jetbrains_skiko_skiko.$_$.z4;
  var mapOf = kotlin_kotlin.$_$.wa;
  var Companion_getInstance_10 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.d4;
  var firstOrNull_0 = kotlin_kotlin.$_$.m9;
  var Paint = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.h1;
  var get_skiaPaint = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.o2;
  var Size = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.j;
  var derivedStateOf = kotlin_androidx_compose_runtime_runtime.$_$.p1;
  var coerceIn_0 = kotlin_kotlin.$_$.di;
  var Companion_getInstance_11 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.l4;
  var Stroke = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.c;
  var setOf = kotlin_kotlin.$_$.sb;
  var get_hostOs = kotlin_org_jetbrains_skiko_skiko.$_$.j6;
  var Companion_getInstance_12 = kotlin_org_jetbrains_skiko_skiko.$_$.l;
  var Companion_getInstance_13 = kotlin_org_jetbrains_skiko_skiko.$_$.j;
  var FontSlant_UPRIGHT_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.w3;
  var FontSlant_ITALIC_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.v3;
  var FontStyle_init_$Create$ = kotlin_org_jetbrains_skiko_skiko.$_$.y4;
  //endregion
  //region block: pre-declaration
  initMetadataForCompanion(Companion);
  initMetadataForClass(MutableRange, 'MutableRange');
  initMetadataForClass(BulletScope, 'BulletScope');
  initMetadataForClass(Range, 'Range');
  initMetadataForClass(Builder, 'Builder', Builder);
  initMetadataForCompanion(Companion_0);
  initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForClass(AnnotatedString, 'AnnotatedString', VOID, VOID, [CharSequence]);
  initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForObject(ComposeUiTextFlags, 'ComposeUiTextFlags');
  initMetadataForClass(LinkAnnotation, 'LinkAnnotation');
  initMetadataForClass(Url, 'Url', VOID, LinkAnnotation);
  initMetadataForClass(Clickable, 'Clickable', VOID, LinkAnnotation);
  initMetadataForClass(MultiParagraph, 'MultiParagraph');
  initMetadataForClass(ParagraphInfo, 'ParagraphInfo');
  function get_hasStaleResolvedFonts() {
    return false;
  }
  initMetadataForInterface(ParagraphIntrinsics, 'ParagraphIntrinsics');
  initMetadataForClass(MultiParagraphIntrinsics, 'MultiParagraphIntrinsics', VOID, VOID, [ParagraphIntrinsics]);
  initMetadataForClass(ParagraphIntrinsicInfo, 'ParagraphIntrinsicInfo');
  initMetadataForClass(ParagraphStyle_0, 'ParagraphStyle');
  initMetadataForClass(Placeholder, 'Placeholder');
  initMetadataForCompanion(Companion_1);
  initMetadataForClass(AnnotationType, 'AnnotationType', VOID, Enum);
  initMetadataForInterface(NonNullValueClassSaver, 'NonNullValueClassSaver', VOID, VOID, [Saver]);
  initMetadataForClass(NonNullValueClassSaver$1, VOID, VOID, VOID, [NonNullValueClassSaver]);
  initMetadataForClass(SpanStyle, 'SpanStyle');
  initMetadataForClass(StringAnnotation, 'StringAnnotation');
  initMetadataForClass(TextLayoutResult, 'TextLayoutResult');
  initMetadataForClass(TextLayoutInput, 'TextLayoutInput');
  initMetadataForClass(TextLinkStyles, 'TextLinkStyles', TextLinkStyles);
  initMetadataForCompanion(Companion_2);
  initMetadataForClass(TextMeasurer, 'TextMeasurer');
  initMetadataForClass(TextLayoutCache, 'TextLayoutCache', TextLayoutCache);
  initMetadataForClass(CacheTextLayoutInput, 'CacheTextLayoutInput');
  initMetadataForObject(TextPainter, 'TextPainter');
  initMetadataForCompanion(Companion_3);
  initMetadataForClass(TextRange, 'TextRange');
  initMetadataForCompanion(Companion_4);
  initMetadataForClass(TextStyle, 'TextStyle');
  initMetadataForClass(TtsAnnotation, 'TtsAnnotation');
  initMetadataForClass(VerbatimTtsAnnotation, 'VerbatimTtsAnnotation', VOID, TtsAnnotation);
  initMetadataForClass(UrlAnnotation, 'UrlAnnotation');
  function get_loadingStrategy() {
    return Companion_getInstance_23().a83_1;
  }
  initMetadataForInterface(Font, 'Font');
  initMetadataForClass(FontFamily, 'FontFamily');
  initMetadataForClass(SystemFontFamily, 'SystemFontFamily', VOID, FontFamily);
  initMetadataForClass(GenericFontFamily, 'GenericFontFamily', VOID, SystemFontFamily);
  initMetadataForCompanion(Companion_5);
  initMetadataForClass(DefaultFontFamily, 'DefaultFontFamily', VOID, SystemFontFamily);
  initMetadataForClass(FileBasedFontFamily, 'FileBasedFontFamily', VOID, FontFamily);
  initMetadataForClass(FontListFontFamily, 'FontListFontFamily', VOID, FileBasedFontFamily, [KtList]);
  initMetadataForClass(LoadedFontFamily, 'LoadedFontFamily', VOID, FontFamily);
  initMetadataForClass(TypefaceRequestCache, 'TypefaceRequestCache', TypefaceRequestCache);
  initMetadataForClass(TypefaceRequest, 'TypefaceRequest');
  initMetadataForClass(Immutable, 'Immutable');
  initMetadataForClass(Async, 'Async');
  initMetadataForClass(FontFamilyResolverImpl, 'FontFamilyResolverImpl', VOID, VOID, VOID, [1]);
  function interceptFontFamily(fontFamily) {
    return fontFamily;
  }
  function interceptFontWeight(fontWeight) {
    return fontWeight;
  }
  function interceptFontStyle(fontStyle) {
    return fontStyle;
  }
  function interceptFontSynthesis(fontSynthesis) {
    return fontSynthesis;
  }
  initMetadataForInterface(PlatformResolveInterceptor, 'PlatformResolveInterceptor');
  initMetadataForClass(PlatformResolveInterceptor$Companion$Default$1, VOID, VOID, VOID, [PlatformResolveInterceptor]);
  initMetadataForCompanion(Companion_6);
  initMetadataForClass(AsyncTypefaceResult, 'AsyncTypefaceResult');
  initMetadataForClass(Key, 'Key');
  initMetadataForCoroutine($runCachedCOROUTINE$, CoroutineImpl);
  initMetadataForClass(AsyncTypefaceCache, 'AsyncTypefaceCache', AsyncTypefaceCache, VOID, VOID, [4]);
  initMetadataForLambda(AsyncFontListLoader$load$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(AsyncFontListLoader$loadWithTimeoutOrNull$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($loadCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($loadWithTimeoutOrNullCOROUTINE$, CoroutineImpl);
  initMetadataForClass(AsyncFontListLoader, 'AsyncFontListLoader', VOID, VOID, VOID, [0, 1]);
  initMetadataForClass(FontListFontFamilyTypefaceAdapter$Companion$DropExceptionHandler$$inlined$CoroutineExceptionHandler$1, VOID, VOID, AbstractCoroutineContextElement, [Element]);
  initMetadataForCompanion(Companion_7);
  initMetadataForLambda(FontListFontFamilyTypefaceAdapter$resolve$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(FontListFontFamilyTypefaceAdapter, 'FontListFontFamilyTypefaceAdapter', FontListFontFamilyTypefaceAdapter, VOID, VOID, [2]);
  initMetadataForCompanion(Companion_8);
  initMetadataForClass(FontMatcher, 'FontMatcher', FontMatcher);
  initMetadataForCompanion(Companion_9);
  initMetadataForClass(FontStyle, 'FontStyle');
  initMetadataForCompanion(Companion_10);
  initMetadataForClass(FontSynthesis, 'FontSynthesis');
  initMetadataForClass(Settings, 'Settings');
  initMetadataForClass(SettingFloat, 'SettingFloat');
  initMetadataForClass(SettingInt, 'SettingInt');
  initMetadataForObject(FontVariation, 'FontVariation');
  initMetadataForCompanion(Companion_11);
  initMetadataForClass(FontWeight, 'FontWeight', VOID, VOID, [Comparable]);
  initMetadataForClass(FinishComposingTextCommand, 'FinishComposingTextCommand', FinishComposingTextCommand);
  initMetadataForClass(CommitTextCommand, 'CommitTextCommand');
  initMetadataForClass(DeleteSurroundingTextCommand, 'DeleteSurroundingTextCommand');
  initMetadataForClass(DeleteAllCommand, 'DeleteAllCommand', DeleteAllCommand);
  initMetadataForClass(SetSelectionCommand, 'SetSelectionCommand');
  initMetadataForClass(SetComposingTextCommand, 'SetComposingTextCommand');
  initMetadataForClass(SetComposingRegionCommand, 'SetComposingRegionCommand');
  initMetadataForClass(DeleteSurroundingTextInCodePointsCommand, 'DeleteSurroundingTextInCodePointsCommand');
  initMetadataForClass(BackspaceCommand, 'BackspaceCommand', BackspaceCommand);
  initMetadataForClass(MoveCursorCommand, 'MoveCursorCommand');
  initMetadataForClass(EditProcessor, 'EditProcessor', EditProcessor);
  initMetadataForCompanion(Companion_12);
  initMetadataForClass(EditingBuffer, 'EditingBuffer');
  initMetadataForCompanion(Companion_13);
  initMetadataForClass(PartialGapBuffer, 'PartialGapBuffer');
  initMetadataForClass(GapBuffer, 'GapBuffer');
  initMetadataForCompanion(Companion_14);
  initMetadataForClass(ImeAction, 'ImeAction');
  initMetadataForCompanion(Companion_15);
  initMetadataForClass(ImeOptions, 'ImeOptions');
  initMetadataForCompanion(Companion_16);
  initMetadataForClass(KeyboardCapitalization, 'KeyboardCapitalization');
  initMetadataForCompanion(Companion_17);
  initMetadataForClass(KeyboardType, 'KeyboardType');
  initMetadataForClass(OffsetMapping$Companion$Identity$1);
  initMetadataForCompanion(Companion_18);
  initMetadataForCompanion(Companion_19);
  initMetadataForClass(TextFieldValue, 'TextFieldValue', TextFieldValue_init_$Create$);
  initMetadataForClass(TextInputService, 'TextInputService');
  initMetadataForClass(TextInputSession, 'TextInputSession');
  function startInput() {
  }
  function notifyFocusedRect(rect) {
  }
  function updateTextLayoutResult(textFieldValue, offsetMapping, textLayoutResult, textFieldToRootTransform, innerTextFieldBounds, decorationBoxBounds) {
  }
  initMetadataForInterface(PlatformTextInputService, 'PlatformTextInputService');
  initMetadataForInterface(VisualTransformation, 'VisualTransformation');
  initMetadataForClass(sam$androidx_compose_ui_text_input_VisualTransformation$0, 'sam$androidx_compose_ui_text_input_VisualTransformation$0', VOID, VOID, [VisualTransformation, FunctionAdapter]);
  initMetadataForCompanion(Companion_20);
  initMetadataForClass(TransformedText, 'TransformedText');
  initMetadataForClass(PasswordVisualTransformation, 'PasswordVisualTransformation', PasswordVisualTransformation, VOID, [VisualTransformation]);
  initMetadataForCompanion(Companion_21);
  initMetadataForClass(LocaleList, 'LocaleList', VOID, VOID, [Collection]);
  initMetadataForCompanion(Companion_22);
  initMetadataForClass(BaselineShift, 'BaselineShift');
  initMetadataForCompanion(Companion_23);
  initMetadataForClass(Hyphens, 'Hyphens');
  initMetadataForCompanion(Companion_24);
  initMetadataForCompanion(Companion_25);
  initMetadataForCompanion(Companion_26);
  initMetadataForCompanion(Companion_27);
  initMetadataForClass(Trim, 'Trim');
  initMetadataForClass(Alignment, 'Alignment');
  initMetadataForClass(Mode, 'Mode');
  initMetadataForClass(LineHeightStyle, 'LineHeightStyle');
  initMetadataForClass(ResolvedTextDirection, 'ResolvedTextDirection', VOID, Enum);
  initMetadataForCompanion(Companion_28);
  initMetadataForClass(TextAlign, 'TextAlign');
  initMetadataForCompanion(Companion_29);
  initMetadataForClass(TextDecoration, 'TextDecoration');
  initMetadataForCompanion(Companion_30);
  initMetadataForClass(TextDirection, 'TextDirection');
  function merge(other) {
    var tmp;
    var tmp_0;
    if (other instanceof BrushStyle) {
      tmp_0 = this instanceof BrushStyle;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = new BrushStyle(other.n8e_1, takeOrElse_0(other.o8e_1, TextForegroundStyle$merge$lambda(this)));
    } else {
      var tmp_1;
      if (other instanceof BrushStyle) {
        tmp_1 = !(this instanceof BrushStyle);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp = other;
      } else {
        var tmp_2;
        if (!(other instanceof BrushStyle)) {
          tmp_2 = this instanceof BrushStyle;
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          tmp = this;
        } else {
          tmp = other.j7z(TextForegroundStyle$merge$lambda_0(this));
        }
      }
    }
    return tmp;
  }
  function takeOrElse(other) {
    return !equals(this, Unspecified_instance) ? this : other();
  }
  initMetadataForInterface(TextForegroundStyle, 'TextForegroundStyle');
  initMetadataForObject(Unspecified, 'Unspecified', VOID, VOID, [TextForegroundStyle]);
  initMetadataForCompanion(Companion_31);
  initMetadataForClass(BrushStyle, 'BrushStyle', VOID, VOID, [TextForegroundStyle]);
  initMetadataForClass(ColorStyle, 'ColorStyle', VOID, VOID, [TextForegroundStyle]);
  initMetadataForCompanion(Companion_32);
  initMetadataForClass(TextGeometricTransform, 'TextGeometricTransform', TextGeometricTransform);
  initMetadataForCompanion(Companion_33);
  initMetadataForClass(TextIndent_0, 'TextIndent', TextIndent_0);
  initMetadataForCompanion(Companion_34);
  initMetadataForClass(TextOverflow, 'TextOverflow');
  initMetadataForClass(AtomicReference, 'AtomicReference');
  initMetadataForClass(ExpireAfterAccessCache, 'ExpireAfterAccessCache');
  initMetadataForCompanion(Companion_35);
  initMetadataForLambda(_get_codePointsOutsideDirectionalIsolate_$slambda_cun5rj, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(_get_codePoints_$slambda_43x8dt, CoroutineImpl, VOID, [1]);
  initMetadataForCompanion(Companion_36);
  initMetadataForClass(FontRasterizationSettings, 'FontRasterizationSettings');
  initMetadataForClass(FontSmoothing, 'FontSmoothing', VOID, Enum);
  initMetadataForClass(FontHinting, 'FontHinting', VOID, Enum);
  function paint$default(canvas, color, shadow, textDecoration, drawStyle, blendMode, $super) {
    color = color === VOID ? Companion_getInstance().u6b_1 : color;
    shadow = shadow === VOID ? null : shadow;
    textDecoration = textDecoration === VOID ? null : textDecoration;
    drawStyle = drawStyle === VOID ? null : drawStyle;
    blendMode = blendMode === VOID ? Companion_getInstance_0().x6h_1 : blendMode;
    var tmp;
    if ($super === VOID) {
      this.l7t(canvas, color, shadow, textDecoration, drawStyle, blendMode);
      tmp = Unit_instance;
    } else {
      tmp = $super.l7t.call(this, canvas, new Color(color), shadow, textDecoration, drawStyle, new BlendMode(blendMode));
    }
    return tmp;
  }
  function paint$default_0(canvas, brush, alpha, shadow, textDecoration, drawStyle, blendMode, $super) {
    alpha = alpha === VOID ? NaN : alpha;
    shadow = shadow === VOID ? null : shadow;
    textDecoration = textDecoration === VOID ? null : textDecoration;
    drawStyle = drawStyle === VOID ? null : drawStyle;
    blendMode = blendMode === VOID ? Companion_getInstance_0().x6h_1 : blendMode;
    var tmp;
    if ($super === VOID) {
      this.n7t(canvas, brush, alpha, shadow, textDecoration, drawStyle, blendMode);
      tmp = Unit_instance;
    } else {
      tmp = $super.n7t.call(this, canvas, brush, alpha, shadow, textDecoration, drawStyle, new BlendMode(blendMode));
    }
    return tmp;
  }
  initMetadataForInterface(Paragraph_1, 'Paragraph');
  initMetadataForClass(SkiaParagraph, 'SkiaParagraph', VOID, VOID, [Paragraph_1]);
  initMetadataForCompanion(Companion_37);
  initMetadataForClass(TextDecorationLineStyle, 'TextDecorationLineStyle');
  initMetadataForClass(PlatformTextStyle, 'PlatformTextStyle');
  initMetadataForCompanion(Companion_38);
  initMetadataForClass(PlatformParagraphStyle, 'PlatformParagraphStyle');
  initMetadataForCompanion(Companion_39);
  initMetadataForClass(PlatformSpanStyle, 'PlatformSpanStyle', PlatformSpanStyle_init_$Create$);
  initMetadataForClass(PlatformFontFamilyTypefaceAdapter, 'PlatformFontFamilyTypefaceAdapter', PlatformFontFamilyTypefaceAdapter);
  initMetadataForClass(SkiaFontLoader, 'SkiaFontLoader', SkiaFontLoader_init_$Create$, VOID, VOID, [1]);
  initMetadataForClass(Immutable_0, 'Immutable', Immutable_0);
  initMetadataForClass(Mutable, 'Mutable');
  initMetadataForClass(Op, 'Op');
  initMetadataForClass(StyleAdd, 'StyleAdd', VOID, Op);
  initMetadataForClass(PutPlaceholder, 'PutPlaceholder', VOID, Op);
  initMetadataForClass(EndPlaceholder, 'EndPlaceholder', VOID, Op);
  initMetadataForClass(Cut, 'Cut');
  initMetadataForClass(StyleAdd_0, 'StyleAdd', VOID, Cut);
  initMetadataForClass(StyleRemove, 'StyleRemove', VOID, Cut);
  initMetadataForClass(PutPlaceholder_0, 'PutPlaceholder', VOID, Cut);
  initMetadataForClass(EndPlaceholder_0, 'EndPlaceholder', VOID, Cut);
  initMetadataForClass(sam$kotlin_Comparator$0_1, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForClass(ParagraphBuilder_0, 'ParagraphBuilder');
  initMetadataForClass(ParagraphLayouter, 'ParagraphLayouter');
  initMetadataForClass(PlatformFont, 'PlatformFont', VOID, VOID, [Font]);
  initMetadataForClass(SystemFont, 'SystemFont', VOID, PlatformFont);
  initMetadataForClass(FontLoader, 'FontLoader', FontLoader);
  initMetadataForClass(FontLoadResult, 'FontLoadResult');
  initMetadataForClass(Platform, 'Platform', VOID, Enum);
  initMetadataForClass(FontCache, 'FontCache', FontCache);
  initMetadataForClass(SkiaBackedTypeface, 'SkiaBackedTypeface');
  initMetadataForClass(LoadedFont, 'LoadedFont', VOID, PlatformFont);
  initMetadataForClass(SkiaParagraphIntrinsics, 'SkiaParagraphIntrinsics', VOID, VOID, [ParagraphIntrinsics]);
  initMetadataForClass(SkiaTextPaint, 'SkiaTextPaint', SkiaTextPaint);
  initMetadataForClass(SynchronizedObject, 'SynchronizedObject', SynchronizedObject);
  initMetadataForCompanion(Companion_40);
  initMetadataForClass(LineBreak, 'LineBreak');
  initMetadataForCompanion(Companion_41);
  initMetadataForClass(TextMotion, 'TextMotion');
  initMetadataForClass(Key_0, 'Key');
  initMetadataForClass(WeakKeysCache, 'WeakKeysCache', WeakKeysCache);
  initMetadataForClass(WeakReference, 'WeakReference');
  initMetadataForCompanion(Companion_42);
  initMetadataForClass(Locale, 'Locale');
  initMetadataForClass(createPlatformLocaleDelegate$1);
  //endregion
  function get_EmptyAnnotatedString() {
    _init_properties_AnnotatedString_kt__ww2pyh();
    return EmptyAnnotatedString;
  }
  var EmptyAnnotatedString;
  var androidx_compose_ui_text_AnnotatedString_Range$stable;
  var androidx_compose_ui_text_AnnotatedString_Builder_BulletScope$stable;
  var androidx_compose_ui_text_AnnotatedString_Builder$stable;
  var androidx_compose_ui_text_AnnotatedString$stable;
  function Range_init_$Init$(item, start, end, $this) {
    Range.call($this, item, start, end, '');
    return $this;
  }
  function Range_init_$Create$(item, start, end) {
    return Range_init_$Init$(item, start, end, objectCreate(protoOf(Range)));
  }
  function Companion() {
  }
  protoOf(Companion).l7p = function (range) {
    return new MutableRange(range.m7p_1, range.n7p_1, range.o7p_1, range.p7p_1);
  };
  var Companion_instance_1;
  function Companion_getInstance_14() {
    return Companion_instance_1;
  }
  function MutableRange(item, start, end, tag) {
    end = end === VOID ? -2147483648 : end;
    tag = tag === VOID ? '' : tag;
    this.q7p_1 = item;
    this.r7p_1 = start;
    this.s7p_1 = end;
    this.t7p_1 = tag;
  }
  protoOf(MutableRange).u7p = function (defaultEnd) {
    var end = this.s7p_1 === -2147483648 ? defaultEnd : this.s7p_1;
    // Inline function 'androidx.compose.ui.text.internal.checkPrecondition' call
    if (!!(end === -2147483648)) {
      var tmp$ret$1 = 'Item.end should be set first';
      throwIllegalStateException(tmp$ret$1);
    }
    return new Range(this.q7p_1, this.r7p_1, end, this.t7p_1);
  };
  protoOf(MutableRange).v7p = function (defaultEnd, $super) {
    defaultEnd = defaultEnd === VOID ? -2147483648 : defaultEnd;
    return $super === VOID ? this.u7p(defaultEnd) : $super.u7p.call(this, defaultEnd);
  };
  protoOf(MutableRange).toString = function () {
    return 'MutableRange(item=' + toString(this.q7p_1) + ', start=' + this.r7p_1 + ', end=' + this.s7p_1 + ', tag=' + this.t7p_1 + ')';
  };
  protoOf(MutableRange).hashCode = function () {
    var result = this.q7p_1 == null ? 0 : hashCode(this.q7p_1);
    result = imul(result, 31) + this.r7p_1 | 0;
    result = imul(result, 31) + this.s7p_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.t7p_1) | 0;
    return result;
  };
  protoOf(MutableRange).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MutableRange))
      return false;
    if (!equals(this.q7p_1, other.q7p_1))
      return false;
    if (!(this.r7p_1 === other.r7p_1))
      return false;
    if (!(this.s7p_1 === other.s7p_1))
      return false;
    if (!(this.t7p_1 === other.t7p_1))
      return false;
    return true;
  };
  function Builder_init_$Init$(text, $this) {
    Builder.call($this);
    $this.a7q(text);
    return $this;
  }
  function Builder_init_$Create$(text) {
    return Builder_init_$Init$(text, objectCreate(protoOf(Builder)));
  }
  function BulletScope(builder) {
    this.b7q_1 = builder;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.c7q_1 = ArrayList_init_$Create$();
  }
  function AnnotatedString_init_$Init$(text, annotations, $this) {
    var tmp;
    if (annotations === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp = emptyList();
    } else {
      tmp = annotations;
    }
    annotations = tmp;
    // Inline function 'kotlin.collections.ifEmpty' call
    var tmp_0;
    if (annotations.r()) {
      tmp_0 = null;
    } else {
      tmp_0 = annotations;
    }
    var tmp$ret$1 = tmp_0;
    AnnotatedString.call($this, tmp$ret$1, text);
    return $this;
  }
  function AnnotatedString_init_$Create$(text, annotations) {
    return AnnotatedString_init_$Init$(text, annotations, objectCreate(protoOf(AnnotatedString)));
  }
  function Range(item, start, end, tag) {
    this.m7p_1 = item;
    this.n7p_1 = start;
    this.o7p_1 = end;
    this.p7p_1 = tag;
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!(this.n7p_1 <= this.o7p_1)) {
      var tmp$ret$1 = 'Reversed range is not supported';
      throwIllegalArgumentException(tmp$ret$1);
    }
  }
  protoOf(Range).zh = function () {
    return this.m7p_1;
  };
  protoOf(Range).ai = function () {
    return this.n7p_1;
  };
  protoOf(Range).hr = function () {
    return this.o7p_1;
  };
  protoOf(Range).d7q = function (item, start, end, tag) {
    return new Range(item, start, end, tag);
  };
  protoOf(Range).e7q = function (item, start, end, tag, $super) {
    item = item === VOID ? this.m7p_1 : item;
    start = start === VOID ? this.n7p_1 : start;
    end = end === VOID ? this.o7p_1 : end;
    tag = tag === VOID ? this.p7p_1 : tag;
    return $super === VOID ? this.d7q(item, start, end, tag) : $super.d7q.call(this, item, start, end, tag);
  };
  protoOf(Range).toString = function () {
    return 'Range(item=' + toString(this.m7p_1) + ', start=' + this.n7p_1 + ', end=' + this.o7p_1 + ', tag=' + this.p7p_1 + ')';
  };
  protoOf(Range).hashCode = function () {
    var result = this.m7p_1 == null ? 0 : hashCode(this.m7p_1);
    result = imul(result, 31) + this.n7p_1 | 0;
    result = imul(result, 31) + this.o7p_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.p7p_1) | 0;
    return result;
  };
  protoOf(Range).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Range))
      return false;
    if (!equals(this.m7p_1, other.m7p_1))
      return false;
    if (!(this.n7p_1 === other.n7p_1))
      return false;
    if (!(this.o7p_1 === other.o7p_1))
      return false;
    if (!(this.p7p_1 === other.p7p_1))
      return false;
    return true;
  };
  function Builder(capacity) {
    capacity = capacity === VOID ? 16 : capacity;
    this.w7p_1 = StringBuilder_init_$Create$(capacity);
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.x7p_1 = ArrayList_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_0.y7p_1 = ArrayList_init_$Create$();
    this.z7p_1 = new BulletScope(this);
  }
  protoOf(Builder).f7q = function (text) {
    this.w7p_1.q(text);
  };
  protoOf(Builder).k1 = function (text) {
    if (text instanceof AnnotatedString) {
      this.a7q(text);
    } else {
      this.w7p_1.k1(text);
    }
    return this;
  };
  protoOf(Builder).s = function (char) {
    this.w7p_1.s(char);
    return this;
  };
  protoOf(Builder).a7q = function (text) {
    var start = this.w7p_1.a();
    this.w7p_1.q(text.h7q_1);
    var tmp0_safe_receiver = text.g7q_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0_safe_receiver.l1(index);
          this.y7p_1.j1(new MutableRange(item.m7p_1, start + item.n7p_1 | 0, start + item.o7p_1 | 0, item.p7p_1));
        }
         while (inductionVariable <= last);
    }
  };
  protoOf(Builder).k7q = function (style, start, end) {
    this.y7p_1.j1(new MutableRange(style, start, end));
  };
  protoOf(Builder).l7q = function (style) {
    // Inline function 'kotlin.also' call
    var this_0 = new MutableRange(style, this.w7p_1.a());
    this.x7p_1.j1(this_0);
    this.y7p_1.j1(this_0);
    return this.x7p_1.n1() - 1 | 0;
  };
  protoOf(Builder).m7q = function (link) {
    // Inline function 'kotlin.also' call
    var this_0 = new MutableRange(link, this.w7p_1.a());
    this.x7p_1.j1(this_0);
    this.y7p_1.j1(this_0);
    return this.x7p_1.n1() - 1 | 0;
  };
  protoOf(Builder).n7q = function () {
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'androidx.compose.ui.text.internal.checkPrecondition' call
    if (!!this.x7p_1.r()) {
      var tmp$ret$2 = 'Nothing to pop.';
      throwIllegalStateException(tmp$ret$2);
    }
    var item = this.x7p_1.h3(this.x7p_1.n1() - 1 | 0);
    item.s7p_1 = this.w7p_1.a();
  };
  protoOf(Builder).o7q = function (index) {
    // Inline function 'androidx.compose.ui.text.internal.checkPrecondition' call
    if (!(index < this.x7p_1.n1())) {
      var tmp$ret$1 = '' + index + ' should be less than ' + this.x7p_1.n1();
      throwIllegalStateException(tmp$ret$1);
    }
    while ((this.x7p_1.n1() - 1 | 0) >= index) {
      this.n7q();
    }
  };
  protoOf(Builder).p7q = function () {
    var tmp = this.w7p_1.toString();
    // Inline function 'androidx.compose.ui.util.fastMap' call
    var this_0 = this.y7p_1;
    var target = ArrayList_init_$Create$_0(this_0.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        // Inline function 'kotlin.collections.plusAssign' call
        var element = item.u7p(this.w7p_1.a());
        target.j1(element);
      }
       while (inductionVariable <= last);
    return AnnotatedString_init_$Create$(tmp, target);
  };
  protoOf(Builder).q7q = function (transform) {
    var inductionVariable = 0;
    var last = this.y7p_1.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var newAnnotation = transform(this.y7p_1.l1(i).v7p());
        this.y7p_1.f3(i, Companion_instance_1.l7p(newAnnotation));
      }
       while (inductionVariable <= last);
  };
  protoOf(Builder).r7q = function (transform) {
    // Inline function 'androidx.compose.ui.util.fastFlatMap' call
    var this_0 = this.y7p_1;
    var target = ArrayList_init_$Create$_0(this_0.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        // Inline function 'androidx.compose.ui.util.fastMap' call
        var this_1 = transform(item.v7p());
        var target_0 = ArrayList_init_$Create$_0(this_1.n1());
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable_0 = 0;
        var last_0 = this_1.n1() - 1 | 0;
        if (inductionVariable_0 <= last_0)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var item_0 = this_1.l1(index_0);
            // Inline function 'kotlin.collections.plusAssign' call
            var element = Companion_instance_1.l7p(item_0);
            target_0.j1(element);
          }
           while (inductionVariable_0 <= last_0);
        var list = target_0;
        addAll(target, list);
      }
       while (inductionVariable <= last);
    var replacedAnnotations = target;
    this.y7p_1.c3();
    this.y7p_1.o1(replacedAnnotations);
  };
  function Companion_0() {
    Companion_instance_2 = this;
    this.s7q_1 = get_AnnotatedStringSaver();
  }
  var Companion_instance_2;
  function Companion_getInstance_15() {
    if (Companion_instance_2 == null)
      new Companion_0();
    return Companion_instance_2;
  }
  function sam$kotlin_Comparator$0(function_0) {
    this.t7q_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0).ze = function (a, b) {
    return this.t7q_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
    return this.ze(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).q3 = function () {
    return this.t7q_1;
  };
  protoOf(sam$kotlin_Comparator$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function AnnotatedString$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp = a.n7p_1;
    var tmp$ret$2 = b.n7p_1;
    return compareValues(tmp, tmp$ret$2);
  }
  function AnnotatedString(annotations, text) {
    Companion_getInstance_15();
    this.g7q_1 = annotations;
    this.h7q_1 = text;
    var spanStyles = null;
    var paragraphStyles = null;
    var tmp0_safe_receiver = this.g7q_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0_safe_receiver.l1(index);
          var tmp = item.m7p_1;
          if (tmp instanceof SpanStyle) {
            if (spanStyles == null) {
              // Inline function 'kotlin.collections.mutableListOf' call
              spanStyles = ArrayList_init_$Create$();
            }
            var tmp_0 = ensureNotNull(spanStyles);
            tmp_0.j1(item instanceof Range ? item : THROW_CCE());
          } else {
            var tmp_1 = item.m7p_1;
            if (tmp_1 instanceof ParagraphStyle_0) {
              if (paragraphStyles == null) {
                // Inline function 'kotlin.collections.mutableListOf' call
                paragraphStyles = ArrayList_init_$Create$();
              }
              var tmp_2 = ensureNotNull(paragraphStyles);
              tmp_2.j1(item instanceof Range ? item : THROW_CCE());
            }
          }
        }
         while (inductionVariable <= last);
    }
    this.i7q_1 = spanStyles;
    this.j7q_1 = paragraphStyles;
    var tmp1_safe_receiver = this.j7q_1;
    var tmp_3;
    if (tmp1_safe_receiver == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.collections.sortedBy' call
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp_4 = AnnotatedString$lambda;
      var tmp$ret$5 = new sam$kotlin_Comparator$0(tmp_4);
      tmp_3 = sortedWith(tmp1_safe_receiver, tmp$ret$5);
    }
    var sorted = tmp_3;
    // Inline function 'kotlin.collections.isNullOrEmpty' call
    if (!(sorted == null || sorted.r())) {
      var previousEnds = mutableIntListOf(first(sorted).o7p_1);
      var inductionVariable_0 = 1;
      var last_0 = sorted.n1();
      if (inductionVariable_0 < last_0)
        do {
          var i = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var current = sorted.l1(i);
          $l$loop_0: while (true) {
            // Inline function 'androidx.collection.IntList.isNotEmpty' call
            if (!!(previousEnds.jv_1 === 0)) {
              break $l$loop_0;
            }
            var previousEnd = previousEnds.xg();
            if (current.n7p_1 >= previousEnd) {
              // Inline function 'androidx.collection.IntList.lastIndex' call
              var tmp$ret$8 = previousEnds.jv_1 - 1 | 0;
              previousEnds.h3(tmp$ret$8);
            } else {
              // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
              if (!(current.o7p_1 <= previousEnd)) {
                var tmp$ret$10 = 'Paragraph overlap not allowed, end ' + current.o7p_1 + ' should be less than or equal to ' + previousEnd;
                throwIllegalArgumentException(tmp$ret$10);
              }
              break $l$loop_0;
            }
          }
          previousEnds.pv(current.o7p_1);
        }
         while (inductionVariable_0 < last_0);
    }
  }
  protoOf(AnnotatedString).a = function () {
    return this.h7q_1.length;
  };
  protoOf(AnnotatedString).b = function (index) {
    return charCodeAt(this.h7q_1, index);
  };
  protoOf(AnnotatedString).c = function (startIndex, endIndex) {
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!(startIndex <= endIndex)) {
      var tmp$ret$1 = 'start (' + startIndex + ') should be less or equal to end (' + endIndex + ')';
      throwIllegalArgumentException(tmp$ret$1);
    }
    if (startIndex === 0 && endIndex === this.h7q_1.length)
      return this;
    var text = substring(this.h7q_1, startIndex, endIndex);
    var tmp0_annotations = filterRanges(this.g7q_1, startIndex, endIndex);
    return new AnnotatedString(tmp0_annotations, text);
  };
  protoOf(AnnotatedString).u7q = function (range) {
    return this.c(_TextRange___get_min__impl__uu95c4(range), _TextRange___get_max__impl__owm8m(range));
  };
  protoOf(AnnotatedString).v7q = function (other) {
    // Inline function 'kotlin.with' call
    var $this$with = Builder_init_$Create$(this);
    $this$with.a7q(other);
    return $this$with.p7q();
  };
  protoOf(AnnotatedString).w7q = function (tag, start, end) {
    var tmp0_safe_receiver = this.g7q_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'androidx.compose.ui.util.fastFilteredMap' call
      var target = ArrayList_init_$Create$_0(tmp0_safe_receiver.n1());
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0_safe_receiver.l1(index);
          var tmp_0;
          var tmp_1;
          var tmp_2 = item.m7p_1;
          if (tmp_2 instanceof StringAnnotation) {
            tmp_1 = tag === item.p7p_1;
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp_0 = intersect(start, end, item.n7p_1, item.o7p_1);
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            // Inline function 'kotlin.collections.plusAssign' call
            var element = unbox(item);
            target.j1(element);
          }
        }
         while (inductionVariable <= last);
      tmp = target;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_3;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.collections.listOf' call
      tmp_3 = emptyList();
    } else {
      tmp_3 = tmp1_elvis_lhs;
    }
    return tmp_3;
  };
  protoOf(AnnotatedString).x7q = function (tag, start, end) {
    var tmp0_safe_receiver = this.g7q_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp$ret$0;
      $l$block: {
        // Inline function 'androidx.compose.ui.util.fastAny' call
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.n1() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var item = tmp0_safe_receiver.l1(index);
            var tmp_0;
            var tmp_1;
            var tmp_2 = item.m7p_1;
            if (tmp_2 instanceof StringAnnotation) {
              tmp_1 = tag === item.p7p_1;
            } else {
              tmp_1 = false;
            }
            if (tmp_1) {
              tmp_0 = intersect(start, end, item.n7p_1, item.o7p_1);
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              tmp$ret$0 = true;
              break $l$block;
            }
          }
           while (inductionVariable <= last);
        tmp$ret$0 = false;
      }
      tmp = tmp$ret$0;
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  };
  protoOf(AnnotatedString).y7q = function (start, end) {
    var tmp0_safe_receiver = this.g7q_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'androidx.compose.ui.util.fastFilter' call
      var target = ArrayList_init_$Create$_0(tmp0_safe_receiver.n1());
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0_safe_receiver.l1(index);
          var tmp_0;
          var tmp_1 = item.m7p_1;
          if (tmp_1 instanceof LinkAnnotation) {
            tmp_0 = intersect(start, end, item.n7p_1, item.o7p_1);
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            // Inline function 'kotlin.collections.plusAssign' call
            target.j1(item);
          }
        }
         while (inductionVariable <= last);
      tmp = target;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_2;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.collections.listOf' call
      tmp_2 = emptyList();
    } else {
      tmp_2 = tmp1_elvis_lhs;
    }
    var tmp_3 = tmp_2;
    return isInterface(tmp_3, KtList) ? tmp_3 : THROW_CCE();
  };
  protoOf(AnnotatedString).z7q = function (start, end) {
    var tmp0_safe_receiver = this.g7q_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp$ret$0;
      $l$block: {
        // Inline function 'androidx.compose.ui.util.fastAny' call
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.n1() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var item = tmp0_safe_receiver.l1(index);
            var tmp_0;
            var tmp_1 = item.m7p_1;
            if (tmp_1 instanceof LinkAnnotation) {
              tmp_0 = intersect(start, end, item.n7p_1, item.o7p_1);
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              tmp$ret$0 = true;
              break $l$block;
            }
          }
           while (inductionVariable <= last);
        tmp$ret$0 = false;
      }
      tmp = tmp$ret$0;
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  };
  protoOf(AnnotatedString).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AnnotatedString))
      return false;
    if (!(this.h7q_1 === other.h7q_1))
      return false;
    if (!equals(this.g7q_1, other.g7q_1))
      return false;
    return true;
  };
  protoOf(AnnotatedString).hashCode = function () {
    var result = getStringHashCode(this.h7q_1);
    var tmp = imul(31, result);
    var tmp0_safe_receiver = this.g7q_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    return result;
  };
  protoOf(AnnotatedString).toString = function () {
    return this.h7q_1;
  };
  protoOf(AnnotatedString).a7r = function (other) {
    return equals(this.g7q_1, other.g7q_1);
  };
  protoOf(AnnotatedString).b7r = function (transform) {
    var builder = Builder_init_$Create$(this);
    builder.q7q(transform);
    return builder.p7q();
  };
  protoOf(AnnotatedString).c7r = function (transform) {
    var builder = Builder_init_$Create$(this);
    builder.r7q(transform);
    return builder.p7q();
  };
  function filterRanges(ranges, start, end) {
    _init_properties_AnnotatedString_kt__ww2pyh();
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!(start <= end)) {
      var tmp$ret$1 = 'start (' + start + ') should be less than or equal to end (' + end + ')';
      throwIllegalArgumentException(tmp$ret$1);
    }
    var tmp;
    if (ranges == null) {
      return null;
    } else {
      tmp = ranges;
    }
    var nonNullRange = tmp;
    // Inline function 'androidx.compose.ui.util.fastFilteredMap' call
    var target = ArrayList_init_$Create$_0(nonNullRange.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = nonNullRange.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = nonNullRange.l1(index);
        if (intersect(start, end, item.n7p_1, item.o7p_1)) {
          // Inline function 'kotlin.comparisons.maxOf' call
          var b = item.n7p_1;
          var tmp_0 = Math.max(start, b) - start | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b_0 = item.o7p_1;
          var tmp$ret$8 = Math.min(end, b_0);
          // Inline function 'kotlin.collections.plusAssign' call
          var element = new Range(item.m7p_1, tmp_0, tmp$ret$8 - start | 0, item.p7p_1);
          target.j1(element);
        }
      }
       while (inductionVariable <= last);
    // Inline function 'kotlin.collections.ifEmpty' call
    var tmp_1;
    if (target.r()) {
      tmp_1 = null;
    } else {
      tmp_1 = target;
    }
    return tmp_1;
  }
  function intersect(lStart, lEnd, rStart, rEnd) {
    _init_properties_AnnotatedString_kt__ww2pyh();
    return !!(!!(!!(lStart === lEnd | rStart === rEnd) & lStart === rStart) | !!(lStart < rEnd & rStart < lEnd));
  }
  function getLocalAnnotations(_this__u8e3s4, start, end, predicate) {
    predicate = predicate === VOID ? null : predicate;
    _init_properties_AnnotatedString_kt__ww2pyh();
    if (start === end)
      return null;
    var tmp0_elvis_lhs = _this__u8e3s4.g7q_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var annotations = tmp;
    if (start === 0 && end >= _this__u8e3s4.h7q_1.length) {
      var tmp_0;
      if (predicate == null) {
        tmp_0 = annotations;
      } else {
        // Inline function 'androidx.compose.ui.util.fastFilter' call
        var target = ArrayList_init_$Create$_0(annotations.n1());
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable = 0;
        var last = annotations.n1() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var item = annotations.l1(index);
            if (predicate(item.m7p_1)) {
              // Inline function 'kotlin.collections.plusAssign' call
              target.j1(item);
            }
          }
           while (inductionVariable <= last);
        tmp_0 = target;
      }
      return tmp_0;
    }
    // Inline function 'androidx.compose.ui.util.fastFilteredMap' call
    var target_0 = ArrayList_init_$Create$_0(annotations.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable_0 = 0;
    var last_0 = annotations.n1() - 1 | 0;
    if (inductionVariable_0 <= last_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var item_0 = annotations.l1(index_0);
        var tmp_1;
        var tmp1_elvis_lhs = predicate == null ? null : predicate(item_0.m7p_1);
        if (tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs) {
          tmp_1 = intersect(start, end, item_0.n7p_1, item_0.o7p_1);
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          var tmp0_tag = item_0.p7p_1;
          var tmp1_item = item_0.m7p_1;
          var tmp2_start = coerceIn(item_0.n7p_1, start, end) - start | 0;
          var tmp3_end = coerceIn(item_0.o7p_1, start, end) - start | 0;
          // Inline function 'kotlin.collections.plusAssign' call
          var element = new Range(tmp1_item, tmp2_start, tmp3_end, tmp0_tag);
          target_0.j1(element);
        }
      }
       while (inductionVariable_0 <= last_0);
    return target_0;
  }
  function emptyAnnotatedString() {
    _init_properties_AnnotatedString_kt__ww2pyh();
    return get_EmptyAnnotatedString();
  }
  function normalizedParagraphStyles(_this__u8e3s4, defaultParagraphStyle) {
    _init_properties_AnnotatedString_kt__ww2pyh();
    var tmp0_safe_receiver = _this__u8e3s4.j7q_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.sortedBy' call
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp_0 = normalizedParagraphStyles$lambda;
      var tmp$ret$1 = new sam$kotlin_Comparator$0_0(tmp_0);
      tmp = sortedWith(tmp0_safe_receiver, tmp$ret$1);
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.collections.listOf' call
      tmp_1 = emptyList();
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    var sortedParagraphs = tmp_1;
    // Inline function 'kotlin.collections.mutableListOf' call
    var result = ArrayList_init_$Create$();
    var lastAdded = 0;
    var stack = ArrayDeque_init_$Create$();
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = sortedParagraphs.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = sortedParagraphs.l1(index);
        var current = item.e7q(defaultParagraphStyle.m7r(item.m7p_1));
        $l$loop: while (true) {
          var tmp_2;
          if (lastAdded < current.n7p_1) {
            // Inline function 'kotlin.collections.isNotEmpty' call
            tmp_2 = !stack.r();
          } else {
            tmp_2 = false;
          }
          if (!tmp_2) {
            break $l$loop;
          }
          var lastInStack = stack.xg();
          if (current.n7p_1 < lastInStack.o7p_1) {
            result.j1(Range_init_$Create$(lastInStack.m7p_1, lastAdded, current.n7p_1));
            lastAdded = current.n7p_1;
          } else {
            result.j1(Range_init_$Create$(lastInStack.m7p_1, lastAdded, lastInStack.o7p_1));
            lastAdded = lastInStack.o7p_1;
            $l$loop_0: while (true) {
              var tmp_3;
              // Inline function 'kotlin.collections.isNotEmpty' call
              if (!stack.r()) {
                tmp_3 = lastAdded === stack.xg().o7p_1;
              } else {
                tmp_3 = false;
              }
              if (!tmp_3) {
                break $l$loop_0;
              }
              stack.dh();
            }
          }
        }
        if (lastAdded < current.n7p_1) {
          result.j1(Range_init_$Create$(defaultParagraphStyle, lastAdded, current.n7p_1));
          lastAdded = current.n7p_1;
        }
        var lastInStack_0 = stack.yg();
        if (!(lastInStack_0 == null)) {
          if (lastInStack_0.n7p_1 === current.n7p_1 && lastInStack_0.o7p_1 === current.o7p_1) {
            stack.dh();
            stack.j1(Range_init_$Create$(lastInStack_0.m7p_1.m7r(current.m7p_1), current.n7p_1, current.o7p_1));
          } else if (lastInStack_0.n7p_1 === lastInStack_0.o7p_1) {
            result.j1(Range_init_$Create$(lastInStack_0.m7p_1, lastInStack_0.n7p_1, lastInStack_0.o7p_1));
            stack.dh();
            stack.j1(Range_init_$Create$(current.m7p_1, current.n7p_1, current.o7p_1));
          } else if (lastInStack_0.o7p_1 < current.o7p_1) {
            throw IllegalArgumentException_init_$Create$();
          } else {
            stack.j1(Range_init_$Create$(lastInStack_0.m7p_1.m7r(current.m7p_1), current.n7p_1, current.o7p_1));
          }
        } else {
          stack.j1(Range_init_$Create$(current.m7p_1, current.n7p_1, current.o7p_1));
        }
      }
       while (inductionVariable <= last);
    $l$loop_1: while (true) {
      var tmp_4;
      if (lastAdded <= _this__u8e3s4.h7q_1.length) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp_4 = !stack.r();
      } else {
        tmp_4 = false;
      }
      if (!tmp_4) {
        break $l$loop_1;
      }
      var lastInStack_1 = stack.xg();
      result.j1(Range_init_$Create$(lastInStack_1.m7p_1, lastAdded, lastInStack_1.o7p_1));
      lastAdded = lastInStack_1.o7p_1;
      $l$loop_2: while (true) {
        var tmp_5;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!stack.r()) {
          tmp_5 = lastAdded === stack.xg().o7p_1;
        } else {
          tmp_5 = false;
        }
        if (!tmp_5) {
          break $l$loop_2;
        }
        stack.dh();
      }
    }
    if (lastAdded < _this__u8e3s4.h7q_1.length) {
      result.j1(Range_init_$Create$(defaultParagraphStyle, lastAdded, _this__u8e3s4.h7q_1.length));
    }
    if (result.r()) {
      result.j1(Range_init_$Create$(defaultParagraphStyle, 0, 0));
    }
    return result;
  }
  function substringWithoutParagraphStyles(_this__u8e3s4, start, end) {
    _init_properties_AnnotatedString_kt__ww2pyh();
    var tmp = !(start === end) ? substring(_this__u8e3s4.h7q_1, start, end) : '';
    var tmp0_elvis_lhs = getLocalAnnotations(_this__u8e3s4, start, end, substringWithoutParagraphStyles$lambda);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.collections.listOf' call
      tmp_0 = emptyList();
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return AnnotatedString_init_$Create$(tmp, tmp_0);
  }
  function access$substringWithoutParagraphStyles$tAnnotatedStringKt($receiver, start, end) {
    return substringWithoutParagraphStyles($receiver, start, end);
  }
  function sam$kotlin_Comparator$0_0(function_0) {
    this.n7r_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_0).ze = function (a, b) {
    return this.n7r_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_0).compare = function (a, b) {
    return this.ze(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_0).q3 = function () {
    return this.n7r_1;
  };
  protoOf(sam$kotlin_Comparator$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0_0).hashCode = function () {
    return hashCode(this.q3());
  };
  function normalizedParagraphStyles$lambda(a, b) {
    _init_properties_AnnotatedString_kt__ww2pyh();
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp = a.n7p_1;
    var tmp$ret$2 = b.n7p_1;
    return compareValues(tmp, tmp$ret$2);
  }
  function substringWithoutParagraphStyles$lambda(it) {
    _init_properties_AnnotatedString_kt__ww2pyh();
    return !(it instanceof ParagraphStyle_0);
  }
  var properties_initialized_AnnotatedString_kt_um06op;
  function _init_properties_AnnotatedString_kt__ww2pyh() {
    if (!properties_initialized_AnnotatedString_kt_um06op) {
      properties_initialized_AnnotatedString_kt_um06op = true;
      EmptyAnnotatedString = AnnotatedString_init_$Create$('');
      androidx_compose_ui_text_AnnotatedString_Range$stable = 0;
      androidx_compose_ui_text_AnnotatedString_Builder_BulletScope$stable = 8;
      androidx_compose_ui_text_AnnotatedString_Builder$stable = 8;
      androidx_compose_ui_text_AnnotatedString$stable = 0;
    }
  }
  var androidx_compose_ui_text_ComposeUiTextFlags$stable;
  function ComposeUiTextFlags() {
    this.o7r_1 = true;
  }
  var ComposeUiTextFlags_instance;
  function ComposeUiTextFlags_getInstance() {
    return ComposeUiTextFlags_instance;
  }
  var androidx_compose_ui_text_LinkAnnotation_Url$stable;
  var androidx_compose_ui_text_LinkAnnotation_Clickable$stable;
  var androidx_compose_ui_text_LinkAnnotation$stable;
  function Url(url, styles, linkInteractionListener) {
    styles = styles === VOID ? null : styles;
    linkInteractionListener = linkInteractionListener === VOID ? null : linkInteractionListener;
    LinkAnnotation.call(this);
    this.p7r_1 = url;
    this.q7r_1 = styles;
    this.r7r_1 = linkInteractionListener;
  }
  protoOf(Url).s7r = function () {
    return this.q7r_1;
  };
  protoOf(Url).t7r = function (url, styles, linkInteractionListener) {
    return new Url(url, styles, linkInteractionListener);
  };
  protoOf(Url).u7r = function (url, styles, linkInteractionListener, $super) {
    url = url === VOID ? this.p7r_1 : url;
    styles = styles === VOID ? this.q7r_1 : styles;
    linkInteractionListener = linkInteractionListener === VOID ? this.r7r_1 : linkInteractionListener;
    return $super === VOID ? this.t7r(url, styles, linkInteractionListener) : $super.t7r.call(this, url, styles, linkInteractionListener);
  };
  protoOf(Url).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Url))
      return false;
    if (!(this.p7r_1 === other.p7r_1))
      return false;
    if (!equals(this.q7r_1, other.q7r_1))
      return false;
    if (!equals(this.r7r_1, other.r7r_1))
      return false;
    return true;
  };
  protoOf(Url).hashCode = function () {
    var result = getStringHashCode(this.p7r_1);
    var tmp = imul(31, result);
    var tmp0_safe_receiver = this.q7r_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hashCode();
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    var tmp_0 = imul(31, result);
    var tmp2_safe_receiver = this.r7r_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : hashCode(tmp2_safe_receiver);
    result = tmp_0 + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    return result;
  };
  protoOf(Url).toString = function () {
    return 'LinkAnnotation.Url(url=' + this.p7r_1 + ')';
  };
  function Clickable(tag, styles, linkInteractionListener) {
    styles = styles === VOID ? null : styles;
    LinkAnnotation.call(this);
    this.v7r_1 = tag;
    this.w7r_1 = styles;
    this.x7r_1 = linkInteractionListener;
  }
  protoOf(Clickable).s7r = function () {
    return this.w7r_1;
  };
  protoOf(Clickable).t7r = function (tag, styles, linkInteractionListener) {
    return new Clickable(tag, styles, linkInteractionListener);
  };
  protoOf(Clickable).y7r = function (tag, styles, linkInteractionListener, $super) {
    tag = tag === VOID ? this.v7r_1 : tag;
    styles = styles === VOID ? this.w7r_1 : styles;
    linkInteractionListener = linkInteractionListener === VOID ? this.x7r_1 : linkInteractionListener;
    return $super === VOID ? this.t7r(tag, styles, linkInteractionListener) : $super.t7r.call(this, tag, styles, linkInteractionListener);
  };
  protoOf(Clickable).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Clickable))
      return false;
    if (!(this.v7r_1 === other.v7r_1))
      return false;
    if (!equals(this.w7r_1, other.w7r_1))
      return false;
    if (!equals(this.x7r_1, other.x7r_1))
      return false;
    return true;
  };
  protoOf(Clickable).hashCode = function () {
    var result = getStringHashCode(this.v7r_1);
    var tmp = imul(31, result);
    var tmp0_safe_receiver = this.w7r_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hashCode();
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    var tmp_0 = imul(31, result);
    var tmp2_safe_receiver = this.x7r_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : hashCode(tmp2_safe_receiver);
    result = tmp_0 + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    return result;
  };
  protoOf(Clickable).toString = function () {
    return 'LinkAnnotation.Clickable(tag=' + this.v7r_1 + ')';
  };
  function LinkAnnotation() {
  }
  var androidx_compose_ui_text_MultiParagraph$stable;
  var androidx_compose_ui_text_ParagraphInfo$stable;
  function _get_annotatedString__kqljtk($this) {
    return $this.e7s_1.z7r_1;
  }
  function requireIndexInRange($this, offset) {
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!(0 <= offset ? offset <= (charSequenceLength(_get_annotatedString__kqljtk($this).h7q_1) - 1 | 0) : false)) {
      var tmp$ret$1 = 'offset(' + offset + ') is out of bounds [0, ' + _get_annotatedString__kqljtk($this).a() + ')';
      throwIllegalArgumentException(tmp$ret$1);
    }
  }
  function requireIndexInRangeInclusiveEnd($this, offset) {
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!(0 <= offset ? offset <= _get_annotatedString__kqljtk($this).h7q_1.length : false)) {
      var tmp$ret$1 = 'offset(' + offset + ') is out of bounds [0, ' + _get_annotatedString__kqljtk($this).a() + ']';
      throwIllegalArgumentException(tmp$ret$1);
    }
  }
  function requireLineIndexInRange($this, lineIndex) {
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!(0 <= lineIndex ? lineIndex < $this.j7s_1 : false)) {
      var tmp$ret$1 = 'lineIndex(' + lineIndex + ') is out of bounds [0, ' + $this.j7s_1 + ')';
      throwIllegalArgumentException(tmp$ret$1);
    }
  }
  function MultiParagraph$getPathForRange$lambda($path, $start, $end) {
    return function (paragraphInfo) {
      // Inline function 'kotlin.with' call
      $path.c6i(paragraphInfo.v7s(paragraphInfo.m7s_1.u7s(paragraphInfo.t7s($start), paragraphInfo.t7s($end))));
      return Unit_instance;
    };
  }
  function MultiParagraph(intrinsics, constraints, maxLines, overflow) {
    maxLines = maxLines === VOID ? 2147483647 : maxLines;
    overflow = overflow === VOID ? Companion_getInstance_49().w7s_1 : overflow;
    this.e7s_1 = intrinsics;
    this.f7s_1 = maxLines;
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!(_Constraints___get_minWidth__impl__hi9lfi(constraints) === 0 && _Constraints___get_minHeight__impl__ev4bgx(constraints) === 0)) {
      var tmp$ret$1 = 'Setting Constraints.minWidth and Constraints.minHeight is not supported, these should be the default zero values instead.';
      throwIllegalArgumentException(tmp$ret$1);
    }
    var currentHeight = 0.0;
    var currentLineCount = 0;
    var didExceedMaxLines = false;
    // Inline function 'kotlin.collections.mutableListOf' call
    var paragraphInfoList = ArrayList_init_$Create$();
    var infoList = this.e7s_1.d7s_1;
    var inductionVariable = 0;
    var last = infoList.n1() - 1 | 0;
    if (inductionVariable <= last)
      $l$loop: do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var paragraphInfo = infoList.l1(index);
        var tmp = _Constraints___get_maxWidth__impl__uuyqc(constraints);
        var tmp_0;
        if (_Constraints___get_hasBoundedHeight__impl__bsh4rw(constraints)) {
          tmp_0 = coerceAtLeast(_Constraints___get_maxHeight__impl__dt3e8z(constraints) - ceilToInt(currentHeight) | 0, 0);
        } else {
          tmp_0 = _Constraints___get_maxHeight__impl__dt3e8z(constraints);
        }
        var paragraph = Paragraph_0(paragraphInfo.b7t_1, Constraints(VOID, tmp, VOID, tmp_0), this.f7s_1 - currentLineCount | 0, overflow);
        var paragraphTop = currentHeight;
        var paragraphBottom = currentHeight + paragraph.i5e();
        currentHeight = paragraphBottom;
        var startLineIndex = currentLineCount;
        var endLineIndex = startLineIndex + paragraph.e7t() | 0;
        currentLineCount = endLineIndex;
        paragraphInfoList.j1(new ParagraphInfo(paragraph, paragraphInfo.c7t_1, paragraphInfo.d7t_1, startLineIndex, endLineIndex, paragraphTop, paragraphBottom));
        if (paragraph.f7t() || (endLineIndex === this.f7s_1 && !(index === get_lastIndex(this.e7s_1.d7s_1)))) {
          didExceedMaxLines = true;
          break $l$loop;
        }
      }
       while (inductionVariable <= last);
    this.i7s_1 = currentHeight;
    this.j7s_1 = currentLineCount;
    this.g7s_1 = didExceedMaxLines;
    this.l7s_1 = paragraphInfoList;
    this.h7s_1 = _Constraints___get_maxWidth__impl__uuyqc(constraints);
    var tmp_1 = this;
    // Inline function 'androidx.compose.ui.util.fastFlatMap' call
    var target = ArrayList_init_$Create$_0(paragraphInfoList.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable_0 = 0;
    var last_0 = paragraphInfoList.n1() - 1 | 0;
    if (inductionVariable_0 <= last_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var item = paragraphInfoList.l1(index_0);
        // Inline function 'kotlin.with' call
        // Inline function 'androidx.compose.ui.util.fastMap' call
        var this_0 = item.m7s_1.g7t();
        var target_0 = ArrayList_init_$Create$_0(this_0.n1());
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable_1 = 0;
        var last_1 = this_0.n1() - 1 | 0;
        if (inductionVariable_1 <= last_1)
          do {
            var index_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var item_0 = this_0.l1(index_1);
            // Inline function 'kotlin.collections.plusAssign' call
            var element = item_0 == null ? null : item.h7t(item_0);
            target_0.j1(element);
          }
           while (inductionVariable_1 <= last_1);
        var list = target_0;
        addAll(target, list);
      }
       while (inductionVariable_0 <= last_0);
    // Inline function 'kotlin.let' call
    var tmp_2;
    if (target.n1() < this.e7s_1.a7s_1.n1()) {
      // Inline function 'kotlin.collections.List' call
      // Inline function 'kotlin.collections.MutableList' call
      var size = this.e7s_1.a7s_1.n1() - target.n1() | 0;
      var list_0 = ArrayList_init_$Create$_0(size);
      // Inline function 'kotlin.repeat' call
      var inductionVariable_2 = 0;
      if (inductionVariable_2 < size)
        do {
          var index_2 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          list_0.j1(null);
        }
         while (inductionVariable_2 < size);
      tmp_2 = plus(target, list_0);
    } else {
      tmp_2 = target;
    }
    tmp_1.k7s_1 = tmp_2;
  }
  protoOf(MultiParagraph).i7t = function () {
    var tmp;
    if (this.l7s_1.r()) {
      tmp = 0.0;
    } else {
      tmp = this.l7s_1.l1(0).m7s_1.i7t();
    }
    return tmp;
  };
  protoOf(MultiParagraph).j7t = function () {
    var tmp;
    if (this.l7s_1.r()) {
      tmp = 0.0;
    } else {
      // Inline function 'kotlin.with' call
      var $this$with = last(this.l7s_1);
      tmp = $this$with.k7t($this$with.m7s_1.j7t());
    }
    return tmp;
  };
  protoOf(MultiParagraph).l7t = function (canvas, color, shadow, decoration, drawStyle, blendMode) {
    canvas.t6d();
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = this.l7s_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        item.m7s_1.l7t(canvas, color, shadow, decoration, drawStyle, blendMode);
        canvas.b5d(0.0, item.m7s_1.i5e());
      }
       while (inductionVariable <= last);
    canvas.u6d();
  };
  protoOf(MultiParagraph).m7t = function (canvas, color, shadow, decoration, drawStyle, blendMode, $super) {
    color = color === VOID ? Companion_getInstance().u6b_1 : color;
    shadow = shadow === VOID ? null : shadow;
    decoration = decoration === VOID ? null : decoration;
    drawStyle = drawStyle === VOID ? null : drawStyle;
    blendMode = blendMode === VOID ? Companion_getInstance_0().x6h_1 : blendMode;
    var tmp;
    if ($super === VOID) {
      this.l7t(canvas, color, shadow, decoration, drawStyle, blendMode);
      tmp = Unit_instance;
    } else {
      tmp = $super.l7t.call(this, canvas, new Color(color), shadow, decoration, drawStyle, new BlendMode(blendMode));
    }
    return tmp;
  };
  protoOf(MultiParagraph).n7t = function (canvas, brush, alpha, shadow, decoration, drawStyle, blendMode) {
    drawMultiParagraph(this, canvas, brush, alpha, shadow, decoration, drawStyle, blendMode);
  };
  protoOf(MultiParagraph).o7t = function (canvas, brush, alpha, shadow, decoration, drawStyle, blendMode, $super) {
    alpha = alpha === VOID ? NaN : alpha;
    shadow = shadow === VOID ? null : shadow;
    decoration = decoration === VOID ? null : decoration;
    drawStyle = drawStyle === VOID ? null : drawStyle;
    blendMode = blendMode === VOID ? Companion_getInstance_0().x6h_1 : blendMode;
    var tmp;
    if ($super === VOID) {
      this.n7t(canvas, brush, alpha, shadow, decoration, drawStyle, blendMode);
      tmp = Unit_instance;
    } else {
      tmp = $super.n7t.call(this, canvas, brush, alpha, shadow, decoration, drawStyle, new BlendMode(blendMode));
    }
    return tmp;
  };
  protoOf(MultiParagraph).u7s = function (start, end) {
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!((0 <= start ? start <= end : false) && end <= _get_annotatedString__kqljtk(this).h7q_1.length)) {
      var tmp$ret$1 = 'Start(' + start + ') or End(' + end + ') is out of range [0..' + _get_annotatedString__kqljtk(this).h7q_1.length + '),' + ' or start > end!';
      throwIllegalArgumentException(tmp$ret$1);
    }
    if (start === end)
      return Path();
    var path = Path();
    var tmp = TextRange_1(start, end);
    findParagraphsByRange(this.l7s_1, tmp, MultiParagraph$getPathForRange$lambda(path, start, end));
    return path;
  };
  protoOf(MultiParagraph).p7t = function (vertical) {
    var paragraphIndex = findParagraphByY(this.l7s_1, vertical);
    // Inline function 'kotlin.with' call
    var $this$with = this.l7s_1.l1(paragraphIndex);
    var tmp;
    if ($this$with.a() === 0) {
      tmp = $this$with.p7s_1;
    } else {
      tmp = $this$with.r7t($this$with.m7s_1.p7t($this$with.q7t(vertical)));
    }
    return tmp;
  };
  protoOf(MultiParagraph).s7t = function (position) {
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value = _Offset___get_packedValue__impl__xh2k8q(position);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
    var tmp$ret$0 = floatFromBits(bits);
    var paragraphIndex = findParagraphByY(this.l7s_1, tmp$ret$0);
    // Inline function 'kotlin.with' call
    var $this$with = this.l7s_1.l1(paragraphIndex);
    var tmp;
    if ($this$with.a() === 0) {
      tmp = $this$with.n7s_1;
    } else {
      tmp = $this$with.u7t($this$with.m7s_1.s7t($this$with.t7t(position)));
    }
    return tmp;
  };
  protoOf(MultiParagraph).v7t = function (offset) {
    requireIndexInRange(this, offset);
    var paragraphIndex = findParagraphByIndex(this.l7s_1, offset);
    // Inline function 'kotlin.with' call
    var $this$with = this.l7s_1.l1(paragraphIndex);
    return $this$with.h7t($this$with.m7s_1.v7t($this$with.t7s(offset)));
  };
  protoOf(MultiParagraph).w7t = function (offset, usePrimaryDirection) {
    requireIndexInRangeInclusiveEnd(this, offset);
    var tmp;
    if (offset === _get_annotatedString__kqljtk(this).a()) {
      tmp = get_lastIndex(this.l7s_1);
    } else {
      tmp = findParagraphByIndex(this.l7s_1, offset);
    }
    var paragraphIndex = tmp;
    // Inline function 'kotlin.with' call
    var $this$with = this.l7s_1.l1(paragraphIndex);
    return $this$with.m7s_1.w7t($this$with.t7s(offset), usePrimaryDirection);
  };
  protoOf(MultiParagraph).x7t = function (offset) {
    requireIndexInRangeInclusiveEnd(this, offset);
    var tmp;
    if (offset === _get_annotatedString__kqljtk(this).a()) {
      tmp = get_lastIndex(this.l7s_1);
    } else {
      tmp = findParagraphByIndex(this.l7s_1, offset);
    }
    var paragraphIndex = tmp;
    // Inline function 'kotlin.with' call
    var $this$with = this.l7s_1.l1(paragraphIndex);
    return $this$with.m7s_1.x7t($this$with.t7s(offset));
  };
  protoOf(MultiParagraph).y7t = function (offset) {
    requireIndexInRangeInclusiveEnd(this, offset);
    var tmp;
    if (offset === _get_annotatedString__kqljtk(this).a()) {
      tmp = get_lastIndex(this.l7s_1);
    } else {
      tmp = findParagraphByIndex(this.l7s_1, offset);
    }
    var paragraphIndex = tmp;
    // Inline function 'kotlin.with' call
    var $this$with = this.l7s_1.l1(paragraphIndex);
    return $this$with.m7s_1.y7t($this$with.t7s(offset));
  };
  protoOf(MultiParagraph).z7t = function (offset) {
    requireIndexInRangeInclusiveEnd(this, offset);
    var tmp;
    if (offset === _get_annotatedString__kqljtk(this).a()) {
      tmp = get_lastIndex(this.l7s_1);
    } else {
      tmp = findParagraphByIndex(this.l7s_1, offset);
    }
    var paragraphIndex = tmp;
    // Inline function 'kotlin.with' call
    var $this$with = this.l7s_1.l1(paragraphIndex);
    return $this$with.a7u($this$with.m7s_1.z7t($this$with.t7s(offset)), false);
  };
  protoOf(MultiParagraph).c7u = function (offset) {
    requireIndexInRangeInclusiveEnd(this, offset);
    var tmp;
    if (offset === _get_annotatedString__kqljtk(this).a()) {
      tmp = get_lastIndex(this.l7s_1);
    } else {
      tmp = findParagraphByIndex(this.l7s_1, offset);
    }
    var paragraphIndex = tmp;
    // Inline function 'kotlin.with' call
    var $this$with = this.l7s_1.l1(paragraphIndex);
    return $this$with.h7t($this$with.m7s_1.c7u($this$with.t7s(offset)));
  };
  protoOf(MultiParagraph).d7u = function (offset) {
    var tmp;
    if (offset >= _get_annotatedString__kqljtk(this).a()) {
      tmp = get_lastIndex(this.l7s_1);
    } else if (offset < 0) {
      tmp = 0;
    } else {
      tmp = findParagraphByIndex(this.l7s_1, offset);
    }
    var paragraphIndex = tmp;
    // Inline function 'kotlin.with' call
    var $this$with = this.l7s_1.l1(paragraphIndex);
    return $this$with.r7t($this$with.m7s_1.d7u($this$with.t7s(offset)));
  };
  protoOf(MultiParagraph).e7u = function (lineIndex) {
    requireLineIndexInRange(this, lineIndex);
    var paragraphIndex = findParagraphByLineIndex(this.l7s_1, lineIndex);
    // Inline function 'kotlin.with' call
    var $this$with = this.l7s_1.l1(paragraphIndex);
    return $this$with.m7s_1.e7u($this$with.f7u(lineIndex));
  };
  protoOf(MultiParagraph).g7u = function (lineIndex) {
    requireLineIndexInRange(this, lineIndex);
    var paragraphIndex = findParagraphByLineIndex(this.l7s_1, lineIndex);
    // Inline function 'kotlin.with' call
    var $this$with = this.l7s_1.l1(paragraphIndex);
    return $this$with.m7s_1.g7u($this$with.f7u(lineIndex));
  };
  protoOf(MultiParagraph).h7u = function (lineIndex) {
    requireLineIndexInRange(this, lineIndex);
    var paragraphIndex = findParagraphByLineIndex(this.l7s_1, lineIndex);
    // Inline function 'kotlin.with' call
    var $this$with = this.l7s_1.l1(paragraphIndex);
    return $this$with.k7t($this$with.m7s_1.h7u($this$with.f7u(lineIndex)));
  };
  protoOf(MultiParagraph).i7u = function (lineIndex) {
    requireLineIndexInRange(this, lineIndex);
    var paragraphIndex = findParagraphByLineIndex(this.l7s_1, lineIndex);
    // Inline function 'kotlin.with' call
    var $this$with = this.l7s_1.l1(paragraphIndex);
    return $this$with.k7t($this$with.m7s_1.i7u($this$with.f7u(lineIndex)));
  };
  protoOf(MultiParagraph).j7u = function (lineIndex) {
    requireLineIndexInRange(this, lineIndex);
    var paragraphIndex = findParagraphByLineIndex(this.l7s_1, lineIndex);
    // Inline function 'kotlin.with' call
    var $this$with = this.l7s_1.l1(paragraphIndex);
    return $this$with.m7s_1.j7u($this$with.f7u(lineIndex));
  };
  protoOf(MultiParagraph).k7u = function (lineIndex) {
    requireLineIndexInRange(this, lineIndex);
    var paragraphIndex = findParagraphByLineIndex(this.l7s_1, lineIndex);
    // Inline function 'kotlin.with' call
    var $this$with = this.l7s_1.l1(paragraphIndex);
    return $this$with.u7t($this$with.m7s_1.k7u($this$with.f7u(lineIndex)));
  };
  protoOf(MultiParagraph).l7u = function (lineIndex, visibleEnd) {
    requireLineIndexInRange(this, lineIndex);
    var paragraphIndex = findParagraphByLineIndex(this.l7s_1, lineIndex);
    // Inline function 'kotlin.with' call
    var $this$with = this.l7s_1.l1(paragraphIndex);
    return $this$with.u7t($this$with.m7s_1.l7u($this$with.f7u(lineIndex), visibleEnd));
  };
  protoOf(MultiParagraph).m7u = function (lineIndex, visibleEnd, $super) {
    visibleEnd = visibleEnd === VOID ? false : visibleEnd;
    return $super === VOID ? this.l7u(lineIndex, visibleEnd) : $super.l7u.call(this, lineIndex, visibleEnd);
  };
  function ParagraphInfo(paragraph, startIndex, endIndex, startLineIndex, endLineIndex, top, bottom) {
    startLineIndex = startLineIndex === VOID ? -1 : startLineIndex;
    endLineIndex = endLineIndex === VOID ? -1 : endLineIndex;
    top = top === VOID ? -1.0 : top;
    bottom = bottom === VOID ? -1.0 : bottom;
    this.m7s_1 = paragraph;
    this.n7s_1 = startIndex;
    this.o7s_1 = endIndex;
    this.p7s_1 = startLineIndex;
    this.q7s_1 = endLineIndex;
    this.r7s_1 = top;
    this.s7s_1 = bottom;
  }
  protoOf(ParagraphInfo).a = function () {
    return this.o7s_1 - this.n7s_1 | 0;
  };
  protoOf(ParagraphInfo).t7s = function (_this__u8e3s4) {
    return coerceIn(_this__u8e3s4, this.n7s_1, this.o7s_1) - this.n7s_1 | 0;
  };
  protoOf(ParagraphInfo).u7t = function (_this__u8e3s4) {
    return _this__u8e3s4 + this.n7s_1 | 0;
  };
  protoOf(ParagraphInfo).f7u = function (_this__u8e3s4) {
    return _this__u8e3s4 - this.p7s_1 | 0;
  };
  protoOf(ParagraphInfo).r7t = function (_this__u8e3s4) {
    return _this__u8e3s4 + this.p7s_1 | 0;
  };
  protoOf(ParagraphInfo).k7t = function (_this__u8e3s4) {
    return _this__u8e3s4 + this.r7s_1;
  };
  protoOf(ParagraphInfo).q7t = function (_this__u8e3s4) {
    return _this__u8e3s4 - this.r7s_1;
  };
  protoOf(ParagraphInfo).t7t = function (_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(_this__u8e3s4);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp0 = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(_this__u8e3s4);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = floatFromBits(bits_0) - this.r7s_1;
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$9 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _Offset___init__impl__c168vi(tmp$ret$9);
  };
  protoOf(ParagraphInfo).h7t = function (_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = this.r7s_1;
    var v1 = fromInt(toRawBits(0.0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$1 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    var tmp$ret$0 = _Offset___init__impl__c168vi(tmp$ret$1);
    return _this__u8e3s4.p5d(tmp$ret$0);
  };
  protoOf(ParagraphInfo).v7s = function (_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = this.r7s_1;
    var v1 = fromInt(toRawBits(0.0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$1 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    var tmp$ret$0 = _Offset___init__impl__c168vi(tmp$ret$1);
    _this__u8e3s4.a5d(tmp$ret$0);
    return _this__u8e3s4;
  };
  protoOf(ParagraphInfo).a7u = function (_this__u8e3s4, treatZeroAsNull) {
    if (treatZeroAsNull && equals(_this__u8e3s4, Companion_getInstance_18().n7u_1)) {
      return Companion_getInstance_18().n7u_1;
    }
    return TextRange_1(this.u7t(_TextRange___get_start__impl__ww4t90(_this__u8e3s4)), this.u7t(_TextRange___get_end__impl__gcdxpp(_this__u8e3s4)));
  };
  protoOf(ParagraphInfo).toString = function () {
    return 'ParagraphInfo(paragraph=' + toString_0(this.m7s_1) + ', startIndex=' + this.n7s_1 + ', endIndex=' + this.o7s_1 + ', startLineIndex=' + this.p7s_1 + ', endLineIndex=' + this.q7s_1 + ', top=' + this.r7s_1 + ', bottom=' + this.s7s_1 + ')';
  };
  protoOf(ParagraphInfo).hashCode = function () {
    var result = hashCode(this.m7s_1);
    result = imul(result, 31) + this.n7s_1 | 0;
    result = imul(result, 31) + this.o7s_1 | 0;
    result = imul(result, 31) + this.p7s_1 | 0;
    result = imul(result, 31) + this.q7s_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.r7s_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.s7s_1) | 0;
    return result;
  };
  protoOf(ParagraphInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ParagraphInfo))
      return false;
    if (!equals(this.m7s_1, other.m7s_1))
      return false;
    if (!(this.n7s_1 === other.n7s_1))
      return false;
    if (!(this.o7s_1 === other.o7s_1))
      return false;
    if (!(this.p7s_1 === other.p7s_1))
      return false;
    if (!(this.q7s_1 === other.q7s_1))
      return false;
    if (!equals(this.r7s_1, other.r7s_1))
      return false;
    if (!equals(this.s7s_1, other.s7s_1))
      return false;
    return true;
  };
  function findParagraphsByRange(paragraphInfoList, range, action) {
    var paragraphIndex = findParagraphByIndex(paragraphInfoList, _TextRange___get_min__impl__uu95c4(range));
    var inductionVariable = paragraphIndex;
    var last = paragraphInfoList.n1();
    if (inductionVariable < last)
      $l$loop_0: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var paragraph = paragraphInfoList.l1(i);
        if (paragraph.n7s_1 >= _TextRange___get_max__impl__owm8m(range))
          break $l$loop_0;
        if (paragraph.n7s_1 === paragraph.o7s_1)
          continue $l$loop_0;
        action(paragraph);
      }
       while (inductionVariable < last);
  }
  function findParagraphByY(paragraphInfoList, y) {
    if (y <= 0)
      return 0;
    if (y >= last(paragraphInfoList).s7s_1)
      return get_lastIndex(paragraphInfoList);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.text.fastBinarySearch' call
      var low = 0;
      var high = paragraphInfoList.n1() - 1 | 0;
      while (low <= high) {
        var mid = (low + high | 0) >>> 1 | 0;
        var midVal = paragraphInfoList.l1(mid);
        var cmp = midVal.r7s_1 > y ? 1 : midVal.s7s_1 <= y ? -1 : 0;
        if (cmp < 0)
          low = mid + 1 | 0;
        else if (cmp > 0)
          high = mid - 1 | 0;
        else {
          tmp$ret$0 = mid;
          break $l$block;
        }
      }
      tmp$ret$0 = -(low + 1 | 0) | 0;
    }
    return tmp$ret$0;
  }
  function findParagraphByIndex(paragraphInfoList, index) {
    var lastLineEnd = last(paragraphInfoList).o7s_1;
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!(index <= last(paragraphInfoList).o7s_1)) {
      var tmp$ret$1 = 'Index ' + index + " should be less or equal than last line's end " + lastLineEnd;
      throwIllegalArgumentException(tmp$ret$1);
    }
    var tmp$ret$2;
    $l$block: {
      // Inline function 'androidx.compose.ui.text.fastBinarySearch' call
      var low = 0;
      var high = paragraphInfoList.n1() - 1 | 0;
      while (low <= high) {
        var mid = (low + high | 0) >>> 1 | 0;
        var midVal = paragraphInfoList.l1(mid);
        var cmp = midVal.n7s_1 > index ? 1 : midVal.o7s_1 <= index ? -1 : 0;
        if (cmp < 0)
          low = mid + 1 | 0;
        else if (cmp > 0)
          high = mid - 1 | 0;
        else {
          tmp$ret$2 = mid;
          break $l$block;
        }
      }
      tmp$ret$2 = -(low + 1 | 0) | 0;
    }
    var paragraphIndex = tmp$ret$2;
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!(0 <= paragraphIndex ? paragraphIndex <= (paragraphInfoList.n1() - 1 | 0) : false)) {
      var tmp = 'Found paragraph index ' + paragraphIndex + ' should be in range [0, ' + paragraphInfoList.n1() + ').\n';
      var tmp$ret$5 = tmp + ('Debug info: index=' + index + ', paragraphs=[' + fastJoinToString(paragraphInfoList, VOID, VOID, VOID, VOID, VOID, findParagraphByIndex$lambda) + ']');
      throwIllegalArgumentException(tmp$ret$5);
    }
    return paragraphIndex;
  }
  function findParagraphByLineIndex(paragraphInfoList, lineIndex) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.text.fastBinarySearch' call
      var low = 0;
      var high = paragraphInfoList.n1() - 1 | 0;
      while (low <= high) {
        var mid = (low + high | 0) >>> 1 | 0;
        var midVal = paragraphInfoList.l1(mid);
        var cmp = midVal.p7s_1 > lineIndex ? 1 : midVal.q7s_1 <= lineIndex ? -1 : 0;
        if (cmp < 0)
          low = mid + 1 | 0;
        else if (cmp > 0)
          high = mid - 1 | 0;
        else {
          tmp$ret$0 = mid;
          break $l$block;
        }
      }
      tmp$ret$0 = -(low + 1 | 0) | 0;
    }
    return tmp$ret$0;
  }
  function findParagraphByIndex$lambda(it) {
    return '[' + it.n7s_1 + ', ' + it.o7s_1 + ')';
  }
  var androidx_compose_ui_text_MultiParagraphIntrinsics$stable;
  var androidx_compose_ui_text_ParagraphIntrinsicInfo$stable;
  function resolveTextDirection($this, style, defaultStyle) {
    return !(style.e7r_1 === Companion_getInstance_45().u7u_1) ? style : style.o7u(VOID, defaultStyle.e7r_1);
  }
  function MultiParagraphIntrinsics$minIntrinsicWidth$delegate$lambda(this$0) {
    return function () {
      var tmp0 = this$0.d7s_1;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'androidx.compose.ui.util.fastMaxBy' call
        if (tmp0.r()) {
          tmp$ret$0 = null;
          break $l$block;
        }
        var maxElem = tmp0.l1(0);
        var maxValue = maxElem.b7t_1.c62();
        var inductionVariable = 1;
        var last = get_lastIndex(tmp0);
        if (inductionVariable <= last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var e = tmp0.l1(i);
            var v = e.b7t_1.c62();
            if (compareTo(maxValue, v) < 0) {
              maxElem = e;
              maxValue = v;
            }
          }
           while (!(i === last));
        tmp$ret$0 = maxElem;
      }
      var tmp0_safe_receiver = tmp$ret$0;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b7t_1;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.c62();
      return tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs;
    };
  }
  function MultiParagraphIntrinsics$_get_minIntrinsicWidth_$ref_bvjwng() {
    return constructCallableReference(function (p0) {
      return p0.c62();
    }, 1, 0, 31);
  }
  function MultiParagraphIntrinsics$maxIntrinsicWidth$delegate$lambda(this$0) {
    return function () {
      var tmp0 = this$0.d7s_1;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'androidx.compose.ui.util.fastMaxBy' call
        if (tmp0.r()) {
          tmp$ret$0 = null;
          break $l$block;
        }
        var maxElem = tmp0.l1(0);
        var maxValue = maxElem.b7t_1.d62();
        var inductionVariable = 1;
        var last = get_lastIndex(tmp0);
        if (inductionVariable <= last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var e = tmp0.l1(i);
            var v = e.b7t_1.d62();
            if (compareTo(maxValue, v) < 0) {
              maxElem = e;
              maxValue = v;
            }
          }
           while (!(i === last));
        tmp$ret$0 = maxElem;
      }
      var tmp0_safe_receiver = tmp$ret$0;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b7t_1;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.d62();
      return tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs;
    };
  }
  function MultiParagraphIntrinsics$_get_maxIntrinsicWidth_$ref_co14jq() {
    return constructCallableReference(function (p0) {
      return p0.d62();
    }, 1, 0, 32);
  }
  function MultiParagraphIntrinsics(annotatedString, style, placeholders, density, fontFamilyResolver) {
    this.z7r_1 = annotatedString;
    this.a7s_1 = placeholders;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_NONE_getInstance();
    tmp.b7s_1 = lazy(tmp_0, MultiParagraphIntrinsics$minIntrinsicWidth$delegate$lambda(this));
    var tmp_1 = this;
    var tmp_2 = LazyThreadSafetyMode_NONE_getInstance();
    tmp_1.c7s_1 = lazy(tmp_2, MultiParagraphIntrinsics$maxIntrinsicWidth$delegate$lambda(this));
    var paragraphStyle = style.y7u();
    var tmp_3 = this;
    // Inline function 'androidx.compose.ui.text.mapEachParagraphStyle' call
    var this_0 = this.z7r_1;
    // Inline function 'androidx.compose.ui.util.fastMap' call
    var this_1 = normalizedParagraphStyles(this_0, paragraphStyle);
    var target = ArrayList_init_$Create$_0(this_1.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = this_1.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_1.l1(index);
        var annotatedString_0 = access$substringWithoutParagraphStyles$tAnnotatedStringKt(this_0, item.n7p_1, item.o7p_1);
        var currentParagraphStyle = resolveTextDirection(this, item.m7p_1, paragraphStyle);
        var tmp1_text = annotatedString_0.h7q_1;
        var tmp2_style = style.z7u(currentParagraphStyle);
        var tmp0_elvis_lhs = annotatedString_0.g7q_1;
        var tmp3_annotations = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
        var tmp4_placeholders = getLocalPlaceholders(this.a7s_1, item.n7p_1, item.o7p_1);
        // Inline function 'kotlin.collections.plusAssign' call
        var element = new ParagraphIntrinsicInfo(ParagraphIntrinsics_0(tmp1_text, tmp2_style, tmp3_annotations, density, fontFamilyResolver, tmp4_placeholders), item.n7p_1, item.o7p_1);
        target.j1(element);
      }
       while (inductionVariable <= last);
    tmp_3.d7s_1 = target;
  }
  protoOf(MultiParagraphIntrinsics).c62 = function () {
    var tmp0 = this.b7s_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('minIntrinsicWidth', 1, tmp, MultiParagraphIntrinsics$_get_minIntrinsicWidth_$ref_bvjwng(), null);
    return tmp0.u1();
  };
  protoOf(MultiParagraphIntrinsics).d62 = function () {
    var tmp0 = this.c7s_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('maxIntrinsicWidth', 1, tmp, MultiParagraphIntrinsics$_get_maxIntrinsicWidth_$ref_co14jq(), null);
    return tmp0.u1();
  };
  protoOf(MultiParagraphIntrinsics).a7v = function () {
    var tmp0 = this.d7s_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastAny' call
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0.l1(index);
          if (item.b7t_1.a7v()) {
            tmp$ret$0 = true;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  };
  function ParagraphIntrinsicInfo(intrinsics, startIndex, endIndex) {
    this.b7t_1 = intrinsics;
    this.c7t_1 = startIndex;
    this.d7t_1 = endIndex;
  }
  protoOf(ParagraphIntrinsicInfo).toString = function () {
    return 'ParagraphIntrinsicInfo(intrinsics=' + toString_0(this.b7t_1) + ', startIndex=' + this.c7t_1 + ', endIndex=' + this.d7t_1 + ')';
  };
  protoOf(ParagraphIntrinsicInfo).hashCode = function () {
    var result = hashCode(this.b7t_1);
    result = imul(result, 31) + this.c7t_1 | 0;
    result = imul(result, 31) + this.d7t_1 | 0;
    return result;
  };
  protoOf(ParagraphIntrinsicInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ParagraphIntrinsicInfo))
      return false;
    if (!equals(this.b7t_1, other.b7t_1))
      return false;
    if (!(this.c7t_1 === other.c7t_1))
      return false;
    if (!(this.d7t_1 === other.d7t_1))
      return false;
    return true;
  };
  function getLocalPlaceholders(_this__u8e3s4, start, end) {
    // Inline function 'androidx.compose.ui.util.fastFilteredMap' call
    var target = ArrayList_init_$Create$_0(_this__u8e3s4.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = _this__u8e3s4.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = _this__u8e3s4.l1(index);
        if (intersect(start, end, item.n7p_1, item.o7p_1)) {
          // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
          if (!(start <= item.n7p_1 && item.o7p_1 <= end)) {
            var tmp$ret$6 = 'placeholder can not overlap with paragraph.';
            throwIllegalArgumentException(tmp$ret$6);
          }
          // Inline function 'kotlin.collections.plusAssign' call
          var element = Range_init_$Create$(item.m7p_1, item.n7p_1 - start | 0, item.o7p_1 - start | 0);
          target.j1(element);
        }
      }
       while (inductionVariable <= last);
    return target;
  }
  function Paragraph(text, style, constraints, density, fontFamilyResolver, spanStyles, placeholders, maxLines, overflow) {
    var tmp;
    if (spanStyles === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp = emptyList();
    } else {
      tmp = spanStyles;
    }
    spanStyles = tmp;
    var tmp_0;
    if (placeholders === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp_0 = emptyList();
    } else {
      tmp_0 = placeholders;
    }
    placeholders = tmp_0;
    maxLines = maxLines === VOID ? 2147483647 : maxLines;
    overflow = overflow === VOID ? Companion_getInstance_49().w7s_1 : overflow;
    return ActualParagraph(text, style, spanStyles, placeholders, maxLines, overflow, constraints, density, fontFamilyResolver);
  }
  function Paragraph_0(paragraphIntrinsics, constraints, maxLines, overflow) {
    maxLines = maxLines === VOID ? 2147483647 : maxLines;
    overflow = overflow === VOID ? Companion_getInstance_49().w7s_1 : overflow;
    return ActualParagraph_0(paragraphIntrinsics, maxLines, overflow, constraints);
  }
  function ceilToInt(_this__u8e3s4) {
    // Inline function 'kotlin.math.ceil' call
    var tmp$ret$0 = Math.ceil(_this__u8e3s4);
    return numberToInt(tmp$ret$0);
  }
  function ParagraphIntrinsics() {
  }
  function ParagraphIntrinsics_0(text, style, annotations, density, fontFamilyResolver, placeholders) {
    var tmp;
    if (placeholders === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp = emptyList();
    } else {
      tmp = placeholders;
    }
    placeholders = tmp;
    return ActualParagraphIntrinsics(text, style, annotations, placeholders, density, fontFamilyResolver);
  }
  function get_DefaultLineHeight() {
    _init_properties_ParagraphStyle_kt__lbx7er();
    return DefaultLineHeight;
  }
  var DefaultLineHeight;
  var androidx_compose_ui_text_ParagraphStyle$stable;
  function ParagraphStyle_0(textAlign, textDirection, lineHeight, textIndent, platformStyle, lineHeightStyle, lineBreak, hyphens, textMotion) {
    textAlign = textAlign === VOID ? Companion_getInstance_43().h7v_1 : textAlign;
    textDirection = textDirection === VOID ? Companion_getInstance_45().u7u_1 : textDirection;
    lineHeight = lineHeight === VOID ? Companion_getInstance_1().q5g_1 : lineHeight;
    textIndent = textIndent === VOID ? null : textIndent;
    platformStyle = platformStyle === VOID ? null : platformStyle;
    lineHeightStyle = lineHeightStyle === VOID ? null : lineHeightStyle;
    lineBreak = lineBreak === VOID ? Companion_getInstance_55().l7v_1 : lineBreak;
    hyphens = hyphens === VOID ? Companion_getInstance_38().o7v_1 : hyphens;
    textMotion = textMotion === VOID ? null : textMotion;
    this.d7r_1 = textAlign;
    this.e7r_1 = textDirection;
    this.f7r_1 = lineHeight;
    this.g7r_1 = textIndent;
    this.h7r_1 = platformStyle;
    this.i7r_1 = lineHeightStyle;
    this.j7r_1 = lineBreak;
    this.k7r_1 = hyphens;
    this.l7r_1 = textMotion;
    if (!equals(this.f7r_1, Companion_getInstance_1().q5g_1)) {
      // Inline function 'androidx.compose.ui.text.internal.checkPrecondition' call
      if (!(_TextUnit___get_value__impl__hpbx0k(this.f7r_1) >= 0.0)) {
        var tmp$ret$1 = "lineHeight can't be negative (" + _TextUnit___get_value__impl__hpbx0k(this.f7r_1) + ')';
        throwIllegalStateException(tmp$ret$1);
      }
    }
  }
  protoOf(ParagraphStyle_0).m7r = function (other) {
    if (other == null)
      return this;
    return fastMerge(this, other.d7r_1, other.e7r_1, other.f7r_1, other.g7r_1, other.h7r_1, other.i7r_1, other.j7r_1, other.k7r_1, other.l7r_1);
  };
  protoOf(ParagraphStyle_0).p7v = function (textAlign, textDirection, lineHeight, textIndent, platformStyle, lineHeightStyle, lineBreak, hyphens, textMotion) {
    return new ParagraphStyle_0(textAlign, textDirection, lineHeight, textIndent, platformStyle, lineHeightStyle, lineBreak, hyphens, textMotion);
  };
  protoOf(ParagraphStyle_0).o7u = function (textAlign, textDirection, lineHeight, textIndent, platformStyle, lineHeightStyle, lineBreak, hyphens, textMotion, $super) {
    textAlign = textAlign === VOID ? this.d7r_1 : textAlign;
    textDirection = textDirection === VOID ? this.e7r_1 : textDirection;
    lineHeight = lineHeight === VOID ? this.f7r_1 : lineHeight;
    textIndent = textIndent === VOID ? this.g7r_1 : textIndent;
    platformStyle = platformStyle === VOID ? this.h7r_1 : platformStyle;
    lineHeightStyle = lineHeightStyle === VOID ? this.i7r_1 : lineHeightStyle;
    lineBreak = lineBreak === VOID ? this.j7r_1 : lineBreak;
    hyphens = hyphens === VOID ? this.k7r_1 : hyphens;
    textMotion = textMotion === VOID ? this.l7r_1 : textMotion;
    return $super === VOID ? this.p7v(textAlign, textDirection, lineHeight, textIndent, platformStyle, lineHeightStyle, lineBreak, hyphens, textMotion) : $super.p7v.call(this, new TextAlign(textAlign), new TextDirection(textDirection), new TextUnit(lineHeight), textIndent, platformStyle, lineHeightStyle, new LineBreak(lineBreak), new Hyphens(hyphens), textMotion);
  };
  protoOf(ParagraphStyle_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ParagraphStyle_0))
      return false;
    if (!(this.d7r_1 === other.d7r_1))
      return false;
    if (!(this.e7r_1 === other.e7r_1))
      return false;
    if (!equals(this.f7r_1, other.f7r_1))
      return false;
    if (!equals(this.g7r_1, other.g7r_1))
      return false;
    if (!equals(this.h7r_1, other.h7r_1))
      return false;
    if (!equals(this.i7r_1, other.i7r_1))
      return false;
    if (!(this.j7r_1 === other.j7r_1))
      return false;
    if (!(this.k7r_1 === other.k7r_1))
      return false;
    if (!equals(this.l7r_1, other.l7r_1))
      return false;
    return true;
  };
  protoOf(ParagraphStyle_0).hashCode = function () {
    var result = TextAlign__hashCode_impl_s8g35y(this.d7r_1);
    result = imul(31, result) + TextDirection__hashCode_impl_g63nwg(this.e7r_1) | 0;
    result = imul(31, result) + TextUnit__hashCode_impl_qsmeov(this.f7r_1) | 0;
    var tmp = imul(31, result);
    var tmp0_safe_receiver = this.g7r_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hashCode();
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    var tmp_0 = imul(31, result);
    var tmp2_safe_receiver = this.h7r_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.hashCode();
    result = tmp_0 + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    var tmp_1 = imul(31, result);
    var tmp4_safe_receiver = this.i7r_1;
    var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.hashCode();
    result = tmp_1 + (tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs) | 0;
    result = imul(31, result) + LineBreak__hashCode_impl_ybksn(this.j7r_1) | 0;
    result = imul(31, result) + Hyphens__hashCode_impl_yb7t8v(this.k7r_1) | 0;
    var tmp_2 = imul(31, result);
    var tmp6_safe_receiver = this.l7r_1;
    var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : hashCode(tmp6_safe_receiver);
    result = tmp_2 + (tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs) | 0;
    return result;
  };
  protoOf(ParagraphStyle_0).toString = function () {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_0();
    this_0.q('ParagraphStyle(');
    this_0.q('textAlign=' + TextAlign__toString_impl_6ha6d3(this.d7r_1) + ', ');
    this_0.q('textDirection=' + TextDirection__toString_impl_x3uh9t(this.e7r_1) + ', ');
    this_0.q('lineHeight=' + TextUnit__toString_impl_51ghw0(this.f7r_1) + ', ');
    this_0.q('textIndent=' + toString(this.g7r_1) + ', ');
    this_0.q('platformStyle=' + toString(this.h7r_1) + ', ');
    this_0.q('lineHeightStyle=' + toString(this.i7r_1) + ', ');
    this_0.q('lineBreak=' + LineBreak__toString_impl_mphhli(this.j7r_1) + ', ');
    this_0.q('hyphens=' + Hyphens__toString_impl_ck1wg0(this.k7r_1) + ', ');
    this_0.q('textMotion=' + toString(this.l7r_1));
    this_0.q(')');
    return this_0.toString();
  };
  function fastMerge(_this__u8e3s4, textAlign, textDirection, lineHeight, textIndent, platformStyle, lineHeightStyle, lineBreak, hyphens, textMotion) {
    _init_properties_ParagraphStyle_kt__lbx7er();
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    var tmp_3;
    var tmp_4;
    var tmp_5;
    var tmp_6;
    if (!(textAlign === Companion_getInstance_43().h7v_1) && !(textAlign === _this__u8e3s4.d7r_1)) {
      tmp_6 = true;
    } else {
      var tmp_7;
      // Inline function 'androidx.compose.ui.unit.isSpecified' call
      // Inline function 'androidx.compose.ui.unit.isUnspecified' call
      if (!equalsLong(_TextUnit___get_rawType__impl__tu8yq5(lineHeight), new Long(0, 0))) {
        tmp_7 = !equals(lineHeight, _this__u8e3s4.f7r_1);
      } else {
        tmp_7 = false;
      }
      tmp_6 = tmp_7;
    }
    if (tmp_6) {
      tmp_5 = true;
    } else {
      tmp_5 = (!(textIndent == null) && !equals(textIndent, _this__u8e3s4.g7r_1));
    }
    if (tmp_5) {
      tmp_4 = true;
    } else {
      tmp_4 = (!(textDirection === Companion_getInstance_45().u7u_1) && !(textDirection === _this__u8e3s4.e7r_1));
    }
    if (tmp_4) {
      tmp_3 = true;
    } else {
      tmp_3 = (!(platformStyle == null) && !equals(platformStyle, _this__u8e3s4.h7r_1));
    }
    if (tmp_3) {
      tmp_2 = true;
    } else {
      tmp_2 = (!(lineHeightStyle == null) && !equals(lineHeightStyle, _this__u8e3s4.i7r_1));
    }
    if (tmp_2) {
      tmp_1 = true;
    } else {
      tmp_1 = (!(lineBreak === Companion_getInstance_55().l7v_1) && !(lineBreak === _this__u8e3s4.j7r_1));
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      tmp_0 = (!(hyphens === Companion_getInstance_38().o7v_1) && !(hyphens === _this__u8e3s4.k7r_1));
    }
    if (tmp_0) {
      tmp = true;
    } else {
      tmp = (!(textMotion == null) && !equals(textMotion, _this__u8e3s4.l7r_1));
    }
    var requiresAlloc = tmp;
    if (!requiresAlloc) {
      return _this__u8e3s4;
    }
    var tmp_8;
    // Inline function 'androidx.compose.ui.unit.isUnspecified' call
    if (equalsLong(_TextUnit___get_rawType__impl__tu8yq5(lineHeight), new Long(0, 0))) {
      tmp_8 = _this__u8e3s4.f7r_1;
    } else {
      tmp_8 = lineHeight;
    }
    var tmp3_lineHeight = tmp_8;
    var tmp4_textIndent = textIndent == null ? _this__u8e3s4.g7r_1 : textIndent;
    var tmp5_textAlign = !(textAlign === Companion_getInstance_43().h7v_1) ? textAlign : _this__u8e3s4.d7r_1;
    var tmp6_textDirection = !(textDirection === Companion_getInstance_45().u7u_1) ? textDirection : _this__u8e3s4.e7r_1;
    var tmp7_platformStyle = mergePlatformStyle(_this__u8e3s4, platformStyle);
    var tmp8_lineHeightStyle = lineHeightStyle == null ? _this__u8e3s4.i7r_1 : lineHeightStyle;
    var tmp9_lineBreak = !(lineBreak === Companion_getInstance_55().l7v_1) ? lineBreak : _this__u8e3s4.j7r_1;
    var tmp10_hyphens = !(hyphens === Companion_getInstance_38().o7v_1) ? hyphens : _this__u8e3s4.k7r_1;
    var tmp11_textMotion = textMotion == null ? _this__u8e3s4.l7r_1 : textMotion;
    return new ParagraphStyle_0(tmp5_textAlign, tmp6_textDirection, tmp3_lineHeight, tmp4_textIndent, tmp7_platformStyle, tmp8_lineHeightStyle, tmp9_lineBreak, tmp10_hyphens, tmp11_textMotion);
  }
  function mergePlatformStyle(_this__u8e3s4, other) {
    _init_properties_ParagraphStyle_kt__lbx7er();
    if (_this__u8e3s4.h7r_1 == null)
      return other;
    if (other == null)
      return _this__u8e3s4.h7r_1;
    return _this__u8e3s4.h7r_1.r7v(other);
  }
  function lerp_4(start, stop, fraction) {
    _init_properties_ParagraphStyle_kt__lbx7er();
    var tmp = lerpDiscrete(new TextAlign(start.d7r_1), new TextAlign(stop.d7r_1), fraction);
    var tmp_0 = lerpDiscrete(new TextDirection(start.e7r_1), new TextDirection(stop.e7r_1), fraction);
    var tmp_1 = lerpTextUnitInheritable(start.f7r_1, stop.f7r_1, fraction);
    var tmp0_elvis_lhs = start.g7r_1;
    var tmp_2 = tmp0_elvis_lhs == null ? Companion_getInstance_48().s7v_1 : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = stop.g7r_1;
    return new ParagraphStyle_0(tmp.t7v_1, tmp_0.u7v_1, tmp_1, lerp_11(tmp_2, tmp1_elvis_lhs == null ? Companion_getInstance_48().s7v_1 : tmp1_elvis_lhs, fraction), lerpPlatformStyle(start.h7r_1, stop.h7r_1, fraction), lerpDiscrete(start.i7r_1, stop.i7r_1, fraction), lerpDiscrete(new LineBreak(start.j7r_1), new LineBreak(stop.j7r_1), fraction).v7v_1, lerpDiscrete(new Hyphens(start.k7r_1), new Hyphens(stop.k7r_1), fraction).w7v_1, lerpDiscrete(start.l7r_1, stop.l7r_1, fraction));
  }
  function resolveParagraphStyleDefaults(style, direction) {
    _init_properties_ParagraphStyle_kt__lbx7er();
    var tmp = style.d7r_1 === Companion_getInstance_43().h7v_1 ? Companion_getInstance_43().f7v_1 : style.d7r_1;
    var tmp_0 = resolveTextDirection_0(direction, style.e7r_1);
    var tmp_1;
    // Inline function 'androidx.compose.ui.unit.isUnspecified' call
    var this_0 = style.f7r_1;
    if (equalsLong(_TextUnit___get_rawType__impl__tu8yq5(this_0), new Long(0, 0))) {
      tmp_1 = get_DefaultLineHeight();
    } else {
      tmp_1 = style.f7r_1;
    }
    var tmp_2 = tmp_1;
    var tmp0_elvis_lhs = style.g7r_1;
    var tmp_3 = tmp0_elvis_lhs == null ? Companion_getInstance_48().s7v_1 : tmp0_elvis_lhs;
    var tmp_4 = style.j7r_1 === Companion_getInstance_55().l7v_1 ? Companion_getInstance_55().i7v_1 : style.j7r_1;
    var tmp_5 = style.k7r_1 === Companion_getInstance_38().o7v_1 ? Companion_getInstance_38().m7v_1 : style.k7r_1;
    var tmp1_elvis_lhs = style.l7r_1;
    return new ParagraphStyle_0(tmp, tmp_0, tmp_2, tmp_3, style.h7r_1, style.i7r_1, tmp_4, tmp_5, tmp1_elvis_lhs == null ? Companion_getInstance_56().x7v_1 : tmp1_elvis_lhs);
  }
  function lerpPlatformStyle(start, stop, fraction) {
    _init_properties_ParagraphStyle_kt__lbx7er();
    if (start == null && stop == null)
      return null;
    var startNonNull = start == null ? Companion_getInstance_53().z7v_1 : start;
    var stopNonNull = stop == null ? Companion_getInstance_53().z7v_1 : stop;
    return lerp_12(startNonNull, stopNonNull, fraction);
  }
  var properties_initialized_ParagraphStyle_kt_y6w405;
  function _init_properties_ParagraphStyle_kt__lbx7er() {
    if (!properties_initialized_ParagraphStyle_kt_y6w405) {
      properties_initialized_ParagraphStyle_kt_y6w405 = true;
      DefaultLineHeight = Companion_getInstance_1().q5g_1;
      androidx_compose_ui_text_ParagraphStyle$stable = 0;
    }
  }
  var androidx_compose_ui_text_Placeholder$stable;
  function Placeholder() {
  }
  protoOf(Placeholder).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Placeholder))
      return false;
    if (!equals(this.a7w_1, other.a7w_1))
      return false;
    if (!equals(this.b7w_1, other.b7w_1))
      return false;
    if (!(this.c7w_1 === other.c7w_1))
      return false;
    return true;
  };
  protoOf(Placeholder).hashCode = function () {
    var result = TextUnit__hashCode_impl_qsmeov(this.a7w_1);
    result = imul(31, result) + TextUnit__hashCode_impl_qsmeov(this.b7w_1) | 0;
    result = imul(31, result) + PlaceholderVerticalAlign__hashCode_impl_1c0k16(this.c7w_1) | 0;
    return result;
  };
  protoOf(Placeholder).toString = function () {
    return 'Placeholder(' + ('width=' + TextUnit__toString_impl_51ghw0(this.a7w_1) + ', ') + ('height=' + TextUnit__toString_impl_51ghw0(this.b7w_1) + ', ') + ('placeholderVerticalAlign=' + PlaceholderVerticalAlign__toString_impl_kf5crp(this.c7w_1)) + ')';
  };
  function _PlaceholderVerticalAlign___init__impl__mll0or(value) {
    return value;
  }
  function PlaceholderVerticalAlign__toString_impl_kf5crp($this) {
    return $this === Companion_getInstance_16().d7w_1 ? 'AboveBaseline' : $this === Companion_getInstance_16().e7w_1 ? 'Top' : $this === Companion_getInstance_16().f7w_1 ? 'Bottom' : $this === Companion_getInstance_16().g7w_1 ? 'Center' : $this === Companion_getInstance_16().h7w_1 ? 'TextTop' : $this === Companion_getInstance_16().i7w_1 ? 'TextBottom' : $this === Companion_getInstance_16().j7w_1 ? 'TextCenter' : 'Invalid';
  }
  function Companion_1() {
    Companion_instance_3 = this;
    this.d7w_1 = _PlaceholderVerticalAlign___init__impl__mll0or(1);
    this.e7w_1 = _PlaceholderVerticalAlign___init__impl__mll0or(2);
    this.f7w_1 = _PlaceholderVerticalAlign___init__impl__mll0or(3);
    this.g7w_1 = _PlaceholderVerticalAlign___init__impl__mll0or(4);
    this.h7w_1 = _PlaceholderVerticalAlign___init__impl__mll0or(5);
    this.i7w_1 = _PlaceholderVerticalAlign___init__impl__mll0or(6);
    this.j7w_1 = _PlaceholderVerticalAlign___init__impl__mll0or(7);
  }
  var Companion_instance_3;
  function Companion_getInstance_16() {
    if (Companion_instance_3 == null)
      new Companion_1();
    return Companion_instance_3;
  }
  function PlaceholderVerticalAlign__hashCode_impl_1c0k16($this) {
    return $this;
  }
  function get_AnnotatedStringSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return AnnotatedStringSaver;
  }
  var AnnotatedStringSaver;
  function get_AnnotationRangeListSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return AnnotationRangeListSaver;
  }
  var AnnotationRangeListSaver;
  function get_AnnotationRangeSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return AnnotationRangeSaver;
  }
  var AnnotationRangeSaver;
  function get_VerbatimTtsAnnotationSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return VerbatimTtsAnnotationSaver;
  }
  var VerbatimTtsAnnotationSaver;
  function get_UrlAnnotationSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return UrlAnnotationSaver;
  }
  var UrlAnnotationSaver;
  function get_LinkSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return LinkSaver;
  }
  var LinkSaver;
  function get_ClickableSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return ClickableSaver;
  }
  var ClickableSaver;
  function get_ParagraphStyleSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return ParagraphStyleSaver;
  }
  var ParagraphStyleSaver;
  function get_SpanStyleSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return SpanStyleSaver;
  }
  var SpanStyleSaver;
  function get_TextLinkStylesSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return TextLinkStylesSaver;
  }
  var TextLinkStylesSaver;
  function get_TextDecorationSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return TextDecorationSaver;
  }
  var TextDecorationSaver;
  function get_TextGeometricTransformSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return TextGeometricTransformSaver;
  }
  var TextGeometricTransformSaver;
  function get_TextIndentSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return TextIndentSaver;
  }
  var TextIndentSaver;
  function get_FontWeightSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return FontWeightSaver;
  }
  var FontWeightSaver;
  function get_BaselineShiftSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return BaselineShiftSaver;
  }
  var BaselineShiftSaver;
  function get_TextRangeSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return TextRangeSaver;
  }
  var TextRangeSaver;
  function get_ShadowSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return ShadowSaver;
  }
  var ShadowSaver;
  function get_ColorSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return ColorSaver;
  }
  var ColorSaver;
  function get_TextAlignSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return TextAlignSaver;
  }
  var TextAlignSaver;
  function get_TextDirectionSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return TextDirectionSaver;
  }
  var TextDirectionSaver;
  function get_HyphensSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return HyphensSaver;
  }
  var HyphensSaver;
  function get_FontStyleSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return FontStyleSaver;
  }
  var FontStyleSaver;
  function get_FontSynthesisSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return FontSynthesisSaver;
  }
  var FontSynthesisSaver;
  function get_TextUnitSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return TextUnitSaver;
  }
  var TextUnitSaver;
  function get_TextUnitTypeSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return TextUnitTypeSaver;
  }
  var TextUnitTypeSaver;
  function get_OffsetSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return OffsetSaver;
  }
  var OffsetSaver;
  function get_LocaleListSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return LocaleListSaver;
  }
  var LocaleListSaver;
  function get_LocaleSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return LocaleSaver;
  }
  var LocaleSaver;
  function get_LineHeightStyleSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return LineHeightStyleSaver;
  }
  var LineHeightStyleSaver;
  function get_LineHeightStyleAlignmentSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return LineHeightStyleAlignmentSaver;
  }
  var LineHeightStyleAlignmentSaver;
  function get_LineHeightStyleTrimSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return LineHeightStyleTrimSaver;
  }
  var LineHeightStyleTrimSaver;
  function get_LineHeightStyleModeSaver() {
    _init_properties_Savers_kt__o6r3ry();
    return LineHeightStyleModeSaver;
  }
  var LineHeightStyleModeSaver;
  function save(value) {
    _init_properties_Savers_kt__o6r3ry();
    return value;
  }
  function save_0(value, saver, scope) {
    _init_properties_Savers_kt__o6r3ry();
    var tmp;
    if (value == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.with' call
      tmp = saver.l7o(scope, value);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  var AnnotationType_Paragraph_instance;
  var AnnotationType_Span_instance;
  var AnnotationType_VerbatimTts_instance;
  var AnnotationType_Url_instance;
  var AnnotationType_Link_instance;
  var AnnotationType_Clickable_instance;
  var AnnotationType_String_instance;
  var AnnotationType_entriesInitialized;
  function AnnotationType_initEntries() {
    if (AnnotationType_entriesInitialized)
      return Unit_instance;
    AnnotationType_entriesInitialized = true;
    AnnotationType_Paragraph_instance = new AnnotationType('Paragraph', 0);
    AnnotationType_Span_instance = new AnnotationType('Span', 1);
    AnnotationType_VerbatimTts_instance = new AnnotationType('VerbatimTts', 2);
    AnnotationType_Url_instance = new AnnotationType('Url', 3);
    AnnotationType_Link_instance = new AnnotationType('Link', 4);
    AnnotationType_Clickable_instance = new AnnotationType('Clickable', 5);
    AnnotationType_String_instance = new AnnotationType('String', 6);
  }
  function AnnotationType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function get_Saver(_this__u8e3s4) {
    _init_properties_Savers_kt__o6r3ry();
    return get_TextAlignSaver();
  }
  function get_Saver_0(_this__u8e3s4) {
    _init_properties_Savers_kt__o6r3ry();
    return get_TextDirectionSaver();
  }
  function get_Saver_1(_this__u8e3s4) {
    _init_properties_Savers_kt__o6r3ry();
    return get_TextUnitSaver();
  }
  function get_Saver_2(_this__u8e3s4) {
    _init_properties_Savers_kt__o6r3ry();
    return get_TextIndentSaver();
  }
  function get_Saver_3(_this__u8e3s4) {
    _init_properties_Savers_kt__o6r3ry();
    return get_LineHeightStyleSaver();
  }
  function get_Saver_4(_this__u8e3s4) {
    _init_properties_Savers_kt__o6r3ry();
    return get_HyphensSaver();
  }
  function get_Saver_5(_this__u8e3s4) {
    _init_properties_Savers_kt__o6r3ry();
    return get_ColorSaver();
  }
  function get_Saver_6(_this__u8e3s4) {
    _init_properties_Savers_kt__o6r3ry();
    return get_FontWeightSaver();
  }
  function get_Saver_7(_this__u8e3s4) {
    _init_properties_Savers_kt__o6r3ry();
    return get_FontStyleSaver();
  }
  function get_Saver_8(_this__u8e3s4) {
    _init_properties_Savers_kt__o6r3ry();
    return get_FontSynthesisSaver();
  }
  function get_Saver_9(_this__u8e3s4) {
    _init_properties_Savers_kt__o6r3ry();
    return get_BaselineShiftSaver();
  }
  function get_Saver_10(_this__u8e3s4) {
    _init_properties_Savers_kt__o6r3ry();
    return get_TextGeometricTransformSaver();
  }
  function get_Saver_11(_this__u8e3s4) {
    _init_properties_Savers_kt__o6r3ry();
    return get_LocaleListSaver();
  }
  function get_Saver_12(_this__u8e3s4) {
    _init_properties_Savers_kt__o6r3ry();
    return get_TextDecorationSaver();
  }
  function get_Saver_13(_this__u8e3s4) {
    _init_properties_Savers_kt__o6r3ry();
    return get_ShadowSaver();
  }
  function get_Saver_14(_this__u8e3s4) {
    _init_properties_Savers_kt__o6r3ry();
    return get_OffsetSaver();
  }
  function NonNullValueClassSaver() {
  }
  function NonNullValueClassSaver_0(save, restore) {
    _init_properties_Savers_kt__o6r3ry();
    return new NonNullValueClassSaver$1(save, restore);
  }
  function get_Saver_15(_this__u8e3s4) {
    _init_properties_Savers_kt__o6r3ry();
    return get_TextUnitTypeSaver();
  }
  function get_Saver_16(_this__u8e3s4) {
    _init_properties_Savers_kt__o6r3ry();
    return get_LocaleSaver();
  }
  function get_Saver_17(_this__u8e3s4) {
    _init_properties_Savers_kt__o6r3ry();
    return get_LineHeightStyleAlignmentSaver();
  }
  function get_Saver_18(_this__u8e3s4) {
    _init_properties_Savers_kt__o6r3ry();
    return get_LineHeightStyleTrimSaver();
  }
  function get_Saver_19(_this__u8e3s4) {
    _init_properties_Savers_kt__o6r3ry();
    return get_LineHeightStyleModeSaver();
  }
  function get_Saver_20(_this__u8e3s4) {
    _init_properties_Savers_kt__o6r3ry();
    return get_TextRangeSaver();
  }
  function AnnotatedStringSaver$lambda($this$Saver, it) {
    _init_properties_Savers_kt__o6r3ry();
    return arrayListOf([save(it.h7q_1), save_0(it.g7q_1, get_AnnotationRangeListSaver(), $this$Saver)]);
  }
  function AnnotatedStringSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    var list = isInterface(it, KtList) ? it : THROW_CCE();
    var tmp0 = list.l1(1);
    var tmp2 = get_AnnotationRangeListSaver();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp;
      if (equals(tmp0, false)) {
        tmp = !isInterface(tmp2, NonNullValueClassSaver);
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = null;
        break $l$block;
      }
      var tmp_0;
      if (tmp0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_1 = tmp2.b7o(tmp0);
        tmp_0 = (tmp_1 == null ? true : isInterface(tmp_1, KtList)) ? tmp_1 : THROW_CCE();
      }
      tmp$ret$0 = tmp_0;
    }
    var annotationsOrNull = tmp$ret$0;
    // Inline function 'androidx.compose.ui.text.restore' call
    var tmp0_safe_receiver = list.l1(0);
    var tmp_2;
    if (tmp0_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_2 = typeof tmp0_safe_receiver === 'string' ? tmp0_safe_receiver : THROW_CCE();
    }
    var tmp$ret$5 = tmp_2;
    var tmp0_text = ensureNotNull(tmp$ret$5);
    return new AnnotatedString(annotationsOrNull, tmp0_text);
  }
  function AnnotationRangeListSaver$lambda($this$Saver, it) {
    _init_properties_Savers_kt__o6r3ry();
    // Inline function 'androidx.compose.ui.util.fastMap' call
    var target = ArrayList_init_$Create$_0(it.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = it.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = it.l1(index);
        // Inline function 'kotlin.collections.plusAssign' call
        var element = save_0(item, get_AnnotationRangeSaver(), $this$Saver);
        target.j1(element);
      }
       while (inductionVariable <= last);
    return target;
  }
  function AnnotationRangeListSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    var list = isInterface(it, KtList) ? it : THROW_CCE();
    // Inline function 'androidx.compose.ui.util.fastMap' call
    var target = ArrayList_init_$Create$_0(list.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = list.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = list.l1(index);
        var tmp2 = get_AnnotationRangeSaver();
        var tmp$ret$4;
        $l$block: {
          // Inline function 'androidx.compose.ui.text.restore' call
          var tmp;
          if (equals(item, false)) {
            tmp = !isInterface(tmp2, NonNullValueClassSaver);
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$4 = null;
            break $l$block;
          }
          var tmp_0;
          if (item == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.with' call
            var tmp_1 = tmp2.b7o(item);
            tmp_0 = (tmp_1 == null ? true : tmp_1 instanceof Range) ? tmp_1 : THROW_CCE();
          }
          tmp$ret$4 = tmp_0;
        }
        var range = ensureNotNull(tmp$ret$4);
        // Inline function 'kotlin.collections.plusAssign' call
        target.j1(range);
      }
       while (inductionVariable <= last);
    return target;
  }
  function AnnotationRangeSaver$lambda($this$Saver, it) {
    _init_properties_Savers_kt__o6r3ry();
    var tmp0_subject = it.m7p_1;
    var tmp;
    if (tmp0_subject instanceof ParagraphStyle_0) {
      tmp = AnnotationType_Paragraph_getInstance();
    } else {
      if (tmp0_subject instanceof SpanStyle) {
        tmp = AnnotationType_Span_getInstance();
      } else {
        if (tmp0_subject instanceof VerbatimTtsAnnotation) {
          tmp = AnnotationType_VerbatimTts_getInstance();
        } else {
          if (tmp0_subject instanceof UrlAnnotation) {
            tmp = AnnotationType_Url_getInstance();
          } else {
            if (tmp0_subject instanceof Url) {
              tmp = AnnotationType_Link_getInstance();
            } else {
              if (tmp0_subject instanceof Clickable) {
                tmp = AnnotationType_Clickable_getInstance();
              } else {
                if (tmp0_subject instanceof StringAnnotation) {
                  tmp = AnnotationType_String_getInstance();
                } else {
                  throw UnsupportedOperationException_init_$Create$();
                }
              }
            }
          }
        }
      }
    }
    var marker = tmp;
    var tmp_0;
    switch (marker.a1_1) {
      case 0:
        var tmp_1 = it.m7p_1;
        tmp_0 = save_0(tmp_1 instanceof ParagraphStyle_0 ? tmp_1 : THROW_CCE(), get_ParagraphStyleSaver(), $this$Saver);
        break;
      case 1:
        var tmp_2 = it.m7p_1;
        tmp_0 = save_0(tmp_2 instanceof SpanStyle ? tmp_2 : THROW_CCE(), get_SpanStyleSaver(), $this$Saver);
        break;
      case 2:
        var tmp_3 = it.m7p_1;
        tmp_0 = save_0(tmp_3 instanceof VerbatimTtsAnnotation ? tmp_3 : THROW_CCE(), get_VerbatimTtsAnnotationSaver(), $this$Saver);
        break;
      case 3:
        var tmp_4 = it.m7p_1;
        tmp_0 = save_0(tmp_4 instanceof UrlAnnotation ? tmp_4 : THROW_CCE(), get_UrlAnnotationSaver(), $this$Saver);
        break;
      case 4:
        var tmp_5 = it.m7p_1;
        tmp_0 = save_0(tmp_5 instanceof Url ? tmp_5 : THROW_CCE(), get_LinkSaver(), $this$Saver);
        break;
      case 5:
        var tmp_6 = it.m7p_1;
        tmp_0 = save_0(tmp_6 instanceof Clickable ? tmp_6 : THROW_CCE(), get_ClickableSaver(), $this$Saver);
        break;
      case 6:
        var tmp_7 = it.m7p_1;
        tmp_0 = save(_StringAnnotation___get_value__impl__v4s4ej(tmp_7 instanceof StringAnnotation ? tmp_7.k7w_1 : THROW_CCE()));
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var item = tmp_0;
    return arrayListOf([save(marker), item, save(it.n7p_1), save(it.o7p_1), save(it.p7p_1)]);
  }
  function AnnotationRangeSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    var list = isInterface(it, KtList) ? it : THROW_CCE();
    // Inline function 'androidx.compose.ui.text.restore' call
    var tmp0_safe_receiver = list.l1(0);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = tmp0_safe_receiver instanceof AnnotationType ? tmp0_safe_receiver : THROW_CCE();
    }
    var tmp$ret$0 = tmp;
    var marker = ensureNotNull(tmp$ret$0);
    // Inline function 'androidx.compose.ui.text.restore' call
    var tmp0_safe_receiver_0 = list.l1(2);
    var tmp_0;
    if (tmp0_safe_receiver_0 == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = typeof tmp0_safe_receiver_0 === 'number' ? tmp0_safe_receiver_0 : THROW_CCE();
    }
    var tmp$ret$3 = tmp_0;
    var start = ensureNotNull(tmp$ret$3);
    // Inline function 'androidx.compose.ui.text.restore' call
    var tmp0_safe_receiver_1 = list.l1(3);
    var tmp_1;
    if (tmp0_safe_receiver_1 == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_1 = typeof tmp0_safe_receiver_1 === 'number' ? tmp0_safe_receiver_1 : THROW_CCE();
    }
    var tmp$ret$6 = tmp_1;
    var end = ensureNotNull(tmp$ret$6);
    // Inline function 'androidx.compose.ui.text.restore' call
    var tmp0_safe_receiver_2 = list.l1(4);
    var tmp_2;
    if (tmp0_safe_receiver_2 == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_2 = typeof tmp0_safe_receiver_2 === 'string' ? tmp0_safe_receiver_2 : THROW_CCE();
    }
    var tmp$ret$9 = tmp_2;
    var tag = ensureNotNull(tmp$ret$9);
    var tmp_3;
    switch (marker.a1_1) {
      case 0:
        var tmp0 = list.l1(1);
        var tmp2 = get_ParagraphStyleSaver();
        var tmp$ret$12;
        $l$block: {
          // Inline function 'androidx.compose.ui.text.restore' call
          var tmp_4;
          if (equals(tmp0, false)) {
            tmp_4 = !isInterface(tmp2, NonNullValueClassSaver);
          } else {
            tmp_4 = false;
          }
          if (tmp_4) {
            tmp$ret$12 = null;
            break $l$block;
          }
          var tmp_5;
          if (tmp0 == null) {
            tmp_5 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.with' call
            var tmp_6 = tmp2.b7o(tmp0);
            tmp_5 = (tmp_6 == null ? true : tmp_6 instanceof ParagraphStyle_0) ? tmp_6 : THROW_CCE();
          }
          tmp$ret$12 = tmp_5;
        }

        var item = ensureNotNull(tmp$ret$12);
        tmp_3 = new Range(item, start, end, tag);
        break;
      case 1:
        var tmp0_0 = list.l1(1);
        var tmp2_0 = get_SpanStyleSaver();
        var tmp$ret$17;
        $l$block_0: {
          // Inline function 'androidx.compose.ui.text.restore' call
          var tmp_7;
          if (equals(tmp0_0, false)) {
            tmp_7 = !isInterface(tmp2_0, NonNullValueClassSaver);
          } else {
            tmp_7 = false;
          }
          if (tmp_7) {
            tmp$ret$17 = null;
            break $l$block_0;
          }
          var tmp_8;
          if (tmp0_0 == null) {
            tmp_8 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.with' call
            var tmp_9 = tmp2_0.b7o(tmp0_0);
            tmp_8 = (tmp_9 == null ? true : tmp_9 instanceof SpanStyle) ? tmp_9 : THROW_CCE();
          }
          tmp$ret$17 = tmp_8;
        }

        var item_0 = ensureNotNull(tmp$ret$17);
        tmp_3 = new Range(item_0, start, end, tag);
        break;
      case 2:
        var tmp0_1 = list.l1(1);
        var tmp2_1 = get_VerbatimTtsAnnotationSaver();
        var tmp$ret$22;
        $l$block_1: {
          // Inline function 'androidx.compose.ui.text.restore' call
          var tmp_10;
          if (equals(tmp0_1, false)) {
            tmp_10 = !isInterface(tmp2_1, NonNullValueClassSaver);
          } else {
            tmp_10 = false;
          }
          if (tmp_10) {
            tmp$ret$22 = null;
            break $l$block_1;
          }
          var tmp_11;
          if (tmp0_1 == null) {
            tmp_11 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.with' call
            var tmp_12 = tmp2_1.b7o(tmp0_1);
            tmp_11 = (tmp_12 == null ? true : tmp_12 instanceof VerbatimTtsAnnotation) ? tmp_12 : THROW_CCE();
          }
          tmp$ret$22 = tmp_11;
        }

        var item_1 = ensureNotNull(tmp$ret$22);
        tmp_3 = new Range(item_1, start, end, tag);
        break;
      case 3:
        var tmp0_2 = list.l1(1);
        var tmp2_2 = get_UrlAnnotationSaver();
        var tmp$ret$27;
        $l$block_2: {
          // Inline function 'androidx.compose.ui.text.restore' call
          var tmp_13;
          if (equals(tmp0_2, false)) {
            tmp_13 = !isInterface(tmp2_2, NonNullValueClassSaver);
          } else {
            tmp_13 = false;
          }
          if (tmp_13) {
            tmp$ret$27 = null;
            break $l$block_2;
          }
          var tmp_14;
          if (tmp0_2 == null) {
            tmp_14 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.with' call
            var tmp_15 = tmp2_2.b7o(tmp0_2);
            tmp_14 = (tmp_15 == null ? true : tmp_15 instanceof UrlAnnotation) ? tmp_15 : THROW_CCE();
          }
          tmp$ret$27 = tmp_14;
        }

        var item_2 = ensureNotNull(tmp$ret$27);
        tmp_3 = new Range(item_2, start, end, tag);
        break;
      case 4:
        var tmp0_3 = list.l1(1);
        var tmp2_3 = get_LinkSaver();
        var tmp$ret$32;
        $l$block_3: {
          // Inline function 'androidx.compose.ui.text.restore' call
          var tmp_16;
          if (equals(tmp0_3, false)) {
            tmp_16 = !isInterface(tmp2_3, NonNullValueClassSaver);
          } else {
            tmp_16 = false;
          }
          if (tmp_16) {
            tmp$ret$32 = null;
            break $l$block_3;
          }
          var tmp_17;
          if (tmp0_3 == null) {
            tmp_17 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.with' call
            var tmp_18 = tmp2_3.b7o(tmp0_3);
            tmp_17 = (tmp_18 == null ? true : tmp_18 instanceof Url) ? tmp_18 : THROW_CCE();
          }
          tmp$ret$32 = tmp_17;
        }

        var item_3 = ensureNotNull(tmp$ret$32);
        tmp_3 = new Range(item_3, start, end, tag);
        break;
      case 5:
        var tmp0_4 = list.l1(1);
        var tmp2_4 = get_ClickableSaver();
        var tmp$ret$37;
        $l$block_4: {
          // Inline function 'androidx.compose.ui.text.restore' call
          var tmp_19;
          if (equals(tmp0_4, false)) {
            tmp_19 = !isInterface(tmp2_4, NonNullValueClassSaver);
          } else {
            tmp_19 = false;
          }
          if (tmp_19) {
            tmp$ret$37 = null;
            break $l$block_4;
          }
          var tmp_20;
          if (tmp0_4 == null) {
            tmp_20 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.with' call
            var tmp_21 = tmp2_4.b7o(tmp0_4);
            tmp_20 = (tmp_21 == null ? true : tmp_21 instanceof Clickable) ? tmp_21 : THROW_CCE();
          }
          tmp$ret$37 = tmp_20;
        }

        var item_4 = ensureNotNull(tmp$ret$37);
        tmp_3 = new Range(item_4, start, end, tag);
        break;
      case 6:
        // Inline function 'androidx.compose.ui.text.restore' call

        var tmp0_safe_receiver_3 = list.l1(1);
        var tmp_22;
        if (tmp0_safe_receiver_3 == null) {
          tmp_22 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_22 = typeof tmp0_safe_receiver_3 === 'string' ? tmp0_safe_receiver_3 : THROW_CCE();
        }

        var tmp$ret$42 = tmp_22;
        var item_5 = ensureNotNull(tmp$ret$42);
        tmp_3 = new Range(new StringAnnotation(_StringAnnotation___init__impl__o6a5i7(item_5)), start, end, tag);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp_3;
  }
  function VerbatimTtsAnnotationSaver$lambda($this$Saver, it) {
    _init_properties_Savers_kt__o6r3ry();
    return save(it.l7w_1);
  }
  function VerbatimTtsAnnotationSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    // Inline function 'androidx.compose.ui.text.restore' call
    var tmp;
    if (it == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = typeof it === 'string' ? it : THROW_CCE();
    }
    var tmp$ret$0 = tmp;
    return new VerbatimTtsAnnotation(ensureNotNull(tmp$ret$0));
  }
  function UrlAnnotationSaver$lambda($this$Saver, it) {
    _init_properties_Savers_kt__o6r3ry();
    return save(it.m7w_1);
  }
  function UrlAnnotationSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    // Inline function 'androidx.compose.ui.text.restore' call
    var tmp;
    if (it == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = typeof it === 'string' ? it : THROW_CCE();
    }
    var tmp$ret$0 = tmp;
    return new UrlAnnotation(ensureNotNull(tmp$ret$0));
  }
  function LinkSaver$lambda($this$Saver, it) {
    _init_properties_Savers_kt__o6r3ry();
    return arrayListOf([save(it.p7r_1), save_0(it.q7r_1, get_TextLinkStylesSaver(), $this$Saver)]);
  }
  function LinkSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    var list = isInterface(it, KtList) ? it : THROW_CCE();
    // Inline function 'androidx.compose.ui.text.restore' call
    var tmp0_safe_receiver = list.l1(0);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = typeof tmp0_safe_receiver === 'string' ? tmp0_safe_receiver : THROW_CCE();
    }
    var tmp$ret$0 = tmp;
    var url = ensureNotNull(tmp$ret$0);
    var tmp0 = list.l1(1);
    var tmp2 = get_TextLinkStylesSaver();
    var tmp$ret$3;
    $l$block: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp_0;
      if (equals(tmp0, false)) {
        tmp_0 = !isInterface(tmp2, NonNullValueClassSaver);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$3 = null;
        break $l$block;
      }
      var tmp_1;
      if (tmp0 == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_2 = tmp2.b7o(tmp0);
        tmp_1 = (tmp_2 == null ? true : tmp_2 instanceof TextLinkStyles) ? tmp_2 : THROW_CCE();
      }
      tmp$ret$3 = tmp_1;
    }
    var stylesOrNull = tmp$ret$3;
    return new Url(url, stylesOrNull);
  }
  function ClickableSaver$lambda($this$Saver, it) {
    _init_properties_Savers_kt__o6r3ry();
    return arrayListOf([save(it.v7r_1), save_0(it.w7r_1, get_TextLinkStylesSaver(), $this$Saver)]);
  }
  function ClickableSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    var list = isInterface(it, KtList) ? it : THROW_CCE();
    // Inline function 'androidx.compose.ui.text.restore' call
    var tmp0_safe_receiver = list.l1(0);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = typeof tmp0_safe_receiver === 'string' ? tmp0_safe_receiver : THROW_CCE();
    }
    var tmp$ret$0 = tmp;
    var tag = ensureNotNull(tmp$ret$0);
    var tmp0 = list.l1(1);
    var tmp2 = get_TextLinkStylesSaver();
    var tmp$ret$3;
    $l$block: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp_0;
      if (equals(tmp0, false)) {
        tmp_0 = !isInterface(tmp2, NonNullValueClassSaver);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$3 = null;
        break $l$block;
      }
      var tmp_1;
      if (tmp0 == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_2 = tmp2.b7o(tmp0);
        tmp_1 = (tmp_2 == null ? true : tmp_2 instanceof TextLinkStyles) ? tmp_2 : THROW_CCE();
      }
      tmp$ret$3 = tmp_1;
    }
    var stylesOrNull = tmp$ret$3;
    return new Clickable(tag, stylesOrNull, null);
  }
  function ParagraphStyleSaver$lambda($this$Saver, it) {
    _init_properties_Savers_kt__o6r3ry();
    return arrayListOf([save_0(new TextAlign(it.d7r_1), get_Saver(Companion_getInstance_43()), $this$Saver), save_0(new TextDirection(it.e7r_1), get_Saver_0(Companion_getInstance_45()), $this$Saver), save_0(new TextUnit(it.f7r_1), get_Saver_1(Companion_getInstance_1()), $this$Saver), save_0(it.g7r_1, get_Saver_2(Companion_getInstance_48()), $this$Saver), save_0(it.h7r_1, get_Saver_21(Companion_getInstance_53()), $this$Saver), save_0(it.i7r_1, get_Saver_3(Companion_getInstance_42()), $this$Saver), save_0(new LineBreak(it.j7r_1), get_Saver_22(Companion_getInstance_55()), $this$Saver), save_0(new Hyphens(it.k7r_1), get_Saver_4(Companion_getInstance_38()), $this$Saver), save_0(it.l7r_1, get_Saver_23(Companion_getInstance_56()), $this$Saver)]);
  }
  function ParagraphStyleSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    var list = isInterface(it, KtList) ? it : THROW_CCE();
    var tmp0 = list.l1(0);
    var tmp2 = get_Saver(Companion_getInstance_43());
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp;
      if (equals(tmp0, false)) {
        tmp = !isInterface(tmp2, NonNullValueClassSaver);
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = null;
        break $l$block;
      }
      var tmp_0;
      if (tmp0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_1 = tmp2.b7o(tmp0);
        var tmp_2;
        if (tmp_1 == null ? true : tmp_1 instanceof TextAlign) {
          var tmp_3 = tmp_1;
          tmp_2 = tmp_3 == null ? null : tmp_3.t7v_1;
        } else {
          tmp_2 = THROW_CCE();
        }
        var tmp_4 = tmp_2;
        var tmp_5 = tmp_4 == null ? null : new TextAlign(tmp_4);
        tmp_0 = tmp_5 == null ? null : tmp_5.t7v_1;
      }
      tmp$ret$0 = tmp_0;
    }
    var tmp_6 = tmp$ret$0;
    var tmp_7 = ensureNotNull(tmp_6 == null ? null : new TextAlign(tmp_6));
    var tmp0_0 = list.l1(1);
    var tmp2_0 = get_Saver_0(Companion_getInstance_45());
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp_8;
      if (equals(tmp0_0, false)) {
        tmp_8 = !isInterface(tmp2_0, NonNullValueClassSaver);
      } else {
        tmp_8 = false;
      }
      if (tmp_8) {
        tmp$ret$5 = null;
        break $l$block_0;
      }
      var tmp_9;
      if (tmp0_0 == null) {
        tmp_9 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_10 = tmp2_0.b7o(tmp0_0);
        var tmp_11;
        if (tmp_10 == null ? true : tmp_10 instanceof TextDirection) {
          var tmp_12 = tmp_10;
          tmp_11 = tmp_12 == null ? null : tmp_12.u7v_1;
        } else {
          tmp_11 = THROW_CCE();
        }
        var tmp_13 = tmp_11;
        var tmp_14 = tmp_13 == null ? null : new TextDirection(tmp_13);
        tmp_9 = tmp_14 == null ? null : tmp_14.u7v_1;
      }
      tmp$ret$5 = tmp_9;
    }
    var tmp_15 = tmp$ret$5;
    var tmp_16 = ensureNotNull(tmp_15 == null ? null : new TextDirection(tmp_15));
    var tmp0_1 = list.l1(2);
    var tmp2_1 = get_Saver_1(Companion_getInstance_1());
    var tmp$ret$10;
    $l$block_1: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp_17;
      if (equals(tmp0_1, false)) {
        tmp_17 = !isInterface(tmp2_1, NonNullValueClassSaver);
      } else {
        tmp_17 = false;
      }
      if (tmp_17) {
        tmp$ret$10 = null;
        break $l$block_1;
      }
      var tmp_18;
      if (tmp0_1 == null) {
        tmp_18 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_19 = tmp2_1.b7o(tmp0_1);
        var tmp_20;
        if (tmp_19 == null ? true : tmp_19 instanceof TextUnit) {
          var tmp_21 = tmp_19;
          tmp_20 = tmp_21 == null ? null : tmp_21.s5g_1;
        } else {
          tmp_20 = THROW_CCE();
        }
        var tmp_22 = tmp_20;
        var tmp_23 = tmp_22 == null ? null : new TextUnit(tmp_22);
        tmp_18 = tmp_23 == null ? null : tmp_23.s5g_1;
      }
      tmp$ret$10 = tmp_18;
    }
    var tmp_24 = tmp$ret$10;
    var tmp_25 = ensureNotNull(tmp_24 == null ? null : new TextUnit(tmp_24));
    var tmp0_2 = list.l1(3);
    var tmp2_2 = get_Saver_2(Companion_getInstance_48());
    var tmp$ret$15;
    $l$block_2: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp_26;
      if (equals(tmp0_2, false)) {
        tmp_26 = !isInterface(tmp2_2, NonNullValueClassSaver);
      } else {
        tmp_26 = false;
      }
      if (tmp_26) {
        tmp$ret$15 = null;
        break $l$block_2;
      }
      var tmp_27;
      if (tmp0_2 == null) {
        tmp_27 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_28 = tmp2_2.b7o(tmp0_2);
        tmp_27 = (tmp_28 == null ? true : tmp_28 instanceof TextIndent_0) ? tmp_28 : THROW_CCE();
      }
      tmp$ret$15 = tmp_27;
    }
    var tmp_29 = tmp$ret$15;
    var tmp0_3 = list.l1(4);
    var tmp2_3 = get_Saver_21(Companion_getInstance_53());
    var tmp$ret$20;
    $l$block_3: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp_30;
      if (equals(tmp0_3, false)) {
        tmp_30 = !isInterface(tmp2_3, NonNullValueClassSaver);
      } else {
        tmp_30 = false;
      }
      if (tmp_30) {
        tmp$ret$20 = null;
        break $l$block_3;
      }
      var tmp_31;
      if (tmp0_3 == null) {
        tmp_31 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_32 = tmp2_3.b7o(tmp0_3);
        tmp_31 = (tmp_32 == null ? true : tmp_32 instanceof PlatformParagraphStyle) ? tmp_32 : THROW_CCE();
      }
      tmp$ret$20 = tmp_31;
    }
    var tmp_33 = tmp$ret$20;
    var tmp0_4 = list.l1(5);
    var tmp2_4 = get_Saver_3(Companion_getInstance_42());
    var tmp$ret$25;
    $l$block_4: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp_34;
      if (equals(tmp0_4, false)) {
        tmp_34 = !isInterface(tmp2_4, NonNullValueClassSaver);
      } else {
        tmp_34 = false;
      }
      if (tmp_34) {
        tmp$ret$25 = null;
        break $l$block_4;
      }
      var tmp_35;
      if (tmp0_4 == null) {
        tmp_35 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_36 = tmp2_4.b7o(tmp0_4);
        tmp_35 = (tmp_36 == null ? true : tmp_36 instanceof LineHeightStyle) ? tmp_36 : THROW_CCE();
      }
      tmp$ret$25 = tmp_35;
    }
    var tmp_37 = tmp$ret$25;
    var tmp0_5 = list.l1(6);
    var tmp2_5 = get_Saver_22(Companion_getInstance_55());
    var tmp$ret$30;
    $l$block_5: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp_38;
      if (equals(tmp0_5, false)) {
        tmp_38 = !isInterface(tmp2_5, NonNullValueClassSaver);
      } else {
        tmp_38 = false;
      }
      if (tmp_38) {
        tmp$ret$30 = null;
        break $l$block_5;
      }
      var tmp_39;
      if (tmp0_5 == null) {
        tmp_39 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_40 = tmp2_5.b7o(tmp0_5);
        var tmp_41;
        if (tmp_40 == null ? true : tmp_40 instanceof LineBreak) {
          var tmp_42 = tmp_40;
          tmp_41 = tmp_42 == null ? null : tmp_42.v7v_1;
        } else {
          tmp_41 = THROW_CCE();
        }
        var tmp_43 = tmp_41;
        var tmp_44 = tmp_43 == null ? null : new LineBreak(tmp_43);
        tmp_39 = tmp_44 == null ? null : tmp_44.v7v_1;
      }
      tmp$ret$30 = tmp_39;
    }
    var tmp_45 = tmp$ret$30;
    var tmp_46 = ensureNotNull(tmp_45 == null ? null : new LineBreak(tmp_45));
    var tmp0_6 = list.l1(7);
    var tmp2_6 = get_Saver_4(Companion_getInstance_38());
    var tmp$ret$35;
    $l$block_6: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp_47;
      if (equals(tmp0_6, false)) {
        tmp_47 = !isInterface(tmp2_6, NonNullValueClassSaver);
      } else {
        tmp_47 = false;
      }
      if (tmp_47) {
        tmp$ret$35 = null;
        break $l$block_6;
      }
      var tmp_48;
      if (tmp0_6 == null) {
        tmp_48 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_49 = tmp2_6.b7o(tmp0_6);
        var tmp_50;
        if (tmp_49 == null ? true : tmp_49 instanceof Hyphens) {
          var tmp_51 = tmp_49;
          tmp_50 = tmp_51 == null ? null : tmp_51.w7v_1;
        } else {
          tmp_50 = THROW_CCE();
        }
        var tmp_52 = tmp_50;
        var tmp_53 = tmp_52 == null ? null : new Hyphens(tmp_52);
        tmp_48 = tmp_53 == null ? null : tmp_53.w7v_1;
      }
      tmp$ret$35 = tmp_48;
    }
    var tmp_54 = tmp$ret$35;
    var tmp_55 = ensureNotNull(tmp_54 == null ? null : new Hyphens(tmp_54));
    var tmp0_7 = list.l1(8);
    var tmp2_7 = get_Saver_23(Companion_getInstance_56());
    var tmp$ret$40;
    $l$block_7: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp_56;
      if (equals(tmp0_7, false)) {
        tmp_56 = !isInterface(tmp2_7, NonNullValueClassSaver);
      } else {
        tmp_56 = false;
      }
      if (tmp_56) {
        tmp$ret$40 = null;
        break $l$block_7;
      }
      var tmp_57;
      if (tmp0_7 == null) {
        tmp_57 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_58 = tmp2_7.b7o(tmp0_7);
        tmp_57 = (tmp_58 == null ? true : tmp_58 instanceof TextMotion) ? tmp_58 : THROW_CCE();
      }
      tmp$ret$40 = tmp_57;
    }
    return new ParagraphStyle_0(tmp_7.t7v_1, tmp_16.u7v_1, tmp_25.s5g_1, tmp_29, tmp_33, tmp_37, tmp_46.v7v_1, tmp_55.w7v_1, tmp$ret$40);
  }
  function SpanStyleSaver$lambda($this$Saver, it) {
    _init_properties_Savers_kt__o6r3ry();
    var tmp = save_0(new Color(it.s6c()), get_Saver_5(Companion_getInstance()), $this$Saver);
    var tmp_0 = save_0(new TextUnit(it.o7w_1), get_Saver_1(Companion_getInstance_1()), $this$Saver);
    var tmp_1 = save_0(it.p7w_1, get_Saver_6(Companion_getInstance_26()), $this$Saver);
    var tmp_2 = it.q7w_1;
    var tmp_3 = save_0(tmp_2 == null ? null : new FontStyle(tmp_2), get_Saver_7(Companion_getInstance_24()), $this$Saver);
    var tmp_4 = it.r7w_1;
    var tmp_5 = save_0(tmp_4 == null ? null : new FontSynthesis(tmp_4), get_Saver_8(Companion_getInstance_25()), $this$Saver);
    var tmp_6 = save(-1);
    var tmp_7 = save(it.t7w_1);
    var tmp_8 = save_0(new TextUnit(it.u7w_1), get_Saver_1(Companion_getInstance_1()), $this$Saver);
    var tmp_9 = it.v7w_1;
    return arrayListOf([tmp, tmp_0, tmp_1, tmp_3, tmp_5, tmp_6, tmp_7, tmp_8, save_0(tmp_9 == null ? null : new BaselineShift(tmp_9), get_Saver_9(Companion_getInstance_37()), $this$Saver), save_0(it.w7w_1, get_Saver_10(Companion_getInstance_47()), $this$Saver), save_0(it.x7w_1, get_Saver_11(Companion_getInstance_36()), $this$Saver), save_0(new Color(it.y7w_1), get_Saver_5(Companion_getInstance()), $this$Saver), save_0(it.z7w_1, get_Saver_12(Companion_getInstance_44()), $this$Saver), save_0(it.a7x_1, get_Saver_13(Companion_getInstance_2()), $this$Saver)]);
  }
  function SpanStyleSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    var list = isInterface(it, KtList) ? it : THROW_CCE();
    var tmp0 = list.l1(0);
    var tmp2 = get_Saver_5(Companion_getInstance());
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp;
      if (equals(tmp0, false)) {
        tmp = !isInterface(tmp2, NonNullValueClassSaver);
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = null;
        break $l$block;
      }
      var tmp_0;
      if (tmp0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_1 = tmp2.b7o(tmp0);
        var tmp_2;
        if (tmp_1 == null ? true : tmp_1 instanceof Color) {
          var tmp_3 = tmp_1;
          tmp_2 = tmp_3 == null ? null : tmp_3.c6d_1;
        } else {
          tmp_2 = THROW_CCE();
        }
        var tmp_4 = tmp_2;
        var tmp_5 = tmp_4 == null ? null : new Color(tmp_4);
        tmp_0 = tmp_5 == null ? null : tmp_5.c6d_1;
      }
      tmp$ret$0 = tmp_0;
    }
    var tmp_6 = tmp$ret$0;
    var tmp_7 = ensureNotNull(tmp_6 == null ? null : new Color(tmp_6));
    var tmp0_0 = list.l1(1);
    var tmp2_0 = get_Saver_1(Companion_getInstance_1());
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp_8;
      if (equals(tmp0_0, false)) {
        tmp_8 = !isInterface(tmp2_0, NonNullValueClassSaver);
      } else {
        tmp_8 = false;
      }
      if (tmp_8) {
        tmp$ret$5 = null;
        break $l$block_0;
      }
      var tmp_9;
      if (tmp0_0 == null) {
        tmp_9 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_10 = tmp2_0.b7o(tmp0_0);
        var tmp_11;
        if (tmp_10 == null ? true : tmp_10 instanceof TextUnit) {
          var tmp_12 = tmp_10;
          tmp_11 = tmp_12 == null ? null : tmp_12.s5g_1;
        } else {
          tmp_11 = THROW_CCE();
        }
        var tmp_13 = tmp_11;
        var tmp_14 = tmp_13 == null ? null : new TextUnit(tmp_13);
        tmp_9 = tmp_14 == null ? null : tmp_14.s5g_1;
      }
      tmp$ret$5 = tmp_9;
    }
    var tmp_15 = tmp$ret$5;
    var tmp_16 = ensureNotNull(tmp_15 == null ? null : new TextUnit(tmp_15));
    var tmp0_1 = list.l1(2);
    var tmp2_1 = get_Saver_6(Companion_getInstance_26());
    var tmp$ret$10;
    $l$block_1: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp_17;
      if (equals(tmp0_1, false)) {
        tmp_17 = !isInterface(tmp2_1, NonNullValueClassSaver);
      } else {
        tmp_17 = false;
      }
      if (tmp_17) {
        tmp$ret$10 = null;
        break $l$block_1;
      }
      var tmp_18;
      if (tmp0_1 == null) {
        tmp_18 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_19 = tmp2_1.b7o(tmp0_1);
        tmp_18 = (tmp_19 == null ? true : tmp_19 instanceof FontWeight) ? tmp_19 : THROW_CCE();
      }
      tmp$ret$10 = tmp_18;
    }
    var tmp_20 = tmp$ret$10;
    var tmp0_2 = list.l1(3);
    var tmp2_2 = get_Saver_7(Companion_getInstance_24());
    var tmp$ret$15;
    $l$block_2: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp_21;
      if (equals(tmp0_2, false)) {
        tmp_21 = !isInterface(tmp2_2, NonNullValueClassSaver);
      } else {
        tmp_21 = false;
      }
      if (tmp_21) {
        tmp$ret$15 = null;
        break $l$block_2;
      }
      var tmp_22;
      if (tmp0_2 == null) {
        tmp_22 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_23 = tmp2_2.b7o(tmp0_2);
        var tmp_24;
        if (tmp_23 == null ? true : tmp_23 instanceof FontStyle) {
          var tmp_25 = tmp_23;
          tmp_24 = tmp_25 == null ? null : tmp_25.d7x_1;
        } else {
          tmp_24 = THROW_CCE();
        }
        var tmp_26 = tmp_24;
        var tmp_27 = tmp_26 == null ? null : new FontStyle(tmp_26);
        tmp_22 = tmp_27 == null ? null : tmp_27.d7x_1;
      }
      tmp$ret$15 = tmp_22;
    }
    var tmp_28 = tmp$ret$15;
    var tmp0_3 = list.l1(4);
    var tmp2_3 = get_Saver_8(Companion_getInstance_25());
    var tmp$ret$20;
    $l$block_3: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp_29;
      if (equals(tmp0_3, false)) {
        tmp_29 = !isInterface(tmp2_3, NonNullValueClassSaver);
      } else {
        tmp_29 = false;
      }
      if (tmp_29) {
        tmp$ret$20 = null;
        break $l$block_3;
      }
      var tmp_30;
      if (tmp0_3 == null) {
        tmp_30 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_31 = tmp2_3.b7o(tmp0_3);
        var tmp_32;
        if (tmp_31 == null ? true : tmp_31 instanceof FontSynthesis) {
          var tmp_33 = tmp_31;
          tmp_32 = tmp_33 == null ? null : tmp_33.e7x_1;
        } else {
          tmp_32 = THROW_CCE();
        }
        var tmp_34 = tmp_32;
        var tmp_35 = tmp_34 == null ? null : new FontSynthesis(tmp_34);
        tmp_30 = tmp_35 == null ? null : tmp_35.e7x_1;
      }
      tmp$ret$20 = tmp_30;
    }
    var tmp_36 = tmp$ret$20;
    // Inline function 'androidx.compose.ui.text.restore' call
    var tmp0_safe_receiver = list.l1(6);
    var tmp_37;
    if (tmp0_safe_receiver == null) {
      tmp_37 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_37 = typeof tmp0_safe_receiver === 'string' ? tmp0_safe_receiver : THROW_CCE();
    }
    var tmp_38 = tmp_37;
    var tmp0_4 = list.l1(7);
    var tmp2_4 = get_Saver_1(Companion_getInstance_1());
    var tmp$ret$28;
    $l$block_4: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp_39;
      if (equals(tmp0_4, false)) {
        tmp_39 = !isInterface(tmp2_4, NonNullValueClassSaver);
      } else {
        tmp_39 = false;
      }
      if (tmp_39) {
        tmp$ret$28 = null;
        break $l$block_4;
      }
      var tmp_40;
      if (tmp0_4 == null) {
        tmp_40 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_41 = tmp2_4.b7o(tmp0_4);
        var tmp_42;
        if (tmp_41 == null ? true : tmp_41 instanceof TextUnit) {
          var tmp_43 = tmp_41;
          tmp_42 = tmp_43 == null ? null : tmp_43.s5g_1;
        } else {
          tmp_42 = THROW_CCE();
        }
        var tmp_44 = tmp_42;
        var tmp_45 = tmp_44 == null ? null : new TextUnit(tmp_44);
        tmp_40 = tmp_45 == null ? null : tmp_45.s5g_1;
      }
      tmp$ret$28 = tmp_40;
    }
    var tmp_46 = tmp$ret$28;
    var tmp_47 = ensureNotNull(tmp_46 == null ? null : new TextUnit(tmp_46));
    var tmp0_5 = list.l1(8);
    var tmp2_5 = get_Saver_9(Companion_getInstance_37());
    var tmp$ret$33;
    $l$block_5: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp_48;
      if (equals(tmp0_5, false)) {
        tmp_48 = !isInterface(tmp2_5, NonNullValueClassSaver);
      } else {
        tmp_48 = false;
      }
      if (tmp_48) {
        tmp$ret$33 = null;
        break $l$block_5;
      }
      var tmp_49;
      if (tmp0_5 == null) {
        tmp_49 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_50 = tmp2_5.b7o(tmp0_5);
        var tmp_51;
        if (tmp_50 == null ? true : tmp_50 instanceof BaselineShift) {
          var tmp_52 = tmp_50;
          tmp_51 = tmp_52 == null ? null : tmp_52.f7x_1;
        } else {
          tmp_51 = THROW_CCE();
        }
        var tmp_53 = tmp_51;
        var tmp_54 = tmp_53 == null ? null : new BaselineShift(tmp_53);
        tmp_49 = tmp_54 == null ? null : tmp_54.f7x_1;
      }
      tmp$ret$33 = tmp_49;
    }
    var tmp_55 = tmp$ret$33;
    var tmp0_6 = list.l1(9);
    var tmp2_6 = get_Saver_10(Companion_getInstance_47());
    var tmp$ret$38;
    $l$block_6: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp_56;
      if (equals(tmp0_6, false)) {
        tmp_56 = !isInterface(tmp2_6, NonNullValueClassSaver);
      } else {
        tmp_56 = false;
      }
      if (tmp_56) {
        tmp$ret$38 = null;
        break $l$block_6;
      }
      var tmp_57;
      if (tmp0_6 == null) {
        tmp_57 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_58 = tmp2_6.b7o(tmp0_6);
        tmp_57 = (tmp_58 == null ? true : tmp_58 instanceof TextGeometricTransform) ? tmp_58 : THROW_CCE();
      }
      tmp$ret$38 = tmp_57;
    }
    var tmp_59 = tmp$ret$38;
    var tmp0_7 = list.l1(10);
    var tmp2_7 = get_Saver_11(Companion_getInstance_36());
    var tmp$ret$43;
    $l$block_7: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp_60;
      if (equals(tmp0_7, false)) {
        tmp_60 = !isInterface(tmp2_7, NonNullValueClassSaver);
      } else {
        tmp_60 = false;
      }
      if (tmp_60) {
        tmp$ret$43 = null;
        break $l$block_7;
      }
      var tmp_61;
      if (tmp0_7 == null) {
        tmp_61 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_62 = tmp2_7.b7o(tmp0_7);
        tmp_61 = (tmp_62 == null ? true : tmp_62 instanceof LocaleList) ? tmp_62 : THROW_CCE();
      }
      tmp$ret$43 = tmp_61;
    }
    var tmp_63 = tmp$ret$43;
    var tmp0_8 = list.l1(11);
    var tmp2_8 = get_Saver_5(Companion_getInstance());
    var tmp$ret$48;
    $l$block_8: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp_64;
      if (equals(tmp0_8, false)) {
        tmp_64 = !isInterface(tmp2_8, NonNullValueClassSaver);
      } else {
        tmp_64 = false;
      }
      if (tmp_64) {
        tmp$ret$48 = null;
        break $l$block_8;
      }
      var tmp_65;
      if (tmp0_8 == null) {
        tmp_65 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_66 = tmp2_8.b7o(tmp0_8);
        var tmp_67;
        if (tmp_66 == null ? true : tmp_66 instanceof Color) {
          var tmp_68 = tmp_66;
          tmp_67 = tmp_68 == null ? null : tmp_68.c6d_1;
        } else {
          tmp_67 = THROW_CCE();
        }
        var tmp_69 = tmp_67;
        var tmp_70 = tmp_69 == null ? null : new Color(tmp_69);
        tmp_65 = tmp_70 == null ? null : tmp_70.c6d_1;
      }
      tmp$ret$48 = tmp_65;
    }
    var tmp_71 = tmp$ret$48;
    var tmp_72 = ensureNotNull(tmp_71 == null ? null : new Color(tmp_71));
    var tmp0_9 = list.l1(12);
    var tmp2_9 = get_Saver_12(Companion_getInstance_44());
    var tmp$ret$53;
    $l$block_9: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp_73;
      if (equals(tmp0_9, false)) {
        tmp_73 = !isInterface(tmp2_9, NonNullValueClassSaver);
      } else {
        tmp_73 = false;
      }
      if (tmp_73) {
        tmp$ret$53 = null;
        break $l$block_9;
      }
      var tmp_74;
      if (tmp0_9 == null) {
        tmp_74 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_75 = tmp2_9.b7o(tmp0_9);
        tmp_74 = (tmp_75 == null ? true : tmp_75 instanceof TextDecoration) ? tmp_75 : THROW_CCE();
      }
      tmp$ret$53 = tmp_74;
    }
    var tmp_76 = tmp$ret$53;
    var tmp0_10 = list.l1(13);
    var tmp2_10 = get_Saver_13(Companion_getInstance_2());
    var tmp$ret$58;
    $l$block_10: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp_77;
      if (equals(tmp0_10, false)) {
        tmp_77 = !isInterface(tmp2_10, NonNullValueClassSaver);
      } else {
        tmp_77 = false;
      }
      if (tmp_77) {
        tmp$ret$58 = null;
        break $l$block_10;
      }
      var tmp_78;
      if (tmp0_10 == null) {
        tmp_78 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_79 = tmp2_10.b7o(tmp0_10);
        tmp_78 = (tmp_79 == null ? true : tmp_79 instanceof Shadow) ? tmp_79 : THROW_CCE();
      }
      tmp$ret$58 = tmp_78;
    }
    return SpanStyle_init_$Create$(tmp_7.c6d_1, tmp_16.s5g_1, tmp_20, tmp_28, tmp_36, VOID, tmp_38, tmp_47.s5g_1, tmp_55, tmp_59, tmp_63, tmp_72.c6d_1, tmp_76, tmp$ret$58);
  }
  function TextLinkStylesSaver$lambda($this$Saver, it) {
    _init_properties_Savers_kt__o6r3ry();
    return arrayListOf([save_0(it.g7x_1, get_SpanStyleSaver(), $this$Saver), save_0(it.h7x_1, get_SpanStyleSaver(), $this$Saver), save_0(it.i7x_1, get_SpanStyleSaver(), $this$Saver), save_0(it.j7x_1, get_SpanStyleSaver(), $this$Saver)]);
  }
  function TextLinkStylesSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    var list = isInterface(it, KtList) ? it : THROW_CCE();
    var tmp0 = list.l1(0);
    var tmp2 = get_SpanStyleSaver();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp;
      if (equals(tmp0, false)) {
        tmp = !isInterface(tmp2, NonNullValueClassSaver);
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = null;
        break $l$block;
      }
      var tmp_0;
      if (tmp0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_1 = tmp2.b7o(tmp0);
        tmp_0 = (tmp_1 == null ? true : tmp_1 instanceof SpanStyle) ? tmp_1 : THROW_CCE();
      }
      tmp$ret$0 = tmp_0;
    }
    var styleOrNull = tmp$ret$0;
    var tmp0_0 = list.l1(1);
    var tmp2_0 = get_SpanStyleSaver();
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp_2;
      if (equals(tmp0_0, false)) {
        tmp_2 = !isInterface(tmp2_0, NonNullValueClassSaver);
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp$ret$5 = null;
        break $l$block_0;
      }
      var tmp_3;
      if (tmp0_0 == null) {
        tmp_3 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_4 = tmp2_0.b7o(tmp0_0);
        tmp_3 = (tmp_4 == null ? true : tmp_4 instanceof SpanStyle) ? tmp_4 : THROW_CCE();
      }
      tmp$ret$5 = tmp_3;
    }
    var focusedStyleOrNull = tmp$ret$5;
    var tmp0_1 = list.l1(2);
    var tmp2_1 = get_SpanStyleSaver();
    var tmp$ret$10;
    $l$block_1: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp_5;
      if (equals(tmp0_1, false)) {
        tmp_5 = !isInterface(tmp2_1, NonNullValueClassSaver);
      } else {
        tmp_5 = false;
      }
      if (tmp_5) {
        tmp$ret$10 = null;
        break $l$block_1;
      }
      var tmp_6;
      if (tmp0_1 == null) {
        tmp_6 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_7 = tmp2_1.b7o(tmp0_1);
        tmp_6 = (tmp_7 == null ? true : tmp_7 instanceof SpanStyle) ? tmp_7 : THROW_CCE();
      }
      tmp$ret$10 = tmp_6;
    }
    var hoveredStyleOrNull = tmp$ret$10;
    var tmp0_2 = list.l1(3);
    var tmp2_2 = get_SpanStyleSaver();
    var tmp$ret$15;
    $l$block_2: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp_8;
      if (equals(tmp0_2, false)) {
        tmp_8 = !isInterface(tmp2_2, NonNullValueClassSaver);
      } else {
        tmp_8 = false;
      }
      if (tmp_8) {
        tmp$ret$15 = null;
        break $l$block_2;
      }
      var tmp_9;
      if (tmp0_2 == null) {
        tmp_9 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_10 = tmp2_2.b7o(tmp0_2);
        tmp_9 = (tmp_10 == null ? true : tmp_10 instanceof SpanStyle) ? tmp_10 : THROW_CCE();
      }
      tmp$ret$15 = tmp_9;
    }
    var pressedStyleOrNull = tmp$ret$15;
    return new TextLinkStyles(styleOrNull, focusedStyleOrNull, hoveredStyleOrNull, pressedStyleOrNull);
  }
  function TextDecorationSaver$lambda($this$Saver, it) {
    _init_properties_Savers_kt__o6r3ry();
    return it.k7x_1;
  }
  function TextDecorationSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    return new TextDecoration(typeof it === 'number' ? it : THROW_CCE());
  }
  function TextGeometricTransformSaver$lambda($this$Saver, it) {
    _init_properties_Savers_kt__o6r3ry();
    return arrayListOf([it.l7x_1, it.m7x_1]);
  }
  function TextGeometricTransformSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    var list = isInterface(it, KtList) ? it : THROW_CCE();
    return new TextGeometricTransform(list.l1(0), list.l1(1));
  }
  function TextIndentSaver$lambda($this$Saver, it) {
    _init_properties_Savers_kt__o6r3ry();
    return arrayListOf([save_0(new TextUnit(it.n7x_1), get_Saver_1(Companion_getInstance_1()), $this$Saver), save_0(new TextUnit(it.o7x_1), get_Saver_1(Companion_getInstance_1()), $this$Saver)]);
  }
  function TextIndentSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    var list = isInterface(it, KtList) ? it : THROW_CCE();
    var tmp0 = list.l1(0);
    var tmp2 = get_Saver_1(Companion_getInstance_1());
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp;
      if (equals(tmp0, false)) {
        tmp = !isInterface(tmp2, NonNullValueClassSaver);
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = null;
        break $l$block;
      }
      var tmp_0;
      if (tmp0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_1 = tmp2.b7o(tmp0);
        var tmp_2;
        if (tmp_1 == null ? true : tmp_1 instanceof TextUnit) {
          var tmp_3 = tmp_1;
          tmp_2 = tmp_3 == null ? null : tmp_3.s5g_1;
        } else {
          tmp_2 = THROW_CCE();
        }
        var tmp_4 = tmp_2;
        var tmp_5 = tmp_4 == null ? null : new TextUnit(tmp_4);
        tmp_0 = tmp_5 == null ? null : tmp_5.s5g_1;
      }
      tmp$ret$0 = tmp_0;
    }
    var tmp_6 = tmp$ret$0;
    var tmp_7 = ensureNotNull(tmp_6 == null ? null : new TextUnit(tmp_6));
    var tmp0_0 = list.l1(1);
    var tmp2_0 = get_Saver_1(Companion_getInstance_1());
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp_8;
      if (equals(tmp0_0, false)) {
        tmp_8 = !isInterface(tmp2_0, NonNullValueClassSaver);
      } else {
        tmp_8 = false;
      }
      if (tmp_8) {
        tmp$ret$5 = null;
        break $l$block_0;
      }
      var tmp_9;
      if (tmp0_0 == null) {
        tmp_9 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_10 = tmp2_0.b7o(tmp0_0);
        var tmp_11;
        if (tmp_10 == null ? true : tmp_10 instanceof TextUnit) {
          var tmp_12 = tmp_10;
          tmp_11 = tmp_12 == null ? null : tmp_12.s5g_1;
        } else {
          tmp_11 = THROW_CCE();
        }
        var tmp_13 = tmp_11;
        var tmp_14 = tmp_13 == null ? null : new TextUnit(tmp_13);
        tmp_9 = tmp_14 == null ? null : tmp_14.s5g_1;
      }
      tmp$ret$5 = tmp_9;
    }
    var tmp_15 = tmp$ret$5;
    return new TextIndent_0(tmp_7.s5g_1, ensureNotNull(tmp_15 == null ? null : new TextUnit(tmp_15)).s5g_1);
  }
  function FontWeightSaver$lambda($this$Saver, it) {
    _init_properties_Savers_kt__o6r3ry();
    return it.p7x_1;
  }
  function FontWeightSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    return new FontWeight(typeof it === 'number' ? it : THROW_CCE());
  }
  function BaselineShiftSaver$lambda($this$Saver, it) {
    _init_properties_Savers_kt__o6r3ry();
    return _BaselineShift___get_multiplier__impl__qhmjek(it.f7x_1);
  }
  function BaselineShiftSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    return new BaselineShift(_BaselineShift___init__impl__scj05g(typeof it === 'number' ? it : THROW_CCE()));
  }
  function TextRangeSaver$lambda($this$Saver, it) {
    _init_properties_Savers_kt__o6r3ry();
    return arrayListOf([save(_TextRange___get_start__impl__ww4t90(it.b7u_1)), save(_TextRange___get_end__impl__gcdxpp(it.b7u_1))]);
  }
  function TextRangeSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    var list = isInterface(it, KtList) ? it : THROW_CCE();
    // Inline function 'androidx.compose.ui.text.restore' call
    var tmp0_safe_receiver = list.l1(0);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = typeof tmp0_safe_receiver === 'number' ? tmp0_safe_receiver : THROW_CCE();
    }
    var tmp$ret$0 = tmp;
    var tmp_0 = ensureNotNull(tmp$ret$0);
    // Inline function 'androidx.compose.ui.text.restore' call
    var tmp0_safe_receiver_0 = list.l1(1);
    var tmp_1;
    if (tmp0_safe_receiver_0 == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_1 = typeof tmp0_safe_receiver_0 === 'number' ? tmp0_safe_receiver_0 : THROW_CCE();
    }
    var tmp$ret$3 = tmp_1;
    return new TextRange(TextRange_1(tmp_0, ensureNotNull(tmp$ret$3)));
  }
  function ShadowSaver$lambda($this$Saver, it) {
    _init_properties_Savers_kt__o6r3ry();
    return arrayListOf([save_0(new Color(it.n6j_1), get_Saver_5(Companion_getInstance()), $this$Saver), save_0(new Offset(it.o6j_1), get_Saver_14(Companion_getInstance_3()), $this$Saver), save(it.p6j_1)]);
  }
  function ShadowSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    var list = isInterface(it, KtList) ? it : THROW_CCE();
    var tmp0 = list.l1(0);
    var tmp2 = get_Saver_5(Companion_getInstance());
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp;
      if (equals(tmp0, false)) {
        tmp = !isInterface(tmp2, NonNullValueClassSaver);
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = null;
        break $l$block;
      }
      var tmp_0;
      if (tmp0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_1 = tmp2.b7o(tmp0);
        var tmp_2;
        if (tmp_1 == null ? true : tmp_1 instanceof Color) {
          var tmp_3 = tmp_1;
          tmp_2 = tmp_3 == null ? null : tmp_3.c6d_1;
        } else {
          tmp_2 = THROW_CCE();
        }
        var tmp_4 = tmp_2;
        var tmp_5 = tmp_4 == null ? null : new Color(tmp_4);
        tmp_0 = tmp_5 == null ? null : tmp_5.c6d_1;
      }
      tmp$ret$0 = tmp_0;
    }
    var tmp_6 = tmp$ret$0;
    var tmp_7 = ensureNotNull(tmp_6 == null ? null : new Color(tmp_6));
    var tmp0_0 = list.l1(1);
    var tmp2_0 = get_Saver_14(Companion_getInstance_3());
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp_8;
      if (equals(tmp0_0, false)) {
        tmp_8 = !isInterface(tmp2_0, NonNullValueClassSaver);
      } else {
        tmp_8 = false;
      }
      if (tmp_8) {
        tmp$ret$5 = null;
        break $l$block_0;
      }
      var tmp_9;
      if (tmp0_0 == null) {
        tmp_9 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_10 = tmp2_0.b7o(tmp0_0);
        var tmp_11;
        if (tmp_10 == null ? true : tmp_10 instanceof Offset) {
          var tmp_12 = tmp_10;
          tmp_11 = tmp_12 == null ? null : tmp_12.e5d_1;
        } else {
          tmp_11 = THROW_CCE();
        }
        var tmp_13 = tmp_11;
        var tmp_14 = tmp_13 == null ? null : new Offset(tmp_13);
        tmp_9 = tmp_14 == null ? null : tmp_14.e5d_1;
      }
      tmp$ret$5 = tmp_9;
    }
    var tmp_15 = tmp$ret$5;
    var tmp_16 = ensureNotNull(tmp_15 == null ? null : new Offset(tmp_15));
    // Inline function 'androidx.compose.ui.text.restore' call
    var tmp0_safe_receiver = list.l1(2);
    var tmp_17;
    if (tmp0_safe_receiver == null) {
      tmp_17 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_17 = typeof tmp0_safe_receiver === 'number' ? tmp0_safe_receiver : THROW_CCE();
    }
    var tmp$ret$10 = tmp_17;
    return new Shadow(tmp_7.c6d_1, tmp_16.e5d_1, ensureNotNull(tmp$ret$10));
  }
  function ColorSaver$lambda($this$NonNullValueClassSaver, it) {
    _init_properties_Savers_kt__o6r3ry();
    var tmp;
    // Inline function 'androidx.compose.ui.graphics.isUnspecified' call
    var this_0 = it.c6d_1;
    if (equals(_Color___get_value__impl__1pls5m(this_0), _ULong___init__impl__c78o9k(new Long(16, 0)))) {
      tmp = false;
    } else {
      tmp = toArgb(it.c6d_1);
    }
    return tmp;
  }
  function ColorSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    var tmp;
    if (equals(it, false)) {
      tmp = Companion_getInstance().u6b_1;
    } else {
      tmp = Color_0(typeof it === 'number' ? it : THROW_CCE());
    }
    var tmp_0 = tmp;
    return tmp_0 == null ? null : new Color(tmp_0);
  }
  function TextAlignSaver$lambda($this$NonNullValueClassSaver, it) {
    _init_properties_Savers_kt__o6r3ry();
    return _TextAlign___get_value__impl__lst7m3(it.t7v_1);
  }
  function TextAlignSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    return new TextAlign(_TextAlign___init__impl__99wz4v(typeof it === 'number' ? it : THROW_CCE()));
  }
  function TextDirectionSaver$lambda($this$NonNullValueClassSaver, it) {
    _init_properties_Savers_kt__o6r3ry();
    return _TextDirection___get_value__impl__ka7r45(it.u7v_1);
  }
  function TextDirectionSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    return new TextDirection(_TextDirection___init__impl__lh8lzt(typeof it === 'number' ? it : THROW_CCE()));
  }
  function HyphensSaver$lambda($this$NonNullValueClassSaver, it) {
    _init_properties_Savers_kt__o6r3ry();
    return _Hyphens___get_value__impl__5itus4(it.w7v_1);
  }
  function HyphensSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    return new Hyphens(_Hyphens___init__impl__m2cvg8(typeof it === 'number' ? it : THROW_CCE()));
  }
  function FontStyleSaver$lambda($this$Saver, it) {
    _init_properties_Savers_kt__o6r3ry();
    return save(_FontStyle___get_value__impl__gx8aaz(it.d7x_1));
  }
  function FontStyleSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    return new FontStyle(_FontStyle___init__impl__jcnduf(typeof it === 'number' ? it : THROW_CCE()));
  }
  function FontSynthesisSaver$lambda($this$Saver, it) {
    _init_properties_Savers_kt__o6r3ry();
    return _FontSynthesis___get_value__impl__xrueqg(it.e7x_1);
  }
  function FontSynthesisSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    return new FontSynthesis(_FontSynthesis___init__impl__n397bg(typeof it === 'number' ? it : THROW_CCE()));
  }
  function TextUnitSaver$lambda($this$NonNullValueClassSaver, it) {
    _init_properties_Savers_kt__o6r3ry();
    var tmp;
    if (equals(it, new TextUnit(Companion_getInstance_1().q5g_1))) {
      tmp = false;
    } else {
      tmp = arrayListOf([save(_TextUnit___get_value__impl__hpbx0k(it.s5g_1)), save_0(new TextUnitType(_TextUnit___get_type__impl__uc2olt(it.s5g_1)), get_Saver_15(Companion_getInstance_4()), $this$NonNullValueClassSaver)]);
    }
    return tmp;
  }
  function TextUnitSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    var tmp;
    if (equals(it, false)) {
      tmp = Companion_getInstance_1().q5g_1;
    } else {
      var list = isInterface(it, KtList) ? it : THROW_CCE();
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp0_safe_receiver = list.l1(0);
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_0 = typeof tmp0_safe_receiver === 'number' ? tmp0_safe_receiver : THROW_CCE();
      }
      var tmp$ret$0 = tmp_0;
      var tmp_1 = ensureNotNull(tmp$ret$0);
      var tmp0 = list.l1(1);
      var tmp2 = get_Saver_15(Companion_getInstance_4());
      var tmp$ret$3;
      $l$block: {
        // Inline function 'androidx.compose.ui.text.restore' call
        var tmp_2;
        if (equals(tmp0, false)) {
          tmp_2 = !isInterface(tmp2, NonNullValueClassSaver);
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          tmp$ret$3 = null;
          break $l$block;
        }
        var tmp_3;
        if (tmp0 == null) {
          tmp_3 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.with' call
          var tmp_4 = tmp2.b7o(tmp0);
          var tmp_5;
          if (tmp_4 == null ? true : tmp_4 instanceof TextUnitType) {
            var tmp_6 = tmp_4;
            tmp_5 = tmp_6 == null ? null : tmp_6.r5g_1;
          } else {
            tmp_5 = THROW_CCE();
          }
          var tmp_7 = tmp_5;
          var tmp_8 = tmp_7 == null ? null : new TextUnitType(tmp_7);
          tmp_3 = tmp_8 == null ? null : tmp_8.r5g_1;
        }
        tmp$ret$3 = tmp_3;
      }
      var tmp_9 = tmp$ret$3;
      tmp = TextUnit_0(tmp_1, ensureNotNull(tmp_9 == null ? null : new TextUnitType(tmp_9)).r5g_1);
    }
    var tmp_10 = tmp;
    return tmp_10 == null ? null : new TextUnit(tmp_10);
  }
  function TextUnitTypeSaver$lambda($this$NonNullValueClassSaver, it) {
    _init_properties_Savers_kt__o6r3ry();
    var tmp0_subject = it.r5g_1;
    return equals(tmp0_subject, Companion_getInstance_4().a5f_1) ? 0 : equals(tmp0_subject, Companion_getInstance_4().z5e_1) ? 1 : false;
  }
  function TextUnitTypeSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    var tmp = equals(it, 0) ? Companion_getInstance_4().a5f_1 : equals(it, 1) ? Companion_getInstance_4().z5e_1 : Companion_getInstance_4().y5e_1;
    return tmp == null ? null : new TextUnitType(tmp);
  }
  function OffsetSaver$lambda($this$NonNullValueClassSaver, it) {
    _init_properties_Savers_kt__o6r3ry();
    var tmp;
    if (equals(it, new Offset(Companion_getInstance_3().i5d_1))) {
      tmp = false;
    } else {
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      var this_0 = it.e5d_1;
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Offset___get_packedValue__impl__xh2k8q(this_0);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      var tmp$ret$0 = floatFromBits(bits);
      var tmp_0 = save(tmp$ret$0);
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      var this_1 = it.e5d_1;
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_0 = _Offset___get_packedValue__impl__xh2k8q(this_1);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      var tmp$ret$4 = floatFromBits(bits_0);
      tmp = arrayListOf([tmp_0, save(tmp$ret$4)]);
    }
    return tmp;
  }
  function OffsetSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    var tmp;
    if (equals(it, false)) {
      tmp = Companion_getInstance_3().i5d_1;
    } else {
      var list = isInterface(it, KtList) ? it : THROW_CCE();
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp0_safe_receiver = list.l1(0);
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_0 = typeof tmp0_safe_receiver === 'number' ? tmp0_safe_receiver : THROW_CCE();
      }
      var tmp$ret$0 = tmp_0;
      var tmp0 = ensureNotNull(tmp$ret$0);
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp0_safe_receiver_0 = list.l1(1);
      var tmp_1;
      if (tmp0_safe_receiver_0 == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_1 = typeof tmp0_safe_receiver_0 === 'number' ? tmp0_safe_receiver_0 : THROW_CCE();
      }
      var tmp$ret$3 = tmp_1;
      // Inline function 'androidx.compose.ui.geometry.Offset' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var val2 = ensureNotNull(tmp$ret$3);
      var v1 = fromInt(toRawBits(tmp0));
      var v2 = fromInt(toRawBits(val2));
      var tmp$ret$7 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
      tmp = _Offset___init__impl__c168vi(tmp$ret$7);
    }
    var tmp_2 = tmp;
    return tmp_2 == null ? null : new Offset(tmp_2);
  }
  function LocaleListSaver$lambda($this$Saver, it) {
    _init_properties_Savers_kt__o6r3ry();
    // Inline function 'androidx.compose.ui.util.fastMap' call
    var this_0 = it.q7x_1;
    var target = ArrayList_init_$Create$_0(this_0.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        // Inline function 'kotlin.collections.plusAssign' call
        var element = save_0(item, get_Saver_16(Companion_instance_44), $this$Saver);
        target.j1(element);
      }
       while (inductionVariable <= last);
    return target;
  }
  function LocaleListSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    var list = isInterface(it, KtList) ? it : THROW_CCE();
    // Inline function 'androidx.compose.ui.util.fastMap' call
    var target = ArrayList_init_$Create$_0(list.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = list.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = list.l1(index);
        var tmp2 = get_Saver_16(Companion_instance_44);
        var tmp$ret$4;
        $l$block: {
          // Inline function 'androidx.compose.ui.text.restore' call
          var tmp;
          if (equals(item, false)) {
            tmp = !isInterface(tmp2, NonNullValueClassSaver);
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$4 = null;
            break $l$block;
          }
          var tmp_0;
          if (item == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.with' call
            var tmp_1 = tmp2.b7o(item);
            tmp_0 = (tmp_1 == null ? true : tmp_1 instanceof Locale) ? tmp_1 : THROW_CCE();
          }
          tmp$ret$4 = tmp_0;
        }
        // Inline function 'kotlin.collections.plusAssign' call
        var element = ensureNotNull(tmp$ret$4);
        target.j1(element);
      }
       while (inductionVariable <= last);
    return new LocaleList(target);
  }
  function LocaleSaver$lambda($this$Saver, it) {
    _init_properties_Savers_kt__o6r3ry();
    return it.u7x();
  }
  function LocaleSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    return Locale_init_$Create$(typeof it === 'string' ? it : THROW_CCE());
  }
  function LineHeightStyleSaver$lambda($this$Saver, it) {
    _init_properties_Savers_kt__o6r3ry();
    return arrayListOf([save_0(new Alignment(it.v7x_1), get_Saver_17(Companion_getInstance_40()), $this$Saver), save_0(new Trim(it.w7x_1), get_Saver_18(Companion_getInstance_39()), $this$Saver), save_0(new Mode(it.x7x_1), get_Saver_19(Companion_getInstance_41()), $this$Saver)]);
  }
  function LineHeightStyleSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    var list = isInterface(it, KtList) ? it : THROW_CCE();
    var tmp0 = list.l1(0);
    var tmp2 = get_Saver_17(Companion_getInstance_40());
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp;
      if (equals(tmp0, false)) {
        tmp = !isInterface(tmp2, NonNullValueClassSaver);
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = null;
        break $l$block;
      }
      var tmp_0;
      if (tmp0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_1 = tmp2.b7o(tmp0);
        var tmp_2;
        if (tmp_1 == null ? true : tmp_1 instanceof Alignment) {
          var tmp_3 = tmp_1;
          tmp_2 = tmp_3 == null ? null : tmp_3.y7x_1;
        } else {
          tmp_2 = THROW_CCE();
        }
        var tmp_4 = tmp_2;
        var tmp_5 = tmp_4 == null ? null : new Alignment(tmp_4);
        tmp_0 = tmp_5 == null ? null : tmp_5.y7x_1;
      }
      tmp$ret$0 = tmp_0;
    }
    var tmp_6 = tmp$ret$0;
    var tmp_7 = ensureNotNull(tmp_6 == null ? null : new Alignment(tmp_6));
    var tmp0_0 = list.l1(1);
    var tmp2_0 = get_Saver_18(Companion_getInstance_39());
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp_8;
      if (equals(tmp0_0, false)) {
        tmp_8 = !isInterface(tmp2_0, NonNullValueClassSaver);
      } else {
        tmp_8 = false;
      }
      if (tmp_8) {
        tmp$ret$5 = null;
        break $l$block_0;
      }
      var tmp_9;
      if (tmp0_0 == null) {
        tmp_9 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_10 = tmp2_0.b7o(tmp0_0);
        var tmp_11;
        if (tmp_10 == null ? true : tmp_10 instanceof Trim) {
          var tmp_12 = tmp_10;
          tmp_11 = tmp_12 == null ? null : tmp_12.z7x_1;
        } else {
          tmp_11 = THROW_CCE();
        }
        var tmp_13 = tmp_11;
        var tmp_14 = tmp_13 == null ? null : new Trim(tmp_13);
        tmp_9 = tmp_14 == null ? null : tmp_14.z7x_1;
      }
      tmp$ret$5 = tmp_9;
    }
    var tmp_15 = tmp$ret$5;
    var tmp_16 = ensureNotNull(tmp_15 == null ? null : new Trim(tmp_15));
    var tmp0_1 = list.l1(2);
    var tmp2_1 = get_Saver_19(Companion_getInstance_41());
    var tmp$ret$10;
    $l$block_1: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp_17;
      if (equals(tmp0_1, false)) {
        tmp_17 = !isInterface(tmp2_1, NonNullValueClassSaver);
      } else {
        tmp_17 = false;
      }
      if (tmp_17) {
        tmp$ret$10 = null;
        break $l$block_1;
      }
      var tmp_18;
      if (tmp0_1 == null) {
        tmp_18 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_19 = tmp2_1.b7o(tmp0_1);
        var tmp_20;
        if (tmp_19 == null ? true : tmp_19 instanceof Mode) {
          var tmp_21 = tmp_19;
          tmp_20 = tmp_21 == null ? null : tmp_21.a7y_1;
        } else {
          tmp_20 = THROW_CCE();
        }
        var tmp_22 = tmp_20;
        var tmp_23 = tmp_22 == null ? null : new Mode(tmp_22);
        tmp_18 = tmp_23 == null ? null : tmp_23.a7y_1;
      }
      tmp$ret$10 = tmp_18;
    }
    var tmp_24 = tmp$ret$10;
    return new LineHeightStyle(tmp_7.y7x_1, tmp_16.z7x_1, ensureNotNull(tmp_24 == null ? null : new Mode(tmp_24)).a7y_1);
  }
  function LineHeightStyleAlignmentSaver$lambda($this$NonNullValueClassSaver, it) {
    _init_properties_Savers_kt__o6r3ry();
    return _Alignment___get_topRatio__impl__gg7tir(it.y7x_1);
  }
  function LineHeightStyleAlignmentSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    return new Alignment(_Alignment___init__impl__it107q(typeof it === 'number' ? it : THROW_CCE()));
  }
  function LineHeightStyleTrimSaver$lambda($this$NonNullValueClassSaver, it) {
    _init_properties_Savers_kt__o6r3ry();
    return _Trim___get_value__impl__o5eglp(it.z7x_1);
  }
  function LineHeightStyleTrimSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    return new Trim(_Trim___init__impl__tcc1lr(typeof it === 'number' ? it : THROW_CCE()));
  }
  function LineHeightStyleModeSaver$lambda($this$NonNullValueClassSaver, it) {
    _init_properties_Savers_kt__o6r3ry();
    return _Mode___get_value__impl__uitpda(it.a7y_1);
  }
  function LineHeightStyleModeSaver$lambda_0(it) {
    _init_properties_Savers_kt__o6r3ry();
    return new Mode(_Mode___init__impl__3rgsrm(typeof it === 'number' ? it : THROW_CCE()));
  }
  function NonNullValueClassSaver$1($save, $restore) {
    this.b7y_1 = $save;
    this.c7y_1 = $restore;
  }
  protoOf(NonNullValueClassSaver$1).l7o = function (_this__u8e3s4, value) {
    return this.b7y_1(_this__u8e3s4, value);
  };
  protoOf(NonNullValueClassSaver$1).b7o = function (value) {
    return this.c7y_1(value);
  };
  function AnnotationType_Paragraph_getInstance() {
    AnnotationType_initEntries();
    return AnnotationType_Paragraph_instance;
  }
  function AnnotationType_Span_getInstance() {
    AnnotationType_initEntries();
    return AnnotationType_Span_instance;
  }
  function AnnotationType_VerbatimTts_getInstance() {
    AnnotationType_initEntries();
    return AnnotationType_VerbatimTts_instance;
  }
  function AnnotationType_Url_getInstance() {
    AnnotationType_initEntries();
    return AnnotationType_Url_instance;
  }
  function AnnotationType_Link_getInstance() {
    AnnotationType_initEntries();
    return AnnotationType_Link_instance;
  }
  function AnnotationType_Clickable_getInstance() {
    AnnotationType_initEntries();
    return AnnotationType_Clickable_instance;
  }
  function AnnotationType_String_getInstance() {
    AnnotationType_initEntries();
    return AnnotationType_String_instance;
  }
  var properties_initialized_Savers_kt_vjp8zk;
  function _init_properties_Savers_kt__o6r3ry() {
    if (!properties_initialized_Savers_kt_vjp8zk) {
      properties_initialized_Savers_kt_vjp8zk = true;
      var tmp = AnnotatedStringSaver$lambda;
      AnnotatedStringSaver = Saver_0(tmp, AnnotatedStringSaver$lambda_0);
      var tmp_0 = AnnotationRangeListSaver$lambda;
      AnnotationRangeListSaver = Saver_0(tmp_0, AnnotationRangeListSaver$lambda_0);
      var tmp_1 = AnnotationRangeSaver$lambda;
      AnnotationRangeSaver = Saver_0(tmp_1, AnnotationRangeSaver$lambda_0);
      var tmp_2 = VerbatimTtsAnnotationSaver$lambda;
      VerbatimTtsAnnotationSaver = Saver_0(tmp_2, VerbatimTtsAnnotationSaver$lambda_0);
      var tmp_3 = UrlAnnotationSaver$lambda;
      UrlAnnotationSaver = Saver_0(tmp_3, UrlAnnotationSaver$lambda_0);
      var tmp_4 = LinkSaver$lambda;
      LinkSaver = Saver_0(tmp_4, LinkSaver$lambda_0);
      var tmp_5 = ClickableSaver$lambda;
      ClickableSaver = Saver_0(tmp_5, ClickableSaver$lambda_0);
      var tmp_6 = ParagraphStyleSaver$lambda;
      ParagraphStyleSaver = Saver_0(tmp_6, ParagraphStyleSaver$lambda_0);
      var tmp_7 = SpanStyleSaver$lambda;
      SpanStyleSaver = Saver_0(tmp_7, SpanStyleSaver$lambda_0);
      var tmp_8 = TextLinkStylesSaver$lambda;
      TextLinkStylesSaver = Saver_0(tmp_8, TextLinkStylesSaver$lambda_0);
      var tmp_9 = TextDecorationSaver$lambda;
      TextDecorationSaver = Saver_0(tmp_9, TextDecorationSaver$lambda_0);
      var tmp_10 = TextGeometricTransformSaver$lambda;
      TextGeometricTransformSaver = Saver_0(tmp_10, TextGeometricTransformSaver$lambda_0);
      var tmp_11 = TextIndentSaver$lambda;
      TextIndentSaver = Saver_0(tmp_11, TextIndentSaver$lambda_0);
      var tmp_12 = FontWeightSaver$lambda;
      FontWeightSaver = Saver_0(tmp_12, FontWeightSaver$lambda_0);
      var tmp_13 = BaselineShiftSaver$lambda;
      BaselineShiftSaver = Saver_0(tmp_13, BaselineShiftSaver$lambda_0);
      var tmp_14 = TextRangeSaver$lambda;
      TextRangeSaver = Saver_0(tmp_14, TextRangeSaver$lambda_0);
      var tmp_15 = ShadowSaver$lambda;
      ShadowSaver = Saver_0(tmp_15, ShadowSaver$lambda_0);
      var tmp_16 = ColorSaver$lambda;
      ColorSaver = NonNullValueClassSaver_0(tmp_16, ColorSaver$lambda_0);
      var tmp_17 = TextAlignSaver$lambda;
      TextAlignSaver = NonNullValueClassSaver_0(tmp_17, TextAlignSaver$lambda_0);
      var tmp_18 = TextDirectionSaver$lambda;
      TextDirectionSaver = NonNullValueClassSaver_0(tmp_18, TextDirectionSaver$lambda_0);
      var tmp_19 = HyphensSaver$lambda;
      HyphensSaver = NonNullValueClassSaver_0(tmp_19, HyphensSaver$lambda_0);
      var tmp_20 = FontStyleSaver$lambda;
      FontStyleSaver = Saver_0(tmp_20, FontStyleSaver$lambda_0);
      var tmp_21 = FontSynthesisSaver$lambda;
      FontSynthesisSaver = Saver_0(tmp_21, FontSynthesisSaver$lambda_0);
      var tmp_22 = TextUnitSaver$lambda;
      TextUnitSaver = NonNullValueClassSaver_0(tmp_22, TextUnitSaver$lambda_0);
      var tmp_23 = TextUnitTypeSaver$lambda;
      TextUnitTypeSaver = NonNullValueClassSaver_0(tmp_23, TextUnitTypeSaver$lambda_0);
      var tmp_24 = OffsetSaver$lambda;
      OffsetSaver = NonNullValueClassSaver_0(tmp_24, OffsetSaver$lambda_0);
      var tmp_25 = LocaleListSaver$lambda;
      LocaleListSaver = Saver_0(tmp_25, LocaleListSaver$lambda_0);
      var tmp_26 = LocaleSaver$lambda;
      LocaleSaver = Saver_0(tmp_26, LocaleSaver$lambda_0);
      var tmp_27 = LineHeightStyleSaver$lambda;
      LineHeightStyleSaver = Saver_0(tmp_27, LineHeightStyleSaver$lambda_0);
      var tmp_28 = LineHeightStyleAlignmentSaver$lambda;
      LineHeightStyleAlignmentSaver = NonNullValueClassSaver_0(tmp_28, LineHeightStyleAlignmentSaver$lambda_0);
      var tmp_29 = LineHeightStyleTrimSaver$lambda;
      LineHeightStyleTrimSaver = NonNullValueClassSaver_0(tmp_29, LineHeightStyleTrimSaver$lambda_0);
      var tmp_30 = LineHeightStyleModeSaver$lambda;
      LineHeightStyleModeSaver = NonNullValueClassSaver_0(tmp_30, LineHeightStyleModeSaver$lambda_0);
    }
  }
  function get_DefaultFontSize() {
    _init_properties_SpanStyle_kt__ixg4k5();
    return DefaultFontSize;
  }
  var DefaultFontSize;
  function get_DefaultLetterSpacing() {
    _init_properties_SpanStyle_kt__ixg4k5();
    return DefaultLetterSpacing;
  }
  var DefaultLetterSpacing;
  function get_DefaultBackgroundColor() {
    _init_properties_SpanStyle_kt__ixg4k5();
    return DefaultBackgroundColor;
  }
  var DefaultBackgroundColor;
  function get_DefaultColor() {
    _init_properties_SpanStyle_kt__ixg4k5();
    return DefaultColor;
  }
  var DefaultColor;
  function get_DefaultColorForegroundStyle() {
    _init_properties_SpanStyle_kt__ixg4k5();
    return DefaultColorForegroundStyle;
  }
  var DefaultColorForegroundStyle;
  var androidx_compose_ui_text_SpanStyle$stable;
  function SpanStyle_init_$Init$(color, fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, shadow, platformStyle, drawStyle, $this) {
    color = color === VOID ? Companion_getInstance().u6b_1 : color;
    fontSize = fontSize === VOID ? Companion_getInstance_1().q5g_1 : fontSize;
    fontWeight = fontWeight === VOID ? null : fontWeight;
    fontStyle = fontStyle === VOID ? null : fontStyle;
    fontSynthesis = fontSynthesis === VOID ? null : fontSynthesis;
    fontFamily = fontFamily === VOID ? null : fontFamily;
    fontFeatureSettings = fontFeatureSettings === VOID ? null : fontFeatureSettings;
    letterSpacing = letterSpacing === VOID ? Companion_getInstance_1().q5g_1 : letterSpacing;
    baselineShift = baselineShift === VOID ? null : baselineShift;
    textGeometricTransform = textGeometricTransform === VOID ? null : textGeometricTransform;
    localeList = localeList === VOID ? null : localeList;
    background = background === VOID ? Companion_getInstance().u6b_1 : background;
    textDecoration = textDecoration === VOID ? null : textDecoration;
    shadow = shadow === VOID ? null : shadow;
    platformStyle = platformStyle === VOID ? null : platformStyle;
    drawStyle = drawStyle === VOID ? null : drawStyle;
    SpanStyle.call($this, Companion_instance_33.d7y(color), fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, shadow, platformStyle, drawStyle);
    return $this;
  }
  function SpanStyle_init_$Create$(color, fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, shadow, platformStyle, drawStyle) {
    return SpanStyle_init_$Init$(color, fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, shadow, platformStyle, drawStyle, objectCreate(protoOf(SpanStyle)));
  }
  function SpanStyle_init_$Init$_0(brush, alpha, fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, shadow, platformStyle, drawStyle, $this) {
    alpha = alpha === VOID ? NaN : alpha;
    fontSize = fontSize === VOID ? Companion_getInstance_1().q5g_1 : fontSize;
    fontWeight = fontWeight === VOID ? null : fontWeight;
    fontStyle = fontStyle === VOID ? null : fontStyle;
    fontSynthesis = fontSynthesis === VOID ? null : fontSynthesis;
    fontFamily = fontFamily === VOID ? null : fontFamily;
    fontFeatureSettings = fontFeatureSettings === VOID ? null : fontFeatureSettings;
    letterSpacing = letterSpacing === VOID ? Companion_getInstance_1().q5g_1 : letterSpacing;
    baselineShift = baselineShift === VOID ? null : baselineShift;
    textGeometricTransform = textGeometricTransform === VOID ? null : textGeometricTransform;
    localeList = localeList === VOID ? null : localeList;
    background = background === VOID ? Companion_getInstance().u6b_1 : background;
    textDecoration = textDecoration === VOID ? null : textDecoration;
    shadow = shadow === VOID ? null : shadow;
    platformStyle = platformStyle === VOID ? null : platformStyle;
    drawStyle = drawStyle === VOID ? null : drawStyle;
    SpanStyle.call($this, Companion_instance_33.e7y(brush, alpha), fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, shadow, platformStyle, drawStyle);
    return $this;
  }
  function SpanStyle_init_$Create$_0(brush, alpha, fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, shadow, platformStyle, drawStyle) {
    return SpanStyle_init_$Init$_0(brush, alpha, fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, shadow, platformStyle, drawStyle, objectCreate(protoOf(SpanStyle)));
  }
  function SpanStyle(textForegroundStyle, fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, shadow, platformStyle, drawStyle) {
    fontSize = fontSize === VOID ? Companion_getInstance_1().q5g_1 : fontSize;
    fontWeight = fontWeight === VOID ? null : fontWeight;
    fontStyle = fontStyle === VOID ? null : fontStyle;
    fontSynthesis = fontSynthesis === VOID ? null : fontSynthesis;
    fontFamily = fontFamily === VOID ? null : fontFamily;
    fontFeatureSettings = fontFeatureSettings === VOID ? null : fontFeatureSettings;
    letterSpacing = letterSpacing === VOID ? Companion_getInstance_1().q5g_1 : letterSpacing;
    baselineShift = baselineShift === VOID ? null : baselineShift;
    textGeometricTransform = textGeometricTransform === VOID ? null : textGeometricTransform;
    localeList = localeList === VOID ? null : localeList;
    background = background === VOID ? Companion_getInstance().u6b_1 : background;
    textDecoration = textDecoration === VOID ? null : textDecoration;
    shadow = shadow === VOID ? null : shadow;
    platformStyle = platformStyle === VOID ? null : platformStyle;
    drawStyle = drawStyle === VOID ? null : drawStyle;
    this.n7w_1 = textForegroundStyle;
    this.o7w_1 = fontSize;
    this.p7w_1 = fontWeight;
    this.q7w_1 = fontStyle;
    this.r7w_1 = fontSynthesis;
    this.s7w_1 = fontFamily;
    this.t7w_1 = fontFeatureSettings;
    this.u7w_1 = letterSpacing;
    this.v7w_1 = baselineShift;
    this.w7w_1 = textGeometricTransform;
    this.x7w_1 = localeList;
    this.y7w_1 = background;
    this.z7w_1 = textDecoration;
    this.a7x_1 = shadow;
    this.b7x_1 = platformStyle;
    this.c7x_1 = drawStyle;
  }
  protoOf(SpanStyle).s6c = function () {
    return this.n7w_1.s6c();
  };
  protoOf(SpanStyle).f7y = function () {
    return this.n7w_1.f7y();
  };
  protoOf(SpanStyle).j68 = function () {
    return this.n7w_1.j68();
  };
  protoOf(SpanStyle).g7y = function (other) {
    if (other == null)
      return this;
    return fastMerge_0(this, other.n7w_1.s6c(), other.n7w_1.f7y(), other.n7w_1.j68(), other.o7w_1, other.p7w_1, other.q7w_1, other.r7w_1, other.s7w_1, other.t7w_1, other.u7w_1, other.v7w_1, other.w7w_1, other.x7w_1, other.y7w_1, other.z7w_1, other.a7x_1, other.b7x_1, other.c7x_1);
  };
  protoOf(SpanStyle).h7y = function (color, fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, shadow, platformStyle, drawStyle) {
    var tmp;
    if (equals(color, this.s6c())) {
      tmp = this.n7w_1;
    } else {
      tmp = Companion_instance_33.d7y(color);
    }
    return new SpanStyle(tmp, fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, shadow, platformStyle, drawStyle);
  };
  protoOf(SpanStyle).i7y = function (color, fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, shadow, platformStyle, drawStyle, $super) {
    color = color === VOID ? this.s6c() : color;
    fontSize = fontSize === VOID ? this.o7w_1 : fontSize;
    fontWeight = fontWeight === VOID ? this.p7w_1 : fontWeight;
    fontStyle = fontStyle === VOID ? this.q7w_1 : fontStyle;
    fontSynthesis = fontSynthesis === VOID ? this.r7w_1 : fontSynthesis;
    fontFamily = fontFamily === VOID ? this.s7w_1 : fontFamily;
    fontFeatureSettings = fontFeatureSettings === VOID ? this.t7w_1 : fontFeatureSettings;
    letterSpacing = letterSpacing === VOID ? this.u7w_1 : letterSpacing;
    baselineShift = baselineShift === VOID ? this.v7w_1 : baselineShift;
    textGeometricTransform = textGeometricTransform === VOID ? this.w7w_1 : textGeometricTransform;
    localeList = localeList === VOID ? this.x7w_1 : localeList;
    background = background === VOID ? this.y7w_1 : background;
    textDecoration = textDecoration === VOID ? this.z7w_1 : textDecoration;
    shadow = shadow === VOID ? this.a7x_1 : shadow;
    platformStyle = platformStyle === VOID ? this.b7x_1 : platformStyle;
    drawStyle = drawStyle === VOID ? this.c7x_1 : drawStyle;
    var tmp;
    if ($super === VOID) {
      tmp = this.h7y(color, fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, shadow, platformStyle, drawStyle);
    } else {
      var tmp_0 = $super.h7y;
      var tmp_1 = fontStyle;
      var tmp_2 = tmp_1 == null ? null : new FontStyle(tmp_1);
      var tmp_3 = fontSynthesis;
      var tmp_4 = tmp_3 == null ? null : new FontSynthesis(tmp_3);
      var tmp_5 = baselineShift;
      tmp = tmp_0.call(this, new Color(color), new TextUnit(fontSize), fontWeight, tmp_2, tmp_4, fontFamily, fontFeatureSettings, new TextUnit(letterSpacing), tmp_5 == null ? null : new BaselineShift(tmp_5), textGeometricTransform, localeList, new Color(background), textDecoration, shadow, platformStyle, drawStyle);
    }
    return tmp;
  };
  protoOf(SpanStyle).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SpanStyle))
      return false;
    return this.j7y(other) && this.k7y(other);
  };
  protoOf(SpanStyle).j7y = function (other) {
    if (this === other)
      return true;
    if (!equals(this.o7w_1, other.o7w_1))
      return false;
    if (!equals(this.p7w_1, other.p7w_1))
      return false;
    var tmp = this.q7w_1;
    var tmp_0 = tmp == null ? null : new FontStyle(tmp);
    var tmp_1 = other.q7w_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new FontStyle(tmp_1)))
      return false;
    var tmp_2 = this.r7w_1;
    var tmp_3 = tmp_2 == null ? null : new FontSynthesis(tmp_2);
    var tmp_4 = other.r7w_1;
    if (!equals(tmp_3, tmp_4 == null ? null : new FontSynthesis(tmp_4)))
      return false;
    if (!equals(this.s7w_1, other.s7w_1))
      return false;
    if (!(this.t7w_1 == other.t7w_1))
      return false;
    if (!equals(this.u7w_1, other.u7w_1))
      return false;
    var tmp_5 = this.v7w_1;
    var tmp_6 = tmp_5 == null ? null : new BaselineShift(tmp_5);
    var tmp_7 = other.v7w_1;
    if (!equals(tmp_6, tmp_7 == null ? null : new BaselineShift(tmp_7)))
      return false;
    if (!equals(this.w7w_1, other.w7w_1))
      return false;
    if (!equals(this.x7w_1, other.x7w_1))
      return false;
    if (!equals(this.y7w_1, other.y7w_1))
      return false;
    if (!equals(this.b7x_1, other.b7x_1))
      return false;
    return true;
  };
  protoOf(SpanStyle).k7y = function (other) {
    if (!equals(this.n7w_1, other.n7w_1))
      return false;
    if (!equals(this.z7w_1, other.z7w_1))
      return false;
    if (!equals(this.a7x_1, other.a7x_1))
      return false;
    if (!equals(this.c7x_1, other.c7x_1))
      return false;
    return true;
  };
  protoOf(SpanStyle).hashCode = function () {
    var result = Color__hashCode_impl_vjyivj(this.s6c());
    var tmp = imul(31, result);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.f7y();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    result = imul(31, result) + getNumberHashCode(this.j68()) | 0;
    result = imul(31, result) + TextUnit__hashCode_impl_qsmeov(this.o7w_1) | 0;
    var tmp_0 = imul(31, result);
    var tmp0_safe_receiver_0 = this.p7w_1;
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.hashCode();
    result = tmp_0 + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
    var tmp_1 = imul(31, result);
    var tmp2_safe_receiver = this.q7w_1;
    var tmp_2;
    var tmp_3 = tmp2_safe_receiver;
    if ((tmp_3 == null ? null : new FontStyle(tmp_3)) == null) {
      tmp_2 = null;
    } else {
      tmp_2 = FontStyle__hashCode_impl_7qhg4w(tmp2_safe_receiver);
    }
    var tmp3_elvis_lhs = tmp_2;
    result = tmp_1 + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    var tmp_4 = imul(31, result);
    var tmp4_safe_receiver = this.r7w_1;
    var tmp_5;
    var tmp_6 = tmp4_safe_receiver;
    if ((tmp_6 == null ? null : new FontSynthesis(tmp_6)) == null) {
      tmp_5 = null;
    } else {
      tmp_5 = FontSynthesis__hashCode_impl_4wi11v(tmp4_safe_receiver);
    }
    var tmp5_elvis_lhs = tmp_5;
    result = tmp_4 + (tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs) | 0;
    var tmp_7 = imul(31, result);
    var tmp6_safe_receiver = this.s7w_1;
    var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : hashCode(tmp6_safe_receiver);
    result = tmp_7 + (tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs) | 0;
    var tmp_8 = imul(31, result);
    var tmp8_safe_receiver = this.t7w_1;
    var tmp9_elvis_lhs = tmp8_safe_receiver == null ? null : getStringHashCode(tmp8_safe_receiver);
    result = tmp_8 + (tmp9_elvis_lhs == null ? 0 : tmp9_elvis_lhs) | 0;
    result = imul(31, result) + TextUnit__hashCode_impl_qsmeov(this.u7w_1) | 0;
    var tmp_9 = imul(31, result);
    var tmp10_safe_receiver = this.v7w_1;
    var tmp_10;
    var tmp_11 = tmp10_safe_receiver;
    if ((tmp_11 == null ? null : new BaselineShift(tmp_11)) == null) {
      tmp_10 = null;
    } else {
      tmp_10 = BaselineShift__hashCode_impl_g0potx(tmp10_safe_receiver);
    }
    var tmp11_elvis_lhs = tmp_10;
    result = tmp_9 + (tmp11_elvis_lhs == null ? 0 : tmp11_elvis_lhs) | 0;
    var tmp_12 = imul(31, result);
    var tmp12_safe_receiver = this.w7w_1;
    var tmp13_elvis_lhs = tmp12_safe_receiver == null ? null : tmp12_safe_receiver.hashCode();
    result = tmp_12 + (tmp13_elvis_lhs == null ? 0 : tmp13_elvis_lhs) | 0;
    var tmp_13 = imul(31, result);
    var tmp14_safe_receiver = this.x7w_1;
    var tmp15_elvis_lhs = tmp14_safe_receiver == null ? null : tmp14_safe_receiver.hashCode();
    result = tmp_13 + (tmp15_elvis_lhs == null ? 0 : tmp15_elvis_lhs) | 0;
    result = imul(31, result) + Color__hashCode_impl_vjyivj(this.y7w_1) | 0;
    var tmp_14 = imul(31, result);
    var tmp16_safe_receiver = this.z7w_1;
    var tmp17_elvis_lhs = tmp16_safe_receiver == null ? null : tmp16_safe_receiver.hashCode();
    result = tmp_14 + (tmp17_elvis_lhs == null ? 0 : tmp17_elvis_lhs) | 0;
    var tmp_15 = imul(31, result);
    var tmp18_safe_receiver = this.a7x_1;
    var tmp19_elvis_lhs = tmp18_safe_receiver == null ? null : tmp18_safe_receiver.hashCode();
    result = tmp_15 + (tmp19_elvis_lhs == null ? 0 : tmp19_elvis_lhs) | 0;
    var tmp_16 = imul(31, result);
    var tmp20_safe_receiver = this.b7x_1;
    var tmp21_elvis_lhs = tmp20_safe_receiver == null ? null : tmp20_safe_receiver.hashCode();
    result = tmp_16 + (tmp21_elvis_lhs == null ? 0 : tmp21_elvis_lhs) | 0;
    var tmp_17 = imul(31, result);
    var tmp22_safe_receiver = this.c7x_1;
    var tmp23_elvis_lhs = tmp22_safe_receiver == null ? null : hashCode(tmp22_safe_receiver);
    result = tmp_17 + (tmp23_elvis_lhs == null ? 0 : tmp23_elvis_lhs) | 0;
    return result;
  };
  protoOf(SpanStyle).l7y = function () {
    var result = TextUnit__hashCode_impl_qsmeov(this.o7w_1);
    var tmp = imul(31, result);
    var tmp0_safe_receiver = this.p7w_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hashCode();
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    var tmp_0 = imul(31, result);
    var tmp2_safe_receiver = this.q7w_1;
    var tmp_1;
    var tmp_2 = tmp2_safe_receiver;
    if ((tmp_2 == null ? null : new FontStyle(tmp_2)) == null) {
      tmp_1 = null;
    } else {
      tmp_1 = FontStyle__hashCode_impl_7qhg4w(tmp2_safe_receiver);
    }
    var tmp3_elvis_lhs = tmp_1;
    result = tmp_0 + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    var tmp_3 = imul(31, result);
    var tmp4_safe_receiver = this.r7w_1;
    var tmp_4;
    var tmp_5 = tmp4_safe_receiver;
    if ((tmp_5 == null ? null : new FontSynthesis(tmp_5)) == null) {
      tmp_4 = null;
    } else {
      tmp_4 = FontSynthesis__hashCode_impl_4wi11v(tmp4_safe_receiver);
    }
    var tmp5_elvis_lhs = tmp_4;
    result = tmp_3 + (tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs) | 0;
    var tmp_6 = imul(31, result);
    var tmp6_safe_receiver = this.s7w_1;
    var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : hashCode(tmp6_safe_receiver);
    result = tmp_6 + (tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs) | 0;
    var tmp_7 = imul(31, result);
    var tmp8_safe_receiver = this.t7w_1;
    var tmp9_elvis_lhs = tmp8_safe_receiver == null ? null : getStringHashCode(tmp8_safe_receiver);
    result = tmp_7 + (tmp9_elvis_lhs == null ? 0 : tmp9_elvis_lhs) | 0;
    result = imul(31, result) + TextUnit__hashCode_impl_qsmeov(this.u7w_1) | 0;
    var tmp_8 = imul(31, result);
    var tmp10_safe_receiver = this.v7w_1;
    var tmp_9;
    var tmp_10 = tmp10_safe_receiver;
    if ((tmp_10 == null ? null : new BaselineShift(tmp_10)) == null) {
      tmp_9 = null;
    } else {
      tmp_9 = BaselineShift__hashCode_impl_g0potx(tmp10_safe_receiver);
    }
    var tmp11_elvis_lhs = tmp_9;
    result = tmp_8 + (tmp11_elvis_lhs == null ? 0 : tmp11_elvis_lhs) | 0;
    var tmp_11 = imul(31, result);
    var tmp12_safe_receiver = this.w7w_1;
    var tmp13_elvis_lhs = tmp12_safe_receiver == null ? null : tmp12_safe_receiver.hashCode();
    result = tmp_11 + (tmp13_elvis_lhs == null ? 0 : tmp13_elvis_lhs) | 0;
    var tmp_12 = imul(31, result);
    var tmp14_safe_receiver = this.x7w_1;
    var tmp15_elvis_lhs = tmp14_safe_receiver == null ? null : tmp14_safe_receiver.hashCode();
    result = tmp_12 + (tmp15_elvis_lhs == null ? 0 : tmp15_elvis_lhs) | 0;
    result = imul(31, result) + Color__hashCode_impl_vjyivj(this.y7w_1) | 0;
    var tmp_13 = imul(31, result);
    var tmp16_safe_receiver = this.b7x_1;
    var tmp17_elvis_lhs = tmp16_safe_receiver == null ? null : tmp16_safe_receiver.hashCode();
    result = tmp_13 + (tmp17_elvis_lhs == null ? 0 : tmp17_elvis_lhs) | 0;
    return result;
  };
  protoOf(SpanStyle).toString = function () {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_0();
    this_0.q('SpanStyle(');
    this_0.q('color=' + Color__toString_impl_hpzmaq(this.s6c()) + ', ');
    this_0.q('brush=' + toString(this.f7y()) + ', ');
    this_0.q('alpha=' + this.j68() + ', ');
    this_0.q('fontSize=' + TextUnit__toString_impl_51ghw0(this.o7w_1) + ', ');
    this_0.q('fontWeight=' + toString(this.p7w_1) + ', ');
    var tmp = this.q7w_1;
    this_0.q('fontStyle=' + toString(tmp == null ? null : new FontStyle(tmp)) + ', ');
    var tmp_0 = this.r7w_1;
    this_0.q('fontSynthesis=' + toString(tmp_0 == null ? null : new FontSynthesis(tmp_0)) + ', ');
    this_0.q('fontFamily=' + toString(this.s7w_1) + ', ');
    this_0.q('fontFeatureSettings=' + this.t7w_1 + ', ');
    this_0.q('letterSpacing=' + TextUnit__toString_impl_51ghw0(this.u7w_1) + ', ');
    var tmp_1 = this.v7w_1;
    this_0.q('baselineShift=' + toString(tmp_1 == null ? null : new BaselineShift(tmp_1)) + ', ');
    this_0.q('textGeometricTransform=' + toString(this.w7w_1) + ', ');
    this_0.q('localeList=' + toString(this.x7w_1) + ', ');
    this_0.q('background=' + Color__toString_impl_hpzmaq(this.y7w_1) + ', ');
    this_0.q('textDecoration=' + toString(this.z7w_1) + ', ');
    this_0.q('shadow=' + toString(this.a7x_1) + ', ');
    this_0.q('platformStyle=' + toString(this.b7x_1) + ', ');
    this_0.q('drawStyle=' + toString(this.c7x_1));
    this_0.q(')');
    return this_0.toString();
  };
  function fastMerge_0(_this__u8e3s4, color, brush, alpha, fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, shadow, platformStyle, drawStyle) {
    _init_properties_SpanStyle_kt__ixg4k5();
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    var tmp_3;
    var tmp_4;
    var tmp_5;
    var tmp_6;
    var tmp_7;
    var tmp_8;
    var tmp_9;
    var tmp_10;
    var tmp_11;
    var tmp_12;
    var tmp_13;
    var tmp_14;
    var tmp_15;
    var tmp_16;
    // Inline function 'androidx.compose.ui.unit.isSpecified' call
    // Inline function 'androidx.compose.ui.unit.isUnspecified' call
    if (!equalsLong(_TextUnit___get_rawType__impl__tu8yq5(fontSize), new Long(0, 0))) {
      tmp_16 = !equals(fontSize, _this__u8e3s4.o7w_1);
    } else {
      tmp_16 = false;
    }
    if (tmp_16) {
      tmp_15 = true;
    } else {
      var tmp_17;
      var tmp_18;
      if (brush == null) {
        // Inline function 'androidx.compose.ui.graphics.isSpecified' call
        tmp_18 = !equals(_Color___get_value__impl__1pls5m(color), _ULong___init__impl__c78o9k(new Long(16, 0)));
      } else {
        tmp_18 = false;
      }
      if (tmp_18) {
        tmp_17 = !equals(color, _this__u8e3s4.n7w_1.s6c());
      } else {
        tmp_17 = false;
      }
      tmp_15 = tmp_17;
    }
    if (tmp_15) {
      tmp_14 = true;
    } else {
      var tmp_19;
      var tmp_20 = fontStyle;
      if (!((tmp_20 == null ? null : new FontStyle(tmp_20)) == null)) {
        var tmp_21 = fontStyle;
        var tmp_22 = tmp_21 == null ? null : new FontStyle(tmp_21);
        var tmp_23 = _this__u8e3s4.q7w_1;
        tmp_19 = !equals(tmp_22, tmp_23 == null ? null : new FontStyle(tmp_23));
      } else {
        tmp_19 = false;
      }
      tmp_14 = tmp_19;
    }
    if (tmp_14) {
      tmp_13 = true;
    } else {
      tmp_13 = (!(fontWeight == null) && !equals(fontWeight, _this__u8e3s4.p7w_1));
    }
    if (tmp_13) {
      tmp_12 = true;
    } else {
      tmp_12 = (!(fontFamily == null) && !(fontFamily === _this__u8e3s4.s7w_1));
    }
    if (tmp_12) {
      tmp_11 = true;
    } else {
      var tmp_24;
      // Inline function 'androidx.compose.ui.unit.isSpecified' call
      // Inline function 'androidx.compose.ui.unit.isUnspecified' call
      if (!equalsLong(_TextUnit___get_rawType__impl__tu8yq5(letterSpacing), new Long(0, 0))) {
        tmp_24 = !equals(letterSpacing, _this__u8e3s4.u7w_1);
      } else {
        tmp_24 = false;
      }
      tmp_11 = tmp_24;
    }
    if (tmp_11) {
      tmp_10 = true;
    } else {
      tmp_10 = (!(textDecoration == null) && !equals(textDecoration, _this__u8e3s4.z7w_1));
    }
    if (tmp_10) {
      tmp_9 = true;
    } else {
      tmp_9 = !equals(brush, _this__u8e3s4.n7w_1.f7y());
    }
    if (tmp_9) {
      tmp_8 = true;
    } else {
      tmp_8 = (!(brush == null) && !(alpha === _this__u8e3s4.n7w_1.j68()));
    }
    if (tmp_8) {
      tmp_7 = true;
    } else {
      var tmp_25;
      var tmp_26 = fontSynthesis;
      if (!((tmp_26 == null ? null : new FontSynthesis(tmp_26)) == null)) {
        var tmp_27 = fontSynthesis;
        var tmp_28 = tmp_27 == null ? null : new FontSynthesis(tmp_27);
        var tmp_29 = _this__u8e3s4.r7w_1;
        tmp_25 = !equals(tmp_28, tmp_29 == null ? null : new FontSynthesis(tmp_29));
      } else {
        tmp_25 = false;
      }
      tmp_7 = tmp_25;
    }
    if (tmp_7) {
      tmp_6 = true;
    } else {
      tmp_6 = (!(fontFeatureSettings == null) && !(fontFeatureSettings == _this__u8e3s4.t7w_1));
    }
    if (tmp_6) {
      tmp_5 = true;
    } else {
      var tmp_30;
      var tmp_31 = baselineShift;
      if (!((tmp_31 == null ? null : new BaselineShift(tmp_31)) == null)) {
        var tmp_32 = baselineShift;
        var tmp_33 = tmp_32 == null ? null : new BaselineShift(tmp_32);
        var tmp_34 = _this__u8e3s4.v7w_1;
        tmp_30 = !equals(tmp_33, tmp_34 == null ? null : new BaselineShift(tmp_34));
      } else {
        tmp_30 = false;
      }
      tmp_5 = tmp_30;
    }
    if (tmp_5) {
      tmp_4 = true;
    } else {
      tmp_4 = (!(textGeometricTransform == null) && !equals(textGeometricTransform, _this__u8e3s4.w7w_1));
    }
    if (tmp_4) {
      tmp_3 = true;
    } else {
      tmp_3 = (!(localeList == null) && !equals(localeList, _this__u8e3s4.x7w_1));
    }
    if (tmp_3) {
      tmp_2 = true;
    } else {
      var tmp_35;
      // Inline function 'androidx.compose.ui.graphics.isSpecified' call
      if (!equals(_Color___get_value__impl__1pls5m(background), _ULong___init__impl__c78o9k(new Long(16, 0)))) {
        tmp_35 = !equals(background, _this__u8e3s4.y7w_1);
      } else {
        tmp_35 = false;
      }
      tmp_2 = tmp_35;
    }
    if (tmp_2) {
      tmp_1 = true;
    } else {
      tmp_1 = (!(shadow == null) && !equals(shadow, _this__u8e3s4.a7x_1));
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      tmp_0 = (!(platformStyle == null) && !equals(platformStyle, _this__u8e3s4.b7x_1));
    }
    if (tmp_0) {
      tmp = true;
    } else {
      tmp = (!(drawStyle == null) && !equals(drawStyle, _this__u8e3s4.c7x_1));
    }
    var requiresAlloc = tmp;
    if (!requiresAlloc) {
      return _this__u8e3s4;
    }
    var tmp_36;
    if (!(brush == null)) {
      tmp_36 = Companion_instance_33.e7y(brush, alpha);
    } else {
      tmp_36 = Companion_instance_33.d7y(color);
    }
    var otherTextForegroundStyle = tmp_36;
    var tmp11_textForegroundStyle = _this__u8e3s4.n7w_1.m7y(otherTextForegroundStyle);
    var tmp12_fontFamily = fontFamily == null ? _this__u8e3s4.s7w_1 : fontFamily;
    var tmp_37;
    // Inline function 'androidx.compose.ui.unit.isUnspecified' call
    if (!equalsLong(_TextUnit___get_rawType__impl__tu8yq5(fontSize), new Long(0, 0))) {
      tmp_37 = fontSize;
    } else {
      tmp_37 = _this__u8e3s4.o7w_1;
    }
    var tmp13_fontSize = tmp_37;
    var tmp14_fontWeight = fontWeight == null ? _this__u8e3s4.p7w_1 : fontWeight;
    var tmp_38;
    var tmp_39 = fontStyle;
    if ((tmp_39 == null ? null : new FontStyle(tmp_39)) == null) {
      tmp_38 = _this__u8e3s4.q7w_1;
    } else {
      tmp_38 = fontStyle;
    }
    var tmp15_fontStyle = tmp_38;
    var tmp_40;
    var tmp_41 = fontSynthesis;
    if ((tmp_41 == null ? null : new FontSynthesis(tmp_41)) == null) {
      tmp_40 = _this__u8e3s4.r7w_1;
    } else {
      tmp_40 = fontSynthesis;
    }
    var tmp16_fontSynthesis = tmp_40;
    var tmp17_fontFeatureSettings = fontFeatureSettings == null ? _this__u8e3s4.t7w_1 : fontFeatureSettings;
    var tmp_42;
    // Inline function 'androidx.compose.ui.unit.isUnspecified' call
    if (!equalsLong(_TextUnit___get_rawType__impl__tu8yq5(letterSpacing), new Long(0, 0))) {
      tmp_42 = letterSpacing;
    } else {
      tmp_42 = _this__u8e3s4.u7w_1;
    }
    var tmp18_letterSpacing = tmp_42;
    var tmp_43;
    var tmp_44 = baselineShift;
    if ((tmp_44 == null ? null : new BaselineShift(tmp_44)) == null) {
      tmp_43 = _this__u8e3s4.v7w_1;
    } else {
      tmp_43 = baselineShift;
    }
    var tmp19_baselineShift = tmp_43;
    var tmp20_textGeometricTransform = textGeometricTransform == null ? _this__u8e3s4.w7w_1 : textGeometricTransform;
    var tmp21_localeList = localeList == null ? _this__u8e3s4.x7w_1 : localeList;
    // Inline function 'androidx.compose.ui.graphics.takeOrElse' call
    var tmp_45;
    // Inline function 'androidx.compose.ui.graphics.isSpecified' call
    if (!equals(_Color___get_value__impl__1pls5m(background), _ULong___init__impl__c78o9k(new Long(16, 0)))) {
      tmp_45 = background;
    } else {
      tmp_45 = _this__u8e3s4.y7w_1;
    }
    var tmp22_background = tmp_45;
    var tmp23_textDecoration = textDecoration == null ? _this__u8e3s4.z7w_1 : textDecoration;
    var tmp24_shadow = shadow == null ? _this__u8e3s4.a7x_1 : shadow;
    var tmp25_platformStyle = mergePlatformStyle_0(_this__u8e3s4, platformStyle);
    var tmp26_drawStyle = drawStyle == null ? _this__u8e3s4.c7x_1 : drawStyle;
    return new SpanStyle(tmp11_textForegroundStyle, tmp13_fontSize, tmp14_fontWeight, tmp15_fontStyle, tmp16_fontSynthesis, tmp12_fontFamily, tmp17_fontFeatureSettings, tmp18_letterSpacing, tmp19_baselineShift, tmp20_textGeometricTransform, tmp21_localeList, tmp22_background, tmp23_textDecoration, tmp24_shadow, tmp25_platformStyle, tmp26_drawStyle);
  }
  function mergePlatformStyle_0(_this__u8e3s4, other) {
    _init_properties_SpanStyle_kt__ixg4k5();
    if (_this__u8e3s4.b7x_1 == null)
      return other;
    if (other == null)
      return _this__u8e3s4.b7x_1;
    return _this__u8e3s4.b7x_1.o7y(other);
  }
  function lerp_5(start, stop, fraction) {
    _init_properties_SpanStyle_kt__ixg4k5();
    var tmp6_textForegroundStyle = lerp_9(start.n7w_1, stop.n7w_1, fraction);
    var tmp7_fontFamily = lerpDiscrete(start.s7w_1, stop.s7w_1, fraction);
    var tmp8_fontSize = lerpTextUnitInheritable(start.o7w_1, stop.o7w_1, fraction);
    var tmp0_elvis_lhs = start.p7w_1;
    var tmp = tmp0_elvis_lhs == null ? Companion_getInstance_26().b7z_1 : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = stop.p7w_1;
    var tmp9_fontWeight = lerp_7(tmp, tmp1_elvis_lhs == null ? Companion_getInstance_26().b7z_1 : tmp1_elvis_lhs, fraction);
    var tmp_0 = start.q7w_1;
    var tmp_1 = tmp_0 == null ? null : new FontStyle(tmp_0);
    var tmp_2 = stop.q7w_1;
    var tmp_3 = lerpDiscrete(tmp_1, tmp_2 == null ? null : new FontStyle(tmp_2), fraction);
    var tmp10_fontStyle = tmp_3 == null ? null : tmp_3.d7x_1;
    var tmp_4 = start.r7w_1;
    var tmp_5 = tmp_4 == null ? null : new FontSynthesis(tmp_4);
    var tmp_6 = stop.r7w_1;
    var tmp_7 = lerpDiscrete(tmp_5, tmp_6 == null ? null : new FontSynthesis(tmp_6), fraction);
    var tmp11_fontSynthesis = tmp_7 == null ? null : tmp_7.e7x_1;
    var tmp12_fontFeatureSettings = lerpDiscrete(start.t7w_1, stop.t7w_1, fraction);
    var tmp13_letterSpacing = lerpTextUnitInheritable(start.u7w_1, stop.u7w_1, fraction);
    var tmp2_elvis_lhs = start.v7w_1;
    var tmp_8;
    var tmp_9 = tmp2_elvis_lhs;
    if ((tmp_9 == null ? null : new BaselineShift(tmp_9)) == null) {
      tmp_8 = _BaselineShift___init__impl__scj05g(0.0);
    } else {
      tmp_8 = tmp2_elvis_lhs;
    }
    var tmp_10 = tmp_8;
    var tmp3_elvis_lhs = stop.v7w_1;
    var tmp_11;
    var tmp_12 = tmp3_elvis_lhs;
    if ((tmp_12 == null ? null : new BaselineShift(tmp_12)) == null) {
      tmp_11 = _BaselineShift___init__impl__scj05g(0.0);
    } else {
      tmp_11 = tmp3_elvis_lhs;
    }
    var tmp14_baselineShift = lerp_8(tmp_10, tmp_11, fraction);
    var tmp4_elvis_lhs = start.w7w_1;
    var tmp_13 = tmp4_elvis_lhs == null ? Companion_getInstance_47().i7z_1 : tmp4_elvis_lhs;
    var tmp5_elvis_lhs = stop.w7w_1;
    var tmp15_textGeometricTransform = lerp_10(tmp_13, tmp5_elvis_lhs == null ? Companion_getInstance_47().i7z_1 : tmp5_elvis_lhs, fraction);
    var tmp16_localeList = lerpDiscrete(start.x7w_1, stop.x7w_1, fraction);
    var tmp17_background = lerp(start.y7w_1, stop.y7w_1, fraction);
    var tmp18_textDecoration = lerpDiscrete(start.z7w_1, stop.z7w_1, fraction);
    var tmp19_shadow = nullSafeLerp(start.a7x_1, stop.a7x_1, fraction);
    var tmp20_platformStyle = lerpPlatformStyle_0(start.b7x_1, stop.b7x_1, fraction);
    var tmp21_drawStyle = lerpDiscrete(start.c7x_1, stop.c7x_1, fraction);
    return new SpanStyle(tmp6_textForegroundStyle, tmp8_fontSize, tmp9_fontWeight, tmp10_fontStyle, tmp11_fontSynthesis, tmp7_fontFamily, tmp12_fontFeatureSettings, tmp13_letterSpacing, tmp14_baselineShift, tmp15_textGeometricTransform, tmp16_localeList, tmp17_background, tmp18_textDecoration, tmp19_shadow, tmp20_platformStyle, tmp21_drawStyle);
  }
  function resolveSpanStyleDefaults(style) {
    _init_properties_SpanStyle_kt__ixg4k5();
    var tmp = style.n7w_1.j7z(resolveSpanStyleDefaults$lambda);
    var tmp_0;
    // Inline function 'androidx.compose.ui.unit.isUnspecified' call
    var this_0 = style.o7w_1;
    if (equalsLong(_TextUnit___get_rawType__impl__tu8yq5(this_0), new Long(0, 0))) {
      tmp_0 = get_DefaultFontSize();
    } else {
      tmp_0 = style.o7w_1;
    }
    var tmp_1 = tmp_0;
    var tmp0_elvis_lhs = style.p7w_1;
    var tmp_2 = tmp0_elvis_lhs == null ? Companion_getInstance_26().b7z_1 : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = style.q7w_1;
    var tmp_3;
    var tmp_4 = tmp1_elvis_lhs;
    if ((tmp_4 == null ? null : new FontStyle(tmp_4)) == null) {
      tmp_3 = Companion_getInstance_24().k7z_1;
    } else {
      tmp_3 = tmp1_elvis_lhs;
    }
    var tmp_5 = tmp_3;
    var tmp2_elvis_lhs = style.r7w_1;
    var tmp_6;
    var tmp_7 = tmp2_elvis_lhs;
    if ((tmp_7 == null ? null : new FontSynthesis(tmp_7)) == null) {
      tmp_6 = Companion_getInstance_25().p7z_1;
    } else {
      tmp_6 = tmp2_elvis_lhs;
    }
    var tmp_8 = tmp_6;
    var tmp3_elvis_lhs = style.s7w_1;
    var tmp_9 = tmp3_elvis_lhs == null ? Companion_getInstance_20().q7z_1 : tmp3_elvis_lhs;
    var tmp4_elvis_lhs = style.t7w_1;
    var tmp_10 = tmp4_elvis_lhs == null ? '' : tmp4_elvis_lhs;
    var tmp_11;
    // Inline function 'androidx.compose.ui.unit.isUnspecified' call
    var this_1 = style.u7w_1;
    if (equalsLong(_TextUnit___get_rawType__impl__tu8yq5(this_1), new Long(0, 0))) {
      tmp_11 = get_DefaultLetterSpacing();
    } else {
      tmp_11 = style.u7w_1;
    }
    var tmp_12 = tmp_11;
    var tmp5_elvis_lhs = style.v7w_1;
    var tmp_13;
    var tmp_14 = tmp5_elvis_lhs;
    if ((tmp_14 == null ? null : new BaselineShift(tmp_14)) == null) {
      tmp_13 = Companion_getInstance_37().x7z_1;
    } else {
      tmp_13 = tmp5_elvis_lhs;
    }
    // Inline function 'androidx.compose.ui.text.style.takeOrElse' call
    var this_2 = tmp_13;
    var tmp_15;
    if (isNaN_0(_BaselineShift___get_multiplier__impl__qhmjek(this_2))) {
      tmp_15 = Companion_getInstance_37().x7z_1;
    } else {
      tmp_15 = this_2;
    }
    var tmp_16 = tmp_15;
    var tmp6_elvis_lhs = style.w7w_1;
    var tmp_17 = tmp6_elvis_lhs == null ? Companion_getInstance_47().i7z_1 : tmp6_elvis_lhs;
    var tmp7_elvis_lhs = style.x7w_1;
    var tmp_18 = tmp7_elvis_lhs == null ? Companion_getInstance_36().e2y() : tmp7_elvis_lhs;
    // Inline function 'androidx.compose.ui.graphics.takeOrElse' call
    var this_3 = style.y7w_1;
    var tmp_19;
    // Inline function 'androidx.compose.ui.graphics.isSpecified' call
    if (!equals(_Color___get_value__impl__1pls5m(this_3), _ULong___init__impl__c78o9k(new Long(16, 0)))) {
      tmp_19 = this_3;
    } else {
      tmp_19 = get_DefaultBackgroundColor();
    }
    var tmp_20 = tmp_19;
    var tmp8_elvis_lhs = style.z7w_1;
    var tmp_21 = tmp8_elvis_lhs == null ? Companion_getInstance_44().a80_1 : tmp8_elvis_lhs;
    var tmp9_elvis_lhs = style.a7x_1;
    var tmp_22 = tmp9_elvis_lhs == null ? Companion_getInstance_2().m6j_1 : tmp9_elvis_lhs;
    var tmp10_elvis_lhs = style.c7x_1;
    return new SpanStyle(tmp, tmp_1, tmp_2, tmp_5, tmp_8, tmp_9, tmp_10, tmp_12, tmp_16, tmp_17, tmp_18, tmp_20, tmp_21, tmp_22, style.b7x_1, tmp10_elvis_lhs == null ? Fill_getInstance() : tmp10_elvis_lhs);
  }
  function lerpDiscrete(a, b, fraction) {
    _init_properties_SpanStyle_kt__ixg4k5();
    return fraction < 0.5 ? a : b;
  }
  function lerpTextUnitInheritable(a, b, t) {
    _init_properties_SpanStyle_kt__ixg4k5();
    var tmp;
    // Inline function 'androidx.compose.ui.unit.isUnspecified' call
    if (equalsLong(_TextUnit___get_rawType__impl__tu8yq5(a), new Long(0, 0))) {
      tmp = true;
    } else {
      // Inline function 'androidx.compose.ui.unit.isUnspecified' call
      tmp = equalsLong(_TextUnit___get_rawType__impl__tu8yq5(b), new Long(0, 0));
    }
    if (tmp)
      return lerpDiscrete(new TextUnit(a), new TextUnit(b), t).s5g_1;
    return lerp_0(a, b, t);
  }
  function nullSafeLerp(lhs, rhs, fraction) {
    _init_properties_SpanStyle_kt__ixg4k5();
    if (!ComposeUiTextFlags_instance.o7r_1) {
      var tmp = lhs == null ? new Shadow() : lhs;
      return lerp_1(tmp, rhs == null ? new Shadow() : rhs, fraction);
    }
    if (lhs == null && rhs == null) {
      return null;
    }
    if (lhs == null) {
      return lerp_1(dropAlpha(ensureNotNull(rhs)), rhs, fraction);
    }
    if (rhs == null) {
      return lerp_1(lhs, dropAlpha(lhs), fraction);
    }
    return lerp_1(lhs, rhs, fraction);
  }
  function lerpPlatformStyle_0(start, stop, fraction) {
    _init_properties_SpanStyle_kt__ixg4k5();
    if (start == null && stop == null)
      return null;
    var startNonNull = start == null ? Companion_getInstance_54().d80_1 : start;
    var stopNonNull = stop == null ? Companion_getInstance_54().d80_1 : stop;
    return lerp_13(startNonNull, stopNonNull, fraction);
  }
  function dropAlpha(_this__u8e3s4) {
    _init_properties_SpanStyle_kt__ixg4k5();
    return _this__u8e3s4.r6j(Color__copy$default_impl_ectz3s(_this__u8e3s4.n6j_1, 0.0));
  }
  function resolveSpanStyleDefaults$lambda() {
    _init_properties_SpanStyle_kt__ixg4k5();
    return get_DefaultColorForegroundStyle();
  }
  var properties_initialized_SpanStyle_kt_cqbdlj;
  function _init_properties_SpanStyle_kt__ixg4k5() {
    if (!properties_initialized_SpanStyle_kt_cqbdlj) {
      properties_initialized_SpanStyle_kt_cqbdlj = true;
      DefaultFontSize = get_sp(14);
      DefaultLetterSpacing = get_sp(0);
      DefaultBackgroundColor = Companion_getInstance().t6b_1;
      DefaultColor = Companion_getInstance().i6b_1;
      DefaultColorForegroundStyle = Companion_instance_33.d7y(get_DefaultColor());
      androidx_compose_ui_text_SpanStyle$stable = 0;
    }
  }
  function _StringAnnotation___init__impl__o6a5i7(value) {
    return value;
  }
  function _StringAnnotation___get_value__impl__v4s4ej($this) {
    return $this;
  }
  function StringAnnotation__toString_impl_xnbt1d($this) {
    return 'StringAnnotation(value=' + $this + ')';
  }
  function StringAnnotation__hashCode_impl_bw5w8i($this) {
    return getStringHashCode($this);
  }
  function StringAnnotation__equals_impl_ro6p8u($this, other) {
    if (!(other instanceof StringAnnotation))
      return false;
    if (!($this === other.k7w_1))
      return false;
    return true;
  }
  function StringAnnotation(value) {
    this.k7w_1 = value;
  }
  protoOf(StringAnnotation).toString = function () {
    return StringAnnotation__toString_impl_xnbt1d(this.k7w_1);
  };
  protoOf(StringAnnotation).hashCode = function () {
    return StringAnnotation__hashCode_impl_bw5w8i(this.k7w_1);
  };
  protoOf(StringAnnotation).equals = function (other) {
    return StringAnnotation__equals_impl_ro6p8u(this.k7w_1, other);
  };
  function unbox(_this__u8e3s4) {
    var tmp = _this__u8e3s4.m7p_1;
    return new Range(_StringAnnotation___get_value__impl__v4s4ej(tmp instanceof StringAnnotation ? tmp.k7w_1 : THROW_CCE()), _this__u8e3s4.n7p_1, _this__u8e3s4.o7p_1, _this__u8e3s4.p7p_1);
  }
  var androidx_compose_ui_text_TextLayoutInput$stable;
  var androidx_compose_ui_text_TextLayoutResult$stable;
  function TextLayoutResult(layoutInput, multiParagraph, size) {
    this.e80_1 = layoutInput;
    this.f80_1 = multiParagraph;
    this.g80_1 = size;
    this.h80_1 = this.f80_1.i7t();
    this.i80_1 = this.f80_1.j7t();
    this.j80_1 = this.f80_1.k7s_1;
  }
  protoOf(TextLayoutResult).k80 = function () {
    var tmp;
    if (this.f80_1.g7s_1) {
      tmp = true;
    } else {
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      var this_0 = this.g80_1;
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
      tmp = convertToInt(bitwiseAnd(value, new Long(-1, 0))) < this.f80_1.i7s_1;
    }
    return tmp;
  };
  protoOf(TextLayoutResult).l80 = function () {
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    var this_0 = this.g80_1;
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
    return convertToInt(shiftRight(value, 32)) < this.f80_1.h7s_1;
  };
  protoOf(TextLayoutResult).m80 = function () {
    return this.l80() || this.k80();
  };
  protoOf(TextLayoutResult).e7t = function () {
    return this.f80_1.j7s_1;
  };
  protoOf(TextLayoutResult).k7u = function (lineIndex) {
    return this.f80_1.k7u(lineIndex);
  };
  protoOf(TextLayoutResult).l7u = function (lineIndex, visibleEnd) {
    return this.f80_1.l7u(lineIndex, visibleEnd);
  };
  protoOf(TextLayoutResult).n80 = function (lineIndex, visibleEnd, $super) {
    visibleEnd = visibleEnd === VOID ? false : visibleEnd;
    return $super === VOID ? this.l7u(lineIndex, visibleEnd) : $super.l7u.call(this, lineIndex, visibleEnd);
  };
  protoOf(TextLayoutResult).h7u = function (lineIndex) {
    return this.f80_1.h7u(lineIndex);
  };
  protoOf(TextLayoutResult).i7u = function (lineIndex) {
    return this.f80_1.i7u(lineIndex);
  };
  protoOf(TextLayoutResult).e7u = function (lineIndex) {
    return this.f80_1.e7u(lineIndex);
  };
  protoOf(TextLayoutResult).g7u = function (lineIndex) {
    return this.f80_1.g7u(lineIndex);
  };
  protoOf(TextLayoutResult).d7u = function (offset) {
    return this.f80_1.d7u(offset);
  };
  protoOf(TextLayoutResult).p7t = function (vertical) {
    return this.f80_1.p7t(vertical);
  };
  protoOf(TextLayoutResult).w7t = function (offset, usePrimaryDirection) {
    return this.f80_1.w7t(offset, usePrimaryDirection);
  };
  protoOf(TextLayoutResult).x7t = function (offset) {
    return this.f80_1.x7t(offset);
  };
  protoOf(TextLayoutResult).y7t = function (offset) {
    return this.f80_1.y7t(offset);
  };
  protoOf(TextLayoutResult).s7t = function (position) {
    return this.f80_1.s7t(position);
  };
  protoOf(TextLayoutResult).v7t = function (offset) {
    return this.f80_1.v7t(offset);
  };
  protoOf(TextLayoutResult).z7t = function (offset) {
    return this.f80_1.z7t(offset);
  };
  protoOf(TextLayoutResult).c7u = function (offset) {
    return this.f80_1.c7u(offset);
  };
  protoOf(TextLayoutResult).u7s = function (start, end) {
    return this.f80_1.u7s(start, end);
  };
  protoOf(TextLayoutResult).o80 = function (layoutInput, size) {
    return new TextLayoutResult(layoutInput, this.f80_1, size);
  };
  protoOf(TextLayoutResult).p80 = function (layoutInput, size, $super) {
    layoutInput = layoutInput === VOID ? this.e80_1 : layoutInput;
    size = size === VOID ? this.g80_1 : size;
    return $super === VOID ? this.o80(layoutInput, size) : $super.o80.call(this, layoutInput, new IntSize(size));
  };
  protoOf(TextLayoutResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextLayoutResult))
      return false;
    if (!this.e80_1.equals(other.e80_1))
      return false;
    if (!equals(this.f80_1, other.f80_1))
      return false;
    if (!equals(this.g80_1, other.g80_1))
      return false;
    if (!(this.h80_1 === other.h80_1))
      return false;
    if (!(this.i80_1 === other.i80_1))
      return false;
    if (!equals(this.j80_1, other.j80_1))
      return false;
    return true;
  };
  protoOf(TextLayoutResult).hashCode = function () {
    var result = this.e80_1.hashCode();
    result = imul(31, result) + hashCode(this.f80_1) | 0;
    result = imul(31, result) + IntSize__hashCode_impl_gm9mta(this.g80_1) | 0;
    result = imul(31, result) + getNumberHashCode(this.h80_1) | 0;
    result = imul(31, result) + getNumberHashCode(this.i80_1) | 0;
    result = imul(31, result) + hashCode(this.j80_1) | 0;
    return result;
  };
  protoOf(TextLayoutResult).toString = function () {
    return 'TextLayoutResult(' + ('layoutInput=' + this.e80_1.toString() + ', ') + ('multiParagraph=' + toString_0(this.f80_1) + ', ') + ('size=' + IntSize__toString_impl_54w9zl(this.g80_1) + ', ') + ('firstBaseline=' + this.h80_1 + ', ') + ('lastBaseline=' + this.i80_1 + ', ') + ('placeholderRects=' + toString_0(this.j80_1)) + ')';
  };
  function TextLayoutInput_init_$Init$(text, style, placeholders, maxLines, softWrap, overflow, density, layoutDirection, fontFamilyResolver, constraints, $this) {
    TextLayoutInput.call($this, text, style, placeholders, maxLines, softWrap, overflow, density, layoutDirection, null, fontFamilyResolver, constraints);
    return $this;
  }
  function TextLayoutInput_init_$Create$(text, style, placeholders, maxLines, softWrap, overflow, density, layoutDirection, fontFamilyResolver, constraints) {
    return TextLayoutInput_init_$Init$(text, style, placeholders, maxLines, softWrap, overflow, density, layoutDirection, fontFamilyResolver, constraints, objectCreate(protoOf(TextLayoutInput)));
  }
  function TextLayoutInput(text, style, placeholders, maxLines, softWrap, overflow, density, layoutDirection, resourceLoader, fontFamilyResolver, constraints) {
    this.q80_1 = text;
    this.r80_1 = style;
    this.s80_1 = placeholders;
    this.t80_1 = maxLines;
    this.u80_1 = softWrap;
    this.v80_1 = overflow;
    this.w80_1 = density;
    this.x80_1 = layoutDirection;
    this.y80_1 = fontFamilyResolver;
    this.z80_1 = constraints;
    this.a81_1 = resourceLoader;
  }
  protoOf(TextLayoutInput).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextLayoutInput))
      return false;
    if (!this.q80_1.equals(other.q80_1))
      return false;
    if (!this.r80_1.equals(other.r80_1))
      return false;
    if (!equals(this.s80_1, other.s80_1))
      return false;
    if (!(this.t80_1 === other.t80_1))
      return false;
    if (!(this.u80_1 === other.u80_1))
      return false;
    if (!(this.v80_1 === other.v80_1))
      return false;
    if (!equals(this.w80_1, other.w80_1))
      return false;
    if (!this.x80_1.equals(other.x80_1))
      return false;
    if (!equals(this.y80_1, other.y80_1))
      return false;
    if (!equals(this.z80_1, other.z80_1))
      return false;
    return true;
  };
  protoOf(TextLayoutInput).hashCode = function () {
    var result = this.q80_1.hashCode();
    result = imul(31, result) + this.r80_1.hashCode() | 0;
    result = imul(31, result) + hashCode(this.s80_1) | 0;
    result = imul(31, result) + this.t80_1 | 0;
    result = imul(31, result) + getBooleanHashCode(this.u80_1) | 0;
    result = imul(31, result) + TextOverflow__hashCode_impl_kqdwgt(this.v80_1) | 0;
    result = imul(31, result) + hashCode(this.w80_1) | 0;
    result = imul(31, result) + this.x80_1.hashCode() | 0;
    result = imul(31, result) + hashCode(this.y80_1) | 0;
    result = imul(31, result) + Constraints__hashCode_impl_ij7484(this.z80_1) | 0;
    return result;
  };
  protoOf(TextLayoutInput).toString = function () {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_0();
    this_0.q('TextLayoutInput(');
    this_0.q('text=' + this.q80_1.toString() + ', ');
    this_0.q('style=' + this.r80_1.toString() + ', ');
    this_0.q('placeholders=' + toString_0(this.s80_1) + ', ');
    this_0.q('maxLines=' + this.t80_1 + ', ');
    this_0.q('softWrap=' + this.u80_1 + ', ');
    this_0.q('overflow=' + TextOverflow__toString_impl_10s0c2(this.v80_1) + ', ');
    this_0.q('density=' + toString_0(this.w80_1) + ', ');
    this_0.q('layoutDirection=' + this.x80_1.toString() + ', ');
    this_0.q('fontFamilyResolver=' + toString_0(this.y80_1) + ', ');
    this_0.q('constraints=' + Constraints__toString_impl_37yskr(this.z80_1));
    this_0.q(')');
    return this_0.toString();
  };
  function androidx_compose_ui_text_TextLayoutResult$stableprop_getter() {
    return androidx_compose_ui_text_TextLayoutResult$stable;
  }
  var androidx_compose_ui_text_TextLinkStyles$stable;
  function TextLinkStyles(style, focusedStyle, hoveredStyle, pressedStyle) {
    style = style === VOID ? null : style;
    focusedStyle = focusedStyle === VOID ? null : focusedStyle;
    hoveredStyle = hoveredStyle === VOID ? null : hoveredStyle;
    pressedStyle = pressedStyle === VOID ? null : pressedStyle;
    this.g7x_1 = style;
    this.h7x_1 = focusedStyle;
    this.i7x_1 = hoveredStyle;
    this.j7x_1 = pressedStyle;
  }
  protoOf(TextLinkStyles).equals = function (other) {
    if (this === other)
      return true;
    var tmp;
    if (other == null) {
      tmp = true;
    } else {
      tmp = !(other instanceof TextLinkStyles);
    }
    if (tmp)
      return false;
    if (!equals(this.g7x_1, other.g7x_1))
      return false;
    if (!equals(this.h7x_1, other.h7x_1))
      return false;
    if (!equals(this.i7x_1, other.i7x_1))
      return false;
    if (!equals(this.j7x_1, other.j7x_1))
      return false;
    return true;
  };
  protoOf(TextLinkStyles).hashCode = function () {
    var tmp0_safe_receiver = this.g7x_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hashCode();
    var result = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp = imul(31, result);
    var tmp2_safe_receiver = this.h7x_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.hashCode();
    result = tmp + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    var tmp_0 = imul(31, result);
    var tmp4_safe_receiver = this.i7x_1;
    var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.hashCode();
    result = tmp_0 + (tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs) | 0;
    var tmp_1 = imul(31, result);
    var tmp6_safe_receiver = this.j7x_1;
    var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.hashCode();
    result = tmp_1 + (tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs) | 0;
    return result;
  };
  var androidx_compose_ui_text_TextMeasurer$stable;
  var androidx_compose_ui_text_TextLayoutCache$stable;
  var androidx_compose_ui_text_CacheTextLayoutInput$stable;
  function layout($this, textLayoutInput) {
    // Inline function 'kotlin.with' call
    var tmp0_annotatedString = textLayoutInput.q80_1;
    var tmp1_style = resolveDefaults(textLayoutInput.r80_1, textLayoutInput.x80_1);
    var tmp2_density = textLayoutInput.w80_1;
    var tmp3_fontFamilyResolver = textLayoutInput.y80_1;
    var tmp4_placeholders = textLayoutInput.s80_1;
    var nonNullIntrinsics = new MultiParagraphIntrinsics(tmp0_annotatedString, tmp1_style, tmp4_placeholders, tmp2_density, tmp3_fontFamilyResolver);
    var minWidth = _Constraints___get_minWidth__impl__hi9lfi(textLayoutInput.z80_1);
    var widthMatters = textLayoutInput.u80_1 || get_isEllipsis(textLayoutInput.v80_1);
    var tmp;
    if (widthMatters && _Constraints___get_hasBoundedWidth__impl__7hd0wr(textLayoutInput.z80_1)) {
      tmp = _Constraints___get_maxWidth__impl__uuyqc(textLayoutInput.z80_1);
    } else {
      tmp = 2147483647;
    }
    var maxWidth = tmp;
    var overwriteMaxLines = !textLayoutInput.u80_1 && get_isEllipsis(textLayoutInput.v80_1);
    var finalMaxLines = overwriteMaxLines ? 1 : textLayoutInput.t80_1;
    var tmp_0;
    if (minWidth === maxWidth) {
      tmp_0 = maxWidth;
    } else {
      tmp_0 = coerceIn(ceilToInt(nonNullIntrinsics.d62()), minWidth, maxWidth);
    }
    var width = tmp_0;
    var multiParagraph = new MultiParagraph(nonNullIntrinsics, Companion_instance.s5e(0, width, 0, _Constraints___get_maxHeight__impl__dt3e8z(textLayoutInput.z80_1)), finalMaxLines, textLayoutInput.v80_1);
    // Inline function 'kotlin.math.ceil' call
    var x = multiParagraph.h7s_1;
    var tmp$ret$2 = Math.ceil(x);
    var tmp0 = numberToInt(tmp$ret$2);
    // Inline function 'kotlin.math.ceil' call
    var x_0 = multiParagraph.i7s_1;
    var tmp$ret$3 = Math.ceil(x_0);
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2 = numberToInt(tmp$ret$3);
    var tmp$ret$5 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
    var tmp$ret$4 = _IntSize___init__impl__emcjft(tmp$ret$5);
    return new TextLayoutResult(textLayoutInput, multiParagraph, constrain(textLayoutInput.z80_1, tmp$ret$4));
  }
  function Companion_2() {
  }
  var Companion_instance_4;
  function Companion_getInstance_17() {
    return Companion_instance_4;
  }
  function TextMeasurer(defaultFontFamilyResolver, defaultDensity, defaultLayoutDirection, cacheSize) {
    cacheSize = cacheSize === VOID ? 8 : cacheSize;
    this.b81_1 = defaultFontFamilyResolver;
    this.c81_1 = defaultDensity;
    this.d81_1 = defaultLayoutDirection;
    this.e81_1 = cacheSize;
    var tmp = this;
    var tmp_0;
    if (this.e81_1 > 0) {
      tmp_0 = new TextLayoutCache(this.e81_1);
    } else {
      tmp_0 = null;
    }
    tmp.f81_1 = tmp_0;
  }
  protoOf(TextMeasurer).g81 = function (text, style, overflow, softWrap, maxLines, placeholders, constraints, layoutDirection, density, fontFamilyResolver, skipCache) {
    var requestedTextLayoutInput = TextLayoutInput_init_$Create$(text, style, placeholders, maxLines, softWrap, overflow, density, layoutDirection, fontFamilyResolver, constraints);
    var tmp;
    if (!skipCache && !(this.f81_1 == null)) {
      tmp = this.f81_1.k81(requestedTextLayoutInput);
    } else {
      tmp = null;
    }
    var cacheResult = tmp;
    var tmp_0;
    if (!(cacheResult == null)) {
      var tmp0 = ceilToInt(cacheResult.f80_1.h7s_1);
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = ceilToInt(cacheResult.f80_1.i7s_1);
      var tmp$ret$2 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      var tmp$ret$1 = _IntSize___init__impl__emcjft(tmp$ret$2);
      tmp_0 = cacheResult.o80(requestedTextLayoutInput, constrain(constraints, tmp$ret$1));
    } else {
      // Inline function 'kotlin.also' call
      var this_0 = layout(Companion_instance_4, requestedTextLayoutInput);
      var tmp0_safe_receiver = this.f81_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.l81(requestedTextLayoutInput, this_0);
      }
      tmp_0 = this_0;
    }
    return tmp_0;
  };
  protoOf(TextMeasurer).m81 = function (text, style, overflow, softWrap, maxLines, placeholders, constraints, layoutDirection, density, fontFamilyResolver, skipCache, $super) {
    style = style === VOID ? Companion_getInstance_19().n81_1 : style;
    overflow = overflow === VOID ? Companion_getInstance_49().w7s_1 : overflow;
    softWrap = softWrap === VOID ? true : softWrap;
    maxLines = maxLines === VOID ? 2147483647 : maxLines;
    var tmp;
    if (placeholders === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp = emptyList();
    } else {
      tmp = placeholders;
    }
    placeholders = tmp;
    constraints = constraints === VOID ? Constraints() : constraints;
    layoutDirection = layoutDirection === VOID ? this.d81_1 : layoutDirection;
    density = density === VOID ? this.c81_1 : density;
    fontFamilyResolver = fontFamilyResolver === VOID ? this.b81_1 : fontFamilyResolver;
    skipCache = skipCache === VOID ? false : skipCache;
    return $super === VOID ? this.g81(text, style, overflow, softWrap, maxLines, placeholders, constraints, layoutDirection, density, fontFamilyResolver, skipCache) : $super.g81.call(this, text, style, new TextOverflow(overflow), softWrap, maxLines, placeholders, new Constraints_0(constraints), layoutDirection, density, fontFamilyResolver, skipCache);
  };
  function TextLayoutCache(capacity) {
    capacity = capacity === VOID ? 8 : capacity;
    var tmp = this;
    var tmp_0;
    if (!(capacity === 1)) {
      tmp_0 = new LruCache(capacity);
    } else {
      tmp_0 = null;
    }
    tmp.h81_1 = tmp_0;
    this.i81_1 = null;
    this.j81_1 = null;
  }
  protoOf(TextLayoutCache).k81 = function (key) {
    var cacheKey = new CacheTextLayoutInput(key);
    var tmp;
    if (!(this.h81_1 == null)) {
      tmp = this.h81_1.iy(cacheKey);
    } else if (equals(this.i81_1, cacheKey)) {
      tmp = this.j81_1;
    } else {
      return null;
    }
    var resultFromCache = tmp;
    if (resultFromCache == null)
      return null;
    if (resultFromCache.f80_1.e7s_1.a7v()) {
      return null;
    }
    return resultFromCache;
  };
  protoOf(TextLayoutCache).l81 = function (key, value) {
    if (!(this.h81_1 == null)) {
      this.h81_1.ly(new CacheTextLayoutInput(key), value);
    } else {
      this.i81_1 = new CacheTextLayoutInput(key);
      this.j81_1 = value;
    }
  };
  function get_isEllipsis(_this__u8e3s4) {
    return _this__u8e3s4 === Companion_getInstance_49().x7s_1 || _this__u8e3s4 === Companion_getInstance_49().z7s_1 || _this__u8e3s4 === Companion_getInstance_49().a7t_1;
  }
  function CacheTextLayoutInput(textLayoutInput) {
    this.o81_1 = textLayoutInput;
  }
  protoOf(CacheTextLayoutInput).hashCode = function () {
    // Inline function 'kotlin.with' call
    var $this$with = this.o81_1;
    var result = $this$with.q80_1.hashCode();
    result = imul(31, result) + $this$with.r80_1.l7y() | 0;
    result = imul(31, result) + hashCode($this$with.s80_1) | 0;
    result = imul(31, result) + $this$with.t80_1 | 0;
    result = imul(31, result) + getBooleanHashCode($this$with.u80_1) | 0;
    result = imul(31, result) + TextOverflow__hashCode_impl_kqdwgt($this$with.v80_1) | 0;
    result = imul(31, result) + hashCode($this$with.w80_1) | 0;
    result = imul(31, result) + $this$with.x80_1.hashCode() | 0;
    result = imul(31, result) + hashCode($this$with.y80_1) | 0;
    result = imul(31, result) + Constraints__hashCode_impl_ij7484($this$with.z80_1) | 0;
    return result;
  };
  protoOf(CacheTextLayoutInput).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CacheTextLayoutInput))
      return false;
    // Inline function 'kotlin.with' call
    var $this$with = this.o81_1;
    if (!$this$with.q80_1.equals(other.o81_1.q80_1))
      return false;
    if (!$this$with.r80_1.p81(other.o81_1.r80_1))
      return false;
    if (!equals($this$with.s80_1, other.o81_1.s80_1))
      return false;
    if (!($this$with.t80_1 === other.o81_1.t80_1))
      return false;
    if (!($this$with.u80_1 === other.o81_1.u80_1))
      return false;
    if (!($this$with.v80_1 === other.o81_1.v80_1))
      return false;
    if (!equals($this$with.w80_1, other.o81_1.w80_1))
      return false;
    if (!$this$with.x80_1.equals(other.o81_1.x80_1))
      return false;
    if (!($this$with.y80_1 === other.o81_1.y80_1))
      return false;
    if (!equals($this$with.z80_1, other.o81_1.z80_1))
      return false;
    return true;
  };
  var androidx_compose_ui_text_TextPainter$stable;
  function drawText(_this__u8e3s4, textLayoutResult, color, topLeft, alpha, shadow, textDecoration, drawStyle, blendMode) {
    color = color === VOID ? Companion_getInstance().u6b_1 : color;
    topLeft = topLeft === VOID ? Companion_getInstance_3().g5d_1 : topLeft;
    alpha = alpha === VOID ? NaN : alpha;
    shadow = shadow === VOID ? null : shadow;
    textDecoration = textDecoration === VOID ? null : textDecoration;
    drawStyle = drawStyle === VOID ? null : drawStyle;
    blendMode = blendMode === VOID ? Companion_getInstance_0().x6h_1 : blendMode;
    var newShadow = shadow == null ? textLayoutResult.e80_1.r80_1.q81() : shadow;
    var newTextDecoration = textDecoration == null ? textLayoutResult.e80_1.r80_1.r81() : textDecoration;
    var newDrawStyle = drawStyle == null ? textLayoutResult.e80_1.r80_1.s81() : drawStyle;
    // Inline function 'androidx.compose.ui.graphics.drawscope.withTransform' call
    // Inline function 'kotlin.with' call
    var $this$with = _this__u8e3s4.v6p();
    var previousSize = $this$with.o5d();
    $this$with.x5u().t6d();
    try {
      var $this$withTransform = $this$with.p6p();
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Offset___get_packedValue__impl__xh2k8q(topLeft);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      var tmp = floatFromBits(bits);
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_0 = _Offset___get_packedValue__impl__xh2k8q(topLeft);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      var tmp$ret$8 = floatFromBits(bits_0);
      $this$withTransform.b5d(tmp, tmp$ret$8);
      clip($this$withTransform, textLayoutResult);
      var brush = textLayoutResult.e80_1.r80_1.f7y();
      var tmp_0;
      if (!(brush == null)) {
        // Inline function 'androidx.compose.ui.graphics.isUnspecified' call
        tmp_0 = equals(_Color___get_value__impl__1pls5m(color), _ULong___init__impl__c78o9k(new Long(16, 0)));
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        textLayoutResult.f80_1.n7t(_this__u8e3s4.v6p().x5u(), brush, !isNaN_0(alpha) ? alpha : textLayoutResult.e80_1.r80_1.j68(), newShadow, newTextDecoration, newDrawStyle, blendMode);
      } else {
        var tmp_1 = _this__u8e3s4.v6p().x5u();
        // Inline function 'androidx.compose.ui.graphics.takeOrElse' call
        var tmp_2;
        // Inline function 'androidx.compose.ui.graphics.isSpecified' call
        if (!equals(_Color___get_value__impl__1pls5m(color), _ULong___init__impl__c78o9k(new Long(16, 0)))) {
          tmp_2 = color;
        } else {
          tmp_2 = textLayoutResult.e80_1.r80_1.s6c();
        }
        var tmp$ret$14 = tmp_2;
        textLayoutResult.f80_1.l7t(tmp_1, modulate(tmp$ret$14, alpha), newShadow, newTextDecoration, newDrawStyle, blendMode);
      }
    }finally {
      $this$with.x5u().u6d();
      $this$with.o6p(previousSize);
    }
  }
  function TextPainter() {
  }
  protoOf(TextPainter).t81 = function (canvas, textLayoutResult) {
    var needClipping = textLayoutResult.m80() && !(textLayoutResult.e80_1.v80_1 === Companion_getInstance_49().y7s_1);
    if (needClipping) {
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      var this_0 = textLayoutResult.g80_1;
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
      var width = convertToInt(shiftRight(value, 32));
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      var this_1 = textLayoutResult.g80_1;
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
      var height = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      var tmp = Companion_getInstance_3().g5d_1;
      // Inline function 'androidx.compose.ui.geometry.Size' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var v1 = fromInt(toRawBits(width));
      var v2 = fromInt(toRawBits(height));
      var tmp$ret$5 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
      var tmp$ret$4 = _Size___init__impl__aywn0g(tmp$ret$5);
      var bounds = Rect(tmp, tmp$ret$4);
      canvas.t6d();
      canvas.b6e(bounds);
    }
    var style = textLayoutResult.e80_1.r80_1.v7u_1;
    var tmp0_elvis_lhs = style.z7w_1;
    var textDecoration = tmp0_elvis_lhs == null ? Companion_getInstance_44().a80_1 : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = style.a7x_1;
    var shadow = tmp1_elvis_lhs == null ? Companion_getInstance_2().m6j_1 : tmp1_elvis_lhs;
    var tmp2_elvis_lhs = style.c7x_1;
    var drawStyle = tmp2_elvis_lhs == null ? Fill_getInstance() : tmp2_elvis_lhs;
    try {
      var brush = style.f7y();
      if (!(brush == null)) {
        var tmp_0;
        if (!(style.n7w_1 === Unspecified_instance)) {
          tmp_0 = style.n7w_1.j68();
        } else {
          tmp_0 = 1.0;
        }
        var alpha = tmp_0;
        textLayoutResult.f80_1.o7t(canvas, brush, alpha, shadow, textDecoration, drawStyle);
      } else {
        var tmp_1;
        if (!(style.n7w_1 === Unspecified_instance)) {
          tmp_1 = style.n7w_1.s6c();
        } else {
          tmp_1 = Companion_getInstance().i6b_1;
        }
        var color = tmp_1;
        textLayoutResult.f80_1.m7t(canvas, color, shadow, textDecoration, drawStyle);
      }
    }finally {
      if (needClipping) {
        canvas.u6d();
      }
    }
  };
  var TextPainter_instance;
  function TextPainter_getInstance() {
    return TextPainter_instance;
  }
  function clip(_this__u8e3s4, textLayoutResult) {
    if (textLayoutResult.m80() && !(textLayoutResult.e80_1.v80_1 === Companion_getInstance_49().y7s_1)) {
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      var this_0 = textLayoutResult.g80_1;
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
      var tmp = convertToInt(shiftRight(value, 32));
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      var this_1 = textLayoutResult.g80_1;
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
      var tmp$ret$2 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      _this__u8e3s4.r6q(0.0, 0.0, tmp, tmp$ret$2);
    }
  }
  function _TextRange___init__impl__h6icbt(packedValue) {
    return packedValue;
  }
  function _get_packedValue__aj623s($this) {
    return $this;
  }
  function _TextRange___get_start__impl__ww4t90($this) {
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value = _get_packedValue__aj623s($this);
    return convertToInt(shiftRight(value, 32));
  }
  function _TextRange___get_end__impl__gcdxpp($this) {
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value = _get_packedValue__aj623s($this);
    return convertToInt(bitwiseAnd(value, new Long(-1, 0)));
  }
  function _TextRange___get_min__impl__uu95c4($this) {
    var tmp0 = _TextRange___get_start__impl__ww4t90($this);
    // Inline function 'kotlin.math.min' call
    var b = _TextRange___get_end__impl__gcdxpp($this);
    return Math.min(tmp0, b);
  }
  function _TextRange___get_max__impl__owm8m($this) {
    var tmp0 = _TextRange___get_start__impl__ww4t90($this);
    // Inline function 'kotlin.math.max' call
    var b = _TextRange___get_end__impl__gcdxpp($this);
    return Math.max(tmp0, b);
  }
  function _TextRange___get_collapsed__impl__cilesp($this) {
    return _TextRange___get_start__impl__ww4t90($this) === _TextRange___get_end__impl__gcdxpp($this);
  }
  function _TextRange___get_reversed__impl__emhnbm($this) {
    return _TextRange___get_start__impl__ww4t90($this) > _TextRange___get_end__impl__gcdxpp($this);
  }
  function _TextRange___get_length__impl__7qes3a($this) {
    return _TextRange___get_max__impl__owm8m($this) - _TextRange___get_min__impl__uu95c4($this) | 0;
  }
  function TextRange__intersects_impl_mhtn49($this, other) {
    return !!(_TextRange___get_min__impl__uu95c4($this) < _TextRange___get_max__impl__owm8m(other) & _TextRange___get_min__impl__uu95c4(other) < _TextRange___get_max__impl__owm8m($this));
  }
  function TextRange__contains_impl_ws45z2($this, other) {
    return !!(_TextRange___get_min__impl__uu95c4($this) <= _TextRange___get_min__impl__uu95c4(other) & _TextRange___get_max__impl__owm8m(other) <= _TextRange___get_max__impl__owm8m($this));
  }
  function TextRange__contains_impl_ws45z2_0($this, offset) {
    var containsLower = _TextRange___get_min__impl__uu95c4($this);
    return offset < _TextRange___get_max__impl__owm8m($this) ? containsLower <= offset : false;
  }
  function TextRange__toString_impl_pqvlzl($this) {
    return 'TextRange(' + _TextRange___get_start__impl__ww4t90($this) + ', ' + _TextRange___get_end__impl__gcdxpp($this) + ')';
  }
  function Companion_3() {
    Companion_instance_5 = this;
    this.n7u_1 = TextRange_0(0);
  }
  var Companion_instance_5;
  function Companion_getInstance_18() {
    if (Companion_instance_5 == null)
      new Companion_3();
    return Companion_instance_5;
  }
  function TextRange__hashCode_impl_3zpp6q($this) {
    return $this.hashCode();
  }
  function TextRange__equals_impl_hkkmea($this, other) {
    if (!(other instanceof TextRange))
      return false;
    var tmp0_other_with_cast = other.b7u_1;
    if (!equalsLong($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function TextRange(packedValue) {
    Companion_getInstance_18();
    this.b7u_1 = packedValue;
  }
  protoOf(TextRange).toString = function () {
    return TextRange__toString_impl_pqvlzl(this.b7u_1);
  };
  protoOf(TextRange).hashCode = function () {
    return TextRange__hashCode_impl_3zpp6q(this.b7u_1);
  };
  protoOf(TextRange).equals = function (other) {
    return TextRange__equals_impl_hkkmea(this.b7u_1, other);
  };
  function TextRange_0(index) {
    return TextRange_1(index, index);
  }
  function TextRange_1(start, end) {
    return _TextRange___init__impl__h6icbt(packWithCheck(start, end));
  }
  function coerceIn_1(_this__u8e3s4, minimumValue, maximumValue) {
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var this_0 = _TextRange___get_start__impl__ww4t90(_this__u8e3s4);
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_1 = this_0 < minimumValue ? minimumValue : this_0;
    var newStart = this_1 > maximumValue ? maximumValue : this_1;
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var this_2 = _TextRange___get_end__impl__gcdxpp(_this__u8e3s4);
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_3 = this_2 < minimumValue ? minimumValue : this_2;
    var newEnd = this_3 > maximumValue ? maximumValue : this_3;
    if (!(newStart === _TextRange___get_start__impl__ww4t90(_this__u8e3s4)) || !(newEnd === _TextRange___get_end__impl__gcdxpp(_this__u8e3s4))) {
      return TextRange_1(newStart, newEnd);
    }
    return _this__u8e3s4;
  }
  function packWithCheck(start, end) {
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!(start >= 0 && end >= 0)) {
      var tmp$ret$1 = 'start and end cannot be negative. [start: ' + start + ', end: ' + end + ']';
      throwIllegalArgumentException(tmp$ret$1);
    }
    // Inline function 'androidx.compose.ui.util.packInts' call
    return bitwiseOr(shiftLeft(fromInt(start), 32), bitwiseAnd(fromInt(end), new Long(-1, 0)));
  }
  var androidx_compose_ui_text_TextStyle$stable;
  function TextStyle_init_$Init$(spanStyle, paragraphStyle, $this) {
    TextStyle.call($this, spanStyle, paragraphStyle, createPlatformTextStyleInternal(spanStyle.b7x_1, paragraphStyle.h7r_1));
    return $this;
  }
  function TextStyle_init_$Create$_0(spanStyle, paragraphStyle) {
    return TextStyle_init_$Init$(spanStyle, paragraphStyle, objectCreate(protoOf(TextStyle)));
  }
  function TextStyle_init_$Init$_0(color, fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, shadow, drawStyle, textAlign, textDirection, lineHeight, textIndent, platformStyle, lineHeightStyle, lineBreak, hyphens, textMotion, $this) {
    color = color === VOID ? Companion_getInstance().u6b_1 : color;
    fontSize = fontSize === VOID ? Companion_getInstance_1().q5g_1 : fontSize;
    fontWeight = fontWeight === VOID ? null : fontWeight;
    fontStyle = fontStyle === VOID ? null : fontStyle;
    fontSynthesis = fontSynthesis === VOID ? null : fontSynthesis;
    fontFamily = fontFamily === VOID ? null : fontFamily;
    fontFeatureSettings = fontFeatureSettings === VOID ? null : fontFeatureSettings;
    letterSpacing = letterSpacing === VOID ? Companion_getInstance_1().q5g_1 : letterSpacing;
    baselineShift = baselineShift === VOID ? null : baselineShift;
    textGeometricTransform = textGeometricTransform === VOID ? null : textGeometricTransform;
    localeList = localeList === VOID ? null : localeList;
    background = background === VOID ? Companion_getInstance().u6b_1 : background;
    textDecoration = textDecoration === VOID ? null : textDecoration;
    shadow = shadow === VOID ? null : shadow;
    drawStyle = drawStyle === VOID ? null : drawStyle;
    textAlign = textAlign === VOID ? Companion_getInstance_43().h7v_1 : textAlign;
    textDirection = textDirection === VOID ? Companion_getInstance_45().u7u_1 : textDirection;
    lineHeight = lineHeight === VOID ? Companion_getInstance_1().q5g_1 : lineHeight;
    textIndent = textIndent === VOID ? null : textIndent;
    platformStyle = platformStyle === VOID ? null : platformStyle;
    lineHeightStyle = lineHeightStyle === VOID ? null : lineHeightStyle;
    lineBreak = lineBreak === VOID ? Companion_getInstance_55().l7v_1 : lineBreak;
    hyphens = hyphens === VOID ? Companion_getInstance_38().o7v_1 : hyphens;
    textMotion = textMotion === VOID ? null : textMotion;
    var tmp = SpanStyle_init_$Create$(color, fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, shadow, platformStyle == null ? null : platformStyle.u81_1, drawStyle);
    TextStyle.call($this, tmp, new ParagraphStyle_0(textAlign, textDirection, lineHeight, textIndent, platformStyle == null ? null : platformStyle.v81_1, lineHeightStyle, lineBreak, hyphens, textMotion), platformStyle);
    return $this;
  }
  function TextStyle_init_$Create$_1(color, fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, shadow, drawStyle, textAlign, textDirection, lineHeight, textIndent, platformStyle, lineHeightStyle, lineBreak, hyphens, textMotion) {
    return TextStyle_init_$Init$_0(color, fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, shadow, drawStyle, textAlign, textDirection, lineHeight, textIndent, platformStyle, lineHeightStyle, lineBreak, hyphens, textMotion, objectCreate(protoOf(TextStyle)));
  }
  function Companion_4() {
    Companion_instance_6 = this;
    this.n81_1 = TextStyle_init_$Create$_1();
  }
  var Companion_instance_6;
  function Companion_getInstance_19() {
    if (Companion_instance_6 == null)
      new Companion_4();
    return Companion_instance_6;
  }
  function TextStyle(spanStyle, paragraphStyle, platformStyle) {
    Companion_getInstance_19();
    platformStyle = platformStyle === VOID ? null : platformStyle;
    this.v7u_1 = spanStyle;
    this.w7u_1 = paragraphStyle;
    this.x7u_1 = platformStyle;
  }
  protoOf(TextStyle).w81 = function () {
    return this.v7u_1;
  };
  protoOf(TextStyle).y7u = function () {
    return this.w7u_1;
  };
  protoOf(TextStyle).x81 = function (other) {
    if (other == null || equals(other, Companion_getInstance_19().n81_1))
      return this;
    return TextStyle_init_$Create$_0(this.w81().g7y(other.w81()), this.y7u().m7r(other.y7u()));
  };
  protoOf(TextStyle).y81 = function (color, fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, shadow, drawStyle, textAlign, textDirection, lineHeight, textIndent, lineHeightStyle, lineBreak, hyphens, platformStyle, textMotion) {
    var mergedSpanStyle = fastMerge_0(this.v7u_1, color, null, NaN, fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, shadow, platformStyle == null ? null : platformStyle.u81_1, drawStyle);
    var mergedParagraphStyle = fastMerge(this.w7u_1, textAlign, textDirection, lineHeight, textIndent, platformStyle == null ? null : platformStyle.v81_1, lineHeightStyle, lineBreak, hyphens, textMotion);
    if (this.v7u_1 === mergedSpanStyle && this.w7u_1 === mergedParagraphStyle)
      return this;
    return TextStyle_init_$Create$_0(mergedSpanStyle, mergedParagraphStyle);
  };
  protoOf(TextStyle).z81 = function (color, fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, shadow, drawStyle, textAlign, textDirection, lineHeight, textIndent, lineHeightStyle, lineBreak, hyphens, platformStyle, textMotion, $super) {
    color = color === VOID ? Companion_getInstance().u6b_1 : color;
    fontSize = fontSize === VOID ? Companion_getInstance_1().q5g_1 : fontSize;
    fontWeight = fontWeight === VOID ? null : fontWeight;
    fontStyle = fontStyle === VOID ? null : fontStyle;
    fontSynthesis = fontSynthesis === VOID ? null : fontSynthesis;
    fontFamily = fontFamily === VOID ? null : fontFamily;
    fontFeatureSettings = fontFeatureSettings === VOID ? null : fontFeatureSettings;
    letterSpacing = letterSpacing === VOID ? Companion_getInstance_1().q5g_1 : letterSpacing;
    baselineShift = baselineShift === VOID ? null : baselineShift;
    textGeometricTransform = textGeometricTransform === VOID ? null : textGeometricTransform;
    localeList = localeList === VOID ? null : localeList;
    background = background === VOID ? Companion_getInstance().u6b_1 : background;
    textDecoration = textDecoration === VOID ? null : textDecoration;
    shadow = shadow === VOID ? null : shadow;
    drawStyle = drawStyle === VOID ? null : drawStyle;
    textAlign = textAlign === VOID ? Companion_getInstance_43().h7v_1 : textAlign;
    textDirection = textDirection === VOID ? Companion_getInstance_45().u7u_1 : textDirection;
    lineHeight = lineHeight === VOID ? Companion_getInstance_1().q5g_1 : lineHeight;
    textIndent = textIndent === VOID ? null : textIndent;
    lineHeightStyle = lineHeightStyle === VOID ? null : lineHeightStyle;
    lineBreak = lineBreak === VOID ? Companion_getInstance_55().l7v_1 : lineBreak;
    hyphens = hyphens === VOID ? Companion_getInstance_38().o7v_1 : hyphens;
    platformStyle = platformStyle === VOID ? null : platformStyle;
    textMotion = textMotion === VOID ? null : textMotion;
    var tmp;
    if ($super === VOID) {
      tmp = this.y81(color, fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, shadow, drawStyle, textAlign, textDirection, lineHeight, textIndent, lineHeightStyle, lineBreak, hyphens, platformStyle, textMotion);
    } else {
      var tmp_0 = $super.y81;
      var tmp_1 = fontStyle;
      var tmp_2 = tmp_1 == null ? null : new FontStyle(tmp_1);
      var tmp_3 = fontSynthesis;
      var tmp_4 = tmp_3 == null ? null : new FontSynthesis(tmp_3);
      var tmp_5 = baselineShift;
      tmp = tmp_0.call(this, new Color(color), new TextUnit(fontSize), fontWeight, tmp_2, tmp_4, fontFamily, fontFeatureSettings, new TextUnit(letterSpacing), tmp_5 == null ? null : new BaselineShift(tmp_5), textGeometricTransform, localeList, new Color(background), textDecoration, shadow, drawStyle, new TextAlign(textAlign), new TextDirection(textDirection), new TextUnit(lineHeight), textIndent, lineHeightStyle, new LineBreak(lineBreak), new Hyphens(hyphens), platformStyle, textMotion);
    }
    return tmp;
  };
  protoOf(TextStyle).z7u = function (other) {
    return TextStyle_init_$Create$_0(this.w81(), this.y7u().m7r(other));
  };
  protoOf(TextStyle).a82 = function (color, fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, shadow, drawStyle, textAlign, textDirection, lineHeight, textIndent, platformStyle, lineHeightStyle, lineBreak, hyphens, textMotion) {
    var tmp;
    if (equals(color, this.v7u_1.s6c())) {
      tmp = this.v7u_1.n7w_1;
    } else {
      tmp = Companion_instance_33.d7y(color);
    }
    var tmp_0 = tmp;
    var tmp_1 = new SpanStyle(tmp_0, fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, shadow, platformStyle == null ? null : platformStyle.u81_1, drawStyle);
    return new TextStyle(tmp_1, new ParagraphStyle_0(textAlign, textDirection, lineHeight, textIndent, platformStyle == null ? null : platformStyle.v81_1, lineHeightStyle, lineBreak, hyphens, textMotion), platformStyle);
  };
  protoOf(TextStyle).b82 = function (color, fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, shadow, drawStyle, textAlign, textDirection, lineHeight, textIndent, platformStyle, lineHeightStyle, lineBreak, hyphens, textMotion, $super) {
    color = color === VOID ? this.v7u_1.s6c() : color;
    fontSize = fontSize === VOID ? this.v7u_1.o7w_1 : fontSize;
    fontWeight = fontWeight === VOID ? this.v7u_1.p7w_1 : fontWeight;
    fontStyle = fontStyle === VOID ? this.v7u_1.q7w_1 : fontStyle;
    fontSynthesis = fontSynthesis === VOID ? this.v7u_1.r7w_1 : fontSynthesis;
    fontFamily = fontFamily === VOID ? this.v7u_1.s7w_1 : fontFamily;
    fontFeatureSettings = fontFeatureSettings === VOID ? this.v7u_1.t7w_1 : fontFeatureSettings;
    letterSpacing = letterSpacing === VOID ? this.v7u_1.u7w_1 : letterSpacing;
    baselineShift = baselineShift === VOID ? this.v7u_1.v7w_1 : baselineShift;
    textGeometricTransform = textGeometricTransform === VOID ? this.v7u_1.w7w_1 : textGeometricTransform;
    localeList = localeList === VOID ? this.v7u_1.x7w_1 : localeList;
    background = background === VOID ? this.v7u_1.y7w_1 : background;
    textDecoration = textDecoration === VOID ? this.v7u_1.z7w_1 : textDecoration;
    shadow = shadow === VOID ? this.v7u_1.a7x_1 : shadow;
    drawStyle = drawStyle === VOID ? this.v7u_1.c7x_1 : drawStyle;
    textAlign = textAlign === VOID ? this.w7u_1.d7r_1 : textAlign;
    textDirection = textDirection === VOID ? this.w7u_1.e7r_1 : textDirection;
    lineHeight = lineHeight === VOID ? this.w7u_1.f7r_1 : lineHeight;
    textIndent = textIndent === VOID ? this.w7u_1.g7r_1 : textIndent;
    platformStyle = platformStyle === VOID ? this.x7u_1 : platformStyle;
    lineHeightStyle = lineHeightStyle === VOID ? this.w7u_1.i7r_1 : lineHeightStyle;
    lineBreak = lineBreak === VOID ? this.w7u_1.j7r_1 : lineBreak;
    hyphens = hyphens === VOID ? this.w7u_1.k7r_1 : hyphens;
    textMotion = textMotion === VOID ? this.w7u_1.l7r_1 : textMotion;
    var tmp;
    if ($super === VOID) {
      tmp = this.a82(color, fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, shadow, drawStyle, textAlign, textDirection, lineHeight, textIndent, platformStyle, lineHeightStyle, lineBreak, hyphens, textMotion);
    } else {
      var tmp_0 = $super.a82;
      var tmp_1 = fontStyle;
      var tmp_2 = tmp_1 == null ? null : new FontStyle(tmp_1);
      var tmp_3 = fontSynthesis;
      var tmp_4 = tmp_3 == null ? null : new FontSynthesis(tmp_3);
      var tmp_5 = baselineShift;
      tmp = tmp_0.call(this, new Color(color), new TextUnit(fontSize), fontWeight, tmp_2, tmp_4, fontFamily, fontFeatureSettings, new TextUnit(letterSpacing), tmp_5 == null ? null : new BaselineShift(tmp_5), textGeometricTransform, localeList, new Color(background), textDecoration, shadow, drawStyle, new TextAlign(textAlign), new TextDirection(textDirection), new TextUnit(lineHeight), textIndent, platformStyle, lineHeightStyle, new LineBreak(lineBreak), new Hyphens(hyphens), textMotion);
    }
    return tmp;
  };
  protoOf(TextStyle).c82 = function (brush, alpha, fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, shadow, drawStyle, textAlign, textDirection, lineHeight, textIndent, platformStyle, lineHeightStyle, lineBreak, hyphens, textMotion) {
    var tmp = SpanStyle_init_$Create$_0(brush, alpha, fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, shadow, platformStyle == null ? null : platformStyle.u81_1, drawStyle);
    return new TextStyle(tmp, new ParagraphStyle_0(textAlign, textDirection, lineHeight, textIndent, platformStyle == null ? null : platformStyle.v81_1, lineHeightStyle, lineBreak, hyphens, textMotion), platformStyle);
  };
  protoOf(TextStyle).d82 = function (brush, alpha, fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, shadow, drawStyle, textAlign, textDirection, lineHeight, textIndent, platformStyle, lineHeightStyle, lineBreak, hyphens, textMotion, $super) {
    alpha = alpha === VOID ? this.v7u_1.j68() : alpha;
    fontSize = fontSize === VOID ? this.v7u_1.o7w_1 : fontSize;
    fontWeight = fontWeight === VOID ? this.v7u_1.p7w_1 : fontWeight;
    fontStyle = fontStyle === VOID ? this.v7u_1.q7w_1 : fontStyle;
    fontSynthesis = fontSynthesis === VOID ? this.v7u_1.r7w_1 : fontSynthesis;
    fontFamily = fontFamily === VOID ? this.v7u_1.s7w_1 : fontFamily;
    fontFeatureSettings = fontFeatureSettings === VOID ? this.v7u_1.t7w_1 : fontFeatureSettings;
    letterSpacing = letterSpacing === VOID ? this.v7u_1.u7w_1 : letterSpacing;
    baselineShift = baselineShift === VOID ? this.v7u_1.v7w_1 : baselineShift;
    textGeometricTransform = textGeometricTransform === VOID ? this.v7u_1.w7w_1 : textGeometricTransform;
    localeList = localeList === VOID ? this.v7u_1.x7w_1 : localeList;
    background = background === VOID ? this.v7u_1.y7w_1 : background;
    textDecoration = textDecoration === VOID ? this.v7u_1.z7w_1 : textDecoration;
    shadow = shadow === VOID ? this.v7u_1.a7x_1 : shadow;
    drawStyle = drawStyle === VOID ? this.v7u_1.c7x_1 : drawStyle;
    textAlign = textAlign === VOID ? this.w7u_1.d7r_1 : textAlign;
    textDirection = textDirection === VOID ? this.w7u_1.e7r_1 : textDirection;
    lineHeight = lineHeight === VOID ? this.w7u_1.f7r_1 : lineHeight;
    textIndent = textIndent === VOID ? this.w7u_1.g7r_1 : textIndent;
    platformStyle = platformStyle === VOID ? this.x7u_1 : platformStyle;
    lineHeightStyle = lineHeightStyle === VOID ? this.w7u_1.i7r_1 : lineHeightStyle;
    lineBreak = lineBreak === VOID ? this.w7u_1.j7r_1 : lineBreak;
    hyphens = hyphens === VOID ? this.w7u_1.k7r_1 : hyphens;
    textMotion = textMotion === VOID ? this.w7u_1.l7r_1 : textMotion;
    var tmp;
    if ($super === VOID) {
      tmp = this.c82(brush, alpha, fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, shadow, drawStyle, textAlign, textDirection, lineHeight, textIndent, platformStyle, lineHeightStyle, lineBreak, hyphens, textMotion);
    } else {
      var tmp_0 = $super.c82;
      var tmp_1 = fontStyle;
      var tmp_2 = tmp_1 == null ? null : new FontStyle(tmp_1);
      var tmp_3 = fontSynthesis;
      var tmp_4 = tmp_3 == null ? null : new FontSynthesis(tmp_3);
      var tmp_5 = baselineShift;
      tmp = tmp_0.call(this, brush, alpha, new TextUnit(fontSize), fontWeight, tmp_2, tmp_4, fontFamily, fontFeatureSettings, new TextUnit(letterSpacing), tmp_5 == null ? null : new BaselineShift(tmp_5), textGeometricTransform, localeList, new Color(background), textDecoration, shadow, drawStyle, new TextAlign(textAlign), new TextDirection(textDirection), new TextUnit(lineHeight), textIndent, platformStyle, lineHeightStyle, new LineBreak(lineBreak), new Hyphens(hyphens), textMotion);
    }
    return tmp;
  };
  protoOf(TextStyle).f7y = function () {
    return this.v7u_1.f7y();
  };
  protoOf(TextStyle).s6c = function () {
    return this.v7u_1.s6c();
  };
  protoOf(TextStyle).j68 = function () {
    return this.v7u_1.j68();
  };
  protoOf(TextStyle).e82 = function () {
    return this.v7u_1.o7w_1;
  };
  protoOf(TextStyle).f82 = function () {
    return this.v7u_1.p7w_1;
  };
  protoOf(TextStyle).g82 = function () {
    return this.v7u_1.q7w_1;
  };
  protoOf(TextStyle).h82 = function () {
    return this.v7u_1.r7w_1;
  };
  protoOf(TextStyle).i82 = function () {
    return this.v7u_1.s7w_1;
  };
  protoOf(TextStyle).j82 = function () {
    return this.v7u_1.t7w_1;
  };
  protoOf(TextStyle).k82 = function () {
    return this.v7u_1.u7w_1;
  };
  protoOf(TextStyle).l82 = function () {
    return this.v7u_1.v7w_1;
  };
  protoOf(TextStyle).m82 = function () {
    return this.v7u_1.w7w_1;
  };
  protoOf(TextStyle).n82 = function () {
    return this.v7u_1.x7w_1;
  };
  protoOf(TextStyle).o82 = function () {
    return this.v7u_1.y7w_1;
  };
  protoOf(TextStyle).r81 = function () {
    return this.v7u_1.z7w_1;
  };
  protoOf(TextStyle).q81 = function () {
    return this.v7u_1.a7x_1;
  };
  protoOf(TextStyle).s81 = function () {
    return this.v7u_1.c7x_1;
  };
  protoOf(TextStyle).p82 = function () {
    return this.w7u_1.d7r_1;
  };
  protoOf(TextStyle).q82 = function () {
    return this.w7u_1.e7r_1;
  };
  protoOf(TextStyle).r82 = function () {
    return this.w7u_1.f7r_1;
  };
  protoOf(TextStyle).s82 = function () {
    return this.w7u_1.g7r_1;
  };
  protoOf(TextStyle).t82 = function () {
    return this.w7u_1.i7r_1;
  };
  protoOf(TextStyle).u82 = function () {
    return this.w7u_1.k7r_1;
  };
  protoOf(TextStyle).v82 = function () {
    return this.w7u_1.j7r_1;
  };
  protoOf(TextStyle).w82 = function () {
    return this.w7u_1.l7r_1;
  };
  protoOf(TextStyle).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextStyle))
      return false;
    if (!this.v7u_1.equals(other.v7u_1))
      return false;
    if (!this.w7u_1.equals(other.w7u_1))
      return false;
    if (!equals(this.x7u_1, other.x7u_1))
      return false;
    return true;
  };
  protoOf(TextStyle).p81 = function (other) {
    return this === other || (this.w7u_1.equals(other.w7u_1) && this.v7u_1.j7y(other.v7u_1));
  };
  protoOf(TextStyle).x82 = function (other) {
    return this === other || this.v7u_1.k7y(other.v7u_1);
  };
  protoOf(TextStyle).hashCode = function () {
    var result = this.v7u_1.hashCode();
    result = imul(31, result) + this.w7u_1.hashCode() | 0;
    var tmp = imul(31, result);
    var tmp0_safe_receiver = this.x7u_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hashCode();
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    return result;
  };
  protoOf(TextStyle).l7y = function () {
    var result = this.v7u_1.l7y();
    result = imul(31, result) + this.w7u_1.hashCode() | 0;
    var tmp = imul(31, result);
    var tmp0_safe_receiver = this.x7u_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hashCode();
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    return result;
  };
  protoOf(TextStyle).toString = function () {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_0();
    this_0.q('TextStyle(');
    this_0.q('color=' + Color__toString_impl_hpzmaq(this.s6c()) + ', ');
    this_0.q('brush=' + toString(this.f7y()) + ', ');
    this_0.q('alpha=' + this.j68() + ', ');
    this_0.q('fontSize=' + TextUnit__toString_impl_51ghw0(this.e82()) + ', ');
    this_0.q('fontWeight=' + toString(this.f82()) + ', ');
    var tmp = this.g82();
    this_0.q('fontStyle=' + toString(tmp == null ? null : new FontStyle(tmp)) + ', ');
    var tmp_0 = this.h82();
    this_0.q('fontSynthesis=' + toString(tmp_0 == null ? null : new FontSynthesis(tmp_0)) + ', ');
    this_0.q('fontFamily=' + toString(this.i82()) + ', ');
    this_0.q('fontFeatureSettings=' + this.j82() + ', ');
    this_0.q('letterSpacing=' + TextUnit__toString_impl_51ghw0(this.k82()) + ', ');
    var tmp_1 = this.l82();
    this_0.q('baselineShift=' + toString(tmp_1 == null ? null : new BaselineShift(tmp_1)) + ', ');
    this_0.q('textGeometricTransform=' + toString(this.m82()) + ', ');
    this_0.q('localeList=' + toString(this.n82()) + ', ');
    this_0.q('background=' + Color__toString_impl_hpzmaq(this.o82()) + ', ');
    this_0.q('textDecoration=' + toString(this.r81()) + ', ');
    this_0.q('shadow=' + toString(this.q81()) + ', ');
    this_0.q('drawStyle=' + toString(this.s81()) + ', ');
    this_0.q('textAlign=' + TextAlign__toString_impl_6ha6d3(this.p82()) + ', ');
    this_0.q('textDirection=' + TextDirection__toString_impl_x3uh9t(this.q82()) + ', ');
    this_0.q('lineHeight=' + TextUnit__toString_impl_51ghw0(this.r82()) + ', ');
    this_0.q('textIndent=' + toString(this.s82()) + ', ');
    this_0.q('platformStyle=' + toString(this.x7u_1) + ', ');
    this_0.q('lineHeightStyle=' + toString(this.t82()) + ', ');
    this_0.q('lineBreak=' + LineBreak__toString_impl_mphhli(this.v82()) + ', ');
    this_0.q('hyphens=' + Hyphens__toString_impl_ck1wg0(this.u82()) + ', ');
    this_0.q('textMotion=' + toString(this.w82()));
    this_0.q(')');
    return this_0.toString();
  };
  function lerp_6(start, stop, fraction) {
    return TextStyle_init_$Create$_0(lerp_5(start.w81(), stop.w81(), fraction), lerp_4(start.y7u(), stop.y7u(), fraction));
  }
  function resolveDefaults(style, direction) {
    return new TextStyle(resolveSpanStyleDefaults(style.v7u_1), resolveParagraphStyleDefaults(style.w7u_1, direction), style.x7u_1);
  }
  function createPlatformTextStyleInternal(platformSpanStyle, platformParagraphStyle) {
    var tmp;
    if (platformSpanStyle == null && platformParagraphStyle == null) {
      tmp = null;
    } else {
      tmp = createPlatformTextStyle(platformSpanStyle, platformParagraphStyle);
    }
    return tmp;
  }
  function resolveTextDirection_0(layoutDirection, textDirection) {
    var tmp;
    if (textDirection === Companion_getInstance_45().r7u_1) {
      var tmp_0;
      switch (layoutDirection.a1_1) {
        case 0:
          tmp_0 = Companion_getInstance_45().s7u_1;
          break;
        case 1:
          tmp_0 = Companion_getInstance_45().t7u_1;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      tmp = tmp_0;
    } else if (textDirection === Companion_getInstance_45().u7u_1) {
      var tmp_1;
      switch (layoutDirection.a1_1) {
        case 0:
          tmp_1 = Companion_getInstance_45().p7u_1;
          break;
        case 1:
          tmp_1 = Companion_getInstance_45().q7u_1;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      tmp = tmp_1;
    } else {
      tmp = textDirection;
    }
    return tmp;
  }
  var androidx_compose_ui_text_TtsAnnotation$stable;
  var androidx_compose_ui_text_VerbatimTtsAnnotation$stable;
  function TtsAnnotation() {
  }
  function VerbatimTtsAnnotation(verbatim) {
    TtsAnnotation.call(this);
    this.l7w_1 = verbatim;
  }
  protoOf(VerbatimTtsAnnotation).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VerbatimTtsAnnotation))
      return false;
    if (!(this.l7w_1 === other.l7w_1))
      return false;
    return true;
  };
  protoOf(VerbatimTtsAnnotation).hashCode = function () {
    return getStringHashCode(this.l7w_1);
  };
  protoOf(VerbatimTtsAnnotation).toString = function () {
    return 'VerbatimTtsAnnotation(verbatim=' + this.l7w_1 + ')';
  };
  var androidx_compose_ui_text_UrlAnnotation$stable;
  function UrlAnnotation(url) {
    this.m7w_1 = url;
  }
  protoOf(UrlAnnotation).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UrlAnnotation))
      return false;
    if (!(this.m7w_1 === other.m7w_1))
      return false;
    return true;
  };
  protoOf(UrlAnnotation).hashCode = function () {
    return getStringHashCode(this.m7w_1);
  };
  protoOf(UrlAnnotation).toString = function () {
    return 'UrlAnnotation(url=' + this.m7w_1 + ')';
  };
  var androidx_compose_ui_text_font_ResourceFont$stable;
  function Font() {
  }
  var androidx_compose_ui_text_font_FontFamily$stable;
  var androidx_compose_ui_text_font_FileBasedFontFamily$stable;
  var androidx_compose_ui_text_font_SystemFontFamily$stable;
  var androidx_compose_ui_text_font_FontListFontFamily$stable;
  var androidx_compose_ui_text_font_GenericFontFamily$stable;
  var androidx_compose_ui_text_font_DefaultFontFamily$stable;
  var androidx_compose_ui_text_font_LoadedFontFamily$stable;
  function GenericFontFamily(name, fontFamilyName) {
    SystemFontFamily.call(this);
    this.e83_1 = name;
    this.f83_1 = fontFamilyName;
  }
  protoOf(GenericFontFamily).toString = function () {
    return this.f83_1;
  };
  function Companion_5() {
    Companion_instance_7 = this;
    this.q7z_1 = new DefaultFontFamily();
    this.r7z_1 = new GenericFontFamily('sans-serif', 'FontFamily.SansSerif');
    this.s7z_1 = new GenericFontFamily('serif', 'FontFamily.Serif');
    this.t7z_1 = new GenericFontFamily('monospace', 'FontFamily.Monospace');
    this.u7z_1 = new GenericFontFamily('cursive', 'FontFamily.Cursive');
  }
  var Companion_instance_7;
  function Companion_getInstance_20() {
    if (Companion_instance_7 == null)
      new Companion_5();
    return Companion_instance_7;
  }
  function FontFamily(canLoadSynchronously) {
    Companion_getInstance_20();
    this.g83_1 = canLoadSynchronously;
  }
  function SystemFontFamily() {
    FontFamily.call(this, true);
  }
  function FontFamily_0(fonts) {
    return new FontListFontFamily(asList(fonts));
  }
  function DefaultFontFamily() {
    SystemFontFamily.call(this);
  }
  protoOf(DefaultFontFamily).toString = function () {
    return 'FontFamily.Default';
  };
  function FontListFontFamily(fonts) {
    FileBasedFontFamily.call(this);
    this.i83_1 = fonts;
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'androidx.compose.ui.text.internal.checkPrecondition' call
    if (!!this.i83_1.r()) {
      var tmp$ret$2 = 'At least one font should be passed to FontFamily';
      throwIllegalStateException(tmp$ret$2);
    }
  }
  protoOf(FontListFontFamily).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FontListFontFamily))
      return false;
    if (!equals(this.i83_1, other.i83_1))
      return false;
    return true;
  };
  protoOf(FontListFontFamily).hashCode = function () {
    return hashCode(this.i83_1);
  };
  protoOf(FontListFontFamily).toString = function () {
    return 'FontListFontFamily(fonts=' + toString_0(this.i83_1) + ')';
  };
  protoOf(FontListFontFamily).r = function () {
    return this.i83_1.r();
  };
  protoOf(FontListFontFamily).j83 = function (element) {
    return this.i83_1.m1(element);
  };
  protoOf(FontListFontFamily).m1 = function (element) {
    if (!(!(element == null) ? isInterface(element, Font) : false))
      return false;
    return this.j83((!(element == null) ? isInterface(element, Font) : false) ? element : THROW_CCE());
  };
  protoOf(FontListFontFamily).t = function () {
    return this.i83_1.t();
  };
  protoOf(FontListFontFamily).k83 = function (elements) {
    return this.i83_1.r2(elements);
  };
  protoOf(FontListFontFamily).r2 = function (elements) {
    return this.k83(elements);
  };
  protoOf(FontListFontFamily).l1 = function (index) {
    return this.i83_1.l1(index);
  };
  protoOf(FontListFontFamily).l83 = function (element) {
    return this.i83_1.q1(element);
  };
  protoOf(FontListFontFamily).q1 = function (element) {
    if (!(!(element == null) ? isInterface(element, Font) : false))
      return -1;
    return this.l83((!(element == null) ? isInterface(element, Font) : false) ? element : THROW_CCE());
  };
  protoOf(FontListFontFamily).p1 = function (index) {
    return this.i83_1.p1(index);
  };
  protoOf(FontListFontFamily).t2 = function (fromIndex, toIndex) {
    return this.i83_1.t2(fromIndex, toIndex);
  };
  protoOf(FontListFontFamily).n1 = function () {
    return this.i83_1.n1();
  };
  function FileBasedFontFamily() {
    FontFamily.call(this, false);
  }
  function LoadedFontFamily() {
  }
  function get_GlobalTypefaceRequestCache() {
    _init_properties_FontFamilyResolver_kt__lawdt3();
    return GlobalTypefaceRequestCache;
  }
  var GlobalTypefaceRequestCache;
  function get_GlobalAsyncTypefaceCache() {
    _init_properties_FontFamilyResolver_kt__lawdt3();
    return GlobalAsyncTypefaceCache;
  }
  var GlobalAsyncTypefaceCache;
  var androidx_compose_ui_text_font_FontFamilyResolverImpl$stable;
  var androidx_compose_ui_text_font_TypefaceRequest$stable;
  var androidx_compose_ui_text_font_TypefaceResult_Immutable$stable;
  var androidx_compose_ui_text_font_TypefaceResult_Async$stable;
  var androidx_compose_ui_text_font_TypefaceRequestCache$stable;
  function TypefaceRequestCache$runCached$lambda(this$0, $typefaceRequest) {
    return function (finalResult) {
      // Inline function 'androidx.compose.ui.text.platform.synchronized' call
      // Inline function 'kotlinx.atomicfu.locks.synchronized' call
      this$0.m83_1;
      if (finalResult.o83()) {
        this$0.n83_1.ly($typefaceRequest, finalResult);
      } else {
        this$0.n83_1.py($typefaceRequest);
      }
      return Unit_instance;
    };
  }
  function TypefaceRequestCache() {
    var tmp = this;
    // Inline function 'androidx.compose.ui.text.platform.makeSynchronizedObject' call
    tmp.m83_1 = new SynchronizedObject();
    this.n83_1 = new LruCache(16);
  }
  protoOf(TypefaceRequestCache).p83 = function (typefaceRequest, resolveTypeface) {
    // Inline function 'androidx.compose.ui.text.platform.synchronized' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.m83_1;
    var tmp0_safe_receiver = this.n83_1.iy(typefaceRequest);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp_0;
      if (tmp0_safe_receiver.o83()) {
        return tmp0_safe_receiver;
      } else {
        tmp_0 = this.n83_1.py(typefaceRequest);
      }
      tmp = tmp_0;
    }
    var tmp_1;
    try {
      tmp_1 = resolveTypeface(TypefaceRequestCache$runCached$lambda(this, typefaceRequest));
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Exception) {
        var cause = $p;
        throw IllegalStateException_init_$Create$('Could not load font', cause);
      } else {
        throw $p;
      }
    }
    var currentTypefaceResult = tmp_1;
    // Inline function 'androidx.compose.ui.text.platform.synchronized' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.m83_1;
    if (this.n83_1.iy(typefaceRequest) == null && currentTypefaceResult.o83()) {
      this.n83_1.ly(typefaceRequest, currentTypefaceResult);
    }
    return currentTypefaceResult;
  };
  function TypefaceRequest(fontFamily, fontWeight, fontStyle, fontSynthesis, resourceLoaderCacheKey) {
    this.q83_1 = fontFamily;
    this.r83_1 = fontWeight;
    this.s83_1 = fontStyle;
    this.t83_1 = fontSynthesis;
    this.u83_1 = resourceLoaderCacheKey;
  }
  protoOf(TypefaceRequest).v83 = function (fontFamily, fontWeight, fontStyle, fontSynthesis, resourceLoaderCacheKey) {
    return new TypefaceRequest(fontFamily, fontWeight, fontStyle, fontSynthesis, resourceLoaderCacheKey);
  };
  protoOf(TypefaceRequest).w83 = function (fontFamily, fontWeight, fontStyle, fontSynthesis, resourceLoaderCacheKey, $super) {
    fontFamily = fontFamily === VOID ? this.q83_1 : fontFamily;
    fontWeight = fontWeight === VOID ? this.r83_1 : fontWeight;
    fontStyle = fontStyle === VOID ? this.s83_1 : fontStyle;
    fontSynthesis = fontSynthesis === VOID ? this.t83_1 : fontSynthesis;
    resourceLoaderCacheKey = resourceLoaderCacheKey === VOID ? this.u83_1 : resourceLoaderCacheKey;
    return $super === VOID ? this.v83(fontFamily, fontWeight, fontStyle, fontSynthesis, resourceLoaderCacheKey) : $super.v83.call(this, fontFamily, fontWeight, new FontStyle(fontStyle), new FontSynthesis(fontSynthesis), resourceLoaderCacheKey);
  };
  protoOf(TypefaceRequest).toString = function () {
    return 'TypefaceRequest(fontFamily=' + toString(this.q83_1) + ', fontWeight=' + this.r83_1.toString() + ', fontStyle=' + FontStyle__toString_impl_thncxr(this.s83_1) + ', fontSynthesis=' + FontSynthesis__toString_impl_gunvr0(this.t83_1) + ', resourceLoaderCacheKey=' + toString(this.u83_1) + ')';
  };
  protoOf(TypefaceRequest).hashCode = function () {
    var result = this.q83_1 == null ? 0 : hashCode(this.q83_1);
    result = imul(result, 31) + this.r83_1.hashCode() | 0;
    result = imul(result, 31) + FontStyle__hashCode_impl_7qhg4w(this.s83_1) | 0;
    result = imul(result, 31) + FontSynthesis__hashCode_impl_4wi11v(this.t83_1) | 0;
    result = imul(result, 31) + (this.u83_1 == null ? 0 : hashCode(this.u83_1)) | 0;
    return result;
  };
  protoOf(TypefaceRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TypefaceRequest))
      return false;
    if (!equals(this.q83_1, other.q83_1))
      return false;
    if (!this.r83_1.equals(other.r83_1))
      return false;
    if (!(this.s83_1 === other.s83_1))
      return false;
    if (!(this.t83_1 === other.t83_1))
      return false;
    if (!equals(this.u83_1, other.u83_1))
      return false;
    return true;
  };
  function Immutable(value, cacheable) {
    cacheable = cacheable === VOID ? true : cacheable;
    this.x83_1 = value;
    this.y83_1 = cacheable;
  }
  protoOf(Immutable).u1 = function () {
    return this.x83_1;
  };
  protoOf(Immutable).o83 = function () {
    return this.y83_1;
  };
  function Async(current) {
    this.z83_1 = current;
  }
  protoOf(Async).o83 = function () {
    return this.z83_1.g84_1;
  };
  protoOf(Async).u1 = function () {
    return this.z83_1.u1();
  };
  function resolve($this, typefaceRequest) {
    var result = $this.j84_1.p83(typefaceRequest, FontFamilyResolverImpl$resolve$lambda($this, typefaceRequest));
    return result;
  }
  function FontFamilyResolverImpl$createDefaultTypeface$lambda(this$0) {
    return function (it) {
      return resolve(this$0, it.w83(null)).u1();
    };
  }
  function FontFamilyResolverImpl$resolve$lambda(this$0, $typefaceRequest) {
    return function (onAsyncCompletion) {
      var tmp0_elvis_lhs = this$0.k84_1.p84($typefaceRequest, this$0.h84_1, onAsyncCompletion, this$0.m84_1);
      var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this$0.l84_1.p84($typefaceRequest, this$0.h84_1, onAsyncCompletion, this$0.m84_1) : tmp0_elvis_lhs;
      var tmp;
      if (tmp1_elvis_lhs == null) {
        throw IllegalStateException_init_$Create$_0('Could not load font');
      } else {
        tmp = tmp1_elvis_lhs;
      }
      return tmp;
    };
  }
  function FontFamilyResolverImpl(platformFontLoader, platformResolveInterceptor, typefaceRequestCache, fontListFontFamilyTypefaceAdapter, platformFamilyTypefaceAdapter) {
    platformResolveInterceptor = platformResolveInterceptor === VOID ? Companion_getInstance_21().q84_1 : platformResolveInterceptor;
    typefaceRequestCache = typefaceRequestCache === VOID ? get_GlobalTypefaceRequestCache() : typefaceRequestCache;
    fontListFontFamilyTypefaceAdapter = fontListFontFamilyTypefaceAdapter === VOID ? new FontListFontFamilyTypefaceAdapter(get_GlobalAsyncTypefaceCache()) : fontListFontFamilyTypefaceAdapter;
    platformFamilyTypefaceAdapter = platformFamilyTypefaceAdapter === VOID ? new PlatformFontFamilyTypefaceAdapter() : platformFamilyTypefaceAdapter;
    this.h84_1 = platformFontLoader;
    this.i84_1 = platformResolveInterceptor;
    this.j84_1 = typefaceRequestCache;
    this.k84_1 = fontListFontFamilyTypefaceAdapter;
    this.l84_1 = platformFamilyTypefaceAdapter;
    var tmp = this;
    tmp.m84_1 = FontFamilyResolverImpl$createDefaultTypeface$lambda(this);
  }
  protoOf(FontFamilyResolverImpl).r84 = function (fontFamily, fontWeight, fontStyle, fontSynthesis) {
    return resolve(this, new TypefaceRequest(this.i84_1.s84(fontFamily), this.i84_1.t84(fontWeight), this.i84_1.u84(fontStyle), this.i84_1.v84(fontSynthesis), this.h84_1.w84()));
  };
  function PlatformResolveInterceptor$Companion$Default$1() {
  }
  function Companion_6() {
    Companion_instance_8 = this;
    var tmp = this;
    tmp.q84_1 = new PlatformResolveInterceptor$Companion$Default$1();
  }
  var Companion_instance_8;
  function Companion_getInstance_21() {
    if (Companion_instance_8 == null)
      new Companion_6();
    return Companion_instance_8;
  }
  function PlatformResolveInterceptor() {
  }
  var properties_initialized_FontFamilyResolver_kt_43uw85;
  function _init_properties_FontFamilyResolver_kt__lawdt3() {
    if (!properties_initialized_FontFamilyResolver_kt_43uw85) {
      properties_initialized_FontFamilyResolver_kt_43uw85 = true;
      GlobalTypefaceRequestCache = new TypefaceRequestCache();
      GlobalAsyncTypefaceCache = new AsyncTypefaceCache();
      androidx_compose_ui_text_font_FontFamilyResolverImpl$stable = 8;
      androidx_compose_ui_text_font_TypefaceRequest$stable = 8;
      androidx_compose_ui_text_font_TypefaceResult_Immutable$stable = 0;
      androidx_compose_ui_text_font_TypefaceResult_Async$stable = 0;
      androidx_compose_ui_text_font_TypefaceRequestCache$stable = 8;
    }
  }
  var androidx_compose_ui_text_font_FontListFontFamilyTypefaceAdapter$stable;
  var androidx_compose_ui_text_font_AsyncFontListLoader$stable;
  var androidx_compose_ui_text_font_AsyncTypefaceCache_Key$stable;
  var androidx_compose_ui_text_font_AsyncTypefaceCache$stable;
  function _AsyncTypefaceResult___init__impl__h4msax(result) {
    return result;
  }
  function _AsyncTypefaceResult___get_result__impl__kpcqqb($this) {
    return $this;
  }
  function _AsyncTypefaceResult___get_isPermanentFailure__impl__sthpca($this) {
    return _AsyncTypefaceResult___get_result__impl__kpcqqb($this) == null;
  }
  function AsyncTypefaceResult__toString_impl_imltdd($this) {
    return 'AsyncTypefaceResult(result=' + toString($this) + ')';
  }
  function AsyncTypefaceResult__hashCode_impl_34k3fi($this) {
    return $this == null ? 0 : hashCode($this);
  }
  function AsyncTypefaceResult__equals_impl_4qqxz2($this, other) {
    if (!(other instanceof AsyncTypefaceResult))
      return false;
    var tmp0_other_with_cast = other.x84_1;
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function AsyncTypefaceResult(result) {
    this.x84_1 = result;
  }
  protoOf(AsyncTypefaceResult).toString = function () {
    return AsyncTypefaceResult__toString_impl_imltdd(this.x84_1);
  };
  protoOf(AsyncTypefaceResult).hashCode = function () {
    return AsyncTypefaceResult__hashCode_impl_34k3fi(this.x84_1);
  };
  protoOf(AsyncTypefaceResult).equals = function (other) {
    return AsyncTypefaceResult__equals_impl_4qqxz2(this.x84_1, other);
  };
  function Key(font, loaderKey) {
    this.y84_1 = font;
    this.z84_1 = loaderKey;
  }
  protoOf(Key).toString = function () {
    return 'Key(font=' + toString_0(this.y84_1) + ', loaderKey=' + toString(this.z84_1) + ')';
  };
  protoOf(Key).hashCode = function () {
    var result = hashCode(this.y84_1);
    result = imul(result, 31) + (this.z84_1 == null ? 0 : hashCode(this.z84_1)) | 0;
    return result;
  };
  protoOf(Key).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Key))
      return false;
    if (!equals(this.y84_1, other.y84_1))
      return false;
    if (!equals(this.z84_1, other.z84_1))
      return false;
    return true;
  };
  function access$_get_resultCache__u960s4($this) {
    return $this.b85_1;
  }
  function access$_get_permanentCache__bpfryv($this) {
    return $this.c85_1;
  }
  function access$_get_cacheLock__y7hpng($this) {
    return $this.d85_1;
  }
  function $runCachedCOROUTINE$(_this__u8e3s4, font, platformFontLoader, forever, block, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.m85_1 = _this__u8e3s4;
    this.n85_1 = font;
    this.o85_1 = platformFontLoader;
    this.p85_1 = forever;
    this.q85_1 = block;
  }
  protoOf($runCachedCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.r85_1 = new Key(this.n85_1, this.o85_1.w84());
            this.m85_1.d85_1;
            var tmp0_elvis_lhs = this.m85_1.b85_1.iy(this.r85_1);
            var priorResult = tmp0_elvis_lhs == null ? this.m85_1.c85_1.w2(this.r85_1) : tmp0_elvis_lhs;
            if (!(priorResult == null)) {
              return _AsyncTypefaceResult___get_result__impl__kpcqqb(priorResult.x84_1);
            }

            this.n9_1 = 1;
            suspendResult = this.q85_1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_0 = suspendResult;
            this.m85_1.d85_1;
            if (this_0 == null) {
              this.m85_1.c85_1.h13(this.r85_1, new AsyncTypefaceResult(this.m85_1.a85_1));
            } else if (this.p85_1) {
              this.m85_1.c85_1.h13(this.r85_1, new AsyncTypefaceResult(_AsyncTypefaceResult___init__impl__h4msax(this_0)));
            } else {
              this.m85_1.b85_1.ly(this.r85_1, new AsyncTypefaceResult(_AsyncTypefaceResult___init__impl__h4msax(this_0)));
            }

            return this_0;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function AsyncTypefaceCache() {
    this.a85_1 = _AsyncTypefaceResult___init__impl__h4msax(null);
    this.b85_1 = new LruCache(16);
    this.c85_1 = mutableScatterMapOf();
    var tmp = this;
    // Inline function 'androidx.compose.ui.text.platform.makeSynchronizedObject' call
    tmp.d85_1 = new SynchronizedObject();
  }
  protoOf(AsyncTypefaceCache).s85 = function (font, platformFontLoader, result, forever) {
    var key = new Key(font, platformFontLoader.w84());
    // Inline function 'androidx.compose.ui.text.platform.synchronized' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.d85_1;
    var tmp;
    if (result == null) {
      this.c85_1.h13(key, new AsyncTypefaceResult(this.a85_1));
      tmp = Unit_instance;
    } else if (forever) {
      this.c85_1.h13(key, new AsyncTypefaceResult(_AsyncTypefaceResult___init__impl__h4msax(result)));
      tmp = Unit_instance;
    } else {
      tmp = this.b85_1.ly(key, new AsyncTypefaceResult(_AsyncTypefaceResult___init__impl__h4msax(result)));
    }
  };
  protoOf(AsyncTypefaceCache).t85 = function (font, platformFontLoader, result, forever, $super) {
    forever = forever === VOID ? false : forever;
    var tmp;
    if ($super === VOID) {
      this.s85(font, platformFontLoader, result, forever);
      tmp = Unit_instance;
    } else {
      tmp = $super.s85.call(this, font, platformFontLoader, result, forever);
    }
    return tmp;
  };
  protoOf(AsyncTypefaceCache).u85 = function (font, platformFontLoader) {
    var key = new Key(font, platformFontLoader.w84());
    // Inline function 'androidx.compose.ui.text.platform.synchronized' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.d85_1;
    var tmp0_elvis_lhs = this.b85_1.iy(key);
    return tmp0_elvis_lhs == null ? this.c85_1.w2(key) : tmp0_elvis_lhs;
  };
  protoOf(AsyncTypefaceCache).v85 = function (font, platformFontLoader, forever, block, $completion) {
    var tmp = new $runCachedCOROUTINE$(this, font, platformFontLoader, forever, block, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  function _set_value__lx0xdg($this, _set____db54di) {
    var tmp0 = $this.f84_1;
    var tmp = KMutableProperty1;
    var tmp_0 = AsyncFontListLoader$_get_value_$ref_okp6ex();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('value', 1, tmp, tmp_0, AsyncFontListLoader$_set_value_$ref_h5kf5n());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function AsyncFontListLoader$_get_value_$ref_okp6ex() {
    return constructCallableReference(function (p0) {
      return p0.u1();
    }, 1, 0, 33);
  }
  function AsyncFontListLoader$_set_value_$ref_h5kf5n() {
    return constructCallableReference(function (p0, p1) {
      _set_value__lx0xdg(p0, p1);
      return Unit_instance;
    }, 2, 0, 34);
  }
  function AsyncFontListLoader$load$slambda(this$0, $font, resultContinuation) {
    this.e86_1 = this$0;
    this.f86_1 = $font;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AsyncFontListLoader$load$slambda).g86 = function ($completion) {
    var tmp = this.s2b($completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AsyncFontListLoader$load$slambda).ia = function ($completion) {
    return this.g86($completion);
  };
  protoOf(AsyncFontListLoader$load$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.e86_1.h86(this.f86_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AsyncFontListLoader$load$slambda).s2b = function (completion) {
    return new AsyncFontListLoader$load$slambda(this.e86_1, this.f86_1, completion);
  };
  function AsyncFontListLoader$load$slambda_0(this$0, $font, resultContinuation) {
    var i = new AsyncFontListLoader$load$slambda(this$0, $font, resultContinuation);
    return constructCallableReference(function ($completion) {
      return i.g86($completion);
    }, 0);
  }
  function AsyncFontListLoader$loadWithTimeoutOrNull$slambda(this$0, $this_loadWithTimeoutOrNull, resultContinuation) {
    this.q86_1 = this$0;
    this.r86_1 = $this_loadWithTimeoutOrNull;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AsyncFontListLoader$loadWithTimeoutOrNull$slambda).t86 = function ($this$withTimeoutOrNull, $completion) {
    var tmp = this.q24($this$withTimeoutOrNull, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AsyncFontListLoader$loadWithTimeoutOrNull$slambda).ja = function (p1, $completion) {
    return this.t86((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AsyncFontListLoader$loadWithTimeoutOrNull$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.q86_1.e84_1.u86(this.r86_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AsyncFontListLoader$loadWithTimeoutOrNull$slambda).q24 = function ($this$withTimeoutOrNull, completion) {
    var i = new AsyncFontListLoader$loadWithTimeoutOrNull$slambda(this.q86_1, this.r86_1, completion);
    i.s86_1 = $this$withTimeoutOrNull;
    return i;
  };
  function AsyncFontListLoader$loadWithTimeoutOrNull$slambda_0(this$0, $this_loadWithTimeoutOrNull, resultContinuation) {
    var i = new AsyncFontListLoader$loadWithTimeoutOrNull$slambda(this$0, $this_loadWithTimeoutOrNull, resultContinuation);
    return constructCallableReference(function ($this$withTimeoutOrNull, $completion) {
      return i.t86($this$withTimeoutOrNull, $completion);
    }, 1);
  }
  function $loadCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.d87_1 = _this__u8e3s4;
  }
  protoOf($loadCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 12;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.o9_1 = 11;
            this.f87_1 = this.d87_1.a84_1;
            this.g87_1 = get_indices(this.f87_1).t();
            this.n9_1 = 3;
            continue $sm;
          case 3:
            if (!this.g87_1.u()) {
              this.n9_1 = 9;
              continue $sm;
            }

            var index = this.g87_1.v();
            var item = this.f87_1.l1(index);
            this.e87_1 = item;
            if (this.e87_1.z82() === Companion_getInstance_23().c83_1) {
              this.n9_1 = 4;
              suspendResult = this.d87_1.c84_1.v85(this.e87_1, this.d87_1.e84_1, false, AsyncFontListLoader$load$slambda_0(this.d87_1, this.e87_1, null), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 7;
              continue $sm;
            }

          case 4:
            var typeface = suspendResult;
            if (!(typeface == null)) {
              _set_value__lx0xdg(this.d87_1, synthesizeTypeface(this.d87_1.b84_1.t83_1, typeface, this.e87_1, this.d87_1.b84_1.r83_1, this.d87_1.b84_1.s83_1));
              this.o9_1 = 12;
              this.n9_1 = 8;
              continue $sm;
            } else {
              this.n9_1 = 5;
              suspendResult = yield_0(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 5:
            this.n9_1 = 6;
            continue $sm;
          case 6:
            this.n9_1 = 7;
            continue $sm;
          case 7:
            this.n9_1 = 3;
            continue $sm;
          case 8:
            this.o9_1 = 12;
            var shouldCache = get_isActive(this.t9());
            this.d87_1.g84_1 = false;
            this.d87_1.d84_1(new Immutable(this.d87_1.u1(), shouldCache));
            return Unit_instance;
          case 9:
            this.o9_1 = 12;
            this.n9_1 = 10;
            continue $sm;
          case 10:
            this.o9_1 = 12;
            var shouldCache_0 = get_isActive(this.t9());
            this.d87_1.g84_1 = false;
            this.d87_1.d84_1(new Immutable(this.d87_1.u1(), shouldCache_0));
            return Unit_instance;
          case 11:
            this.o9_1 = 12;
            var t = this.q9_1;
            var shouldCache_1 = get_isActive(this.t9());
            this.d87_1.g84_1 = false;
            this.d87_1.d84_1(new Immutable(this.d87_1.u1(), shouldCache_1));
            throw t;
          case 12:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 12) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $loadWithTimeoutOrNullCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.p87_1 = _this__u8e3s4;
    this.q87_1 = _this__u8e3s4_0;
  }
  protoOf($loadWithTimeoutOrNullCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = new Long(15000, 0);
            suspendResult = withTimeoutOrNull(tmp_0, AsyncFontListLoader$loadWithTimeoutOrNull$slambda_0(this.p87_1, this.q87_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.r87_1 = suspendResult;
            this.o9_1 = 3;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.o9_1 = 3;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof CancellationException) {
              var cancel = this.q9_1;
              var tmp_2 = this;
              var tmp_3;
              if (get_isActive(this.t9())) {
                tmp_3 = null;
              } else {
                throw cancel;
              }
              tmp_2.r87_1 = tmp_3;
              this.n9_1 = 4;
              continue $sm;
            } else {
              var tmp_4 = this.q9_1;
              if (tmp_4 instanceof Exception) {
                var uncaughtFontLoadException = this.q9_1;
                var tmp_5 = this;
                var tmp0_safe_receiver = this.t9().aa(Key_instance);
                if (tmp0_safe_receiver == null)
                  null;
                else {
                  tmp0_safe_receiver.f1h(this.t9(), IllegalStateException_init_$Create$('Unable to load font ' + toString_0(this.q87_1), uncaughtFontLoadException));
                }
                tmp_5.r87_1 = null;
                this.n9_1 = 4;
                continue $sm;
              } else {
                throw this.q9_1;
              }
            }

          case 3:
            throw this.q9_1;
          case 4:
            this.o9_1 = 3;
            return this.r87_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function AsyncFontListLoader(fontList, initialType, typefaceRequest, asyncTypefaceCache, onCompletion, platformFontLoader) {
    this.a84_1 = fontList;
    this.b84_1 = typefaceRequest;
    this.c84_1 = asyncTypefaceCache;
    this.d84_1 = onCompletion;
    this.e84_1 = platformFontLoader;
    this.f84_1 = mutableStateOf(initialType);
    this.g84_1 = true;
  }
  protoOf(AsyncFontListLoader).u1 = function () {
    var tmp0 = this.f84_1;
    var tmp = KMutableProperty1;
    var tmp_0 = AsyncFontListLoader$_get_value_$ref_okp6ex();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('value', 1, tmp, tmp_0, AsyncFontListLoader$_set_value_$ref_h5kf5n());
    return tmp0.u1();
  };
  protoOf(AsyncFontListLoader).s87 = function ($completion) {
    var tmp = new $loadCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AsyncFontListLoader).h86 = function (_this__u8e3s4, $completion) {
    var tmp = new $loadWithTimeoutOrNullCOROUTINE$(this, _this__u8e3s4, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  function FontListFontFamilyTypefaceAdapter$Companion$DropExceptionHandler$$inlined$CoroutineExceptionHandler$1() {
    AbstractCoroutineContextElement.call(this, Key_instance);
  }
  protoOf(FontListFontFamilyTypefaceAdapter$Companion$DropExceptionHandler$$inlined$CoroutineExceptionHandler$1).f1h = function (context, exception) {
    return Unit_instance;
  };
  function Companion_7() {
    Companion_instance_9 = this;
    this.u87_1 = new FontMatcher();
    var tmp = this;
    // Inline function 'kotlinx.coroutines.CoroutineExceptionHandler' call
    tmp.v87_1 = new FontListFontFamilyTypefaceAdapter$Companion$DropExceptionHandler$$inlined$CoroutineExceptionHandler$1();
  }
  var Companion_instance_9;
  function Companion_getInstance_22() {
    if (Companion_instance_9 == null)
      new Companion_7();
    return Companion_instance_9;
  }
  function FontListFontFamilyTypefaceAdapter$resolve$slambda($asyncLoader, resultContinuation) {
    this.e88_1 = $asyncLoader;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(FontListFontFamilyTypefaceAdapter$resolve$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(FontListFontFamilyTypefaceAdapter$resolve$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(FontListFontFamilyTypefaceAdapter$resolve$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.e88_1.s87(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(FontListFontFamilyTypefaceAdapter$resolve$slambda).q24 = function ($this$launch, completion) {
    var i = new FontListFontFamilyTypefaceAdapter$resolve$slambda(this.e88_1, completion);
    i.f88_1 = $this$launch;
    return i;
  };
  function FontListFontFamilyTypefaceAdapter$resolve$slambda_0($asyncLoader, resultContinuation) {
    var i = new FontListFontFamilyTypefaceAdapter$resolve$slambda($asyncLoader, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function FontListFontFamilyTypefaceAdapter(asyncTypefaceCache, injectedContext) {
    Companion_getInstance_22();
    asyncTypefaceCache = asyncTypefaceCache === VOID ? new AsyncTypefaceCache() : asyncTypefaceCache;
    injectedContext = injectedContext === VOID ? EmptyCoroutineContext_getInstance() : injectedContext;
    this.n84_1 = asyncTypefaceCache;
    this.o84_1 = CoroutineScope_0(Companion_getInstance_22().v87_1.xj(get_FontCacheManagementDispatcher()).xj(injectedContext).xj(SupervisorJob(injectedContext.aa(Key_instance_0))));
  }
  protoOf(FontListFontFamilyTypefaceAdapter).p84 = function (typefaceRequest, platformFontLoader, onAsyncCompletion, createDefaultTypeface) {
    var tmp = typefaceRequest.q83_1;
    if (!(tmp instanceof FontListFontFamily))
      return null;
    var matched = Companion_getInstance_22().u87_1.g88(typefaceRequest.q83_1.i83_1, typefaceRequest.r83_1, typefaceRequest.s83_1);
    var _destruct__k2r9zo = firstImmediatelyAvailable(matched, typefaceRequest, this.n84_1, platformFontLoader, createDefaultTypeface);
    var asyncFontsToLoad = _destruct__k2r9zo.zh();
    var synthesizedTypeface = _destruct__k2r9zo.ai();
    if (asyncFontsToLoad == null)
      return new Immutable(synthesizedTypeface);
    var asyncLoader = new AsyncFontListLoader(asyncFontsToLoad, synthesizedTypeface, typefaceRequest, this.n84_1, onAsyncCompletion, platformFontLoader);
    var tmp_0 = this.o84_1;
    var tmp_1 = CoroutineStart_UNDISPATCHED_getInstance();
    launch(tmp_0, VOID, tmp_1, FontListFontFamilyTypefaceAdapter$resolve$slambda_0(asyncLoader, null));
    return new Async(asyncLoader);
  };
  function firstImmediatelyAvailable(_this__u8e3s4, typefaceRequest, asyncTypefaceCache, platformFontLoader, createDefaultTypeface) {
    var asyncFontsToLoad = null;
    var inductionVariable = 0;
    var last = _this__u8e3s4.n1() - 1 | 0;
    if (inductionVariable <= last)
      $l$loop: do {
        var idx = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var font = _this__u8e3s4.l1(idx);
        var tmp0_subject = font.z82();
        if (tmp0_subject === Companion_getInstance_23().a83_1) {
          var tmp$ret$0;
          $l$block: {
            // Inline function 'androidx.compose.ui.text.font.AsyncTypefaceCache.runCachedBlocking' call
            // Inline function 'androidx.compose.ui.text.platform.synchronized' call
            // Inline function 'kotlinx.atomicfu.locks.synchronized' call
            access$_get_cacheLock__y7hpng(asyncTypefaceCache);
            var key = new Key(font, platformFontLoader.w84());
            var tmp0_elvis_lhs = access$_get_resultCache__u960s4(asyncTypefaceCache).iy(key);
            var priorResult = tmp0_elvis_lhs == null ? access$_get_permanentCache__bpfryv(asyncTypefaceCache).w2(key) : tmp0_elvis_lhs;
            if (!(priorResult == null)) {
              tmp$ret$0 = _AsyncTypefaceResult___get_result__impl__kpcqqb(priorResult.x84_1);
              break $l$block;
            }
            var tmp;
            try {
              tmp = platformFontLoader.h88(font);
            } catch ($p) {
              var tmp_0;
              if ($p instanceof Exception) {
                var cause = $p;
                tmp_0 = createDefaultTypeface(typefaceRequest);
              } else {
                throw $p;
              }
              tmp = tmp_0;
            }
            // Inline function 'kotlin.also' call
            var this_0 = tmp;
            asyncTypefaceCache.t85(font, platformFontLoader, this_0);
            tmp$ret$0 = this_0;
          }
          var tmp1_elvis_lhs = tmp$ret$0;
          var result = tmp1_elvis_lhs == null ? createDefaultTypeface(typefaceRequest) : tmp1_elvis_lhs;
          return to(asyncFontsToLoad, synthesizeTypeface(typefaceRequest.t83_1, result, font, typefaceRequest.r83_1, typefaceRequest.s83_1));
        } else if (tmp0_subject === Companion_getInstance_23().b83_1) {
          var tmp$ret$7;
          $l$block_0: {
            // Inline function 'androidx.compose.ui.text.font.AsyncTypefaceCache.runCachedBlocking' call
            // Inline function 'androidx.compose.ui.text.platform.synchronized' call
            // Inline function 'kotlinx.atomicfu.locks.synchronized' call
            access$_get_cacheLock__y7hpng(asyncTypefaceCache);
            var key_0 = new Key(font, platformFontLoader.w84());
            var tmp0_elvis_lhs_0 = access$_get_resultCache__u960s4(asyncTypefaceCache).iy(key_0);
            var priorResult_0 = tmp0_elvis_lhs_0 == null ? access$_get_permanentCache__bpfryv(asyncTypefaceCache).w2(key_0) : tmp0_elvis_lhs_0;
            if (!(priorResult_0 == null)) {
              tmp$ret$7 = _AsyncTypefaceResult___get_result__impl__kpcqqb(priorResult_0.x84_1);
              break $l$block_0;
            }
            // Inline function 'kotlin.runCatching' call
            var tmp_1;
            try {
              // Inline function 'kotlin.Companion.success' call
              var value = platformFontLoader.h88(font);
              tmp_1 = _Result___init__impl__xyqfz8(value);
            } catch ($p_0) {
              var tmp_2;
              if ($p_0 instanceof Error) {
                var e = $p_0;
                // Inline function 'kotlin.Companion.failure' call
                tmp_2 = _Result___init__impl__xyqfz8(createFailure(e));
              } else {
                throw $p_0;
              }
              tmp_1 = tmp_2;
            }
            // Inline function 'kotlin.Result.getOrNull' call
            var this_1 = tmp_1;
            // Inline function 'kotlin.also' call
            var this_2 = _Result___get_isFailure__impl__jpiriv(this_1) ? null : _Result___get_value__impl__bjfvqg(this_1);
            asyncTypefaceCache.t85(font, platformFontLoader, this_2);
            tmp$ret$7 = this_2;
          }
          var result_0 = tmp$ret$7;
          if (!(result_0 == null)) {
            return to(asyncFontsToLoad, synthesizeTypeface(typefaceRequest.t83_1, result_0, font, typefaceRequest.r83_1, typefaceRequest.s83_1));
          }
        } else if (tmp0_subject === Companion_getInstance_23().c83_1) {
          var cacheResult = asyncTypefaceCache.u85(font, platformFontLoader);
          if (cacheResult == null) {
            if (asyncFontsToLoad == null) {
              asyncFontsToLoad = mutableListOf([font]);
            } else {
              asyncFontsToLoad.j1(font);
            }
          } else if (_AsyncTypefaceResult___get_isPermanentFailure__impl__sthpca(cacheResult.x84_1)) {
            continue $l$loop;
          } else if (!(_AsyncTypefaceResult___get_result__impl__kpcqqb(cacheResult.x84_1) == null)) {
            return to(asyncFontsToLoad, synthesizeTypeface(typefaceRequest.t83_1, _AsyncTypefaceResult___get_result__impl__kpcqqb(cacheResult.x84_1), font, typefaceRequest.r83_1, typefaceRequest.s83_1));
          }
        } else
          throw IllegalStateException_init_$Create$_0('Unknown font type ' + toString_0(font));
      }
       while (inductionVariable <= last);
    var fallbackTypeface = createDefaultTypeface(typefaceRequest);
    return to(asyncFontsToLoad, fallbackTypeface);
  }
  function _FontLoadingStrategy___init__impl__if1sp3(value) {
    return value;
  }
  function _FontLoadingStrategy___get_value__impl__ggsl83($this) {
    return $this;
  }
  function FontLoadingStrategy__toString_impl_fx0z8f($this) {
    return $this === Companion_getInstance_23().a83_1 ? 'Blocking' : $this === Companion_getInstance_23().b83_1 ? 'Optional' : $this === Companion_getInstance_23().c83_1 ? 'Async' : 'Invalid(value=' + _FontLoadingStrategy___get_value__impl__ggsl83($this) + ')';
  }
  function Companion_8() {
    Companion_instance_10 = this;
    this.a83_1 = _FontLoadingStrategy___init__impl__if1sp3(0);
    this.b83_1 = _FontLoadingStrategy___init__impl__if1sp3(1);
    this.c83_1 = _FontLoadingStrategy___init__impl__if1sp3(2);
  }
  var Companion_instance_10;
  function Companion_getInstance_23() {
    if (Companion_instance_10 == null)
      new Companion_8();
    return Companion_instance_10;
  }
  var androidx_compose_ui_text_font_FontMatcher$stable;
  function FontMatcher() {
  }
  protoOf(FontMatcher).g88 = function (fontList, fontWeight, fontStyle) {
    // Inline function 'androidx.compose.ui.util.fastFilter' call
    var target = ArrayList_init_$Create$_0(fontList.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = fontList.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = fontList.l1(index);
        if (item.g5p().equals(fontWeight) && item.y82() === fontStyle) {
          // Inline function 'kotlin.collections.plusAssign' call
          target.j1(item);
        }
      }
       while (inductionVariable <= last);
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!target.r()) {
      return target;
    }
    // Inline function 'androidx.compose.ui.util.fastFilter' call
    var target_0 = ArrayList_init_$Create$_0(fontList.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable_0 = 0;
    var last_0 = fontList.n1() - 1 | 0;
    if (inductionVariable_0 <= last_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var item_0 = fontList.l1(index_0);
        if (item_0.y82() === fontStyle) {
          // Inline function 'kotlin.collections.plusAssign' call
          target_0.j1(item_0);
        }
      }
       while (inductionVariable_0 <= last_0);
    // Inline function 'kotlin.collections.ifEmpty' call
    var tmp;
    if (target_0.r()) {
      tmp = fontList;
    } else {
      tmp = target_0;
    }
    var fontsToSearch = tmp;
    var tmp_0;
    if (fontWeight.i88(Companion_getInstance_26().s7y_1) < 0) {
      // Inline function 'androidx.compose.ui.text.font.FontMatcher.filterByClosestWeight' call
      var bestWeightAbove = null;
      var bestWeightBelow = null;
      var inductionVariable_1 = 0;
      var last_1 = fontsToSearch.n1() - 1 | 0;
      if (inductionVariable_1 <= last_1)
        $l$loop_1: do {
          var index_1 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var font = fontsToSearch.l1(index_1);
          var possibleWeight = font.g5p();
          if (!(null == null) && possibleWeight.i88(null) < 0) {
            continue $l$loop_1;
          }
          if (!(null == null) && possibleWeight.i88(null) > 0) {
            continue $l$loop_1;
          }
          if (possibleWeight.i88(fontWeight) < 0) {
            if (bestWeightBelow == null || possibleWeight.i88(bestWeightBelow) > 0) {
              bestWeightBelow = possibleWeight;
            }
          } else if (possibleWeight.i88(fontWeight) > 0) {
            if (bestWeightAbove == null || possibleWeight.i88(bestWeightAbove) < 0) {
              bestWeightAbove = possibleWeight;
            }
          } else {
            bestWeightAbove = possibleWeight;
            bestWeightBelow = possibleWeight;
            break $l$loop_1;
          }
        }
         while (inductionVariable_1 <= last_1);
      var tmp_1;
      if (true) {
        var tmp0_elvis_lhs = bestWeightBelow;
        tmp_1 = tmp0_elvis_lhs == null ? bestWeightAbove : tmp0_elvis_lhs;
      } else {
        var tmp1_elvis_lhs = bestWeightAbove;
        tmp_1 = tmp1_elvis_lhs == null ? bestWeightBelow : tmp1_elvis_lhs;
      }
      var bestWeight = tmp_1;
      // Inline function 'androidx.compose.ui.util.fastFilter' call
      var target_1 = ArrayList_init_$Create$_0(fontsToSearch.n1());
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable_2 = 0;
      var last_2 = fontsToSearch.n1() - 1 | 0;
      if (inductionVariable_2 <= last_2)
        do {
          var index_2 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          var item_1 = fontsToSearch.l1(index_2);
          if (item_1.g5p().equals(bestWeight)) {
            // Inline function 'kotlin.collections.plusAssign' call
            target_1.j1(item_1);
          }
        }
         while (inductionVariable_2 <= last_2);
      tmp_0 = target_1;
    } else if (fontWeight.i88(Companion_getInstance_26().t7y_1) > 0) {
      // Inline function 'androidx.compose.ui.text.font.FontMatcher.filterByClosestWeight' call
      var bestWeightAbove_0 = null;
      var bestWeightBelow_0 = null;
      var inductionVariable_3 = 0;
      var last_3 = fontsToSearch.n1() - 1 | 0;
      if (inductionVariable_3 <= last_3)
        $l$loop_4: do {
          var index_3 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          var font_0 = fontsToSearch.l1(index_3);
          var possibleWeight_0 = font_0.g5p();
          if (!(null == null) && possibleWeight_0.i88(null) < 0) {
            continue $l$loop_4;
          }
          if (!(null == null) && possibleWeight_0.i88(null) > 0) {
            continue $l$loop_4;
          }
          if (possibleWeight_0.i88(fontWeight) < 0) {
            if (bestWeightBelow_0 == null || possibleWeight_0.i88(bestWeightBelow_0) > 0) {
              bestWeightBelow_0 = possibleWeight_0;
            }
          } else if (possibleWeight_0.i88(fontWeight) > 0) {
            if (bestWeightAbove_0 == null || possibleWeight_0.i88(bestWeightAbove_0) < 0) {
              bestWeightAbove_0 = possibleWeight_0;
            }
          } else {
            bestWeightAbove_0 = possibleWeight_0;
            bestWeightBelow_0 = possibleWeight_0;
            break $l$loop_4;
          }
        }
         while (inductionVariable_3 <= last_3);
      var tmp_2;
      if (false) {
        var tmp0_elvis_lhs_0 = bestWeightBelow_0;
        tmp_2 = tmp0_elvis_lhs_0 == null ? bestWeightAbove_0 : tmp0_elvis_lhs_0;
      } else {
        var tmp1_elvis_lhs_0 = bestWeightAbove_0;
        tmp_2 = tmp1_elvis_lhs_0 == null ? bestWeightBelow_0 : tmp1_elvis_lhs_0;
      }
      var bestWeight_0 = tmp_2;
      // Inline function 'androidx.compose.ui.util.fastFilter' call
      var target_2 = ArrayList_init_$Create$_0(fontsToSearch.n1());
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable_4 = 0;
      var last_4 = fontsToSearch.n1() - 1 | 0;
      if (inductionVariable_4 <= last_4)
        do {
          var index_4 = inductionVariable_4;
          inductionVariable_4 = inductionVariable_4 + 1 | 0;
          var item_2 = fontsToSearch.l1(index_4);
          if (item_2.g5p().equals(bestWeight_0)) {
            // Inline function 'kotlin.collections.plusAssign' call
            target_2.j1(item_2);
          }
        }
         while (inductionVariable_4 <= last_4);
      tmp_0 = target_2;
    } else {
      // Inline function 'androidx.compose.ui.text.font.FontMatcher.filterByClosestWeight' call
      var maxSearchRange = Companion_getInstance_26().t7y_1;
      var bestWeightAbove_1 = null;
      var bestWeightBelow_1 = null;
      var inductionVariable_5 = 0;
      var last_5 = fontsToSearch.n1() - 1 | 0;
      if (inductionVariable_5 <= last_5)
        $l$loop_7: do {
          var index_5 = inductionVariable_5;
          inductionVariable_5 = inductionVariable_5 + 1 | 0;
          var font_1 = fontsToSearch.l1(index_5);
          var possibleWeight_1 = font_1.g5p();
          if (!(null == null) && possibleWeight_1.i88(null) < 0) {
            continue $l$loop_7;
          }
          if (!(maxSearchRange == null) && possibleWeight_1.i88(maxSearchRange) > 0) {
            continue $l$loop_7;
          }
          if (possibleWeight_1.i88(fontWeight) < 0) {
            if (bestWeightBelow_1 == null || possibleWeight_1.i88(bestWeightBelow_1) > 0) {
              bestWeightBelow_1 = possibleWeight_1;
            }
          } else if (possibleWeight_1.i88(fontWeight) > 0) {
            if (bestWeightAbove_1 == null || possibleWeight_1.i88(bestWeightAbove_1) < 0) {
              bestWeightAbove_1 = possibleWeight_1;
            }
          } else {
            bestWeightAbove_1 = possibleWeight_1;
            bestWeightBelow_1 = possibleWeight_1;
            break $l$loop_7;
          }
        }
         while (inductionVariable_5 <= last_5);
      var tmp_3;
      if (false) {
        var tmp0_elvis_lhs_1 = bestWeightBelow_1;
        tmp_3 = tmp0_elvis_lhs_1 == null ? bestWeightAbove_1 : tmp0_elvis_lhs_1;
      } else {
        var tmp1_elvis_lhs_1 = bestWeightAbove_1;
        tmp_3 = tmp1_elvis_lhs_1 == null ? bestWeightBelow_1 : tmp1_elvis_lhs_1;
      }
      var bestWeight_1 = tmp_3;
      // Inline function 'androidx.compose.ui.util.fastFilter' call
      var target_3 = ArrayList_init_$Create$_0(fontsToSearch.n1());
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable_6 = 0;
      var last_6 = fontsToSearch.n1() - 1 | 0;
      if (inductionVariable_6 <= last_6)
        do {
          var index_6 = inductionVariable_6;
          inductionVariable_6 = inductionVariable_6 + 1 | 0;
          var item_3 = fontsToSearch.l1(index_6);
          if (item_3.g5p().equals(bestWeight_1)) {
            // Inline function 'kotlin.collections.plusAssign' call
            target_3.j1(item_3);
          }
        }
         while (inductionVariable_6 <= last_6);
      // Inline function 'kotlin.collections.ifEmpty' call
      var tmp_4;
      if (target_3.r()) {
        // Inline function 'androidx.compose.ui.text.font.FontMatcher.filterByClosestWeight' call
        var minSearchRange = Companion_getInstance_26().t7y_1;
        var bestWeightAbove_2 = null;
        var bestWeightBelow_2 = null;
        var inductionVariable_7 = 0;
        var last_7 = fontsToSearch.n1() - 1 | 0;
        if (inductionVariable_7 <= last_7)
          $l$loop_10: do {
            var index_7 = inductionVariable_7;
            inductionVariable_7 = inductionVariable_7 + 1 | 0;
            var font_2 = fontsToSearch.l1(index_7);
            var possibleWeight_2 = font_2.g5p();
            if (!(minSearchRange == null) && possibleWeight_2.i88(minSearchRange) < 0) {
              continue $l$loop_10;
            }
            if (!(null == null) && possibleWeight_2.i88(null) > 0) {
              continue $l$loop_10;
            }
            if (possibleWeight_2.i88(fontWeight) < 0) {
              if (bestWeightBelow_2 == null || possibleWeight_2.i88(bestWeightBelow_2) > 0) {
                bestWeightBelow_2 = possibleWeight_2;
              }
            } else if (possibleWeight_2.i88(fontWeight) > 0) {
              if (bestWeightAbove_2 == null || possibleWeight_2.i88(bestWeightAbove_2) < 0) {
                bestWeightAbove_2 = possibleWeight_2;
              }
            } else {
              bestWeightAbove_2 = possibleWeight_2;
              bestWeightBelow_2 = possibleWeight_2;
              break $l$loop_10;
            }
          }
           while (inductionVariable_7 <= last_7);
        var tmp_5;
        if (false) {
          var tmp0_elvis_lhs_2 = bestWeightBelow_2;
          tmp_5 = tmp0_elvis_lhs_2 == null ? bestWeightAbove_2 : tmp0_elvis_lhs_2;
        } else {
          var tmp1_elvis_lhs_2 = bestWeightAbove_2;
          tmp_5 = tmp1_elvis_lhs_2 == null ? bestWeightBelow_2 : tmp1_elvis_lhs_2;
        }
        var bestWeight_2 = tmp_5;
        // Inline function 'androidx.compose.ui.util.fastFilter' call
        var target_4 = ArrayList_init_$Create$_0(fontsToSearch.n1());
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable_8 = 0;
        var last_8 = fontsToSearch.n1() - 1 | 0;
        if (inductionVariable_8 <= last_8)
          do {
            var index_8 = inductionVariable_8;
            inductionVariable_8 = inductionVariable_8 + 1 | 0;
            var item_4 = fontsToSearch.l1(index_8);
            if (item_4.g5p().equals(bestWeight_2)) {
              // Inline function 'kotlin.collections.plusAssign' call
              target_4.j1(item_4);
            }
          }
           while (inductionVariable_8 <= last_8);
        tmp_4 = target_4;
      } else {
        tmp_4 = target_3;
      }
      tmp_0 = tmp_4;
    }
    var result = tmp_0;
    return result;
  };
  function _FontStyle___init__impl__jcnduf(value) {
    return value;
  }
  function _FontStyle___get_value__impl__gx8aaz($this) {
    return $this;
  }
  function FontStyle__toString_impl_thncxr($this) {
    return $this === Companion_getInstance_24().k7z_1 ? 'Normal' : $this === Companion_getInstance_24().l7z_1 ? 'Italic' : 'Invalid';
  }
  function Companion_9() {
    Companion_instance_11 = this;
    this.k7z_1 = _FontStyle___init__impl__jcnduf(0);
    this.l7z_1 = _FontStyle___init__impl__jcnduf(1);
  }
  var Companion_instance_11;
  function Companion_getInstance_24() {
    if (Companion_instance_11 == null)
      new Companion_9();
    return Companion_instance_11;
  }
  function FontStyle__hashCode_impl_7qhg4w($this) {
    return $this;
  }
  function FontStyle__equals_impl_2zal3g($this, other) {
    if (!(other instanceof FontStyle))
      return false;
    if (!($this === other.d7x_1))
      return false;
    return true;
  }
  function FontStyle(value) {
    Companion_getInstance_24();
    this.d7x_1 = value;
  }
  protoOf(FontStyle).toString = function () {
    return FontStyle__toString_impl_thncxr(this.d7x_1);
  };
  protoOf(FontStyle).hashCode = function () {
    return FontStyle__hashCode_impl_7qhg4w(this.d7x_1);
  };
  protoOf(FontStyle).equals = function (other) {
    return FontStyle__equals_impl_2zal3g(this.d7x_1, other);
  };
  function _FontSynthesis___init__impl__n397bg(value) {
    return value;
  }
  function _FontSynthesis___get_value__impl__xrueqg($this) {
    return $this;
  }
  function FontSynthesis__toString_impl_gunvr0($this) {
    return $this === Companion_getInstance_25().m7z_1 ? 'None' : $this === Companion_getInstance_25().n7z_1 ? 'Weight' : $this === Companion_getInstance_25().o7z_1 ? 'Style' : $this === Companion_getInstance_25().p7z_1 ? 'All' : 'Invalid';
  }
  function Companion_10() {
    Companion_instance_12 = this;
    this.m7z_1 = _FontSynthesis___init__impl__n397bg(0);
    this.n7z_1 = _FontSynthesis___init__impl__n397bg(1);
    this.o7z_1 = _FontSynthesis___init__impl__n397bg(2);
    this.p7z_1 = _FontSynthesis___init__impl__n397bg(65535);
  }
  protoOf(Companion_10).j88 = function (value) {
    var tmp0;
    switch (value) {
      case 0:
      case 1:
      case 2:
        tmp0 = true;
        break;
      default:
        tmp0 = value === 65535;
        break;
    }
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!tmp0) {
      var tmp$ret$1 = 'The given value=' + value + ' is not recognized by FontSynthesis.';
      throwIllegalArgumentException(tmp$ret$1);
    }
    return _FontSynthesis___init__impl__n397bg(value);
  };
  var Companion_instance_12;
  function Companion_getInstance_25() {
    if (Companion_instance_12 == null)
      new Companion_10();
    return Companion_instance_12;
  }
  function FontSynthesis__hashCode_impl_4wi11v($this) {
    return $this;
  }
  function FontSynthesis__equals_impl_zgu9mf($this, other) {
    if (!(other instanceof FontSynthesis))
      return false;
    if (!($this === other.e7x_1))
      return false;
    return true;
  }
  function FontSynthesis(value) {
    Companion_getInstance_25();
    this.e7x_1 = value;
  }
  protoOf(FontSynthesis).toString = function () {
    return FontSynthesis__toString_impl_gunvr0(this.e7x_1);
  };
  protoOf(FontSynthesis).hashCode = function () {
    return FontSynthesis__hashCode_impl_4wi11v(this.e7x_1);
  };
  protoOf(FontSynthesis).equals = function (other) {
    return FontSynthesis__equals_impl_zgu9mf(this.e7x_1, other);
  };
  var androidx_compose_ui_text_font_FontVariation_Settings$stable;
  var androidx_compose_ui_text_font_FontVariation$stable;
  function Settings(settings) {
    var needsDensity = false;
    var inductionVariable = 0;
    var last = settings.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var setting = settings[i];
        var name = setting.k88();
        // Inline function 'kotlin.collections.count' call
        var count = 0;
        var inductionVariable_0 = 0;
        var last_0 = settings.length;
        while (inductionVariable_0 < last_0) {
          var element = settings[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (element.k88() === name) {
            count = count + 1 | 0;
          }
        }
        var count_0 = count;
        // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
        if (!(count_0 === 1)) {
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList_init_$Create$();
          var inductionVariable_1 = 0;
          var last_1 = settings.length;
          while (inductionVariable_1 < last_1) {
            var element_0 = settings[inductionVariable_1];
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            if (element_0.k88() === name) {
              destination.j1(element_0);
            }
          }
          var tmp$ret$3 = "'" + name + "' must be unique. Actual [" + toString_0(destination) + ']';
          throwIllegalArgumentException(tmp$ret$3);
        }
        needsDensity = needsDensity || setting.l88();
      }
       while (inductionVariable <= last);
    this.m88_1 = toList(settings);
    this.n88_1 = needsDensity;
  }
  protoOf(Settings).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Settings))
      return false;
    if (!equals(this.m88_1, other.m88_1))
      return false;
    return true;
  };
  protoOf(Settings).hashCode = function () {
    return hashCode(this.m88_1);
  };
  function SettingFloat(axisName, value) {
    this.o88_1 = axisName;
    this.p88_1 = value;
    this.q88_1 = false;
  }
  protoOf(SettingFloat).k88 = function () {
    return this.o88_1;
  };
  protoOf(SettingFloat).r88 = function (density) {
    return this.p88_1;
  };
  protoOf(SettingFloat).l88 = function () {
    return this.q88_1;
  };
  protoOf(SettingFloat).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SettingFloat))
      return false;
    if (!(this.o88_1 === other.o88_1))
      return false;
    if (!(this.p88_1 === other.p88_1))
      return false;
    return true;
  };
  protoOf(SettingFloat).hashCode = function () {
    var result = getStringHashCode(this.o88_1);
    result = imul(31, result) + getNumberHashCode(this.p88_1) | 0;
    return result;
  };
  protoOf(SettingFloat).toString = function () {
    return "FontVariation.Setting(axisName='" + this.o88_1 + "', value=" + this.p88_1 + ')';
  };
  function SettingInt(axisName, value) {
    this.s88_1 = axisName;
    this.t88_1 = value;
    this.u88_1 = false;
  }
  protoOf(SettingInt).k88 = function () {
    return this.s88_1;
  };
  protoOf(SettingInt).r88 = function (density) {
    return this.t88_1;
  };
  protoOf(SettingInt).l88 = function () {
    return this.u88_1;
  };
  protoOf(SettingInt).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SettingInt))
      return false;
    if (!(this.s88_1 === other.s88_1))
      return false;
    if (!(this.t88_1 === other.t88_1))
      return false;
    return true;
  };
  protoOf(SettingInt).hashCode = function () {
    var result = getStringHashCode(this.s88_1);
    result = imul(31, result) + this.t88_1 | 0;
    return result;
  };
  protoOf(SettingInt).toString = function () {
    return "FontVariation.Setting(axisName='" + this.s88_1 + "', value=" + this.t88_1 + ')';
  };
  function FontVariation() {
  }
  protoOf(FontVariation).v88 = function (value) {
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!(0.0 <= value ? value <= 1.0 : false)) {
      var tmp$ret$1 = "'ital' must be in 0.0f..1.0f. Actual: " + value;
      throwIllegalArgumentException(tmp$ret$1);
    }
    return new SettingFloat('ital', value);
  };
  protoOf(FontVariation).w88 = function (value) {
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!(1 <= value ? value <= 1000 : false)) {
      var tmp$ret$1 = "'wght' value must be in [1, 1000]. Actual: " + value;
      throwIllegalArgumentException(tmp$ret$1);
    }
    return new SettingInt('wght', value);
  };
  protoOf(FontVariation).x88 = function (weight, style, settings) {
    return new Settings(arrayConcat([[this.w88(weight.p7x_1), this.v88(_FontStyle___get_value__impl__gx8aaz(style))], settings]));
  };
  var FontVariation_instance;
  function FontVariation_getInstance() {
    return FontVariation_instance;
  }
  var androidx_compose_ui_text_font_FontWeight$stable;
  function Companion_11() {
    Companion_instance_13 = this;
    this.p7y_1 = new FontWeight(100);
    this.q7y_1 = new FontWeight(200);
    this.r7y_1 = new FontWeight(300);
    this.s7y_1 = new FontWeight(400);
    this.t7y_1 = new FontWeight(500);
    this.u7y_1 = new FontWeight(600);
    this.v7y_1 = new FontWeight(700);
    this.w7y_1 = new FontWeight(800);
    this.x7y_1 = new FontWeight(900);
    this.y7y_1 = this.p7y_1;
    this.z7y_1 = this.q7y_1;
    this.a7z_1 = this.r7y_1;
    this.b7z_1 = this.s7y_1;
    this.c7z_1 = this.t7y_1;
    this.d7z_1 = this.u7y_1;
    this.e7z_1 = this.v7y_1;
    this.f7z_1 = this.w7y_1;
    this.g7z_1 = this.x7y_1;
    this.h7z_1 = listOf([this.p7y_1, this.q7y_1, this.r7y_1, this.s7y_1, this.t7y_1, this.u7y_1, this.v7y_1, this.w7y_1, this.x7y_1]);
  }
  var Companion_instance_13;
  function Companion_getInstance_26() {
    if (Companion_instance_13 == null)
      new Companion_11();
    return Companion_instance_13;
  }
  function FontWeight(weight) {
    Companion_getInstance_26();
    this.p7x_1 = weight;
    var containsArg = this.p7x_1;
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!(1 <= containsArg ? containsArg <= 1000 : false)) {
      var tmp$ret$1 = 'Font weight can be in range [1, 1000]. Current value: ' + this.p7x_1;
      throwIllegalArgumentException(tmp$ret$1);
    }
  }
  protoOf(FontWeight).i88 = function (other) {
    return compareTo(this.p7x_1, other.p7x_1);
  };
  protoOf(FontWeight).d = function (other) {
    return this.i88(other instanceof FontWeight ? other : THROW_CCE());
  };
  protoOf(FontWeight).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FontWeight))
      return false;
    if (!(this.p7x_1 === other.p7x_1))
      return false;
    return true;
  };
  protoOf(FontWeight).hashCode = function () {
    return this.p7x_1;
  };
  protoOf(FontWeight).toString = function () {
    return 'FontWeight(weight=' + this.p7x_1 + ')';
  };
  function lerp_7(start, stop, fraction) {
    var weight = coerceIn(lerp_2(start.p7x_1, stop.p7x_1, fraction), 1, 1000);
    return new FontWeight(weight);
  }
  var androidx_compose_ui_text_input_CommitTextCommand$stable;
  var androidx_compose_ui_text_input_SetComposingRegionCommand$stable;
  var androidx_compose_ui_text_input_SetComposingTextCommand$stable;
  var androidx_compose_ui_text_input_DeleteSurroundingTextCommand$stable;
  var androidx_compose_ui_text_input_DeleteSurroundingTextInCodePointsCommand$stable;
  var androidx_compose_ui_text_input_SetSelectionCommand$stable;
  var androidx_compose_ui_text_input_FinishComposingTextCommand$stable;
  var androidx_compose_ui_text_input_BackspaceCommand$stable;
  var androidx_compose_ui_text_input_MoveCursorCommand$stable;
  var androidx_compose_ui_text_input_DeleteAllCommand$stable;
  function FinishComposingTextCommand() {
  }
  protoOf(FinishComposingTextCommand).y88 = function (buffer) {
    buffer.e89();
  };
  protoOf(FinishComposingTextCommand).equals = function (other) {
    return other instanceof FinishComposingTextCommand;
  };
  protoOf(FinishComposingTextCommand).hashCode = function () {
    return getKClassFromExpression(this).hashCode();
  };
  protoOf(FinishComposingTextCommand).toString = function () {
    return 'FinishComposingTextCommand()';
  };
  function CommitTextCommand_init_$Init$(text, newCursorPosition, $this) {
    CommitTextCommand.call($this, AnnotatedString_init_$Create$(text), newCursorPosition);
    return $this;
  }
  function CommitTextCommand_init_$Create$(text, newCursorPosition) {
    return CommitTextCommand_init_$Init$(text, newCursorPosition, objectCreate(protoOf(CommitTextCommand)));
  }
  function CommitTextCommand(annotatedString, newCursorPosition) {
    this.f89_1 = annotatedString;
    this.g89_1 = newCursorPosition;
  }
  protoOf(CommitTextCommand).h89 = function () {
    return this.f89_1.h7q_1;
  };
  protoOf(CommitTextCommand).y88 = function (buffer) {
    if (buffer.j89()) {
      buffer.i89(buffer.c89_1, buffer.d89_1, this.h89());
    } else {
      buffer.i89(buffer.a89_1, buffer.b89_1, this.h89());
    }
    var newCursor = buffer.k89();
    var tmp;
    if (this.g89_1 > 0) {
      tmp = (newCursor + this.g89_1 | 0) - 1 | 0;
    } else {
      tmp = (newCursor + this.g89_1 | 0) - this.h89().length | 0;
    }
    var newCursorInBuffer = tmp;
    buffer.m89(coerceIn(newCursorInBuffer, 0, buffer.l89()));
  };
  protoOf(CommitTextCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CommitTextCommand))
      return false;
    if (!(this.h89() === other.h89()))
      return false;
    if (!(this.g89_1 === other.g89_1))
      return false;
    return true;
  };
  protoOf(CommitTextCommand).hashCode = function () {
    var result = getStringHashCode(this.h89());
    result = imul(31, result) + this.g89_1 | 0;
    return result;
  };
  protoOf(CommitTextCommand).toString = function () {
    return "CommitTextCommand(text='" + this.h89() + "', newCursorPosition=" + this.g89_1 + ')';
  };
  function DeleteSurroundingTextCommand(lengthBeforeCursor, lengthAfterCursor) {
    this.n89_1 = lengthBeforeCursor;
    this.o89_1 = lengthAfterCursor;
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!(this.n89_1 >= 0 && this.o89_1 >= 0)) {
      var tmp$ret$1 = 'Expected lengthBeforeCursor and lengthAfterCursor to be non-negative, were ' + ('' + this.n89_1 + ' and ' + this.o89_1 + ' respectively.');
      throwIllegalArgumentException(tmp$ret$1);
    }
  }
  protoOf(DeleteSurroundingTextCommand).y88 = function (buffer) {
    var tmp0 = buffer.b89_1;
    // Inline function 'androidx.compose.ui.text.input.addExactOrElse' call
    var right = this.o89_1;
    var result = tmp0 + right | 0;
    var tmp;
    if (((tmp0 ^ result) & (right ^ result)) < 0) {
      tmp = buffer.l89();
    } else {
      tmp = result;
    }
    var end = tmp;
    var tmp_0 = buffer.b89_1;
    // Inline function 'kotlin.comparisons.minOf' call
    var b = buffer.l89();
    var tmp$ret$2 = Math.min(end, b);
    buffer.p89(tmp_0, tmp$ret$2);
    var tmp0_0 = buffer.a89_1;
    // Inline function 'androidx.compose.ui.text.input.subtractExactOrElse' call
    var right_0 = this.n89_1;
    var result_0 = tmp0_0 - right_0 | 0;
    var tmp_1;
    if (((tmp0_0 ^ right_0) & (tmp0_0 ^ result_0)) < 0) {
      tmp_1 = 0;
    } else {
      tmp_1 = result_0;
    }
    var start = tmp_1;
    // Inline function 'kotlin.comparisons.maxOf' call
    var tmp$ret$5 = Math.max(0, start);
    buffer.p89(tmp$ret$5, buffer.a89_1);
  };
  protoOf(DeleteSurroundingTextCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DeleteSurroundingTextCommand))
      return false;
    if (!(this.n89_1 === other.n89_1))
      return false;
    if (!(this.o89_1 === other.o89_1))
      return false;
    return true;
  };
  protoOf(DeleteSurroundingTextCommand).hashCode = function () {
    var result = this.n89_1;
    result = imul(31, result) + this.o89_1 | 0;
    return result;
  };
  protoOf(DeleteSurroundingTextCommand).toString = function () {
    return 'DeleteSurroundingTextCommand(lengthBeforeCursor=' + this.n89_1 + ', ' + ('lengthAfterCursor=' + this.o89_1 + ')');
  };
  function DeleteAllCommand() {
  }
  protoOf(DeleteAllCommand).y88 = function (buffer) {
    buffer.i89(0, buffer.l89(), '');
  };
  protoOf(DeleteAllCommand).equals = function (other) {
    return other instanceof DeleteAllCommand;
  };
  protoOf(DeleteAllCommand).hashCode = function () {
    return getKClassFromExpression(this).hashCode();
  };
  protoOf(DeleteAllCommand).toString = function () {
    return 'DeleteAllCommand()';
  };
  function SetSelectionCommand(start, end) {
    this.q89_1 = start;
    this.r89_1 = end;
  }
  protoOf(SetSelectionCommand).y88 = function (buffer) {
    var clampedStart = coerceIn(this.q89_1, 0, buffer.l89());
    var clampedEnd = coerceIn(this.r89_1, 0, buffer.l89());
    if (clampedStart < clampedEnd) {
      buffer.s89(clampedStart, clampedEnd);
    } else {
      buffer.s89(clampedEnd, clampedStart);
    }
  };
  protoOf(SetSelectionCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetSelectionCommand))
      return false;
    if (!(this.q89_1 === other.q89_1))
      return false;
    if (!(this.r89_1 === other.r89_1))
      return false;
    return true;
  };
  protoOf(SetSelectionCommand).hashCode = function () {
    var result = this.q89_1;
    result = imul(31, result) + this.r89_1 | 0;
    return result;
  };
  protoOf(SetSelectionCommand).toString = function () {
    return 'SetSelectionCommand(start=' + this.q89_1 + ', end=' + this.r89_1 + ')';
  };
  function SetComposingTextCommand_init_$Init$(text, newCursorPosition, $this) {
    SetComposingTextCommand.call($this, AnnotatedString_init_$Create$(text), newCursorPosition);
    return $this;
  }
  function SetComposingTextCommand_init_$Create$(text, newCursorPosition) {
    return SetComposingTextCommand_init_$Init$(text, newCursorPosition, objectCreate(protoOf(SetComposingTextCommand)));
  }
  function SetComposingTextCommand(annotatedString, newCursorPosition) {
    this.t89_1 = annotatedString;
    this.u89_1 = newCursorPosition;
  }
  protoOf(SetComposingTextCommand).h89 = function () {
    return this.t89_1.h7q_1;
  };
  protoOf(SetComposingTextCommand).y88 = function (buffer) {
    if (buffer.j89()) {
      var compositionStart = buffer.c89_1;
      buffer.i89(buffer.c89_1, buffer.d89_1, this.h89());
      // Inline function 'kotlin.text.isNotEmpty' call
      var this_0 = this.h89();
      if (charSequenceLength(this_0) > 0) {
        buffer.v89(compositionStart, compositionStart + this.h89().length | 0);
      }
    } else {
      var selectionStart = buffer.a89_1;
      buffer.i89(buffer.a89_1, buffer.b89_1, this.h89());
      // Inline function 'kotlin.text.isNotEmpty' call
      var this_1 = this.h89();
      if (charSequenceLength(this_1) > 0) {
        buffer.v89(selectionStart, selectionStart + this.h89().length | 0);
      }
    }
    var newCursor = buffer.k89();
    var tmp;
    if (this.u89_1 > 0) {
      tmp = (newCursor + this.u89_1 | 0) - 1 | 0;
    } else {
      tmp = (newCursor + this.u89_1 | 0) - this.h89().length | 0;
    }
    var newCursorInBuffer = tmp;
    buffer.m89(coerceIn(newCursorInBuffer, 0, buffer.l89()));
  };
  protoOf(SetComposingTextCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetComposingTextCommand))
      return false;
    if (!(this.h89() === other.h89()))
      return false;
    if (!(this.u89_1 === other.u89_1))
      return false;
    return true;
  };
  protoOf(SetComposingTextCommand).hashCode = function () {
    var result = getStringHashCode(this.h89());
    result = imul(31, result) + this.u89_1 | 0;
    return result;
  };
  protoOf(SetComposingTextCommand).toString = function () {
    return "SetComposingTextCommand(text='" + this.h89() + "', newCursorPosition=" + this.u89_1 + ')';
  };
  function SetComposingRegionCommand() {
  }
  protoOf(SetComposingRegionCommand).toString = function () {
    return 'SetComposingRegionCommand(start=' + this.w89_1 + ', end=' + this.x89_1 + ')';
  };
  function DeleteSurroundingTextInCodePointsCommand() {
  }
  protoOf(DeleteSurroundingTextInCodePointsCommand).toString = function () {
    return 'DeleteSurroundingTextInCodePointsCommand(lengthBeforeCursor=' + this.y89_1 + ', ' + ('lengthAfterCursor=' + this.z89_1 + ')');
  };
  function BackspaceCommand() {
  }
  protoOf(BackspaceCommand).y88 = function (buffer) {
    if (buffer.j89()) {
      buffer.p89(buffer.c89_1, buffer.d89_1);
      return Unit_instance;
    }
    if (buffer.k89() === -1) {
      var delStart = buffer.a89_1;
      var delEnd = buffer.b89_1;
      buffer.m89(buffer.a89_1);
      buffer.p89(delStart, delEnd);
      return Unit_instance;
    }
    if (buffer.k89() === 0) {
      return Unit_instance;
    }
    var prevCursorPos = findPrecedingBreak(buffer.toString(), buffer.k89());
    buffer.p89(prevCursorPos, buffer.k89());
  };
  protoOf(BackspaceCommand).equals = function (other) {
    return other instanceof BackspaceCommand;
  };
  protoOf(BackspaceCommand).hashCode = function () {
    return getKClassFromExpression(this).hashCode();
  };
  protoOf(BackspaceCommand).toString = function () {
    return 'BackspaceCommand()';
  };
  function MoveCursorCommand() {
  }
  protoOf(MoveCursorCommand).toString = function () {
    return 'MoveCursorCommand(amount=' + this.a8a_1 + ')';
  };
  var androidx_compose_ui_text_input_EditProcessor$stable;
  function generateBatchErrorMessage($this, editCommands, failedCommand) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_0();
    var tmp = 'length=' + $this.c8a_1.l89() + ', ';
    var tmp_0 = $this.c8a_1.d8a();
    // Inline function 'kotlin.text.appendLine' call
    var value = 'Error while applying EditCommand batch to buffer (' + tmp + ('composition=' + toString(tmp_0 == null ? null : new TextRange(tmp_0)) + ', ') + ('selection=' + TextRange__toString_impl_pqvlzl($this.c8a_1.e8a()) + '):');
    // Inline function 'kotlin.text.appendLine' call
    this_0.q(value).s(_Char___init__impl__6a9atx(10));
    joinTo(editCommands, this_0, '\n', VOID, VOID, VOID, VOID, EditProcessor$generateBatchErrorMessage$lambda(failedCommand, $this));
    return this_0.toString();
  }
  function toStringForLog($this, $receiver) {
    var tmp;
    if ($receiver instanceof CommitTextCommand) {
      tmp = 'CommitTextCommand(text.length=' + $receiver.h89().length + ', newCursorPosition=' + $receiver.g89_1 + ')';
    } else {
      if ($receiver instanceof SetComposingTextCommand) {
        tmp = 'SetComposingTextCommand(text.length=' + $receiver.h89().length + ', ' + ('newCursorPosition=' + $receiver.u89_1 + ')');
      } else {
        if ($receiver instanceof SetComposingRegionCommand) {
          tmp = $receiver.toString();
        } else {
          if ($receiver instanceof DeleteSurroundingTextCommand) {
            tmp = $receiver.toString();
          } else {
            if ($receiver instanceof DeleteSurroundingTextInCodePointsCommand) {
              tmp = $receiver.toString();
            } else {
              if ($receiver instanceof SetSelectionCommand) {
                tmp = $receiver.toString();
              } else {
                if ($receiver instanceof FinishComposingTextCommand) {
                  tmp = $receiver.toString();
                } else {
                  if ($receiver instanceof BackspaceCommand) {
                    tmp = $receiver.toString();
                  } else {
                    if ($receiver instanceof MoveCursorCommand) {
                      tmp = $receiver.toString();
                    } else {
                      if ($receiver instanceof DeleteAllCommand) {
                        tmp = $receiver.toString();
                      } else {
                        var tmp1_elvis_lhs = getKClassFromExpression($receiver).o();
                        tmp = 'Unknown EditCommand: ' + (tmp1_elvis_lhs == null ? '{anonymous EditCommand}' : tmp1_elvis_lhs);
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  function EditProcessor$generateBatchErrorMessage$lambda($failedCommand, this$0) {
    return function (it) {
      var prefix = $failedCommand === it ? ' > ' : '   ';
      return prefix + toStringForLog(this$0, it);
    };
  }
  function EditProcessor() {
    this.b8a_1 = new TextFieldValue(emptyAnnotatedString(), Companion_getInstance_18().n7u_1, null);
    this.c8a_1 = new EditingBuffer(this.b8a_1.f8a_1, this.b8a_1.g8a_1);
  }
  protoOf(EditProcessor).i8a = function (value, textInputSession) {
    var textChanged = false;
    var selectionChanged = false;
    var tmp = value.h8a_1;
    var tmp_0 = tmp == null ? null : new TextRange(tmp);
    var tmp_1 = this.c8a_1.d8a();
    var compositionChanged = !equals(tmp_0, tmp_1 == null ? null : new TextRange(tmp_1));
    if (!(this.b8a_1.f8a_1.h7q_1 === value.f8a_1.h7q_1)) {
      this.c8a_1 = new EditingBuffer(value.f8a_1, value.g8a_1);
      textChanged = true;
    } else if (!equals(this.b8a_1.g8a_1, value.g8a_1)) {
      this.c8a_1.s89(_TextRange___get_min__impl__uu95c4(value.g8a_1), _TextRange___get_max__impl__owm8m(value.g8a_1));
      selectionChanged = true;
    }
    var tmp_2 = value.h8a_1;
    if ((tmp_2 == null ? null : new TextRange(tmp_2)) == null) {
      this.c8a_1.e89();
    } else {
      if (!_TextRange___get_collapsed__impl__cilesp(value.h8a_1)) {
        this.c8a_1.v89(_TextRange___get_min__impl__uu95c4(value.h8a_1), _TextRange___get_max__impl__owm8m(value.h8a_1));
      }
    }
    var tmp_3;
    if (textChanged || (!selectionChanged && compositionChanged)) {
      this.c8a_1.e89();
      tmp_3 = value.j8a(VOID, VOID, null);
    } else {
      tmp_3 = value;
    }
    var newValue = tmp_3;
    var oldValue = this.b8a_1;
    this.b8a_1 = newValue;
    if (textInputSession == null)
      null;
    else
      textInputSession.m8a(oldValue, newValue);
  };
  protoOf(EditProcessor).n8a = function (editCommands) {
    var lastCommand = null;
    try {
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = editCommands.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = editCommands.l1(index);
          lastCommand = item;
          item.y88(this.c8a_1);
        }
         while (inductionVariable <= last);
    } catch ($p) {
      if ($p instanceof Exception) {
        var e = $p;
        throw RuntimeException_init_$Create$(generateBatchErrorMessage(this, editCommands, lastCommand), e);
      } else {
        throw $p;
      }
    }
    var tmp = this.c8a_1.o8a();
    // Inline function 'kotlin.run' call
    var $this$run = this.c8a_1.e8a();
    // Inline function 'kotlin.takeUnless' call
    var this_0 = new TextRange($this$run);
    var tmp_0;
    this_0.b7u_1;
    if (!_TextRange___get_reversed__impl__emhnbm(this.b8a_1.g8a_1)) {
      tmp_0 = this_0;
    } else {
      tmp_0 = null;
    }
    var tmp_1 = tmp_0;
    var tmp0_elvis_lhs = tmp_1 == null ? null : tmp_1.b7u_1;
    var tmp_2;
    var tmp_3 = tmp0_elvis_lhs;
    if ((tmp_3 == null ? null : new TextRange(tmp_3)) == null) {
      tmp_2 = TextRange_1(_TextRange___get_max__impl__owm8m($this$run), _TextRange___get_min__impl__uu95c4($this$run));
    } else {
      tmp_2 = tmp0_elvis_lhs;
    }
    var tmp$ret$2 = tmp_2;
    var newState = new TextFieldValue(tmp, tmp$ret$2, this.c8a_1.d8a());
    this.b8a_1 = newState;
    return newState;
  };
  protoOf(EditProcessor).p8a = function () {
    return this.b8a_1;
  };
  var androidx_compose_ui_text_input_EditingBuffer$stable;
  function Companion_12() {
    this.q8a_1 = -1;
  }
  var Companion_instance_14;
  function Companion_getInstance_27() {
    return Companion_instance_14;
  }
  function _set_selectionStart__65lsx($this, value) {
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!(value >= 0)) {
      var tmp$ret$1 = 'Cannot set selectionStart to a negative value: ' + value;
      throwIllegalArgumentException(tmp$ret$1);
    }
    $this.a89_1 = value;
  }
  function _set_selectionEnd__2o1cag($this, value) {
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!(value >= 0)) {
      var tmp$ret$1 = 'Cannot set selectionEnd to a negative value: ' + value;
      throwIllegalArgumentException(tmp$ret$1);
    }
    $this.b89_1 = value;
  }
  function EditingBuffer(text, selection) {
    this.z88_1 = new PartialGapBuffer(text.h7q_1);
    this.a89_1 = _TextRange___get_min__impl__uu95c4(selection);
    this.b89_1 = _TextRange___get_max__impl__owm8m(selection);
    this.c89_1 = -1;
    this.d89_1 = -1;
    var start = _TextRange___get_min__impl__uu95c4(selection);
    var end = _TextRange___get_max__impl__owm8m(selection);
    if (start < 0 || start > text.a()) {
      throw IndexOutOfBoundsException_init_$Create$('start (' + start + ') offset is outside of text region ' + text.a());
    }
    if (end < 0 || end > text.a()) {
      throw IndexOutOfBoundsException_init_$Create$('end (' + end + ') offset is outside of text region ' + text.a());
    }
    if (start > end) {
      throw IllegalArgumentException_init_$Create$_0('Do not set reversed range: ' + start + ' > ' + end);
    }
  }
  protoOf(EditingBuffer).j89 = function () {
    return !(this.c89_1 === -1);
  };
  protoOf(EditingBuffer).d8a = function () {
    var tmp;
    if (this.j89()) {
      tmp = TextRange_1(this.c89_1, this.d89_1);
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(EditingBuffer).e8a = function () {
    return TextRange_1(this.a89_1, this.b89_1);
  };
  protoOf(EditingBuffer).m89 = function (cursor) {
    return this.s89(cursor, cursor);
  };
  protoOf(EditingBuffer).k89 = function () {
    return this.a89_1 === this.b89_1 ? this.b89_1 : -1;
  };
  protoOf(EditingBuffer).l89 = function () {
    return this.z88_1.a();
  };
  protoOf(EditingBuffer).i89 = function (start, end, text) {
    if (start < 0 || start > this.z88_1.a()) {
      throw IndexOutOfBoundsException_init_$Create$('start (' + start + ') offset is outside of text region ' + this.z88_1.a());
    }
    if (end < 0 || end > this.z88_1.a()) {
      throw IndexOutOfBoundsException_init_$Create$('end (' + end + ') offset is outside of text region ' + this.z88_1.a());
    }
    if (start > end) {
      throw IllegalArgumentException_init_$Create$_0('Do not set reversed range: ' + start + ' > ' + end);
    }
    this.z88_1.v8a(start, end, text);
    _set_selectionStart__65lsx(this, start + text.length | 0);
    _set_selectionEnd__2o1cag(this, start + text.length | 0);
    this.c89_1 = -1;
    this.d89_1 = -1;
  };
  protoOf(EditingBuffer).p89 = function (start, end) {
    var deleteRange = TextRange_1(start, end);
    this.z88_1.v8a(start, end, '');
    var newSelection = updateRangeAfterDelete(TextRange_1(this.a89_1, this.b89_1), deleteRange);
    _set_selectionStart__65lsx(this, _TextRange___get_min__impl__uu95c4(newSelection));
    _set_selectionEnd__2o1cag(this, _TextRange___get_max__impl__owm8m(newSelection));
    if (this.j89()) {
      var compositionRange = TextRange_1(this.c89_1, this.d89_1);
      var newComposition = updateRangeAfterDelete(compositionRange, deleteRange);
      if (_TextRange___get_collapsed__impl__cilesp(newComposition)) {
        this.e89();
      } else {
        this.c89_1 = _TextRange___get_min__impl__uu95c4(newComposition);
        this.d89_1 = _TextRange___get_max__impl__owm8m(newComposition);
      }
    }
  };
  protoOf(EditingBuffer).s89 = function (start, end) {
    if (start < 0 || start > this.z88_1.a()) {
      throw IndexOutOfBoundsException_init_$Create$('start (' + start + ') offset is outside of text region ' + this.z88_1.a());
    }
    if (end < 0 || end > this.z88_1.a()) {
      throw IndexOutOfBoundsException_init_$Create$('end (' + end + ') offset is outside of text region ' + this.z88_1.a());
    }
    if (start > end) {
      throw IllegalArgumentException_init_$Create$_0('Do not set reversed range: ' + start + ' > ' + end);
    }
    _set_selectionStart__65lsx(this, start);
    _set_selectionEnd__2o1cag(this, end);
  };
  protoOf(EditingBuffer).v89 = function (start, end) {
    if (start < 0 || start > this.z88_1.a()) {
      throw IndexOutOfBoundsException_init_$Create$('start (' + start + ') offset is outside of text region ' + this.z88_1.a());
    }
    if (end < 0 || end > this.z88_1.a()) {
      throw IndexOutOfBoundsException_init_$Create$('end (' + end + ') offset is outside of text region ' + this.z88_1.a());
    }
    if (start >= end) {
      throw IllegalArgumentException_init_$Create$_0('Do not set reversed or empty range: ' + start + ' > ' + end);
    }
    this.c89_1 = start;
    this.d89_1 = end;
  };
  protoOf(EditingBuffer).e89 = function () {
    this.c89_1 = -1;
    this.d89_1 = -1;
  };
  protoOf(EditingBuffer).toString = function () {
    return this.z88_1.toString();
  };
  protoOf(EditingBuffer).o8a = function () {
    return AnnotatedString_init_$Create$(this.toString());
  };
  function updateRangeAfterDelete(target, deleted) {
    var targetMin = _TextRange___get_min__impl__uu95c4(target);
    var targetMax = _TextRange___get_max__impl__owm8m(target);
    if (TextRange__intersects_impl_mhtn49(deleted, target)) {
      if (TextRange__contains_impl_ws45z2(deleted, target)) {
        targetMin = _TextRange___get_min__impl__uu95c4(deleted);
        targetMax = targetMin;
      } else if (TextRange__contains_impl_ws45z2(target, deleted)) {
        targetMax = targetMax - _TextRange___get_length__impl__7qes3a(deleted) | 0;
      } else if (TextRange__contains_impl_ws45z2_0(deleted, targetMin)) {
        targetMin = _TextRange___get_min__impl__uu95c4(deleted);
        targetMax = targetMax - _TextRange___get_length__impl__7qes3a(deleted) | 0;
      } else {
        targetMax = _TextRange___get_min__impl__uu95c4(deleted);
      }
    } else {
      if (targetMax > _TextRange___get_min__impl__uu95c4(deleted)) {
        targetMin = targetMin - _TextRange___get_length__impl__7qes3a(deleted) | 0;
        targetMax = targetMax - _TextRange___get_length__impl__7qes3a(deleted) | 0;
      }
    }
    return TextRange_1(targetMin, targetMax);
  }
  var androidx_compose_ui_text_input_PartialGapBuffer$stable;
  function Companion_13() {
    this.w8a_1 = 255;
    this.x8a_1 = 64;
    this.y8a_1 = -1;
  }
  var Companion_instance_15;
  function Companion_getInstance_28() {
    return Companion_instance_15;
  }
  function PartialGapBuffer(text) {
    this.r8a_1 = text;
    this.s8a_1 = null;
    this.t8a_1 = -1;
    this.u8a_1 = -1;
  }
  protoOf(PartialGapBuffer).a = function () {
    var tmp0_elvis_lhs = this.s8a_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return this.r8a_1.length;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var buffer = tmp;
    return (this.r8a_1.length - (this.u8a_1 - this.t8a_1 | 0) | 0) + buffer.d8b() | 0;
  };
  protoOf(PartialGapBuffer).v8a = function (start, end, text) {
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!(start <= end)) {
      var tmp$ret$1 = 'start index must be less than or equal to end index: ' + start + ' > ' + end;
      throwIllegalArgumentException(tmp$ret$1);
    }
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!(start >= 0)) {
      var tmp$ret$3 = 'start must be non-negative, but was ' + start;
      throwIllegalArgumentException(tmp$ret$3);
    }
    var buffer = this.s8a_1;
    if (buffer == null) {
      // Inline function 'kotlin.comparisons.maxOf' call
      var b = text.length + 128 | 0;
      var tmp$ret$4 = Math.max(255, b);
      var charArray_0 = charArray(tmp$ret$4);
      // Inline function 'kotlin.comparisons.minOf' call
      var leftCopyCount = Math.min(start, 64);
      // Inline function 'kotlin.comparisons.minOf' call
      var a = this.r8a_1.length - end | 0;
      var rightCopyCount = Math.min(a, 64);
      toCharArray_0(this.r8a_1, charArray_0, 0, start - leftCopyCount | 0, start);
      toCharArray_0(this.r8a_1, charArray_0, charArray_0.length - rightCopyCount | 0, end, end + rightCopyCount | 0);
      toCharArray(text, charArray_0, leftCopyCount);
      this.s8a_1 = new GapBuffer(charArray_0, leftCopyCount + text.length | 0, charArray_0.length - rightCopyCount | 0);
      this.t8a_1 = start - leftCopyCount | 0;
      this.u8a_1 = end + rightCopyCount | 0;
      return Unit_instance;
    }
    var bufferStart = start - this.t8a_1 | 0;
    var bufferEnd = end - this.t8a_1 | 0;
    if (bufferStart < 0 || bufferEnd > buffer.d8b()) {
      this.r8a_1 = this.toString();
      this.s8a_1 = null;
      this.t8a_1 = -1;
      this.u8a_1 = -1;
      return this.v8a(start, end, text);
    }
    buffer.v8a(bufferStart, bufferEnd, text);
  };
  protoOf(PartialGapBuffer).toString = function () {
    var tmp0_elvis_lhs = this.s8a_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return this.r8a_1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var b = tmp;
    var sb = StringBuilder_init_$Create$_0();
    sb.bd(this.r8a_1, 0, this.t8a_1);
    b.e8b(sb);
    sb.bd(this.r8a_1, this.u8a_1, this.r8a_1.length);
    return sb.toString();
  };
  function gapLength($this) {
    return $this.c8b_1 - $this.b8b_1 | 0;
  }
  function makeSureAvailableSpace($this, requestSize) {
    if (requestSize <= gapLength($this)) {
      return Unit_instance;
    }
    var necessarySpace = requestSize - gapLength($this) | 0;
    var newCapacity = imul($this.z8a_1, 2);
    while ((newCapacity - $this.z8a_1 | 0) < necessarySpace) {
      newCapacity = imul(newCapacity, 2);
    }
    var newBuffer = charArray(newCapacity);
    var tmp0 = $this.a8b_1;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = $this.b8b_1;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = tmp0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, newBuffer, 0, 0, endIndex);
    var tailLength = $this.z8a_1 - $this.c8b_1 | 0;
    var newEnd = newCapacity - tailLength | 0;
    var tmp0_0 = $this.a8b_1;
    var tmp6 = $this.c8b_1;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex_0 = $this.c8b_1 + tailLength | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = tmp0_0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp_0, newBuffer, newEnd, tmp6, endIndex_0);
    $this.a8b_1 = newBuffer;
    $this.z8a_1 = newCapacity;
    $this.c8b_1 = newEnd;
  }
  function delete_0($this, start, end) {
    if (start < $this.b8b_1 && end <= $this.b8b_1) {
      var copyLen = $this.b8b_1 - end | 0;
      var tmp0 = $this.a8b_1;
      var tmp2 = $this.a8b_1;
      var tmp4 = $this.c8b_1 - copyLen | 0;
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex = $this.b8b_1;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = tmp0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      arrayCopy(tmp, tmp2, tmp4, end, endIndex);
      $this.b8b_1 = start;
      $this.c8b_1 = $this.c8b_1 - copyLen | 0;
    } else if (start < $this.b8b_1 && end >= $this.b8b_1) {
      $this.c8b_1 = end + gapLength($this) | 0;
      $this.b8b_1 = start;
    } else {
      var startInBuffer = start + gapLength($this) | 0;
      var endInBuffer = end + gapLength($this) | 0;
      var copyLen_0 = startInBuffer - $this.c8b_1 | 0;
      var tmp0_0 = $this.a8b_1;
      var tmp2_0 = $this.a8b_1;
      var tmp4_0 = $this.b8b_1;
      // Inline function 'kotlin.collections.copyInto' call
      var startIndex = $this.c8b_1;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp_0 = tmp0_0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      arrayCopy(tmp_0, tmp2_0, tmp4_0, startIndex, startInBuffer);
      $this.b8b_1 = $this.b8b_1 + copyLen_0 | 0;
      $this.c8b_1 = endInBuffer;
    }
  }
  function GapBuffer(initBuffer, initGapStart, initGapEnd) {
    this.z8a_1 = initBuffer.length;
    this.a8b_1 = initBuffer;
    this.b8b_1 = initGapStart;
    this.c8b_1 = initGapEnd;
  }
  protoOf(GapBuffer).v8a = function (start, end, text) {
    makeSureAvailableSpace(this, text.length - (end - start | 0) | 0);
    delete_0(this, start, end);
    toCharArray(text, this.a8b_1, this.b8b_1);
    this.b8b_1 = this.b8b_1 + text.length | 0;
  };
  protoOf(GapBuffer).e8b = function (builder) {
    builder.md(this.a8b_1, 0, this.b8b_1);
    builder.md(this.a8b_1, this.c8b_1, this.z8a_1);
  };
  protoOf(GapBuffer).d8b = function () {
    return this.z8a_1 - gapLength(this) | 0;
  };
  protoOf(GapBuffer).toString = function () {
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_0();
    this_0.k1(this_0);
    return this_0.toString();
  };
  function toCharArray(_this__u8e3s4, destination, destinationOffset) {
    return toCharArray_0(_this__u8e3s4, destination, destinationOffset, 0, _this__u8e3s4.length);
  }
  function _ImeAction___init__impl__ucgwde(value) {
    return value;
  }
  function ImeAction__toString_impl_r8bdhy($this) {
    return $this === Companion_getInstance_29().f8b_1 ? 'Unspecified' : $this === Companion_getInstance_29().h8b_1 ? 'None' : $this === Companion_getInstance_29().g8b_1 ? 'Default' : $this === Companion_getInstance_29().i8b_1 ? 'Go' : $this === Companion_getInstance_29().j8b_1 ? 'Search' : $this === Companion_getInstance_29().k8b_1 ? 'Send' : $this === Companion_getInstance_29().l8b_1 ? 'Previous' : $this === Companion_getInstance_29().m8b_1 ? 'Next' : $this === Companion_getInstance_29().n8b_1 ? 'Done' : 'Invalid';
  }
  function Companion_14() {
    Companion_instance_16 = this;
    this.f8b_1 = _ImeAction___init__impl__ucgwde(-1);
    this.g8b_1 = _ImeAction___init__impl__ucgwde(1);
    this.h8b_1 = _ImeAction___init__impl__ucgwde(0);
    this.i8b_1 = _ImeAction___init__impl__ucgwde(2);
    this.j8b_1 = _ImeAction___init__impl__ucgwde(3);
    this.k8b_1 = _ImeAction___init__impl__ucgwde(4);
    this.l8b_1 = _ImeAction___init__impl__ucgwde(5);
    this.m8b_1 = _ImeAction___init__impl__ucgwde(6);
    this.n8b_1 = _ImeAction___init__impl__ucgwde(7);
  }
  var Companion_instance_16;
  function Companion_getInstance_29() {
    if (Companion_instance_16 == null)
      new Companion_14();
    return Companion_instance_16;
  }
  function ImeAction__hashCode_impl_m1mrob($this) {
    return $this;
  }
  function ImeAction__equals_impl_tgas09($this, other) {
    if (!(other instanceof ImeAction))
      return false;
    if (!($this === other.o8b_1))
      return false;
    return true;
  }
  function ImeAction(value) {
    Companion_getInstance_29();
    this.o8b_1 = value;
  }
  protoOf(ImeAction).toString = function () {
    return ImeAction__toString_impl_r8bdhy(this.o8b_1);
  };
  protoOf(ImeAction).hashCode = function () {
    return ImeAction__hashCode_impl_m1mrob(this.o8b_1);
  };
  protoOf(ImeAction).equals = function (other) {
    return ImeAction__equals_impl_tgas09(this.o8b_1, other);
  };
  var androidx_compose_ui_text_input_ImeOptions$stable;
  function Companion_15() {
    Companion_instance_17 = this;
    this.p8b_1 = new ImeOptions();
  }
  var Companion_instance_17;
  function Companion_getInstance_30() {
    if (Companion_instance_17 == null)
      new Companion_15();
    return Companion_instance_17;
  }
  function ImeOptions(singleLine, capitalization, autoCorrect, keyboardType, imeAction, platformImeOptions, hintLocales) {
    Companion_getInstance_30();
    singleLine = singleLine === VOID ? false : singleLine;
    capitalization = capitalization === VOID ? Companion_getInstance_31().r8b_1 : capitalization;
    autoCorrect = autoCorrect === VOID ? true : autoCorrect;
    keyboardType = keyboardType === VOID ? Companion_getInstance_32().w8b_1 : keyboardType;
    imeAction = imeAction === VOID ? Companion_getInstance_29().g8b_1 : imeAction;
    platformImeOptions = platformImeOptions === VOID ? null : platformImeOptions;
    hintLocales = hintLocales === VOID ? Companion_getInstance_36().z7z_1 : hintLocales;
    this.f8c_1 = singleLine;
    this.g8c_1 = capitalization;
    this.h8c_1 = autoCorrect;
    this.i8c_1 = keyboardType;
    this.j8c_1 = imeAction;
    this.k8c_1 = platformImeOptions;
    this.l8c_1 = hintLocales;
  }
  protoOf(ImeOptions).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ImeOptions))
      return false;
    if (!(this.f8c_1 === other.f8c_1))
      return false;
    if (!(this.g8c_1 === other.g8c_1))
      return false;
    if (!(this.h8c_1 === other.h8c_1))
      return false;
    if (!(this.i8c_1 === other.i8c_1))
      return false;
    if (!(this.j8c_1 === other.j8c_1))
      return false;
    if (!equals(this.k8c_1, other.k8c_1))
      return false;
    if (!this.l8c_1.equals(other.l8c_1))
      return false;
    return true;
  };
  protoOf(ImeOptions).hashCode = function () {
    var result = getBooleanHashCode(this.f8c_1);
    result = imul(31, result) + KeyboardCapitalization__hashCode_impl_6ibuz5(this.g8c_1) | 0;
    result = imul(31, result) + getBooleanHashCode(this.h8c_1) | 0;
    result = imul(31, result) + KeyboardType__hashCode_impl_mw6m33(this.i8c_1) | 0;
    result = imul(31, result) + ImeAction__hashCode_impl_m1mrob(this.j8c_1) | 0;
    var tmp = imul(31, result);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.k8c_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    result = imul(31, result) + this.l8c_1.hashCode() | 0;
    return result;
  };
  protoOf(ImeOptions).toString = function () {
    return 'ImeOptions(singleLine=' + this.f8c_1 + ', capitalization=' + KeyboardCapitalization__toString_impl_f8u1tq(this.g8c_1) + ', ' + ('autoCorrect=' + this.h8c_1 + ', keyboardType=' + KeyboardType__toString_impl_150pa8(this.i8c_1) + ', imeAction=' + ImeAction__toString_impl_r8bdhy(this.j8c_1) + ', ') + ('platformImeOptions=' + toString(this.k8c_1) + ', hintLocales=' + this.l8c_1.toString() + ')');
  };
  function _KeyboardCapitalization___init__impl__fmdpvi(value) {
    return value;
  }
  function KeyboardCapitalization__toString_impl_f8u1tq($this) {
    return $this === Companion_getInstance_31().q8b_1 ? 'Unspecified' : $this === Companion_getInstance_31().r8b_1 ? 'None' : $this === Companion_getInstance_31().s8b_1 ? 'Characters' : $this === Companion_getInstance_31().t8b_1 ? 'Words' : $this === Companion_getInstance_31().u8b_1 ? 'Sentences' : 'Invalid';
  }
  function Companion_16() {
    Companion_instance_18 = this;
    this.q8b_1 = _KeyboardCapitalization___init__impl__fmdpvi(-1);
    this.r8b_1 = _KeyboardCapitalization___init__impl__fmdpvi(0);
    this.s8b_1 = _KeyboardCapitalization___init__impl__fmdpvi(1);
    this.t8b_1 = _KeyboardCapitalization___init__impl__fmdpvi(2);
    this.u8b_1 = _KeyboardCapitalization___init__impl__fmdpvi(3);
  }
  var Companion_instance_18;
  function Companion_getInstance_31() {
    if (Companion_instance_18 == null)
      new Companion_16();
    return Companion_instance_18;
  }
  function KeyboardCapitalization__hashCode_impl_6ibuz5($this) {
    return $this;
  }
  function KeyboardCapitalization__equals_impl_dba8wb($this, other) {
    if (!(other instanceof KeyboardCapitalization))
      return false;
    if (!($this === other.m8c_1))
      return false;
    return true;
  }
  function KeyboardCapitalization(value) {
    Companion_getInstance_31();
    this.m8c_1 = value;
  }
  protoOf(KeyboardCapitalization).toString = function () {
    return KeyboardCapitalization__toString_impl_f8u1tq(this.m8c_1);
  };
  protoOf(KeyboardCapitalization).hashCode = function () {
    return KeyboardCapitalization__hashCode_impl_6ibuz5(this.m8c_1);
  };
  protoOf(KeyboardCapitalization).equals = function (other) {
    return KeyboardCapitalization__equals_impl_dba8wb(this.m8c_1, other);
  };
  function _KeyboardType___init__impl__csir7k(value) {
    return value;
  }
  function KeyboardType__toString_impl_150pa8($this) {
    return $this === Companion_getInstance_32().v8b_1 ? 'Unspecified' : $this === Companion_getInstance_32().w8b_1 ? 'Text' : $this === Companion_getInstance_32().x8b_1 ? 'Ascii' : $this === Companion_getInstance_32().y8b_1 ? 'Number' : $this === Companion_getInstance_32().z8b_1 ? 'Phone' : $this === Companion_getInstance_32().a8c_1 ? 'Uri' : $this === Companion_getInstance_32().b8c_1 ? 'Email' : $this === Companion_getInstance_32().c8c_1 ? 'Password' : $this === Companion_getInstance_32().d8c_1 ? 'NumberPassword' : $this === Companion_getInstance_32().e8c_1 ? 'Decimal' : 'Invalid';
  }
  function Companion_17() {
    Companion_instance_19 = this;
    this.v8b_1 = _KeyboardType___init__impl__csir7k(0);
    this.w8b_1 = _KeyboardType___init__impl__csir7k(1);
    this.x8b_1 = _KeyboardType___init__impl__csir7k(2);
    this.y8b_1 = _KeyboardType___init__impl__csir7k(3);
    this.z8b_1 = _KeyboardType___init__impl__csir7k(4);
    this.a8c_1 = _KeyboardType___init__impl__csir7k(5);
    this.b8c_1 = _KeyboardType___init__impl__csir7k(6);
    this.c8c_1 = _KeyboardType___init__impl__csir7k(7);
    this.d8c_1 = _KeyboardType___init__impl__csir7k(8);
    this.e8c_1 = _KeyboardType___init__impl__csir7k(9);
  }
  var Companion_instance_19;
  function Companion_getInstance_32() {
    if (Companion_instance_19 == null)
      new Companion_17();
    return Companion_instance_19;
  }
  function KeyboardType__hashCode_impl_mw6m33($this) {
    return $this;
  }
  function KeyboardType__equals_impl_1eug1f($this, other) {
    if (!(other instanceof KeyboardType))
      return false;
    if (!($this === other.n8c_1))
      return false;
    return true;
  }
  function KeyboardType(value) {
    Companion_getInstance_32();
    this.n8c_1 = value;
  }
  protoOf(KeyboardType).toString = function () {
    return KeyboardType__toString_impl_150pa8(this.n8c_1);
  };
  protoOf(KeyboardType).hashCode = function () {
    return KeyboardType__hashCode_impl_mw6m33(this.n8c_1);
  };
  protoOf(KeyboardType).equals = function (other) {
    return KeyboardType__equals_impl_1eug1f(this.n8c_1, other);
  };
  function OffsetMapping$Companion$Identity$1() {
  }
  protoOf(OffsetMapping$Companion$Identity$1).o8c = function (offset) {
    return offset;
  };
  protoOf(OffsetMapping$Companion$Identity$1).p8c = function (offset) {
    return offset;
  };
  function Companion_18() {
    Companion_instance_20 = this;
    var tmp = this;
    tmp.q8c_1 = new OffsetMapping$Companion$Identity$1();
  }
  var Companion_instance_20;
  function Companion_getInstance_33() {
    if (Companion_instance_20 == null)
      new Companion_18();
    return Companion_instance_20;
  }
  var androidx_compose_ui_text_input_TextFieldValue$stable;
  function TextFieldValue$Companion$Saver$lambda($this$Saver, it) {
    return arrayListOf([save_0(it.f8a_1, get_AnnotatedStringSaver(), $this$Saver), save_0(new TextRange(it.g8a_1), get_Saver_20(Companion_getInstance_18()), $this$Saver)]);
  }
  function TextFieldValue$Companion$Saver$lambda_0(it) {
    var list = isInterface(it, KtList) ? it : THROW_CCE();
    var tmp0 = list.l1(0);
    var tmp2 = get_AnnotatedStringSaver();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp;
      if (equals(tmp0, false)) {
        tmp = !isInterface(tmp2, NonNullValueClassSaver);
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = null;
        break $l$block;
      }
      var tmp_0;
      if (tmp0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_1 = tmp2.b7o(tmp0);
        tmp_0 = (tmp_1 == null ? true : tmp_1 instanceof AnnotatedString) ? tmp_1 : THROW_CCE();
      }
      tmp$ret$0 = tmp_0;
    }
    var tmp_2 = ensureNotNull(tmp$ret$0);
    var tmp0_0 = list.l1(1);
    var tmp2_0 = get_Saver_20(Companion_getInstance_18());
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'androidx.compose.ui.text.restore' call
      var tmp_3;
      if (equals(tmp0_0, false)) {
        tmp_3 = !isInterface(tmp2_0, NonNullValueClassSaver);
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp$ret$5 = null;
        break $l$block_0;
      }
      var tmp_4;
      if (tmp0_0 == null) {
        tmp_4 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.with' call
        var tmp_5 = tmp2_0.b7o(tmp0_0);
        var tmp_6;
        if (tmp_5 == null ? true : tmp_5 instanceof TextRange) {
          var tmp_7 = tmp_5;
          tmp_6 = tmp_7 == null ? null : tmp_7.b7u_1;
        } else {
          tmp_6 = THROW_CCE();
        }
        var tmp_8 = tmp_6;
        var tmp_9 = tmp_8 == null ? null : new TextRange(tmp_8);
        tmp_4 = tmp_9 == null ? null : tmp_9.b7u_1;
      }
      tmp$ret$5 = tmp_4;
    }
    var tmp_10 = tmp$ret$5;
    return new TextFieldValue(tmp_2, ensureNotNull(tmp_10 == null ? null : new TextRange(tmp_10)).b7u_1);
  }
  function TextFieldValue_init_$Init$(text, selection, composition, $this) {
    text = text === VOID ? '' : text;
    selection = selection === VOID ? Companion_getInstance_18().n7u_1 : selection;
    composition = composition === VOID ? null : composition;
    TextFieldValue.call($this, AnnotatedString_init_$Create$(text), selection, composition);
    return $this;
  }
  function TextFieldValue_init_$Create$(text, selection, composition) {
    return TextFieldValue_init_$Init$(text, selection, composition, objectCreate(protoOf(TextFieldValue)));
  }
  function Companion_19() {
    Companion_instance_21 = this;
    var tmp = this;
    var tmp_0 = TextFieldValue$Companion$Saver$lambda;
    tmp.r8c_1 = Saver_0(tmp_0, TextFieldValue$Companion$Saver$lambda_0);
  }
  var Companion_instance_21;
  function Companion_getInstance_34() {
    if (Companion_instance_21 == null)
      new Companion_19();
    return Companion_instance_21;
  }
  function TextFieldValue(annotatedString, selection, composition) {
    Companion_getInstance_34();
    selection = selection === VOID ? Companion_getInstance_18().n7u_1 : selection;
    composition = composition === VOID ? null : composition;
    this.f8a_1 = annotatedString;
    this.g8a_1 = coerceIn_1(selection, 0, this.h89().length);
    var tmp = this;
    var tmp_0;
    var tmp_1 = composition;
    if ((tmp_1 == null ? null : new TextRange(tmp_1)) == null) {
      tmp_0 = null;
    } else {
      tmp_0 = coerceIn_1(composition, 0, this.h89().length);
    }
    tmp.h8a_1 = tmp_0;
  }
  protoOf(TextFieldValue).h89 = function () {
    return this.f8a_1.h7q_1;
  };
  protoOf(TextFieldValue).s8c = function (annotatedString, selection, composition) {
    return new TextFieldValue(annotatedString, selection, composition);
  };
  protoOf(TextFieldValue).j8a = function (annotatedString, selection, composition, $super) {
    annotatedString = annotatedString === VOID ? this.f8a_1 : annotatedString;
    selection = selection === VOID ? this.g8a_1 : selection;
    composition = composition === VOID ? this.h8a_1 : composition;
    var tmp;
    if ($super === VOID) {
      tmp = this.s8c(annotatedString, selection, composition);
    } else {
      var tmp_0 = $super.s8c;
      var tmp_1 = composition;
      tmp = tmp_0.call(this, annotatedString, new TextRange(selection), tmp_1 == null ? null : new TextRange(tmp_1));
    }
    return tmp;
  };
  protoOf(TextFieldValue).t8c = function (text, selection, composition) {
    return new TextFieldValue(AnnotatedString_init_$Create$(text), selection, composition);
  };
  protoOf(TextFieldValue).u8c = function (text, selection, composition, $super) {
    selection = selection === VOID ? this.g8a_1 : selection;
    composition = composition === VOID ? this.h8a_1 : composition;
    var tmp;
    if ($super === VOID) {
      tmp = this.t8c(text, selection, composition);
    } else {
      var tmp_0 = $super.t8c;
      var tmp_1 = composition;
      tmp = tmp_0.call(this, text, new TextRange(selection), tmp_1 == null ? null : new TextRange(tmp_1));
    }
    return tmp;
  };
  protoOf(TextFieldValue).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextFieldValue))
      return false;
    var tmp;
    var tmp_0;
    if (equals(this.g8a_1, other.g8a_1)) {
      var tmp_1 = this.h8a_1;
      var tmp_2 = tmp_1 == null ? null : new TextRange(tmp_1);
      var tmp_3 = other.h8a_1;
      tmp_0 = equals(tmp_2, tmp_3 == null ? null : new TextRange(tmp_3));
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.f8a_1.equals(other.f8a_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(TextFieldValue).hashCode = function () {
    var result = this.f8a_1.hashCode();
    result = imul(31, result) + TextRange__hashCode_impl_3zpp6q(this.g8a_1) | 0;
    var tmp = imul(31, result);
    var tmp0_safe_receiver = this.h8a_1;
    var tmp_0;
    var tmp_1 = tmp0_safe_receiver;
    if ((tmp_1 == null ? null : new TextRange(tmp_1)) == null) {
      tmp_0 = null;
    } else {
      tmp_0 = TextRange__hashCode_impl_3zpp6q(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp_0;
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    return result;
  };
  protoOf(TextFieldValue).toString = function () {
    var tmp = "text='" + this.f8a_1.toString() + "', ";
    var tmp_0 = 'selection=' + TextRange__toString_impl_pqvlzl(this.g8a_1) + ', ';
    var tmp_1 = this.h8a_1;
    return 'TextFieldValue(' + tmp + tmp_0 + ('composition=' + toString(tmp_1 == null ? null : new TextRange(tmp_1)) + ')');
  };
  function getSelectedText(_this__u8e3s4) {
    return _this__u8e3s4.f8a_1.u7q(_this__u8e3s4.g8a_1);
  }
  function getTextBeforeSelection(_this__u8e3s4, maxChars) {
    // Inline function 'androidx.compose.ui.text.input.subtractExactOrElse' call
    var this_0 = _TextRange___get_min__impl__uu95c4(_this__u8e3s4.g8a_1);
    var result = this_0 - maxChars | 0;
    var tmp;
    if (((this_0 ^ maxChars) & (this_0 ^ result)) < 0) {
      tmp = 0;
    } else {
      tmp = result;
    }
    // Inline function 'kotlin.math.max' call
    var b = tmp;
    var tmp$ret$2 = Math.max(0, b);
    return _this__u8e3s4.f8a_1.c(tmp$ret$2, _TextRange___get_min__impl__uu95c4(_this__u8e3s4.g8a_1));
  }
  function getTextAfterSelection(_this__u8e3s4, maxChars) {
    var tmp = _TextRange___get_max__impl__owm8m(_this__u8e3s4.g8a_1);
    // Inline function 'androidx.compose.ui.text.input.addExactOrElse' call
    var this_0 = _TextRange___get_max__impl__owm8m(_this__u8e3s4.g8a_1);
    var result = this_0 + maxChars | 0;
    var tmp_0;
    if (((this_0 ^ result) & (maxChars ^ result)) < 0) {
      tmp_0 = _this__u8e3s4.h89().length;
    } else {
      tmp_0 = result;
    }
    var tmp0 = tmp_0;
    // Inline function 'kotlin.math.min' call
    var b = _this__u8e3s4.h89().length;
    var tmp$ret$2 = Math.min(tmp0, b);
    return _this__u8e3s4.f8a_1.c(tmp, tmp$ret$2);
  }
  var androidx_compose_ui_text_input_TextInputService$stable;
  var androidx_compose_ui_text_input_TextInputSession$stable;
  function TextInputService(platformTextInputService) {
    this.v8c_1 = platformTextInputService;
    this.w8c_1 = new AtomicReference(null);
  }
  protoOf(TextInputService).x8c = function () {
    return this.w8c_1.f1i();
  };
  protoOf(TextInputService).z8c = function (value, imeOptions, onEditCommand, onImeActionPerformed) {
    this.v8c_1.a8d(value, imeOptions, onEditCommand, onImeActionPerformed);
    var nextSession = new TextInputSession(this, this.v8c_1);
    this.w8c_1.k2p(nextSession);
    return nextSession;
  };
  protoOf(TextInputService).b8d = function () {
    this.v8c_1.b8d();
    var nextSession = new TextInputSession(this, this.v8c_1);
    this.w8c_1.k2p(nextSession);
  };
  protoOf(TextInputService).c8d = function (session) {
    if (this.w8c_1.w21(session, null)) {
      this.v8c_1.d8d();
    }
  };
  protoOf(TextInputService).d8d = function () {
    this.w8c_1.k2p(null);
    this.v8c_1.d8d();
  };
  protoOf(TextInputService).e8d = function () {
    if (!(this.x8c() == null)) {
      this.v8c_1.e8d();
    }
  };
  protoOf(TextInputService).f8d = function () {
    return this.v8c_1.f8d();
  };
  function TextInputSession(textInputService, platformTextInputService) {
    this.k8a_1 = textInputService;
    this.l8a_1 = platformTextInputService;
  }
  protoOf(TextInputSession).g8d = function () {
    return equals(this.k8a_1.x8c(), this);
  };
  protoOf(TextInputSession).s1d = function () {
    this.k8a_1.c8d(this);
  };
  protoOf(TextInputSession).h8d = function (rect) {
    // Inline function 'androidx.compose.ui.text.input.TextInputSession.ensureOpenSession' call
    // Inline function 'kotlin.also' call
    var this_0 = this.g8d();
    if (this_0) {
      this.l8a_1.i8d(rect);
    }
    return this_0;
  };
  protoOf(TextInputSession).j8d = function (textFieldValue, offsetMapping, textLayoutResult, textFieldToRootTransform, innerTextFieldBounds, decorationBoxBounds) {
    // Inline function 'androidx.compose.ui.text.input.TextInputSession.ensureOpenSession' call
    // Inline function 'kotlin.also' call
    var this_0 = this.g8d();
    if (this_0) {
      this.l8a_1.k8d(textFieldValue, offsetMapping, textLayoutResult, textFieldToRootTransform, innerTextFieldBounds, decorationBoxBounds);
    }
    return this_0;
  };
  protoOf(TextInputSession).m8a = function (oldValue, newValue) {
    // Inline function 'androidx.compose.ui.text.input.TextInputSession.ensureOpenSession' call
    // Inline function 'kotlin.also' call
    var this_0 = this.g8d();
    if (this_0) {
      this.l8a_1.l8d(oldValue, newValue);
    }
    return this_0;
  };
  function PlatformTextInputService() {
  }
  var androidx_compose_ui_text_input_TransformedText$stable;
  var androidx_compose_ui_text_input_PasswordVisualTransformation$stable;
  function sam$androidx_compose_ui_text_input_VisualTransformation$0(function_0) {
    this.m8d_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_text_input_VisualTransformation$0).n8d = function (text) {
    return this.m8d_1(text);
  };
  protoOf(sam$androidx_compose_ui_text_input_VisualTransformation$0).q3 = function () {
    return this.m8d_1;
  };
  protoOf(sam$androidx_compose_ui_text_input_VisualTransformation$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, VisualTransformation) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_text_input_VisualTransformation$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function VisualTransformation$Companion$None$lambda(text) {
    return new TransformedText(text, Companion_getInstance_33().q8c_1);
  }
  function Companion_20() {
    Companion_instance_22 = this;
    var tmp = this;
    var tmp_0 = VisualTransformation$Companion$None$lambda;
    tmp.o8d_1 = new sam$androidx_compose_ui_text_input_VisualTransformation$0(tmp_0);
  }
  var Companion_instance_22;
  function Companion_getInstance_35() {
    if (Companion_instance_22 == null)
      new Companion_20();
    return Companion_instance_22;
  }
  function VisualTransformation() {
  }
  function TransformedText(text, offsetMapping) {
    this.p8d_1 = text;
    this.q8d_1 = offsetMapping;
  }
  protoOf(TransformedText).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TransformedText))
      return false;
    if (!this.p8d_1.equals(other.p8d_1))
      return false;
    if (!equals(this.q8d_1, other.q8d_1))
      return false;
    return true;
  };
  protoOf(TransformedText).hashCode = function () {
    var result = this.p8d_1.hashCode();
    result = imul(31, result) + hashCode(this.q8d_1) | 0;
    return result;
  };
  protoOf(TransformedText).toString = function () {
    return 'TransformedText(text=' + this.p8d_1.toString() + ', offsetMapping=' + toString_0(this.q8d_1) + ')';
  };
  function PasswordVisualTransformation(mask) {
    mask = mask === VOID ? _Char___init__impl__6a9atx(8226) : mask;
    this.r8d_1 = mask;
  }
  protoOf(PasswordVisualTransformation).n8d = function (text) {
    return new TransformedText(AnnotatedString_init_$Create$(repeat(toString_1(this.r8d_1), text.h7q_1.length)), Companion_getInstance_33().q8c_1);
  };
  protoOf(PasswordVisualTransformation).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PasswordVisualTransformation))
      return false;
    if (!(this.r8d_1 === other.r8d_1))
      return false;
    return true;
  };
  protoOf(PasswordVisualTransformation).hashCode = function () {
    return Char__hashCode_impl_otmys(this.r8d_1);
  };
  function throwIllegalArgumentException(message) {
    throw IllegalArgumentException_init_$Create$_0(message);
  }
  function throwIllegalStateException(message) {
    throw IllegalStateException_init_$Create$_0(message);
  }
  var androidx_compose_ui_text_intl_LocaleList$stable;
  function Companion_21() {
    Companion_instance_23 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    tmp.z7z_1 = new LocaleList(tmp$ret$0);
  }
  protoOf(Companion_21).e2y = function () {
    return get_platformLocaleDelegate().e2y();
  };
  var Companion_instance_23;
  function Companion_getInstance_36() {
    if (Companion_instance_23 == null)
      new Companion_21();
    return Companion_instance_23;
  }
  function LocaleList(localeList) {
    Companion_getInstance_36();
    this.q7x_1 = localeList;
    this.r7x_1 = this.q7x_1.n1();
  }
  protoOf(LocaleList).l1 = function (i) {
    return this.q7x_1.l1(i);
  };
  protoOf(LocaleList).n1 = function () {
    return this.r7x_1;
  };
  protoOf(LocaleList).s8d = function (element) {
    return this.q7x_1.m1(element);
  };
  protoOf(LocaleList).m1 = function (element) {
    if (!(element instanceof Locale))
      return false;
    return this.s8d(element instanceof Locale ? element : THROW_CCE());
  };
  protoOf(LocaleList).t8d = function (elements) {
    return this.q7x_1.r2(elements);
  };
  protoOf(LocaleList).r2 = function (elements) {
    return this.t8d(elements);
  };
  protoOf(LocaleList).r = function () {
    return this.q7x_1.r();
  };
  protoOf(LocaleList).t = function () {
    return this.q7x_1.t();
  };
  protoOf(LocaleList).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LocaleList))
      return false;
    if (!equals(this.q7x_1, other.q7x_1))
      return false;
    return true;
  };
  protoOf(LocaleList).hashCode = function () {
    return hashCode(this.q7x_1);
  };
  protoOf(LocaleList).toString = function () {
    return 'LocaleList(localeList=' + toString_0(this.q7x_1) + ')';
  };
  function get_platformLocaleDelegate() {
    _init_properties_PlatformLocale_kt__d5ixzh();
    return platformLocaleDelegate;
  }
  var platformLocaleDelegate;
  var properties_initialized_PlatformLocale_kt_ya8ii9;
  function _init_properties_PlatformLocale_kt__d5ixzh() {
    if (!properties_initialized_PlatformLocale_kt_ya8ii9) {
      properties_initialized_PlatformLocale_kt_ya8ii9 = true;
      platformLocaleDelegate = createPlatformLocaleDelegate();
    }
  }
  function get_FontCacheManagementDispatcher() {
    _init_properties_Dispatcher_kt__c4qz95();
    return FontCacheManagementDispatcher;
  }
  var FontCacheManagementDispatcher;
  var properties_initialized_Dispatcher_kt_c7cauv;
  function _init_properties_Dispatcher_kt__c4qz95() {
    if (!properties_initialized_Dispatcher_kt_c7cauv) {
      properties_initialized_Dispatcher_kt_c7cauv = true;
      FontCacheManagementDispatcher = Dispatchers_getInstance().m1h();
    }
  }
  function _BaselineShift___init__impl__scj05g(multiplier) {
    return multiplier;
  }
  function _BaselineShift___get_multiplier__impl__qhmjek($this) {
    return $this;
  }
  function Companion_22() {
    Companion_instance_24 = this;
    this.v7z_1 = _BaselineShift___init__impl__scj05g(0.5);
    this.w7z_1 = _BaselineShift___init__impl__scj05g(-0.5);
    this.x7z_1 = _BaselineShift___init__impl__scj05g(0.0);
    this.y7z_1 = _BaselineShift___init__impl__scj05g(NaN);
  }
  var Companion_instance_24;
  function Companion_getInstance_37() {
    if (Companion_instance_24 == null)
      new Companion_22();
    return Companion_instance_24;
  }
  function BaselineShift__toString_impl_x98gcc($this) {
    return 'BaselineShift(multiplier=' + $this + ')';
  }
  function BaselineShift__hashCode_impl_g0potx($this) {
    return getNumberHashCode($this);
  }
  function BaselineShift__equals_impl_37wrjj($this, other) {
    if (!(other instanceof BaselineShift))
      return false;
    var tmp0_other_with_cast = other.f7x_1;
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function BaselineShift(multiplier) {
    Companion_getInstance_37();
    this.f7x_1 = multiplier;
  }
  protoOf(BaselineShift).toString = function () {
    return BaselineShift__toString_impl_x98gcc(this.f7x_1);
  };
  protoOf(BaselineShift).hashCode = function () {
    return BaselineShift__hashCode_impl_g0potx(this.f7x_1);
  };
  protoOf(BaselineShift).equals = function (other) {
    return BaselineShift__equals_impl_37wrjj(this.f7x_1, other);
  };
  function lerp_8(start, stop, fraction) {
    return _BaselineShift___init__impl__scj05g(lerp_3(_BaselineShift___get_multiplier__impl__qhmjek(start), _BaselineShift___get_multiplier__impl__qhmjek(stop), fraction));
  }
  function _Hyphens___init__impl__m2cvg8(value) {
    return value;
  }
  function _Hyphens___get_value__impl__5itus4($this) {
    return $this;
  }
  function Companion_23() {
    Companion_instance_25 = this;
    this.m7v_1 = _Hyphens___init__impl__m2cvg8(1);
    this.n7v_1 = _Hyphens___init__impl__m2cvg8(2);
    this.o7v_1 = _Hyphens___init__impl__m2cvg8(0);
  }
  protoOf(Companion_23).u8d = function (value) {
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!(0 <= value ? value <= 2 : false)) {
      var tmp$ret$1 = 'The given value=' + value + ' is not recognized by Hyphens.';
      throwIllegalArgumentException(tmp$ret$1);
    }
    return _Hyphens___init__impl__m2cvg8(value);
  };
  var Companion_instance_25;
  function Companion_getInstance_38() {
    if (Companion_instance_25 == null)
      new Companion_23();
    return Companion_instance_25;
  }
  function Hyphens__toString_impl_ck1wg0($this) {
    return $this === Companion_getInstance_38().m7v_1 ? 'Hyphens.None' : $this === Companion_getInstance_38().n7v_1 ? 'Hyphens.Auto' : $this === Companion_getInstance_38().o7v_1 ? 'Hyphens.Unspecified' : 'Invalid';
  }
  function Hyphens__hashCode_impl_yb7t8v($this) {
    return $this;
  }
  function Hyphens__equals_impl_oqoi4t($this, other) {
    if (!(other instanceof Hyphens))
      return false;
    if (!($this === other.w7v_1))
      return false;
    return true;
  }
  function Hyphens(value) {
    Companion_getInstance_38();
    this.w7v_1 = value;
  }
  protoOf(Hyphens).toString = function () {
    return Hyphens__toString_impl_ck1wg0(this.w7v_1);
  };
  protoOf(Hyphens).hashCode = function () {
    return Hyphens__hashCode_impl_yb7t8v(this.w7v_1);
  };
  protoOf(Hyphens).equals = function (other) {
    return Hyphens__equals_impl_oqoi4t(this.w7v_1, other);
  };
  var androidx_compose_ui_text_style_LineHeightStyle$stable;
  function _Trim___init__impl__tcc1lr(value) {
    return value;
  }
  function _Trim___get_value__impl__o5eglp($this) {
    return $this;
  }
  function Trim__toString_impl_hxcm0x($this) {
    var tmp0_subject = _Trim___get_value__impl__o5eglp($this);
    return tmp0_subject === _Trim___get_value__impl__o5eglp(Companion_getInstance_39().x8d_1) ? 'LineHeightStyle.Trim.FirstLineTop' : tmp0_subject === _Trim___get_value__impl__o5eglp(Companion_getInstance_39().y8d_1) ? 'LineHeightStyle.Trim.LastLineBottom' : tmp0_subject === _Trim___get_value__impl__o5eglp(Companion_getInstance_39().z8d_1) ? 'LineHeightStyle.Trim.Both' : tmp0_subject === _Trim___get_value__impl__o5eglp(Companion_getInstance_39().a8e_1) ? 'LineHeightStyle.Trim.None' : 'Invalid';
  }
  function Companion_24() {
    Companion_instance_26 = this;
    this.v8d_1 = 1;
    this.w8d_1 = 16;
    this.x8d_1 = _Trim___init__impl__tcc1lr(1);
    this.y8d_1 = _Trim___init__impl__tcc1lr(16);
    this.z8d_1 = _Trim___init__impl__tcc1lr(17);
    this.a8e_1 = _Trim___init__impl__tcc1lr(0);
  }
  var Companion_instance_26;
  function Companion_getInstance_39() {
    if (Companion_instance_26 == null)
      new Companion_24();
    return Companion_instance_26;
  }
  function Trim__isTrimFirstLineTop_impl_tqdsaa($this) {
    return (_Trim___get_value__impl__o5eglp($this) & 1) > 0;
  }
  function Trim__isTrimLastLineBottom_impl_8k6x3e($this) {
    return (_Trim___get_value__impl__o5eglp($this) & 16) > 0;
  }
  function Trim__hashCode_impl_vclj5c($this) {
    return $this;
  }
  function Trim__equals_impl_6x7eks($this, other) {
    if (!(other instanceof Trim))
      return false;
    if (!($this === other.z7x_1))
      return false;
    return true;
  }
  function _Alignment___init__impl__it107q(topRatio) {
    var tmp;
    var containsArg = _Alignment___get_topRatio__impl__gg7tir(topRatio);
    if (0.0 <= containsArg ? containsArg <= 1.0 : false) {
      tmp = true;
    } else {
      tmp = _Alignment___get_topRatio__impl__gg7tir(topRatio) === -1.0;
    }
    // Inline function 'androidx.compose.ui.text.internal.checkPrecondition' call
    if (!tmp) {
      var tmp$ret$1 = 'topRatio should be in [0..1] range or -1';
      throwIllegalStateException(tmp$ret$1);
    }
    return topRatio;
  }
  function _Alignment___get_topRatio__impl__gg7tir($this) {
    return $this;
  }
  function Alignment__toString_impl_on6yhu($this) {
    var tmp0_subject = _Alignment___get_topRatio__impl__gg7tir($this);
    return tmp0_subject === _Alignment___get_topRatio__impl__gg7tir(Companion_getInstance_40().b8e_1) ? 'LineHeightStyle.Alignment.Top' : tmp0_subject === _Alignment___get_topRatio__impl__gg7tir(Companion_getInstance_40().c8e_1) ? 'LineHeightStyle.Alignment.Center' : tmp0_subject === _Alignment___get_topRatio__impl__gg7tir(Companion_getInstance_40().d8e_1) ? 'LineHeightStyle.Alignment.Proportional' : tmp0_subject === _Alignment___get_topRatio__impl__gg7tir(Companion_getInstance_40().e8e_1) ? 'LineHeightStyle.Alignment.Bottom' : 'LineHeightStyle.Alignment(topPercentage = ' + _Alignment___get_topRatio__impl__gg7tir($this) + ')';
  }
  function Companion_25() {
    Companion_instance_27 = this;
    this.b8e_1 = _Alignment___init__impl__it107q(0.0);
    this.c8e_1 = _Alignment___init__impl__it107q(0.5);
    this.d8e_1 = _Alignment___init__impl__it107q(-1.0);
    this.e8e_1 = _Alignment___init__impl__it107q(1.0);
  }
  var Companion_instance_27;
  function Companion_getInstance_40() {
    if (Companion_instance_27 == null)
      new Companion_25();
    return Companion_instance_27;
  }
  function Alignment__hashCode_impl_omr6of($this) {
    return getNumberHashCode($this);
  }
  function Alignment__equals_impl_9ve0tn($this, other) {
    if (!(other instanceof Alignment))
      return false;
    var tmp0_other_with_cast = other.y7x_1;
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function _Mode___init__impl__3rgsrm(value) {
    return value;
  }
  function _Mode___get_value__impl__uitpda($this) {
    return $this;
  }
  function Mode__toString_impl_dwwrtq($this) {
    return $this === Companion_getInstance_41().f8e_1 ? 'LineHeightStyle.Mode.Fixed' : $this === Companion_getInstance_41().g8e_1 ? 'LineHeightStyle.Mode.Minimum' : $this === Companion_getInstance_41().h8e_1 ? 'LineHeightStyle.Mode.Tight' : 'Invalid';
  }
  function Companion_26() {
    Companion_instance_28 = this;
    this.f8e_1 = _Mode___init__impl__3rgsrm(0);
    this.g8e_1 = _Mode___init__impl__3rgsrm(1);
    this.h8e_1 = _Mode___init__impl__3rgsrm(2);
  }
  var Companion_instance_28;
  function Companion_getInstance_41() {
    if (Companion_instance_28 == null)
      new Companion_26();
    return Companion_instance_28;
  }
  function Mode__hashCode_impl_7u94z5($this) {
    return $this;
  }
  function Mode__equals_impl_uwixm3($this, other) {
    if (!(other instanceof Mode))
      return false;
    if (!($this === other.a7y_1))
      return false;
    return true;
  }
  function LineHeightStyle_init_$Init$(alignment, trim, $this) {
    LineHeightStyle.call($this, alignment, trim, Companion_getInstance_41().f8e_1);
    return $this;
  }
  function LineHeightStyle_init_$Create$(alignment, trim) {
    return LineHeightStyle_init_$Init$(alignment, trim, objectCreate(protoOf(LineHeightStyle)));
  }
  function Companion_27() {
    Companion_instance_29 = this;
    this.i8e_1 = new LineHeightStyle(Companion_getInstance_40().d8e_1, Companion_getInstance_39().z8d_1, Companion_getInstance_41().f8e_1);
  }
  var Companion_instance_29;
  function Companion_getInstance_42() {
    if (Companion_instance_29 == null)
      new Companion_27();
    return Companion_instance_29;
  }
  function Trim(value) {
    Companion_getInstance_39();
    this.z7x_1 = value;
  }
  protoOf(Trim).toString = function () {
    return Trim__toString_impl_hxcm0x(this.z7x_1);
  };
  protoOf(Trim).hashCode = function () {
    return Trim__hashCode_impl_vclj5c(this.z7x_1);
  };
  protoOf(Trim).equals = function (other) {
    return Trim__equals_impl_6x7eks(this.z7x_1, other);
  };
  function Alignment(topRatio) {
    Companion_getInstance_40();
    this.y7x_1 = topRatio;
  }
  protoOf(Alignment).toString = function () {
    return Alignment__toString_impl_on6yhu(this.y7x_1);
  };
  protoOf(Alignment).hashCode = function () {
    return Alignment__hashCode_impl_omr6of(this.y7x_1);
  };
  protoOf(Alignment).equals = function (other) {
    return Alignment__equals_impl_9ve0tn(this.y7x_1, other);
  };
  function Mode(value) {
    Companion_getInstance_41();
    this.a7y_1 = value;
  }
  protoOf(Mode).toString = function () {
    return Mode__toString_impl_dwwrtq(this.a7y_1);
  };
  protoOf(Mode).hashCode = function () {
    return Mode__hashCode_impl_7u94z5(this.a7y_1);
  };
  protoOf(Mode).equals = function (other) {
    return Mode__equals_impl_uwixm3(this.a7y_1, other);
  };
  function LineHeightStyle(alignment, trim, mode) {
    Companion_getInstance_42();
    this.v7x_1 = alignment;
    this.w7x_1 = trim;
    this.x7x_1 = mode;
  }
  protoOf(LineHeightStyle).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LineHeightStyle))
      return false;
    if (!equals(this.v7x_1, other.v7x_1))
      return false;
    if (!(this.w7x_1 === other.w7x_1))
      return false;
    if (!(this.x7x_1 === other.x7x_1))
      return false;
    return true;
  };
  protoOf(LineHeightStyle).hashCode = function () {
    var result = Alignment__hashCode_impl_omr6of(this.v7x_1);
    result = imul(31, result) + Trim__hashCode_impl_vclj5c(this.w7x_1) | 0;
    result = imul(31, result) + Mode__hashCode_impl_7u94z5(this.x7x_1) | 0;
    return result;
  };
  protoOf(LineHeightStyle).toString = function () {
    return 'LineHeightStyle(' + ('alignment=' + Alignment__toString_impl_on6yhu(this.v7x_1) + ', ') + ('trim=' + Trim__toString_impl_hxcm0x(this.w7x_1) + ',') + ('mode=' + Mode__toString_impl_dwwrtq(this.x7x_1)) + ')';
  };
  var ResolvedTextDirection_Ltr_instance;
  var ResolvedTextDirection_Rtl_instance;
  var ResolvedTextDirection_entriesInitialized;
  function ResolvedTextDirection_initEntries() {
    if (ResolvedTextDirection_entriesInitialized)
      return Unit_instance;
    ResolvedTextDirection_entriesInitialized = true;
    ResolvedTextDirection_Ltr_instance = new ResolvedTextDirection('Ltr', 0);
    ResolvedTextDirection_Rtl_instance = new ResolvedTextDirection('Rtl', 1);
  }
  function ResolvedTextDirection(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function ResolvedTextDirection_Ltr_getInstance() {
    ResolvedTextDirection_initEntries();
    return ResolvedTextDirection_Ltr_instance;
  }
  function ResolvedTextDirection_Rtl_getInstance() {
    ResolvedTextDirection_initEntries();
    return ResolvedTextDirection_Rtl_instance;
  }
  function _TextAlign___init__impl__99wz4v(value) {
    return value;
  }
  function _TextAlign___get_value__impl__lst7m3($this) {
    return $this;
  }
  function TextAlign__toString_impl_6ha6d3($this) {
    return $this === Companion_getInstance_43().b7v_1 ? 'Left' : $this === Companion_getInstance_43().c7v_1 ? 'Right' : $this === Companion_getInstance_43().d7v_1 ? 'Center' : $this === Companion_getInstance_43().e7v_1 ? 'Justify' : $this === Companion_getInstance_43().f7v_1 ? 'Start' : $this === Companion_getInstance_43().g7v_1 ? 'End' : $this === Companion_getInstance_43().h7v_1 ? 'Unspecified' : 'Invalid';
  }
  function Companion_28() {
    Companion_instance_30 = this;
    this.b7v_1 = _TextAlign___init__impl__99wz4v(1);
    this.c7v_1 = _TextAlign___init__impl__99wz4v(2);
    this.d7v_1 = _TextAlign___init__impl__99wz4v(3);
    this.e7v_1 = _TextAlign___init__impl__99wz4v(4);
    this.f7v_1 = _TextAlign___init__impl__99wz4v(5);
    this.g7v_1 = _TextAlign___init__impl__99wz4v(6);
    this.h7v_1 = _TextAlign___init__impl__99wz4v(0);
  }
  protoOf(Companion_28).j8e = function (value) {
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!(0 <= value ? value <= 6 : false)) {
      var tmp$ret$1 = 'The given value=' + value + ' is not recognized by TextAlign.';
      throwIllegalArgumentException(tmp$ret$1);
    }
    return _TextAlign___init__impl__99wz4v(value);
  };
  var Companion_instance_30;
  function Companion_getInstance_43() {
    if (Companion_instance_30 == null)
      new Companion_28();
    return Companion_instance_30;
  }
  function TextAlign__hashCode_impl_s8g35y($this) {
    return $this;
  }
  function TextAlign__equals_impl_latoh6($this, other) {
    if (!(other instanceof TextAlign))
      return false;
    if (!($this === other.t7v_1))
      return false;
    return true;
  }
  function TextAlign(value) {
    Companion_getInstance_43();
    this.t7v_1 = value;
  }
  protoOf(TextAlign).toString = function () {
    return TextAlign__toString_impl_6ha6d3(this.t7v_1);
  };
  protoOf(TextAlign).hashCode = function () {
    return TextAlign__hashCode_impl_s8g35y(this.t7v_1);
  };
  protoOf(TextAlign).equals = function (other) {
    return TextAlign__equals_impl_latoh6(this.t7v_1, other);
  };
  var androidx_compose_ui_text_style_TextDecoration$stable;
  function Companion_29() {
    Companion_instance_31 = this;
    this.a80_1 = new TextDecoration(0);
    this.b80_1 = new TextDecoration(1);
    this.c80_1 = new TextDecoration(2);
  }
  protoOf(Companion_29).k8e = function (mask) {
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!((mask | 3) === 3)) {
      var tmp$ret$1 = 'The given mask=' + mask + ' is not recognized by TextDecoration.';
      throwIllegalArgumentException(tmp$ret$1);
    }
    switch (mask) {
      case 0:
        return this.a80_1;
      case 1:
        return this.b80_1;
      case 2:
        return this.c80_1;
      default:
        return new TextDecoration(mask);
    }
  };
  var Companion_instance_31;
  function Companion_getInstance_44() {
    if (Companion_instance_31 == null)
      new Companion_29();
    return Companion_instance_31;
  }
  function TextDecoration(mask) {
    Companion_getInstance_44();
    this.k7x_1 = mask;
  }
  protoOf(TextDecoration).l8e = function (other) {
    return (this.k7x_1 | other.k7x_1) === this.k7x_1;
  };
  protoOf(TextDecoration).toString = function () {
    if (this.k7x_1 === 0) {
      return 'TextDecoration.None';
    }
    // Inline function 'kotlin.collections.mutableListOf' call
    var values = ArrayList_init_$Create$();
    if (!((this.k7x_1 & Companion_getInstance_44().b80_1.k7x_1) === 0)) {
      values.j1('Underline');
    }
    if (!((this.k7x_1 & Companion_getInstance_44().c80_1.k7x_1) === 0)) {
      values.j1('LineThrough');
    }
    if (values.n1() === 1) {
      return 'TextDecoration.' + values.l1(0);
    }
    return 'TextDecoration[' + fastJoinToString(values, ', ') + ']';
  };
  protoOf(TextDecoration).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextDecoration))
      return false;
    if (!(this.k7x_1 === other.k7x_1))
      return false;
    return true;
  };
  protoOf(TextDecoration).hashCode = function () {
    return this.k7x_1;
  };
  function _TextDirection___init__impl__lh8lzt(value) {
    return value;
  }
  function _TextDirection___get_value__impl__ka7r45($this) {
    return $this;
  }
  function TextDirection__toString_impl_x3uh9t($this) {
    return $this === Companion_getInstance_45().p7u_1 ? 'Ltr' : $this === Companion_getInstance_45().q7u_1 ? 'Rtl' : $this === Companion_getInstance_45().r7u_1 ? 'Content' : $this === Companion_getInstance_45().s7u_1 ? 'ContentOrLtr' : $this === Companion_getInstance_45().t7u_1 ? 'ContentOrRtl' : $this === Companion_getInstance_45().u7u_1 ? 'Unspecified' : 'Invalid';
  }
  function Companion_30() {
    Companion_instance_32 = this;
    this.p7u_1 = _TextDirection___init__impl__lh8lzt(1);
    this.q7u_1 = _TextDirection___init__impl__lh8lzt(2);
    this.r7u_1 = _TextDirection___init__impl__lh8lzt(3);
    this.s7u_1 = _TextDirection___init__impl__lh8lzt(4);
    this.t7u_1 = _TextDirection___init__impl__lh8lzt(5);
    this.u7u_1 = _TextDirection___init__impl__lh8lzt(0);
  }
  protoOf(Companion_30).m8e = function (value) {
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!(0 <= value ? value <= 5 : false)) {
      var tmp$ret$1 = 'The given value=' + value + ' is not recognized by TextDirection.';
      throwIllegalArgumentException(tmp$ret$1);
    }
    return _TextDirection___init__impl__lh8lzt(value);
  };
  var Companion_instance_32;
  function Companion_getInstance_45() {
    if (Companion_instance_32 == null)
      new Companion_30();
    return Companion_instance_32;
  }
  function TextDirection__hashCode_impl_g63nwg($this) {
    return $this;
  }
  function TextDirection__equals_impl_3fvxt0($this, other) {
    if (!(other instanceof TextDirection))
      return false;
    if (!($this === other.u7v_1))
      return false;
    return true;
  }
  function TextDirection(value) {
    Companion_getInstance_45();
    this.u7v_1 = value;
  }
  protoOf(TextDirection).toString = function () {
    return TextDirection__toString_impl_x3uh9t(this.u7v_1);
  };
  protoOf(TextDirection).hashCode = function () {
    return TextDirection__hashCode_impl_g63nwg(this.u7v_1);
  };
  protoOf(TextDirection).equals = function (other) {
    return TextDirection__equals_impl_3fvxt0(this.u7v_1, other);
  };
  var androidx_compose_ui_text_style_TextForegroundStyle_Unspecified$stable;
  function Unspecified() {
  }
  protoOf(Unspecified).s6c = function () {
    return Companion_getInstance().u6b_1;
  };
  protoOf(Unspecified).f7y = function () {
    return null;
  };
  protoOf(Unspecified).j68 = function () {
    return NaN;
  };
  var Unspecified_instance;
  function Unspecified_getInstance() {
    return Unspecified_instance;
  }
  function Companion_31() {
  }
  protoOf(Companion_31).d7y = function (color) {
    var tmp;
    // Inline function 'androidx.compose.ui.graphics.isSpecified' call
    if (!equals(_Color___get_value__impl__1pls5m(color), _ULong___init__impl__c78o9k(new Long(16, 0)))) {
      tmp = new ColorStyle(color);
    } else {
      tmp = Unspecified_instance;
    }
    return tmp;
  };
  protoOf(Companion_31).e7y = function (brush, alpha) {
    var tmp;
    if (brush == null) {
      tmp = Unspecified_instance;
    } else {
      if (brush instanceof SolidColor) {
        tmp = this.d7y(modulate(brush.d6b_1, alpha));
      } else {
        if (brush instanceof ShaderBrush) {
          tmp = new BrushStyle(brush, alpha);
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    return tmp;
  };
  var Companion_instance_33;
  function Companion_getInstance_46() {
    return Companion_instance_33;
  }
  function TextForegroundStyle$merge$lambda(this$0) {
    return function () {
      return this$0.o8e_1;
    };
  }
  function TextForegroundStyle$merge$lambda_0(this$0) {
    return function () {
      return this$0;
    };
  }
  function TextForegroundStyle() {
  }
  function modulate(_this__u8e3s4, alpha) {
    return isNaN_0(alpha) || alpha >= 1.0 ? _this__u8e3s4 : Color__copy$default_impl_ectz3s(_this__u8e3s4, _Color___get_alpha__impl__wcfyv1(_this__u8e3s4) * alpha);
  }
  function BrushStyle(value, alpha) {
    this.n8e_1 = value;
    this.o8e_1 = alpha;
  }
  protoOf(BrushStyle).j68 = function () {
    return this.o8e_1;
  };
  protoOf(BrushStyle).s6c = function () {
    return Companion_getInstance().u6b_1;
  };
  protoOf(BrushStyle).f7y = function () {
    return this.n8e_1;
  };
  protoOf(BrushStyle).toString = function () {
    return 'BrushStyle(value=' + toString_0(this.n8e_1) + ', alpha=' + this.o8e_1 + ')';
  };
  protoOf(BrushStyle).hashCode = function () {
    var result = hashCode(this.n8e_1);
    result = imul(result, 31) + getNumberHashCode(this.o8e_1) | 0;
    return result;
  };
  protoOf(BrushStyle).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BrushStyle))
      return false;
    if (!equals(this.n8e_1, other.n8e_1))
      return false;
    if (!equals(this.o8e_1, other.o8e_1))
      return false;
    return true;
  };
  function takeOrElse_0(_this__u8e3s4, block) {
    return isNaN_0(_this__u8e3s4) ? block() : _this__u8e3s4;
  }
  function ColorStyle(value) {
    this.p8e_1 = value;
    // Inline function 'androidx.compose.ui.graphics.isSpecified' call
    var this_0 = this.p8e_1;
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!!equals(_Color___get_value__impl__1pls5m(this_0), _ULong___init__impl__c78o9k(new Long(16, 0)))) {
      var tmp$ret$2 = 'ColorStyle value must be specified, use TextForegroundStyle.Unspecified instead.';
      throwIllegalArgumentException(tmp$ret$2);
    }
  }
  protoOf(ColorStyle).s6c = function () {
    return this.p8e_1;
  };
  protoOf(ColorStyle).f7y = function () {
    return null;
  };
  protoOf(ColorStyle).j68 = function () {
    return _Color___get_alpha__impl__wcfyv1(this.s6c());
  };
  protoOf(ColorStyle).toString = function () {
    return 'ColorStyle(value=' + Color__toString_impl_hpzmaq(this.p8e_1) + ')';
  };
  protoOf(ColorStyle).hashCode = function () {
    return Color__hashCode_impl_vjyivj(this.p8e_1);
  };
  protoOf(ColorStyle).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorStyle))
      return false;
    if (!equals(this.p8e_1, other.p8e_1))
      return false;
    return true;
  };
  function lerp_9(start, stop, fraction) {
    var tmp;
    var tmp_0;
    if (!(start instanceof BrushStyle)) {
      tmp_0 = !(stop instanceof BrushStyle);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = Companion_instance_33.d7y(lerp(start.s6c(), stop.s6c(), fraction));
    } else {
      var tmp_1;
      if (start instanceof BrushStyle) {
        tmp_1 = stop instanceof BrushStyle;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp = Companion_instance_33.e7y(lerpDiscrete(start.f7y(), stop.f7y(), fraction), lerp_3(start.o8e_1, stop.o8e_1, fraction));
      } else {
        tmp = lerpDiscrete(start, stop, fraction);
      }
    }
    return tmp;
  }
  var androidx_compose_ui_text_style_TextGeometricTransform$stable;
  function Companion_32() {
    Companion_instance_34 = this;
    this.i7z_1 = new TextGeometricTransform(1.0, 0.0);
  }
  var Companion_instance_34;
  function Companion_getInstance_47() {
    if (Companion_instance_34 == null)
      new Companion_32();
    return Companion_instance_34;
  }
  function TextGeometricTransform(scaleX, skewX) {
    Companion_getInstance_47();
    scaleX = scaleX === VOID ? 1.0 : scaleX;
    skewX = skewX === VOID ? 0.0 : skewX;
    this.l7x_1 = scaleX;
    this.m7x_1 = skewX;
  }
  protoOf(TextGeometricTransform).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextGeometricTransform))
      return false;
    if (!(this.l7x_1 === other.l7x_1))
      return false;
    if (!(this.m7x_1 === other.m7x_1))
      return false;
    return true;
  };
  protoOf(TextGeometricTransform).hashCode = function () {
    var result = getNumberHashCode(this.l7x_1);
    result = imul(31, result) + getNumberHashCode(this.m7x_1) | 0;
    return result;
  };
  protoOf(TextGeometricTransform).toString = function () {
    return 'TextGeometricTransform(scaleX=' + this.l7x_1 + ', skewX=' + this.m7x_1 + ')';
  };
  function lerp_10(start, stop, fraction) {
    return new TextGeometricTransform(lerp_3(start.l7x_1, stop.l7x_1, fraction), lerp_3(start.m7x_1, stop.m7x_1, fraction));
  }
  var androidx_compose_ui_text_style_TextIndent$stable;
  function Companion_33() {
    Companion_instance_35 = this;
    this.s7v_1 = new TextIndent_0();
  }
  var Companion_instance_35;
  function Companion_getInstance_48() {
    if (Companion_instance_35 == null)
      new Companion_33();
    return Companion_instance_35;
  }
  function TextIndent_0(firstLine, restLine) {
    Companion_getInstance_48();
    firstLine = firstLine === VOID ? get_sp(0) : firstLine;
    restLine = restLine === VOID ? get_sp(0) : restLine;
    this.n7x_1 = firstLine;
    this.o7x_1 = restLine;
  }
  protoOf(TextIndent_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextIndent_0))
      return false;
    if (!equals(this.n7x_1, other.n7x_1))
      return false;
    if (!equals(this.o7x_1, other.o7x_1))
      return false;
    return true;
  };
  protoOf(TextIndent_0).hashCode = function () {
    var result = TextUnit__hashCode_impl_qsmeov(this.n7x_1);
    result = imul(31, result) + TextUnit__hashCode_impl_qsmeov(this.o7x_1) | 0;
    return result;
  };
  protoOf(TextIndent_0).toString = function () {
    return 'TextIndent(firstLine=' + TextUnit__toString_impl_51ghw0(this.n7x_1) + ', restLine=' + TextUnit__toString_impl_51ghw0(this.o7x_1) + ')';
  };
  function lerp_11(start, stop, fraction) {
    return new TextIndent_0(lerpTextUnitInheritable(start.n7x_1, stop.n7x_1, fraction), lerpTextUnitInheritable(start.o7x_1, stop.o7x_1, fraction));
  }
  function _TextOverflow___init__impl__obguoe(value) {
    return value;
  }
  function _TextOverflow___get_value__impl__vugm5i($this) {
    return $this;
  }
  function TextOverflow__toString_impl_10s0c2($this) {
    return $this === Companion_getInstance_49().w7s_1 ? 'Clip' : $this === Companion_getInstance_49().x7s_1 ? 'Ellipsis' : $this === Companion_getInstance_49().a7t_1 ? 'MiddleEllipsis' : $this === Companion_getInstance_49().y7s_1 ? 'Visible' : $this === Companion_getInstance_49().z7s_1 ? 'StartEllipsis' : 'Invalid';
  }
  function Companion_34() {
    Companion_instance_36 = this;
    this.w7s_1 = _TextOverflow___init__impl__obguoe(1);
    this.x7s_1 = _TextOverflow___init__impl__obguoe(2);
    this.y7s_1 = _TextOverflow___init__impl__obguoe(3);
    this.z7s_1 = _TextOverflow___init__impl__obguoe(4);
    this.a7t_1 = _TextOverflow___init__impl__obguoe(5);
  }
  var Companion_instance_36;
  function Companion_getInstance_49() {
    if (Companion_instance_36 == null)
      new Companion_34();
    return Companion_instance_36;
  }
  function TextOverflow__hashCode_impl_kqdwgt($this) {
    return $this;
  }
  function TextOverflow__equals_impl_jkxdof($this, other) {
    if (!(other instanceof TextOverflow))
      return false;
    if (!($this === other.q8e_1))
      return false;
    return true;
  }
  function TextOverflow(value) {
    Companion_getInstance_49();
    this.q8e_1 = value;
  }
  protoOf(TextOverflow).toString = function () {
    return TextOverflow__toString_impl_10s0c2(this.q8e_1);
  };
  protoOf(TextOverflow).hashCode = function () {
    return TextOverflow__hashCode_impl_kqdwgt(this.q8e_1);
  };
  protoOf(TextOverflow).equals = function (other) {
    return TextOverflow__equals_impl_jkxdof(this.q8e_1, other);
  };
  function userPreferredLanguages() {
    return toList(getUserPreferredLanguagesAsArray());
  }
  function getUserPreferredLanguagesAsArray() {
    return window.navigator.languages;
  }
  var androidx_compose_ui_text_AtomicReference$stable;
  function AtomicReference(value) {
    this.y8c_1 = atomic$ref$1(value);
  }
  protoOf(AtomicReference).f1i = function () {
    return this.y8c_1.kotlinx$atomicfu$value;
  };
  protoOf(AtomicReference).k2p = function (value) {
    this.y8c_1.kotlinx$atomicfu$value = value;
  };
  protoOf(AtomicReference).w21 = function (expect, newValue) {
    return this.y8c_1.atomicfu$compareAndSet(expect, newValue);
  };
  function isNonSpacingMark(_this__u8e3s4) {
    return CharDirection_getInstance().o60(_this__u8e3s4) === 17;
  }
  function isNeutralDirection(_this__u8e3s4) {
    switch (CharDirection_getInstance().o60(_this__u8e3s4)) {
      case 10:
      case 9:
      case 18:
        return true;
      default:
        return false;
    }
  }
  function strongDirectionType(_this__u8e3s4) {
    switch (CharDirection_getInstance().o60(_this__u8e3s4)) {
      case 0:
        return Companion_getInstance_50().s8e_1;
      case 1:
      case 13:
        return Companion_getInstance_50().t8e_1;
      default:
        return Companion_getInstance_50().r8e_1;
    }
  }
  function toCharArray_0(_this__u8e3s4, destination, destinationOffset, startIndex, endIndex) {
    // Inline function 'kotlin.collections.forEach' call
    var progression = until(startIndex, endIndex);
    var inductionVariable = progression.x1_1;
    var last = progression.y1_1;
    if (inductionVariable <= last)
      do {
        var element = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var it = element;
        destination[(destinationOffset + it | 0) - startIndex | 0] = charCodeAt(_this__u8e3s4, it);
      }
       while (!(element === last));
  }
  var androidx_compose_ui_text_ExpireAfterAccessCache$stable;
  function checkEvicted($this, now) {
    var expireTime = subtract(now, $this.u8e_1);
    var iterator = $this.x8e_1.s1().t();
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = iterator;
    $l$loop: while (_iterator__ex2g4s.u()) {
      var entry = _iterator__ex2g4s.v();
      if (compare(entry.u1(), expireTime) < 0) {
        $this.w8e_1.a3(entry.t1());
        iterator.l4();
      } else
        break $l$loop;
    }
  }
  function access$checkEvicted($this, now) {
    return checkEvicted($this, now);
  }
  function currentNanoTime$ref() {
    return constructCallableReference(function () {
      return currentNanoTime();
    }, 0, 0, 35, 'currentNanoTime');
  }
  function ExpireAfterAccessCache(expireAfterNanos, currentNanos) {
    var tmp;
    if (currentNanos === VOID) {
      tmp = currentNanoTime$ref();
    } else {
      tmp = currentNanos;
    }
    currentNanos = tmp;
    this.u8e_1 = expireAfterNanos;
    this.v8e_1 = currentNanos;
    this.w8e_1 = HashMap_init_$Create$();
    this.x8e_1 = LinkedHashMap_init_$Create$();
  }
  function get_PUSH_DIRECTIONAL_ISOLATE_RANGE() {
    _init_properties_CharHelpers_skiko_kt__8ej40s();
    return PUSH_DIRECTIONAL_ISOLATE_RANGE;
  }
  var PUSH_DIRECTIONAL_ISOLATE_RANGE;
  function _StrongDirectionType___init__impl__59uet3(value) {
    return value;
  }
  function Companion_35() {
    Companion_instance_37 = this;
    this.r8e_1 = _StrongDirectionType___init__impl__59uet3(0);
    this.s8e_1 = _StrongDirectionType___init__impl__59uet3(1);
    this.t8e_1 = _StrongDirectionType___init__impl__59uet3(2);
  }
  var Companion_instance_37;
  function Companion_getInstance_50() {
    if (Companion_instance_37 == null)
      new Companion_35();
    return Companion_instance_37;
  }
  function firstStrongDirectionType(_this__u8e3s4) {
    _init_properties_CharHelpers_skiko_kt__8ej40s();
    var _iterator__ex2g4s = get_codePointsOutsideDirectionalIsolate(_this__u8e3s4).t();
    $l$loop: while (_iterator__ex2g4s.u()) {
      var codePoint = _iterator__ex2g4s.v();
      var strongDirectionType_0 = strongDirectionType(codePoint);
      var tmp;
      if (strongDirectionType_0 === Companion_getInstance_50().r8e_1) {
        continue $l$loop;
      } else {
        tmp = strongDirectionType_0;
      }
      return tmp;
    }
    return Companion_getInstance_50().r8e_1;
  }
  function findPrecedingBreak(_this__u8e3s4, index) {
    _init_properties_CharHelpers_skiko_kt__8ej40s();
    var it = Companion_getInstance_5().l5j();
    it.t5j(_this__u8e3s4);
    return it.r5j(index);
  }
  function findFollowingBreak(_this__u8e3s4, index) {
    _init_properties_CharHelpers_skiko_kt__8ej40s();
    var it = Companion_getInstance_5().l5j();
    it.t5j(_this__u8e3s4);
    return it.s5j(index);
  }
  function codePointAt(_this__u8e3s4, index) {
    _init_properties_CharHelpers_skiko_kt__8ej40s();
    var high = charSequenceGet(_this__u8e3s4, index);
    if (isHighSurrogate(high) && (index + 1 | 0) < charSequenceLength(_this__u8e3s4)) {
      var low = charSequenceGet(_this__u8e3s4, index + 1 | 0);
      if (isLowSurrogate(low)) {
        return toCodePoint(Companion_getInstance_6(), high, low);
      }
    }
    // Inline function 'kotlin.code' call
    return Char__toInt_impl_vasixd(high);
  }
  function get_codePointsOutsideDirectionalIsolate(_this__u8e3s4) {
    _init_properties_CharHelpers_skiko_kt__8ej40s();
    return sequence(_get_codePointsOutsideDirectionalIsolate_$slambda_cun5rj_0(_this__u8e3s4, null));
  }
  function toCodePoint(_this__u8e3s4, high, low) {
    _init_properties_CharHelpers_skiko_kt__8ej40s();
    return (Char__minus_impl_a2frrh(high, _Char___init__impl__6a9atx(55296)) << 10 | Char__minus_impl_a2frrh(low, _Char___init__impl__6a9atx(56320))) + 65536 | 0;
  }
  function get_codePoints(_this__u8e3s4) {
    _init_properties_CharHelpers_skiko_kt__8ej40s();
    return sequence(_get_codePoints_$slambda_43x8dt_0(_this__u8e3s4, null));
  }
  function charCount(_this__u8e3s4) {
    _init_properties_CharHelpers_skiko_kt__8ej40s();
    return _this__u8e3s4 >= 65536 ? 2 : 1;
  }
  function _get_codePointsOutsideDirectionalIsolate_$slambda_cun5rj($this_codePointsOutsideDirectionalIsolate, resultContinuation) {
    this.g8f_1 = $this_codePointsOutsideDirectionalIsolate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(_get_codePointsOutsideDirectionalIsolate_$slambda_cun5rj).k8f = function ($this$sequence, $completion) {
    var tmp = this.l8f($this$sequence, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(_get_codePointsOutsideDirectionalIsolate_$slambda_cun5rj).ja = function (p1, $completion) {
    return this.k8f(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(_get_codePointsOutsideDirectionalIsolate_$slambda_cun5rj).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.i8f_1 = 0;
            this.j8f_1 = get_codePoints(this.g8f_1).t();
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!this.j8f_1.u()) {
              this.n9_1 = 4;
              continue $sm;
            }

            var codePoint = this.j8f_1.v();
            var progression = get_PUSH_DIRECTIONAL_ISOLATE_RANGE();
            var containsLower = progression.x1_1;
            if (codePoint <= progression.y1_1 ? containsLower <= codePoint : false) {
              this.i8f_1 = this.i8f_1 + 1 | 0;
              this.n9_1 = 3;
              continue $sm;
            } else {
              if (codePoint === 8297) {
                if (this.i8f_1 > 0) {
                  this.i8f_1 = this.i8f_1 - 1 | 0;
                }
                this.n9_1 = 3;
                continue $sm;
              } else {
                if (this.i8f_1 === 0) {
                  this.n9_1 = 2;
                  suspendResult = this.h8f_1.oi(codePoint, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  this.n9_1 = 3;
                  continue $sm;
                }
              }
            }

          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.n9_1 = 1;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(_get_codePointsOutsideDirectionalIsolate_$slambda_cun5rj).l8f = function ($this$sequence, completion) {
    var i = new _get_codePointsOutsideDirectionalIsolate_$slambda_cun5rj(this.g8f_1, completion);
    i.h8f_1 = $this$sequence;
    return i;
  };
  function _get_codePointsOutsideDirectionalIsolate_$slambda_cun5rj_0($this_codePointsOutsideDirectionalIsolate, resultContinuation) {
    var i = new _get_codePointsOutsideDirectionalIsolate_$slambda_cun5rj($this_codePointsOutsideDirectionalIsolate, resultContinuation);
    return constructCallableReference(function ($this$sequence, $completion) {
      return i.k8f($this$sequence, $completion);
    }, 1);
  }
  function _get_codePoints_$slambda_43x8dt($this_codePoints, resultContinuation) {
    this.u8f_1 = $this_codePoints;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(_get_codePoints_$slambda_43x8dt).k8f = function ($this$sequence, $completion) {
    var tmp = this.l8f($this$sequence, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(_get_codePoints_$slambda_43x8dt).ja = function (p1, $completion) {
    return this.k8f(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(_get_codePoints_$slambda_43x8dt).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.w8f_1 = 0;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!(this.w8f_1 < charSequenceLength(this.u8f_1))) {
              this.n9_1 = 3;
              continue $sm;
            }

            this.x8f_1 = codePointAt(this.u8f_1, this.w8f_1);
            this.n9_1 = 2;
            suspendResult = this.v8f_1.oi(this.x8f_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.w8f_1 = this.w8f_1 + charCount(this.x8f_1) | 0;
            this.n9_1 = 1;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(_get_codePoints_$slambda_43x8dt).l8f = function ($this$sequence, completion) {
    var i = new _get_codePoints_$slambda_43x8dt(this.u8f_1, completion);
    i.v8f_1 = $this$sequence;
    return i;
  };
  function _get_codePoints_$slambda_43x8dt_0($this_codePoints, resultContinuation) {
    var i = new _get_codePoints_$slambda_43x8dt($this_codePoints, resultContinuation);
    return constructCallableReference(function ($this$sequence, $completion) {
      return i.k8f($this$sequence, $completion);
    }, 1);
  }
  var properties_initialized_CharHelpers_skiko_kt_d762bq;
  function _init_properties_CharHelpers_skiko_kt__8ej40s() {
    if (!properties_initialized_CharHelpers_skiko_kt_d762bq) {
      properties_initialized_CharHelpers_skiko_kt_d762bq = true;
      PUSH_DIRECTIONAL_ISOLATE_RANGE = numberRangeToNumber(8294, 8296);
    }
  }
  var androidx_compose_ui_text_FontRasterizationSettings$stable;
  function FontRasterizationSettings$Companion$PlatformDefault$delegate$lambda() {
    var tmp;
    switch (currentPlatform().a1_1) {
      case 2:
        var tmp1_smoothing = FontSmoothing_AntiAlias_getInstance();
        var tmp2_hinting = FontHinting_Normal_getInstance();
        tmp = new FontRasterizationSettings(tmp1_smoothing, tmp2_hinting, true, false);
        break;
      case 1:
      case 0:
        var tmp3_smoothing = FontSmoothing_AntiAlias_getInstance();
        var tmp4_hinting = FontHinting_Slight_getInstance();
        tmp = new FontRasterizationSettings(tmp3_smoothing, tmp4_hinting, true, false);
        break;
      case 7:
        var tmp5_smoothing = FontSmoothing_AntiAlias_getInstance();
        var tmp6_hinting = FontHinting_Slight_getInstance();
        tmp = new FontRasterizationSettings(tmp5_smoothing, tmp6_hinting, true, false);
        break;
      case 3:
      case 4:
      case 5:
      case 6:
        var tmp7_smoothing = FontSmoothing_AntiAlias_getInstance();
        var tmp8_hinting = FontHinting_Normal_getInstance();
        tmp = new FontRasterizationSettings(tmp7_smoothing, tmp8_hinting, true, false);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function FontRasterizationSettings$Companion$_get_PlatformDefault_$ref_q7exdb() {
    return constructCallableReference(function (p0) {
      return p0.z8f();
    }, 1, 0, 36);
  }
  function Companion_36() {
    Companion_instance_38 = this;
    var tmp = this;
    tmp.y8f_1 = lazy_0(FontRasterizationSettings$Companion$PlatformDefault$delegate$lambda);
  }
  protoOf(Companion_36).z8f = function () {
    var tmp0 = this.y8f_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('PlatformDefault', 1, tmp, FontRasterizationSettings$Companion$_get_PlatformDefault_$ref_q7exdb(), null);
    return tmp0.u1();
  };
  var Companion_instance_38;
  function Companion_getInstance_51() {
    if (Companion_instance_38 == null)
      new Companion_36();
    return Companion_instance_38;
  }
  function FontRasterizationSettings(smoothing, hinting, subpixelPositioning, autoHintingForced) {
    Companion_getInstance_51();
    this.a8g_1 = smoothing;
    this.b8g_1 = hinting;
    this.c8g_1 = subpixelPositioning;
    this.d8g_1 = autoHintingForced;
  }
  protoOf(FontRasterizationSettings).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof FontRasterizationSettings))
      THROW_CCE();
    if (!this.a8g_1.equals(other.a8g_1))
      return false;
    if (!this.b8g_1.equals(other.b8g_1))
      return false;
    if (!(this.c8g_1 === other.c8g_1))
      return false;
    return this.d8g_1 === other.d8g_1;
  };
  protoOf(FontRasterizationSettings).hashCode = function () {
    var result = this.a8g_1.hashCode();
    result = imul(31, result) + this.b8g_1.hashCode() | 0;
    result = imul(31, result) + getBooleanHashCode(this.c8g_1) | 0;
    result = imul(31, result) + getBooleanHashCode(this.d8g_1) | 0;
    return result;
  };
  protoOf(FontRasterizationSettings).toString = function () {
    return 'FontRasterizationSettings(smoothing=' + this.a8g_1.toString() + ', ' + ('hinting=' + this.b8g_1.toString() + ', ') + ('subpixelPositioning=' + this.c8g_1 + ', ') + ('autoHintingForced=' + this.d8g_1 + ')');
  };
  function toSkFontEdging(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.a1_1) {
      case 0:
        tmp = FontEdging_ALIAS_getInstance();
        break;
      case 1:
        tmp = FontEdging_ANTI_ALIAS_getInstance();
        break;
      case 2:
        tmp = FontEdging_SUBPIXEL_ANTI_ALIAS_getInstance();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  var FontSmoothing_None_instance;
  var FontSmoothing_AntiAlias_instance;
  var FontSmoothing_SubpixelAntiAlias_instance;
  var FontSmoothing_entriesInitialized;
  function FontSmoothing_initEntries() {
    if (FontSmoothing_entriesInitialized)
      return Unit_instance;
    FontSmoothing_entriesInitialized = true;
    FontSmoothing_None_instance = new FontSmoothing('None', 0);
    FontSmoothing_AntiAlias_instance = new FontSmoothing('AntiAlias', 1);
    FontSmoothing_SubpixelAntiAlias_instance = new FontSmoothing('SubpixelAntiAlias', 2);
  }
  function FontSmoothing(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function toSkFontHinting(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.a1_1) {
      case 0:
        tmp = FontHinting_NONE_getInstance();
        break;
      case 1:
        tmp = FontHinting_SLIGHT_getInstance();
        break;
      case 2:
        tmp = FontHinting_NORMAL_getInstance();
        break;
      case 3:
        tmp = FontHinting_FULL_getInstance();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  var FontHinting_None_instance;
  var FontHinting_Slight_instance;
  var FontHinting_Normal_instance;
  var FontHinting_Full_instance;
  var FontHinting_entriesInitialized;
  function FontHinting_initEntries() {
    if (FontHinting_entriesInitialized)
      return Unit_instance;
    FontHinting_entriesInitialized = true;
    FontHinting_None_instance = new FontHinting('None', 0);
    FontHinting_Slight_instance = new FontHinting('Slight', 1);
    FontHinting_Normal_instance = new FontHinting('Normal', 2);
    FontHinting_Full_instance = new FontHinting('Full', 3);
  }
  function FontHinting(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function FontSmoothing_AntiAlias_getInstance() {
    FontSmoothing_initEntries();
    return FontSmoothing_AntiAlias_instance;
  }
  function FontHinting_Slight_getInstance() {
    FontHinting_initEntries();
    return FontHinting_Slight_instance;
  }
  function FontHinting_Normal_getInstance() {
    FontHinting_initEntries();
    return FontHinting_Normal_instance;
  }
  function Paragraph_1() {
  }
  function get_PlatformParagraphStyleSaver() {
    _init_properties_Savers_skiko_kt__qtio6d();
    return PlatformParagraphStyleSaver;
  }
  var PlatformParagraphStyleSaver;
  function get_LineBreakSaver() {
    _init_properties_Savers_skiko_kt__qtio6d();
    return LineBreakSaver;
  }
  var LineBreakSaver;
  function get_TextMotionSaver() {
    _init_properties_Savers_skiko_kt__qtio6d();
    return TextMotionSaver;
  }
  var TextMotionSaver;
  function get_Saver_21(_this__u8e3s4) {
    _init_properties_Savers_skiko_kt__qtio6d();
    return get_PlatformParagraphStyleSaver();
  }
  function get_Saver_22(_this__u8e3s4) {
    _init_properties_Savers_skiko_kt__qtio6d();
    return get_LineBreakSaver();
  }
  function get_Saver_23(_this__u8e3s4) {
    _init_properties_Savers_skiko_kt__qtio6d();
    return get_TextMotionSaver();
  }
  function PlatformParagraphStyleSaver$lambda($this$Saver, it) {
    _init_properties_Savers_skiko_kt__qtio6d();
    return Unit_instance;
  }
  function PlatformParagraphStyleSaver$lambda_0(it) {
    _init_properties_Savers_skiko_kt__qtio6d();
    return PlatformParagraphStyle_init_$Create$();
  }
  function LineBreakSaver$lambda($this$Saver, it) {
    _init_properties_Savers_skiko_kt__qtio6d();
    return _LineBreak___get_mask__impl__je2e1t(it.v7v_1);
  }
  function LineBreakSaver$lambda_0(it) {
    _init_properties_Savers_skiko_kt__qtio6d();
    var mask = typeof it === 'number' ? it : THROW_CCE();
    var tmp;
    switch (mask) {
      case 1:
        tmp = Companion_getInstance_55().i7v_1;
        break;
      case 2:
        tmp = Companion_getInstance_55().j7v_1;
        break;
      case 3:
        tmp = Companion_getInstance_55().k7v_1;
        break;
      default:
        tmp = Companion_getInstance_55().l7v_1;
        break;
    }
    var tmp_0 = tmp;
    return tmp_0 == null ? null : new LineBreak(tmp_0);
  }
  function TextMotionSaver$lambda($this$Saver, it) {
    _init_properties_Savers_skiko_kt__qtio6d();
    return equals(it, Companion_getInstance_56().x7v_1) ? 0 : 1;
  }
  function TextMotionSaver$lambda_0(it) {
    _init_properties_Savers_skiko_kt__qtio6d();
    var tmp;
    if (equals(it, 0)) {
      tmp = Companion_getInstance_56().x7v_1;
    } else {
      tmp = Companion_getInstance_56().y7v_1;
    }
    return tmp;
  }
  var properties_initialized_Savers_skiko_kt_n0li93;
  function _init_properties_Savers_skiko_kt__qtio6d() {
    if (!properties_initialized_Savers_skiko_kt_n0li93) {
      properties_initialized_Savers_skiko_kt_n0li93 = true;
      var tmp = PlatformParagraphStyleSaver$lambda;
      PlatformParagraphStyleSaver = Saver_0(tmp, PlatformParagraphStyleSaver$lambda_0);
      var tmp_0 = LineBreakSaver$lambda;
      LineBreakSaver = Saver_0(tmp_0, LineBreakSaver$lambda_0);
      var tmp_1 = TextMotionSaver$lambda;
      TextMotionSaver = Saver_0(tmp_1, TextMotionSaver$lambda_0);
    }
  }
  var androidx_compose_ui_text_SkiaParagraph$stable;
  function _set_paragraph__p1bfvb($this, value) {
    $this.l8g_1 = value;
    $this.m8g_1 = null;
  }
  function _get_ellipsis__kt5xpi($this) {
    return listOf([new TextOverflow(Companion_getInstance_49().x7s_1), new TextOverflow(Companion_getInstance_49().a7t_1), new TextOverflow(Companion_getInstance_49().z7s_1)]).m1(new TextOverflow($this.i8g_1)) ? '\u2026' : '';
  }
  function _get_text__de5ose($this) {
    return $this.g8g_1.n8g_1;
  }
  function lineMetricsForOffset($this, offset) {
    var tmp;
    if (0 <= offset ? offset <= _get_text__de5ose($this).length : false) {
      var tmp0 = _get_lineMetrics__5iiuki($this);
      var tmp$ret$0;
      $l$block: {
        // Inline function 'androidx.compose.ui.text.binarySearchFirstMatchingOrLast' call
        // Inline function 'kotlin.collections.isEmpty' call
        if (tmp0.length === 0) {
          tmp$ret$0 = null;
          break $l$block;
        }
        var tmp_0 = asList(tmp0);
        var index = binarySearch(tmp_0, VOID, VOID, SkiaParagraph$lineMetricsForOffset$lambda(offset));
        tmp$ret$0 = tmp0[coerceAtMost((-index | 0) - 1 | 0, get_lastIndex_0(tmp0))];
      }
      tmp = tmp$ret$0;
    } else {
      tmp = null;
    }
    return tmp;
  }
  function getLineMetricsForVerticalPosition($this, vertical) {
    var tmp0 = _get_lineMetrics__5iiuki($this);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.text.binarySearchFirstMatchingOrLast' call
      // Inline function 'kotlin.collections.isEmpty' call
      if (tmp0.length === 0) {
        tmp$ret$0 = null;
        break $l$block;
      }
      var tmp = asList(tmp0);
      var index = binarySearch(tmp, VOID, VOID, SkiaParagraph$getLineMetricsForVerticalPosition$lambda(vertical));
      tmp$ret$0 = tmp0[coerceAtMost((-index | 0) - 1 | 0, get_lastIndex_0(tmp0))];
    }
    return tmp$ret$0;
  }
  function getAlignedStartingPosition($this, isRtl) {
    var tmp0_subject = $this.k8g_1.c8h().p82();
    return tmp0_subject === Companion_getInstance_43().b7v_1 ? 0.0 : tmp0_subject === Companion_getInstance_43().c7v_1 ? $this.h5e() : tmp0_subject === Companion_getInstance_43().d7v_1 ? $this.h5e() / 2 : tmp0_subject === Companion_getInstance_43().f7v_1 ? isRtl ? $this.h5e() : 0.0 : tmp0_subject === Companion_getInstance_43().g7v_1 ? isRtl ? 0.0 : $this.h5e() : 0.0;
  }
  function _get_lineMetrics__5iiuki($this) {
    var tmp0_elvis_lhs = $this.m8g_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = receiveLineMetrics($this);
      $this.m8g_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var lineMetrics = tmp;
    return lineMetrics;
  }
  function receiveLineMetrics($this) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    var this_0 = _get_text__de5ose($this);
    if (charSequenceLength(this_0) === 0) {
      tmp = $this.k8g_1.d8h($this.l8g_1);
    } else {
      // Inline function 'kotlin.collections.ifEmpty' call
      var this_1 = $this.l8g_1.m62();
      var tmp_0;
      // Inline function 'kotlin.collections.isEmpty' call
      if (this_1.length === 0) {
        tmp_0 = $this.k8g_1.d8h($this.l8g_1);
      } else {
        tmp_0 = this_1;
      }
      tmp = tmp_0;
    }
    var lineMetrics = tmp;
    var fontMetrics = $this.e8h().l5n();
    lineMetrics[0] = trimFirstAscent(lineMetrics[0], fontMetrics, $this.k8g_1.c8h());
    lineMetrics[lineMetrics.length - 1 | 0] = trimLastDescent(lineMetrics[lineMetrics.length - 1 | 0], fontMetrics, $this.k8g_1.c8h());
    return lineMetrics;
  }
  function getBoxForwardByOffset($this, offset) {
    if (!(0 <= offset ? offset <= _get_text__de5ose($this).length : false))
      return null;
    var to = offset + 1 | 0;
    while (to <= _get_text__de5ose($this).length) {
      var box = firstOrNull($this.l8g_1.i62(offset, to, RectHeightMode_STRUT_getInstance(), RectWidthMode_TIGHT_getInstance()));
      if (!(box == null)) {
        return box;
      }
      to = to + 1 | 0;
    }
    return null;
  }
  function getBoxBackwardByOffset($this, offset, end) {
    end = end === VOID ? offset : end;
    if (!(0 <= offset ? offset <= _get_text__de5ose($this).length : false))
      return null;
    var from = offset - 1 | 0;
    var isRtl = $this.g8g_1.t8g_1.equals(ResolvedTextDirection_Rtl_getInstance());
    while (from >= 0) {
      var box = firstOrNull($this.l8g_1.i62(from, end, RectHeightMode_STRUT_getInstance(), RectWidthMode_TIGHT_getInstance()));
      if (box == null)
        from = from - 1 | 0;
      else if (charCodeAt(_get_text__de5ose($this), from) === _Char___init__impl__6a9atx(10)) {
        var tmp;
        if (!isRtl) {
          var bottom = box.y63_1.n5k_1 + box.y63_1.n5k_1 - box.y63_1.l5k_1;
          var rect = new Rect_0(0.0, box.y63_1.n5k_1, 0.0, bottom);
          return new TextBox(rect, box.a64());
        } else {
          var tmp_0;
          if (from === get_lastIndex_1(_get_text__de5ose($this))) {
            var bottom_0 = box.y63_1.n5k_1 + box.y63_1.n5k_1 - box.y63_1.l5k_1;
            var rect_0 = new Rect_0($this.h5e(), box.y63_1.n5k_1, $this.h5e(), bottom_0);
            tmp_0 = new TextBox(rect_0, box.a64());
          } else {
            var nextBox = first_0($this.l8g_1.i62(offset, offset + 1 | 0, RectHeightMode_STRUT_getInstance(), RectWidthMode_TIGHT_getInstance()));
            var rect_1 = new Rect_0(nextBox.y63_1.k5k_1, nextBox.y63_1.l5k_1, nextBox.y63_1.k5k_1, nextBox.y63_1.n5k_1);
            tmp_0 = new TextBox(rect_1, nextBox.a64());
          }
          tmp = tmp_0;
        }
        return tmp;
      } else
        return box;
    }
    return null;
  }
  function SkiaParagraph$lineMetricsForOffset$lambda($offset) {
    return function (it) {
      var tmp;
      if ($offset < it.n61_1) {
        tmp = 1;
      } else {
        tmp = -1;
      }
      return tmp;
    };
  }
  function SkiaParagraph$getLineMetricsForVerticalPosition$lambda($vertical) {
    return function (it) {
      var tmp;
      if ($vertical < it.v61_1 + it.q61_1) {
        tmp = 1;
      } else {
        tmp = -1;
      }
      return tmp;
    };
  }
  function SkiaParagraph(paragraphIntrinsics, maxLines, overflow, constraints) {
    this.g8g_1 = paragraphIntrinsics;
    this.h8g_1 = maxLines;
    this.i8g_1 = overflow;
    this.j8g_1 = constraints;
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = this.g8g_1.f8h();
    this_0.g8h(this.h8g_1, _get_ellipsis__kt5xpi(this));
    tmp.k8g_1 = this_0;
    this.l8g_1 = this.k8g_1.h8h(this.h5e());
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!(_Constraints___get_minHeight__impl__ev4bgx(this.j8g_1) === 0 && _Constraints___get_minWidth__impl__hi9lfi(this.j8g_1) === 0)) {
      var tmp$ret$3 = 'Setting Constraints.minWidth and Constraints.minHeight is not supported, these should be the default zero values instead.';
      throwIllegalArgumentException(tmp$ret$3);
    }
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!(this.h8g_1 >= 1)) {
      var tmp$ret$5 = 'maxLines should be greater than 0';
      throwIllegalArgumentException(tmp$ret$5);
    }
    var tmp0 = this.h5e();
    // Inline function 'androidx.compose.ui.geometry.Size' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = this.i5e();
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$7 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    var tmp$ret$6 = _Size___init__impl__aywn0g(tmp$ret$7);
    this.k8g_1.i8h(tmp$ret$6);
    _set_paragraph__p1bfvb(this, this.k8g_1.h8h(this.h5e()));
    if (this.i8g_1 === Companion_getInstance_49().x7s_1 && this.l8g_1.i5e() > _Constraints___get_maxHeight__impl__dt3e8z(this.j8g_1) && this.h8g_1 > 1) {
      var calculatedMaxLines = numberOfLinesThatFitMaxHeight(this, _Constraints___get_maxHeight__impl__dt3e8z(this.j8g_1));
      if (calculatedMaxLines >= 0 && !(calculatedMaxLines === this.h8g_1)) {
        this.k8g_1.g8h(coerceAtLeast(calculatedMaxLines, 1), _get_ellipsis__kt5xpi(this));
        _set_paragraph__p1bfvb(this, this.k8g_1.h8h(this.h5e()));
      }
    }
    this.m8g_1 = null;
  }
  protoOf(SkiaParagraph).e8h = function () {
    return this.k8g_1.j8h();
  };
  protoOf(SkiaParagraph).h5e = function () {
    return _Constraints___get_maxWidth__impl__uuyqc(this.j8g_1);
  };
  protoOf(SkiaParagraph).i5e = function () {
    return this.l8g_1.i5e();
  };
  protoOf(SkiaParagraph).c62 = function () {
    return this.g8g_1.v8g_1;
  };
  protoOf(SkiaParagraph).d62 = function () {
    return this.g8g_1.w8g_1;
  };
  protoOf(SkiaParagraph).i7t = function () {
    var tmp0_safe_receiver = firstOrNull(_get_lineMetrics__5iiuki(this));
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.run' call
      tmp = tmp0_safe_receiver.v61_1;
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
  };
  protoOf(SkiaParagraph).j7t = function () {
    var tmp0_safe_receiver = lastOrNull(_get_lineMetrics__5iiuki(this));
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.run' call
      tmp = tmp0_safe_receiver.v61_1;
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
  };
  protoOf(SkiaParagraph).f7t = function () {
    return this.l8g_1.f62();
  };
  protoOf(SkiaParagraph).e7t = function () {
    var tmp;
    if (_get_text__de5ose(this) === '' || this.l8g_1.n62() < 1) {
      tmp = 1;
    } else {
      tmp = this.l8g_1.n62();
    }
    return tmp;
  };
  protoOf(SkiaParagraph).g7t = function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.l8g_1.j62();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$2 = toComposeRect(item.y63_1);
      destination.j1(tmp$ret$2);
    }
    return destination;
  };
  protoOf(SkiaParagraph).u7s = function (start, end) {
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!((0 <= start ? start <= end : false) && end <= _get_text__de5ose(this).length)) {
      var tmp$ret$1 = 'start(' + start + ') or end(' + end + ') is out of range [0..' + _get_text__de5ose(this).length + '],' + ' or start > end!';
      throwIllegalArgumentException(tmp$ret$1);
    }
    var boxes = this.l8g_1.i62(start, end, RectHeightMode_MAX_getInstance(), RectWidthMode_TIGHT_getInstance());
    var pathBuilder = PathBuilder_init_$Create$();
    var inductionVariable = 0;
    var last = boxes.length;
    while (inductionVariable < last) {
      var b = boxes[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      pathBuilder.s5s(b.y63_1.k5k_1, b.y63_1.l5k_1, b.y63_1.m5k_1, b.y63_1.n5k_1);
    }
    return asComposePath(pathBuilder.g5s());
  };
  protoOf(SkiaParagraph).c7u = function (offset) {
    // Inline function 'androidx.compose.ui.text.SkiaParagraph.checkOffsetIsValid' call
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!(0 <= offset ? offset <= _get_text__de5ose(this).length : false)) {
      var tmp$ret$2 = 'offset(' + offset + ') is out of bounds [0,' + _get_text__de5ose(this).length + ']';
      throwIllegalArgumentException(tmp$ret$2);
    }
    var horizontal = this.w7t(offset, true);
    var line = ensureNotNull(lineMetricsForOffset(this, offset));
    var isNewEmptyLine = (offset - 1 | 0) === line.k61_1 && offset === _get_text__de5ose(this).length;
    var metrics = this.e8h().l5n();
    // Inline function 'kotlin.let' call
    var it = line.p61_1;
    var tmp;
    if (isNewEmptyLine) {
      var ascent = -metrics.f5o_1;
      tmp = coerceAtMost_0(it, ascent);
    } else {
      tmp = it;
    }
    var asc = tmp;
    // Inline function 'kotlin.let' call
    var it_0 = line.q61_1;
    var tmp_0;
    if (isNewEmptyLine) {
      var descent = metrics.g5o_1;
      tmp_0 = coerceAtMost_0(it_0, descent);
    } else {
      tmp_0 = it_0;
    }
    var desc = tmp_0;
    return new Rect_1(horizontal, line.v61_1 - asc, horizontal, line.v61_1 + desc);
  };
  protoOf(SkiaParagraph).e7u = function (lineIndex) {
    var tmp0_safe_receiver = getOrNull(_get_lineMetrics__5iiuki(this), lineIndex);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u61_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver;
    return tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs;
  };
  protoOf(SkiaParagraph).g7u = function (lineIndex) {
    var tmp0_safe_receiver = getOrNull(_get_lineMetrics__5iiuki(this), lineIndex);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x61();
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver;
    return tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs;
  };
  protoOf(SkiaParagraph).h7u = function (lineIndex) {
    var tmp0_safe_receiver = getOrNull(_get_lineMetrics__5iiuki(this), lineIndex);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.math.floor' call
      var x = tmp0_safe_receiver.v61_1 - tmp0_safe_receiver.p61_1;
      tmp = Math.floor(x);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
  };
  protoOf(SkiaParagraph).i7u = function (lineIndex) {
    var tmp0_safe_receiver = getOrNull(_get_lineMetrics__5iiuki(this), lineIndex);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.math.floor' call
      var x = tmp0_safe_receiver.v61_1 + tmp0_safe_receiver.q61_1;
      tmp = Math.floor(x);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
  };
  protoOf(SkiaParagraph).j7u = function (lineIndex) {
    var tmp0_safe_receiver = getOrNull(_get_lineMetrics__5iiuki(this), lineIndex);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s61_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver;
    return tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs;
  };
  protoOf(SkiaParagraph).k7u = function (lineIndex) {
    var tmp0_safe_receiver = getOrNull(_get_lineMetrics__5iiuki(this), lineIndex);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k61_1;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  protoOf(SkiaParagraph).l7u = function (lineIndex, visibleEnd) {
    var tmp0_elvis_lhs = getOrNull(_get_lineMetrics__5iiuki(this), lineIndex);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return 0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var metrics = tmp;
    var tmp_0;
    if (visibleEnd) {
      var tmp_1;
      if (lineIndex > 0 && metrics.k61_1 < _get_lineMetrics__5iiuki(this)[lineIndex - 1 | 0].l61_1) {
        tmp_1 = metrics.l61_1;
      } else if (metrics.k61_1 < _get_text__de5ose(this).length && charCodeAt(_get_text__de5ose(this), metrics.k61_1) === _Char___init__impl__6a9atx(10)) {
        tmp_1 = metrics.k61_1;
      } else {
        tmp_1 = metrics.m61_1;
      }
      tmp_0 = tmp_1;
    } else {
      tmp_0 = metrics.l61_1;
    }
    return tmp_0;
  };
  protoOf(SkiaParagraph).d7u = function (offset) {
    return offset < 0 ? 0 : offset > _get_text__de5ose(this).length ? this.e7t() - 1 | 0 : ensureNotNull(lineMetricsForOffset(this, offset)).w61_1;
  };
  protoOf(SkiaParagraph).p7t = function (vertical) {
    var tmp0_safe_receiver = getLineMetricsForVerticalPosition(this, vertical);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w61_1;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  protoOf(SkiaParagraph).w7t = function (offset, usePrimaryDirection) {
    var prevBox = getBoxBackwardByOffset(this, offset);
    var nextBox = getBoxForwardByOffset(this, offset);
    var isRtl = this.g8g_1.t8g_1.equals(ResolvedTextDirection_Rtl_getInstance());
    var isLtr = !isRtl;
    return prevBox == null && nextBox == null ? getAlignedStartingPosition(this, isRtl) : prevBox == null ? cursorHorizontalPosition(ensureNotNull(nextBox), true) : nextBox == null ? cursorHorizontalPosition(prevBox) : nextBox.a64().equals(prevBox.a64()) ? cursorHorizontalPosition(nextBox, true) : isLtr && prevBox.a64().equals(Direction_LTR_getInstance()) ? cursorHorizontalPosition(nextBox, true) : isRtl && prevBox.a64().equals(Direction_RTL_getInstance()) ? cursorHorizontalPosition(nextBox, true) : usePrimaryDirection ? cursorHorizontalPosition(prevBox) : cursorHorizontalPosition(nextBox, true);
  };
  protoOf(SkiaParagraph).x7t = function (offset) {
    return this.g8g_1.t8g_1;
  };
  protoOf(SkiaParagraph).y7t = function (offset) {
    var tmp0_safe_receiver = getBoxForwardByOffset(this, offset);
    var tmp1_subject = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a64();
    var tmp;
    switch (tmp1_subject == null ? -1 : tmp1_subject.a1_1) {
      case 0:
        tmp = ResolvedTextDirection_Rtl_getInstance();
        break;
      case 1:
        tmp = ResolvedTextDirection_Ltr_getInstance();
        break;
      case -1:
        tmp = ResolvedTextDirection_Ltr_getInstance();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  protoOf(SkiaParagraph).s7t = function (position) {
    var tmp = this.l8g_1;
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(position);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp_0 = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(position);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var tmp$ret$4 = floatFromBits(bits_0);
    var initialGlyphPosition = tmp.k62(tmp_0, tmp$ret$4).r63_1;
    var glyphPosition = initialGlyphPosition;
    if (0 <= glyphPosition ? glyphPosition < _get_text__de5ose(this).length : false) {
      var isNonSpacingMark_0 = isNonSpacingMark(codePointAt(_get_text__de5ose(this), glyphPosition));
      if (isNonSpacingMark_0) {
        var precedingBreak = findPrecedingBreak(_get_text__de5ose(this), glyphPosition);
        var followingBreak = findFollowingBreak(_get_text__de5ose(this), glyphPosition);
        if (!(precedingBreak === glyphPosition) && !(followingBreak === glyphPosition)) {
          glyphPosition = followingBreak;
        }
      }
    }
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_1 = _Offset___get_packedValue__impl__xh2k8q(position);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_1 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
    var tmp$ret$8 = floatFromBits(bits_1);
    var tmp0_elvis_lhs = getLineMetricsForVerticalPosition(this, tmp$ret$8);
    var tmp_1;
    if (tmp0_elvis_lhs == null) {
      return glyphPosition;
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    var expectedLine = tmp_1;
    var isNotEmptyLine = expectedLine.k61_1 < expectedLine.l61_1;
    var tmp_2;
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_2 = _Offset___get_packedValue__impl__xh2k8q(position);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_2 = convertToInt(shiftRight(value_2, 32));
    if (floatFromBits(bits_2) > expectedLine.u61_1) {
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_3 = _Offset___get_packedValue__impl__xh2k8q(position);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_3 = convertToInt(shiftRight(value_3, 32));
      tmp_2 = floatFromBits(bits_3) < expectedLine.x61();
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      return glyphPosition;
    }
    var tmp_3;
    if (isNotEmptyLine) {
      tmp_3 = this.l8g_1.i62(expectedLine.k61_1, expectedLine.o61_1 ? expectedLine.l61_1 : expectedLine.l61_1 - 1 | 0, RectHeightMode_STRUT_getInstance(), RectWidthMode_TIGHT_getInstance());
    } else {
      tmp_3 = null;
    }
    var rects = tmp_3;
    var tmp2_safe_receiver = rects == null ? null : firstOrNull(rects);
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.y63_1;
    var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.k5k_1;
    var leftX = tmp4_elvis_lhs == null ? expectedLine.u61_1 : tmp4_elvis_lhs;
    var tmp6_safe_receiver = rects == null ? null : lastOrNull(rects);
    var tmp7_safe_receiver = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.y63_1;
    var tmp8_elvis_lhs = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.m5k_1;
    var rightX = tmp8_elvis_lhs == null ? expectedLine.x61() : tmp8_elvis_lhs;
    if (leftX === rightX) {
      return glyphPosition;
    }
    var tmp_4;
    if (isNotEmptyLine && expectedLine.m61_1 > 0) {
      var lastCharIndex = expectedLine.m61_1 - 1 | 0;
      var tmp_5;
      if (lastCharIndex >= 0 && lastCharIndex < _get_text__de5ose(this).length) {
        tmp_5 = isNonSpacingMark(codePointAt(_get_text__de5ose(this), lastCharIndex));
      } else {
        tmp_5 = false;
      }
      tmp_4 = tmp_5;
    } else {
      tmp_4 = false;
    }
    var hasNonSpacingMarkAtEnd = tmp_4;
    if (hasNonSpacingMarkAtEnd) {
      return glyphPosition;
    }
    var correctedGlyphPosition = glyphPosition;
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_4 = _Offset___get_packedValue__impl__xh2k8q(position);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_4 = convertToInt(shiftRight(value_4, 32));
    if (floatFromBits(bits_4) <= leftX) {
      var tmp_6 = this.l8g_1;
      var tmp_7 = leftX + 1.0;
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_5 = _Offset___get_packedValue__impl__xh2k8q(position);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_5 = convertToInt(bitwiseAnd(value_5, new Long(-1, 0)));
      var tmp$ret$24 = floatFromBits(bits_5);
      correctedGlyphPosition = tmp_6.k62(tmp_7, tmp$ret$24).r63_1;
    } else {
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_6 = _Offset___get_packedValue__impl__xh2k8q(position);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_6 = convertToInt(shiftRight(value_6, 32));
      if (floatFromBits(bits_6) >= rightX) {
        var tmp_8 = this.l8g_1;
        var tmp_9 = rightX - 1.0;
        // Inline function 'androidx.compose.ui.geometry.Offset.y' call
        // Inline function 'androidx.compose.ui.util.unpackFloat2' call
        var value_7 = _Offset___get_packedValue__impl__xh2k8q(position);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_7 = convertToInt(bitwiseAnd(value_7, new Long(-1, 0)));
        var tmp$ret$32 = floatFromBits(bits_7);
        correctedGlyphPosition = tmp_8.k62(tmp_9, tmp$ret$32).r63_1;
        var tmp_10;
        if (0 <= correctedGlyphPosition ? correctedGlyphPosition <= (charSequenceLength(_get_text__de5ose(this)) - 1 | 0) : false) {
          tmp_10 = isNeutralDirection(codePointAt(_get_text__de5ose(this), correctedGlyphPosition));
        } else {
          tmp_10 = false;
        }
        var isNeutralChar = tmp_10;
        var tmp_11;
        if (!isNeutralChar) {
          var tmp9_safe_receiver = getBoxBackwardByOffset(this, correctedGlyphPosition);
          tmp_11 = equals(tmp9_safe_receiver == null ? null : tmp9_safe_receiver.a64(), Direction_RTL_getInstance());
        } else {
          tmp_11 = false;
        }
        if (tmp_11) {
          correctedGlyphPosition = correctedGlyphPosition - 1 | 0;
        }
      }
    }
    return correctedGlyphPosition;
  };
  protoOf(SkiaParagraph).v7t = function (offset) {
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!(0 <= offset ? offset <= (charSequenceLength(_get_text__de5ose(this)) - 1 | 0) : false)) {
      var tmp$ret$1 = 'offset(' + offset + ') is out of bounds [0,' + _get_text__de5ose(this).length + ')';
      throwIllegalArgumentException(tmp$ret$1);
    }
    var tmp0_elvis_lhs = getBoxForwardByOffset(this, offset);
    var box = tmp0_elvis_lhs == null ? ensureNotNull(getBoxBackwardByOffset(this, offset, _get_text__de5ose(this).length)) : tmp0_elvis_lhs;
    return toComposeRect(box.y63_1);
  };
  protoOf(SkiaParagraph).z7t = function (offset) {
    // Inline function 'androidx.compose.ui.text.SkiaParagraph.checkOffsetIsValid' call
    // Inline function 'androidx.compose.ui.text.internal.requirePrecondition' call
    if (!(0 <= offset ? offset <= _get_text__de5ose(this).length : false)) {
      var tmp$ret$2 = 'offset(' + offset + ') is out of bounds [0,' + _get_text__de5ose(this).length + ']';
      throwIllegalArgumentException(tmp$ret$2);
    }
    if (offset < _get_text__de5ose(this).length && isWhitespace(charCodeAt(_get_text__de5ose(this), offset)) || offset === _get_text__de5ose(this).length) {
      var tmp;
      if (offset > 0 && !isWhitespace(charCodeAt(_get_text__de5ose(this), offset - 1 | 0))) {
        tmp = toTextRange(this.l8g_1.l62(offset - 1 | 0));
      } else {
        tmp = TextRange_1(offset, offset);
      }
      return tmp;
    }
    return toTextRange(this.l8g_1.l62(offset));
  };
  protoOf(SkiaParagraph).l7t = function (canvas, color, shadow, textDecoration, drawStyle, blendMode) {
    // Inline function 'kotlin.with' call
    var $this$with = this.k8g_1;
    $this$with.k8h(color);
    $this$with.l8h(shadow, textDecoration);
    $this$with.m8h(drawStyle);
    $this$with.n8h(blendMode);
    var tmp$ret$0 = $this$with.h8h(this.h5e());
    _set_paragraph__p1bfvb(this, tmp$ret$0);
    this.l8g_1.h62(get_skiaCanvas(canvas), 0.0, 0.0);
  };
  protoOf(SkiaParagraph).n7t = function (canvas, brush, alpha, shadow, textDecoration, drawStyle, blendMode) {
    // Inline function 'kotlin.with' call
    var $this$with = this.k8g_1;
    var tmp0 = this.h5e();
    // Inline function 'androidx.compose.ui.geometry.Size' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = this.i5e();
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$3 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    var tmp$ret$2 = _Size___init__impl__aywn0g(tmp$ret$3);
    $this$with.o8h(brush, tmp$ret$2, alpha);
    $this$with.l8h(shadow, textDecoration);
    $this$with.m8h(drawStyle);
    $this$with.n8h(blendMode);
    var tmp$ret$0 = $this$with.h8h(this.h5e());
    _set_paragraph__p1bfvb(this, tmp$ret$0);
    this.l8g_1.h62(get_skiaCanvas(canvas), 0.0, 0.0);
  };
  function numberOfLinesThatFitMaxHeight(_this__u8e3s4, maxHeight) {
    var inductionVariable = 0;
    var last = _this__u8e3s4.e7t();
    if (inductionVariable < last)
      do {
        var lineIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (_this__u8e3s4.i7u(lineIndex) > maxHeight)
          return lineIndex;
      }
       while (inductionVariable < last);
    return _this__u8e3s4.e7t();
  }
  function trimFirstAscent(_this__u8e3s4, fontMetrics, textStyle) {
    // Inline function 'androidx.compose.ui.unit.isUnspecified' call
    var this_0 = textStyle.r82();
    if (equalsLong(_TextUnit___get_rawType__impl__tu8yq5(this_0), new Long(0, 0)))
      return _this__u8e3s4;
    var tmp0_elvis_lhs = textStyle.t82();
    var style = tmp0_elvis_lhs == null ? Companion_getInstance_42().i8e_1 : tmp0_elvis_lhs;
    var tmp;
    if (Trim__isTrimFirstLineTop_impl_tqdsaa(style.w7x_1)) {
      tmp = -fontMetrics.f5o_1;
    } else {
      tmp = _this__u8e3s4.p61_1;
    }
    var ascent = tmp;
    return copy(_this__u8e3s4, VOID, VOID, VOID, VOID, VOID, ascent);
  }
  function trimLastDescent(_this__u8e3s4, fontMetrics, textStyle) {
    // Inline function 'androidx.compose.ui.unit.isUnspecified' call
    var this_0 = textStyle.r82();
    if (equalsLong(_TextUnit___get_rawType__impl__tu8yq5(this_0), new Long(0, 0)))
      return _this__u8e3s4;
    var tmp0_elvis_lhs = textStyle.t82();
    var style = tmp0_elvis_lhs == null ? Companion_getInstance_42().i8e_1 : tmp0_elvis_lhs;
    var tmp;
    if (Trim__isTrimLastLineBottom_impl_8k6x3e(style.w7x_1)) {
      tmp = fontMetrics.g5o_1;
    } else {
      tmp = _this__u8e3s4.q61_1;
    }
    var descent = tmp;
    return copy(_this__u8e3s4, VOID, VOID, VOID, VOID, VOID, VOID, descent);
  }
  function toTextRange(_this__u8e3s4) {
    return TextRange_1(_this__u8e3s4.x5p_1, _this__u8e3s4.y5p_1);
  }
  function copy(_this__u8e3s4, startIndex, endIndex, endExcludingWhitespaces, endIncludingNewline, isHardBreak, ascent, descent, unscaledAscent, height, width, left, baseline, lineNumber) {
    startIndex = startIndex === VOID ? _this__u8e3s4.k61_1 : startIndex;
    endIndex = endIndex === VOID ? _this__u8e3s4.l61_1 : endIndex;
    endExcludingWhitespaces = endExcludingWhitespaces === VOID ? _this__u8e3s4.m61_1 : endExcludingWhitespaces;
    endIncludingNewline = endIncludingNewline === VOID ? _this__u8e3s4.n61_1 : endIncludingNewline;
    isHardBreak = isHardBreak === VOID ? _this__u8e3s4.o61_1 : isHardBreak;
    ascent = ascent === VOID ? _this__u8e3s4.p61_1 : ascent;
    descent = descent === VOID ? _this__u8e3s4.q61_1 : descent;
    unscaledAscent = unscaledAscent === VOID ? _this__u8e3s4.r61_1 : unscaledAscent;
    height = height === VOID ? _this__u8e3s4.s61_1 : height;
    width = width === VOID ? _this__u8e3s4.t61_1 : width;
    left = left === VOID ? _this__u8e3s4.u61_1 : left;
    baseline = baseline === VOID ? _this__u8e3s4.v61_1 : baseline;
    lineNumber = lineNumber === VOID ? _this__u8e3s4.w61_1 : lineNumber;
    return new LineMetrics(startIndex, endIndex, endExcludingWhitespaces, endIncludingNewline, isHardBreak, ascent, descent, unscaledAscent, height, width, left, baseline, lineNumber);
  }
  function _TextDecorationLineStyle___init__impl__fccanb(value) {
    return value;
  }
  function TextDecorationLineStyle__toString_impl_uezvi9($this) {
    return $this === Companion_getInstance_52().p8h_1 ? 'Solid' : $this === Companion_getInstance_52().q8h_1 ? 'Double' : $this === Companion_getInstance_52().r8h_1 ? 'Dotted' : $this === Companion_getInstance_52().s8h_1 ? 'Dashed' : $this === Companion_getInstance_52().t8h_1 ? 'Wavy' : 'Invalid';
  }
  function Companion_37() {
    Companion_instance_39 = this;
    this.p8h_1 = _TextDecorationLineStyle___init__impl__fccanb(1);
    this.q8h_1 = _TextDecorationLineStyle___init__impl__fccanb(2);
    this.r8h_1 = _TextDecorationLineStyle___init__impl__fccanb(3);
    this.s8h_1 = _TextDecorationLineStyle___init__impl__fccanb(4);
    this.t8h_1 = _TextDecorationLineStyle___init__impl__fccanb(5);
  }
  var Companion_instance_39;
  function Companion_getInstance_52() {
    if (Companion_instance_39 == null)
      new Companion_37();
    return Companion_instance_39;
  }
  function TextDecorationLineStyle__hashCode_impl_8ntype($this) {
    return $this;
  }
  function TextDecorationLineStyle__equals_impl_3jy6m($this, other) {
    if (!(other instanceof TextDecorationLineStyle))
      return false;
    if (!($this === other.u8h_1))
      return false;
    return true;
  }
  function TextDecorationLineStyle(value) {
    Companion_getInstance_52();
    this.u8h_1 = value;
  }
  protoOf(TextDecorationLineStyle).toString = function () {
    return TextDecorationLineStyle__toString_impl_uezvi9(this.u8h_1);
  };
  protoOf(TextDecorationLineStyle).hashCode = function () {
    return TextDecorationLineStyle__hashCode_impl_8ntype(this.u8h_1);
  };
  protoOf(TextDecorationLineStyle).equals = function (other) {
    return TextDecorationLineStyle__equals_impl_3jy6m(this.u8h_1, other);
  };
  var androidx_compose_ui_text_PlatformTextStyle$stable;
  var androidx_compose_ui_text_PlatformParagraphStyle$stable;
  var androidx_compose_ui_text_PlatformSpanStyle$stable;
  function PlatformTextStyle_init_$Init$(spanStyle, paragraphStyle, $this) {
    PlatformTextStyle.call($this);
    $this.u81_1 = spanStyle;
    $this.v81_1 = paragraphStyle;
    return $this;
  }
  function PlatformTextStyle_init_$Create$(spanStyle, paragraphStyle) {
    return PlatformTextStyle_init_$Init$(spanStyle, paragraphStyle, objectCreate(protoOf(PlatformTextStyle)));
  }
  protoOf(PlatformTextStyle).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PlatformTextStyle))
      return false;
    if (!equals(this.v81_1, other.v81_1))
      return false;
    if (!equals(this.u81_1, other.u81_1))
      return false;
    return true;
  };
  protoOf(PlatformTextStyle).hashCode = function () {
    var tmp0_safe_receiver = this.u81_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hashCode();
    var result = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp = imul(31, result);
    var tmp2_safe_receiver = this.v81_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.hashCode();
    result = tmp + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    return result;
  };
  function PlatformTextStyle() {
  }
  function Companion_38() {
    Companion_instance_40 = this;
    this.z7v_1 = PlatformParagraphStyle_init_$Create$();
  }
  var Companion_instance_40;
  function Companion_getInstance_53() {
    if (Companion_instance_40 == null)
      new Companion_38();
    return Companion_instance_40;
  }
  function PlatformParagraphStyle_init_$Init$($this) {
    PlatformParagraphStyle.call($this);
    $this.q7v_1 = Companion_getInstance_51().z8f();
    return $this;
  }
  function PlatformParagraphStyle_init_$Create$() {
    return PlatformParagraphStyle_init_$Init$(objectCreate(protoOf(PlatformParagraphStyle)));
  }
  protoOf(PlatformParagraphStyle).r7v = function (other) {
    if (other == null)
      return this;
    return other;
  };
  protoOf(PlatformParagraphStyle).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PlatformParagraphStyle))
      return false;
    if (!this.q7v_1.equals(other.q7v_1))
      return false;
    return true;
  };
  protoOf(PlatformParagraphStyle).hashCode = function () {
    return this.q7v_1.hashCode();
  };
  function PlatformParagraphStyle() {
    Companion_getInstance_53();
  }
  function PlatformSpanStyle_init_$Init$($this) {
    PlatformSpanStyle.call($this, null);
    return $this;
  }
  function PlatformSpanStyle_init_$Create$() {
    return PlatformSpanStyle_init_$Init$(objectCreate(protoOf(PlatformSpanStyle)));
  }
  function Companion_39() {
    Companion_instance_41 = this;
    this.d80_1 = PlatformSpanStyle_init_$Create$();
  }
  var Companion_instance_41;
  function Companion_getInstance_54() {
    if (Companion_instance_41 == null)
      new Companion_39();
    return Companion_instance_41;
  }
  function PlatformSpanStyle(textDecorationLineStyle) {
    Companion_getInstance_54();
    this.n7y_1 = textDecorationLineStyle;
  }
  protoOf(PlatformSpanStyle).o7y = function (other) {
    return this;
  };
  protoOf(PlatformSpanStyle).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PlatformSpanStyle))
      return false;
    var tmp = this.n7y_1;
    var tmp_0 = tmp == null ? null : new TextDecorationLineStyle(tmp);
    var tmp_1 = other.n7y_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new TextDecorationLineStyle(tmp_1)))
      return false;
    return true;
  };
  protoOf(PlatformSpanStyle).hashCode = function () {
    var tmp = this.n7y_1;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = tmp == null ? null : new TextDecorationLineStyle(tmp);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  function createPlatformTextStyle(spanStyle, paragraphStyle) {
    return PlatformTextStyle_init_$Create$(spanStyle, paragraphStyle);
  }
  function lerp_12(start, stop, fraction) {
    return start;
  }
  function lerp_13(start, stop, fraction) {
    var tmp = start.n7y_1;
    var tmp_0 = tmp == null ? null : new TextDecorationLineStyle(tmp);
    var tmp_1 = stop.n7y_1;
    if (equals(tmp_0, tmp_1 == null ? null : new TextDecorationLineStyle(tmp_1)))
      return start;
    var tmp_2 = start.n7y_1;
    var tmp_3 = tmp_2 == null ? null : new TextDecorationLineStyle(tmp_2);
    var tmp_4 = stop.n7y_1;
    var tmp_5 = lerpDiscrete(tmp_3, tmp_4 == null ? null : new TextDecorationLineStyle(tmp_4), fraction);
    return new PlatformSpanStyle(tmp_5 == null ? null : tmp_5.u8h_1);
  }
  function createFontFamilyResolver(fontCache) {
    return new FontFamilyResolverImpl(SkiaFontLoader_init_$Create$(fontCache), createPlatformResolveInterceptor());
  }
  function createFontFamilyResolver_0() {
    return new FontFamilyResolverImpl(SkiaFontLoader_init_$Create$(), createPlatformResolveInterceptor());
  }
  var androidx_compose_ui_text_font_PlatformFontFamilyTypefaceAdapter$stable;
  function PlatformFontFamilyTypefaceAdapter() {
  }
  protoOf(PlatformFontFamilyTypefaceAdapter).p84 = function (typefaceRequest, platformFontLoader, onAsyncCompletion, createDefaultTypeface) {
    var tmp = typefaceRequest.q83_1;
    if (tmp instanceof FontListFontFamily)
      return null;
    var skiaFontLoader = platformFontLoader instanceof SkiaFontLoader ? platformFontLoader : THROW_CCE();
    var tmp0_elvis_lhs = typefaceRequest.q83_1;
    var result = skiaFontLoader.w8h(tmp0_elvis_lhs == null ? Companion_getInstance_20().q7z_1 : tmp0_elvis_lhs, typefaceRequest.r83_1, typefaceRequest.s83_1);
    return new Immutable(result);
  };
  var androidx_compose_ui_text_font_SkiaFontLoader$stable;
  function SkiaFontLoader_init_$Init$(fontCache, $this) {
    fontCache = fontCache === VOID ? new FontCache() : fontCache;
    SkiaFontLoader.call($this, SkiaFontLoader$_init_$lambda_5eoe7t(fontCache));
    return $this;
  }
  function SkiaFontLoader_init_$Create$(fontCache) {
    return SkiaFontLoader_init_$Init$(fontCache, objectCreate(protoOf(SkiaFontLoader)));
  }
  function _get_fontCache__rq14qm($this) {
    var tmp0 = $this.v8h_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('fontCache', 1, tmp, SkiaFontLoader$_get_fontCache_$ref_77g67v(), null);
    return tmp0.u1();
  }
  function SkiaFontLoader$_init_$lambda_5eoe7t($fontCache) {
    return function () {
      return $fontCache;
    };
  }
  function SkiaFontLoader$_get_fontCache_$ref_77g67v() {
    return constructCallableReference(function (p0) {
      return _get_fontCache__rq14qm(p0);
    }, 1, 0, 37);
  }
  function SkiaFontLoader(fontCacheProvider) {
    this.v8h_1 = lazy_0(fontCacheProvider);
  }
  protoOf(SkiaFontLoader).x8h = function () {
    return _get_fontCache__rq14qm(this).y8h_1;
  };
  protoOf(SkiaFontLoader).h88 = function (font) {
    if (!(font instanceof PlatformFont)) {
      if (!(font.z82() === Companion_getInstance_23().b83_1)) {
        throw IllegalArgumentException_init_$Create$_0('Unsupported font type: ' + toString_0(font));
      }
      return null;
    }
    var tmp0_subject = font.z82();
    var tmp;
    if (tmp0_subject === Companion_getInstance_23().a83_1) {
      tmp = _get_fontCache__rq14qm(this).c8i(font);
    } else if (tmp0_subject === Companion_getInstance_23().b83_1) {
      // Inline function 'kotlin.runCatching' call
      var tmp_0;
      try {
        // Inline function 'kotlin.Companion.success' call
        var value = _get_fontCache__rq14qm(this).c8i(font);
        tmp_0 = _Result___init__impl__xyqfz8(value);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'kotlin.Companion.failure' call
          tmp_1 = _Result___init__impl__xyqfz8(createFailure(e));
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      // Inline function 'kotlin.Result.getOrNull' call
      var this_0 = tmp_0;
      tmp = _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
    } else if (tmp0_subject === Companion_getInstance_23().c83_1) {
      throw UnsupportedOperationException_init_$Create$_0('Unsupported Async font load path');
    } else {
      throw IllegalArgumentException_init_$Create$_0('Unknown loading type ' + FontLoadingStrategy__toString_impl_fx0z8f(font.z82()));
    }
    return tmp;
  };
  protoOf(SkiaFontLoader).w8h = function (fontFamily, fontWeight, fontStyle) {
    return _get_fontCache__rq14qm(this).w8h(fontFamily, fontWeight, fontStyle);
  };
  protoOf(SkiaFontLoader).d8i = function (font, $completion) {
    return this.h88(font);
  };
  protoOf(SkiaFontLoader).u86 = function (font, $completion) {
    return this.d8i(font, $completion);
  };
  protoOf(SkiaFontLoader).w84 = function () {
    return _get_fontCache__rq14qm(this);
  };
  var androidx_compose_ui_text_input_PlatformImeOptions$stable;
  function ActualParagraph(text, style, annotations, placeholders, maxLines, overflow, constraints, density, fontFamilyResolver) {
    return new SkiaParagraph(new SkiaParagraphIntrinsics(text, style, annotations, placeholders, density, fontFamilyResolver), maxLines, overflow, constraints);
  }
  function ActualParagraph_0(paragraphIntrinsics, maxLines, overflow, constraints) {
    return new SkiaParagraph(paragraphIntrinsics instanceof SkiaParagraphIntrinsics ? paragraphIntrinsics : THROW_CCE(), maxLines, overflow, constraints);
  }
  function get_DefaultFontSize_0() {
    _init_properties_ParagraphBuilder_skiko_kt__fblzyk();
    return DefaultFontSize_0;
  }
  var DefaultFontSize_0;
  function get_skTextStylesCache() {
    _init_properties_ParagraphBuilder_skiko_kt__fblzyk();
    return skTextStylesCache;
  }
  var skTextStylesCache;
  var androidx_compose_ui_text_platform_ComputedStyle_Immutable$stable;
  var androidx_compose_ui_text_platform_ComputedStyle_Mutable$stable;
  var androidx_compose_ui_text_platform_ParagraphBuilder_Op_StyleAdd$stable;
  var androidx_compose_ui_text_platform_ParagraphBuilder_Op_PutPlaceholder$stable;
  var androidx_compose_ui_text_platform_ParagraphBuilder_Op_EndPlaceholder$stable;
  var androidx_compose_ui_text_platform_ParagraphBuilder_Cut_StyleAdd$stable;
  var androidx_compose_ui_text_platform_ParagraphBuilder_Cut_StyleRemove$stable;
  var androidx_compose_ui_text_platform_ParagraphBuilder_Cut_PutPlaceholder$stable;
  var androidx_compose_ui_text_platform_ParagraphBuilder_Cut_EndPlaceholder$stable;
  var androidx_compose_ui_text_platform_ParagraphBuilder$stable;
  function Immutable_0(textForegroundStyle, brushSize, fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, fontRasterizationSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, textDecorationLineStyle, shadow, drawStyle, blendMode, lineHeight, topRatio) {
    textForegroundStyle = textForegroundStyle === VOID ? Unspecified_instance : textForegroundStyle;
    brushSize = brushSize === VOID ? Companion_getInstance_7().k5e_1 : brushSize;
    fontSize = fontSize === VOID ? NaN : fontSize;
    fontWeight = fontWeight === VOID ? null : fontWeight;
    fontStyle = fontStyle === VOID ? null : fontStyle;
    fontSynthesis = fontSynthesis === VOID ? null : fontSynthesis;
    fontFamily = fontFamily === VOID ? null : fontFamily;
    fontFeatureSettings = fontFeatureSettings === VOID ? null : fontFeatureSettings;
    fontRasterizationSettings = fontRasterizationSettings === VOID ? Companion_getInstance_51().z8f() : fontRasterizationSettings;
    letterSpacing = letterSpacing === VOID ? null : letterSpacing;
    baselineShift = baselineShift === VOID ? null : baselineShift;
    textGeometricTransform = textGeometricTransform === VOID ? null : textGeometricTransform;
    localeList = localeList === VOID ? null : localeList;
    background = background === VOID ? Companion_getInstance().u6b_1 : background;
    textDecoration = textDecoration === VOID ? null : textDecoration;
    textDecorationLineStyle = textDecorationLineStyle === VOID ? null : textDecorationLineStyle;
    shadow = shadow === VOID ? null : shadow;
    drawStyle = drawStyle === VOID ? null : drawStyle;
    blendMode = blendMode === VOID ? Companion_getInstance_0().x6h_1 : blendMode;
    lineHeight = lineHeight === VOID ? null : lineHeight;
    topRatio = topRatio === VOID ? -1.0 : topRatio;
    this.e8i_1 = textForegroundStyle;
    this.f8i_1 = brushSize;
    this.g8i_1 = fontSize;
    this.h8i_1 = fontWeight;
    this.i8i_1 = fontStyle;
    this.j8i_1 = fontSynthesis;
    this.k8i_1 = fontFamily;
    this.l8i_1 = fontFeatureSettings;
    this.m8i_1 = fontRasterizationSettings;
    this.n8i_1 = letterSpacing;
    this.o8i_1 = baselineShift;
    this.p8i_1 = textGeometricTransform;
    this.q8i_1 = localeList;
    this.r8i_1 = background;
    this.s8i_1 = textDecoration;
    this.t8i_1 = textDecorationLineStyle;
    this.u8i_1 = shadow;
    this.v8i_1 = drawStyle;
    this.w8i_1 = blendMode;
    this.x8i_1 = lineHeight;
    this.y8i_1 = topRatio;
    this.z8i_1 = new SkiaTextPaint();
  }
  protoOf(Immutable_0).f82 = function () {
    return this.h8i_1;
  };
  protoOf(Immutable_0).g82 = function () {
    return this.i8i_1;
  };
  protoOf(Immutable_0).h82 = function () {
    return this.j8i_1;
  };
  protoOf(Immutable_0).i82 = function () {
    return this.k8i_1;
  };
  protoOf(Immutable_0).a8j = function () {
    var paint = this.z8i_1.f8j();
    paint.v5q();
    this.z8i_1.f6b(this.e8i_1.s6c());
    this.z8i_1.o8h(this.e8i_1.f7y(), this.f8i_1, this.e8i_1.j68());
    this.z8i_1.m8h(this.v8i_1);
    this.z8i_1.b6p(this.w8i_1);
    return paint;
  };
  protoOf(Immutable_0).g8j = function (fontFamilyResolver) {
    var res = TextStyle_init_$Create$();
    // Inline function 'androidx.compose.ui.graphics.isSpecified' call
    var this_0 = this.e8i_1.s6c();
    if (!equals(_Color___get_value__impl__1pls5m(this_0), _ULong___init__impl__c78o9k(new Long(16, 0)))) {
      res.z5q(toArgb(this.e8i_1.s6c()));
    }
    var foreground = this.a8j();
    if (!(foreground.k5r() == null) || !foreground.y5q().equals(PaintMode_FILL_getInstance()) || !foreground.o5r()) {
      res.f64(foreground);
    }
    var tmp0_safe_receiver = this.i8i_1;
    var tmp = tmp0_safe_receiver;
    if ((tmp == null ? null : new FontStyle(tmp)) == null)
      null;
    else {
      var tmp_0 = tmp0_safe_receiver;
      // Inline function 'kotlin.let' call
      var it = (tmp_0 == null ? null : new FontStyle(tmp_0)).d7x_1;
      res.l64(toSkFontStyle(it));
    }
    // Inline function 'kotlin.takeUnless' call
    var this_1 = this.s8i_1;
    var tmp_1;
    if (!equals(this_1, Companion_getInstance_44().a80_1)) {
      tmp_1 = this_1;
    } else {
      tmp_1 = null;
    }
    var tmp1_safe_receiver = tmp_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      res.j64(toSkDecorationStyle(tmp1_safe_receiver, this.e8i_1.s6c(), this.t8i_1));
    }
    if (!equals(this.r8i_1, Companion_getInstance().u6b_1)) {
      // Inline function 'kotlin.also' call
      var this_2 = Paint_init_$Create$();
      this_2.z5q(toArgb(this.r8i_1));
      res.h64(this_2);
    }
    var tmp2_safe_receiver = this.h8i_1;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      res.l64(res.c5v().h5p(tmp2_safe_receiver.p7x_1));
    }
    // Inline function 'kotlin.takeUnless' call
    var this_3 = this.u8i_1;
    var tmp_2;
    if (!equals(this_3, Companion_getInstance_2().m6j_1)) {
      tmp_2 = this_3;
    } else {
      tmp_2 = null;
    }
    var tmp3_safe_receiver = tmp_2;
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      res.n64(toSkShadow(tmp3_safe_receiver));
    }
    var tmp4_safe_receiver = this.n8i_1;
    if (tmp4_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      res.y64(tmp4_safe_receiver);
    }
    var tmp_3 = Companion_getInstance_8();
    // Inline function 'kotlin.text.orEmpty' call
    var tmp0_elvis_lhs = this.l8i_1;
    var tmp$ret$17 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    res.p64(tmp_3.x5n(tmp$ret$17));
    res.f65(toSkFontEdging(this.m8i_1.a8g_1));
    res.h65(toSkFontHinting(this.m8i_1.b8g_1));
    res.g65(this.m8i_1.c8g_1);
    res.q64(this.g8i_1);
    var tmp5_safe_receiver = this.k8i_1;
    if (tmp5_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp0_elvis_lhs_0 = this.h8i_1;
      var tmp_4 = tmp0_elvis_lhs_0 == null ? Companion_getInstance_26().b7z_1 : tmp0_elvis_lhs_0;
      var tmp1_elvis_lhs = this.i8i_1;
      var tmp_5;
      var tmp_6 = tmp1_elvis_lhs;
      if ((tmp_6 == null ? null : new FontStyle(tmp_6)) == null) {
        tmp_5 = Companion_getInstance_24().k7z_1;
      } else {
        tmp_5 = tmp1_elvis_lhs;
      }
      var tmp_7 = tmp_5;
      var tmp2_elvis_lhs = this.j8i_1;
      var tmp_8;
      var tmp_9 = tmp2_elvis_lhs;
      if ((tmp_9 == null ? null : new FontSynthesis(tmp_9)) == null) {
        tmp_8 = Companion_getInstance_25().m7z_1;
      } else {
        tmp_8 = tmp2_elvis_lhs;
      }
      var tmp_10 = fontFamilyResolver.r84(tmp5_safe_receiver, tmp_4, tmp_7, tmp_8).u1();
      var resolved = tmp_10 instanceof FontLoadResult ? tmp_10 : THROW_CCE();
      // Inline function 'kotlin.collections.toTypedArray' call
      var this_4 = resolved.i8j_1;
      var tmp$ret$20 = copyToArray(this_4);
      res.s64(tmp$ret$20);
      res.c65(resolved.h8j_1);
    }
    var tmp6_safe_receiver = this.o8i_1;
    var tmp_11 = tmp6_safe_receiver;
    if ((tmp_11 == null ? null : new BaselineShift(tmp_11)) == null)
      null;
    else {
      var tmp_12 = tmp6_safe_receiver;
      // Inline function 'kotlin.let' call
      var it_0 = (tmp_12 == null ? null : new BaselineShift(tmp_12)).f7x_1;
      var fontMetrics = res.e65();
      res.a65(_BaselineShift___get_multiplier__impl__qhmjek(it_0) * fontMetrics.f5o_1);
    }
    var tmp7_safe_receiver = this.x8i_1;
    if (tmp7_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      res.u64(tmp7_safe_receiver / this.g8i_1);
    }
    res.w64(this.y8i_1);
    return res;
  };
  protoOf(Immutable_0).j8j = function () {
    return new Mutable(this.e8i_1, this.f8i_1, this.g8i_1, this.h8i_1, this.i8i_1, this.j8i_1, this.k8i_1, this.l8i_1, this.m8i_1, this.n8i_1, this.o8i_1, this.p8i_1, this.q8i_1, this.r8i_1, this.s8i_1, this.t8i_1, this.u8i_1, this.v8i_1, this.w8i_1, this.x8i_1, this.y8i_1);
  };
  protoOf(Immutable_0).toString = function () {
    var tmp = toString_0(this.e8i_1);
    var tmp_0 = Size__toString_impl_o87ni8(this.f8i_1);
    var tmp_1 = toString(this.h8i_1);
    var tmp_2 = this.i8i_1;
    var tmp_3 = toString(tmp_2 == null ? null : new FontStyle(tmp_2));
    var tmp_4 = this.j8i_1;
    var tmp_5 = toString(tmp_4 == null ? null : new FontSynthesis(tmp_4));
    var tmp_6 = toString(this.k8i_1);
    var tmp_7 = this.m8i_1.toString();
    var tmp_8 = this.o8i_1;
    var tmp_9 = toString(tmp_8 == null ? null : new BaselineShift(tmp_8));
    var tmp_10 = toString(this.p8i_1);
    var tmp_11 = toString(this.q8i_1);
    var tmp_12 = Color__toString_impl_hpzmaq(this.r8i_1);
    var tmp_13 = toString(this.s8i_1);
    var tmp_14 = this.t8i_1;
    return 'Immutable(textForegroundStyle=' + tmp + ', brushSize=' + tmp_0 + ', fontSize=' + this.g8i_1 + ', fontWeight=' + tmp_1 + ', fontStyle=' + tmp_3 + ', fontSynthesis=' + tmp_5 + ', fontFamily=' + tmp_6 + ', fontFeatureSettings=' + this.l8i_1 + ', fontRasterizationSettings=' + tmp_7 + ', letterSpacing=' + this.n8i_1 + ', baselineShift=' + tmp_9 + ', textGeometricTransform=' + tmp_10 + ', localeList=' + tmp_11 + ', background=' + tmp_12 + ', textDecoration=' + tmp_13 + ', textDecorationLineStyle=' + toString(tmp_14 == null ? null : new TextDecorationLineStyle(tmp_14)) + ', shadow=' + toString(this.u8i_1) + ', drawStyle=' + toString(this.v8i_1) + ', blendMode=' + BlendMode__toString_impl_uuibkd(this.w8i_1) + ', lineHeight=' + this.x8i_1 + ', topRatio=' + this.y8i_1 + ')';
  };
  protoOf(Immutable_0).hashCode = function () {
    var result = hashCode(this.e8i_1);
    result = imul(result, 31) + Size__hashCode_impl_2h1qpd(this.f8i_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.g8i_1) | 0;
    result = imul(result, 31) + (this.h8i_1 == null ? 0 : this.h8i_1.hashCode()) | 0;
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this.i8i_1;
    if ((tmp_1 == null ? null : new FontStyle(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      tmp_0 = FontStyle__hashCode_impl_7qhg4w(this.i8i_1);
    }
    result = tmp + tmp_0 | 0;
    var tmp_2 = imul(result, 31);
    var tmp_3;
    var tmp_4 = this.j8i_1;
    if ((tmp_4 == null ? null : new FontSynthesis(tmp_4)) == null) {
      tmp_3 = 0;
    } else {
      tmp_3 = FontSynthesis__hashCode_impl_4wi11v(this.j8i_1);
    }
    result = tmp_2 + tmp_3 | 0;
    result = imul(result, 31) + (this.k8i_1 == null ? 0 : hashCode(this.k8i_1)) | 0;
    result = imul(result, 31) + (this.l8i_1 == null ? 0 : getStringHashCode(this.l8i_1)) | 0;
    result = imul(result, 31) + this.m8i_1.hashCode() | 0;
    result = imul(result, 31) + (this.n8i_1 == null ? 0 : getNumberHashCode(this.n8i_1)) | 0;
    var tmp_5 = imul(result, 31);
    var tmp_6;
    var tmp_7 = this.o8i_1;
    if ((tmp_7 == null ? null : new BaselineShift(tmp_7)) == null) {
      tmp_6 = 0;
    } else {
      tmp_6 = BaselineShift__hashCode_impl_g0potx(this.o8i_1);
    }
    result = tmp_5 + tmp_6 | 0;
    result = imul(result, 31) + (this.p8i_1 == null ? 0 : this.p8i_1.hashCode()) | 0;
    result = imul(result, 31) + (this.q8i_1 == null ? 0 : this.q8i_1.hashCode()) | 0;
    result = imul(result, 31) + Color__hashCode_impl_vjyivj(this.r8i_1) | 0;
    result = imul(result, 31) + (this.s8i_1 == null ? 0 : this.s8i_1.hashCode()) | 0;
    var tmp_8 = imul(result, 31);
    var tmp_9;
    var tmp_10 = this.t8i_1;
    if ((tmp_10 == null ? null : new TextDecorationLineStyle(tmp_10)) == null) {
      tmp_9 = 0;
    } else {
      tmp_9 = TextDecorationLineStyle__hashCode_impl_8ntype(this.t8i_1);
    }
    result = tmp_8 + tmp_9 | 0;
    result = imul(result, 31) + (this.u8i_1 == null ? 0 : this.u8i_1.hashCode()) | 0;
    result = imul(result, 31) + (this.v8i_1 == null ? 0 : hashCode(this.v8i_1)) | 0;
    result = imul(result, 31) + BlendMode__hashCode_impl_93ceri(this.w8i_1) | 0;
    result = imul(result, 31) + (this.x8i_1 == null ? 0 : getNumberHashCode(this.x8i_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.y8i_1) | 0;
    return result;
  };
  protoOf(Immutable_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Immutable_0))
      return false;
    if (!equals(this.e8i_1, other.e8i_1))
      return false;
    if (!equals(this.f8i_1, other.f8i_1))
      return false;
    if (!equals(this.g8i_1, other.g8i_1))
      return false;
    if (!equals(this.h8i_1, other.h8i_1))
      return false;
    var tmp = this.i8i_1;
    var tmp_0 = tmp == null ? null : new FontStyle(tmp);
    var tmp_1 = other.i8i_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new FontStyle(tmp_1)))
      return false;
    var tmp_2 = this.j8i_1;
    var tmp_3 = tmp_2 == null ? null : new FontSynthesis(tmp_2);
    var tmp_4 = other.j8i_1;
    if (!equals(tmp_3, tmp_4 == null ? null : new FontSynthesis(tmp_4)))
      return false;
    if (!equals(this.k8i_1, other.k8i_1))
      return false;
    if (!(this.l8i_1 == other.l8i_1))
      return false;
    if (!this.m8i_1.equals(other.m8i_1))
      return false;
    if (!equals(this.n8i_1, other.n8i_1))
      return false;
    var tmp_5 = this.o8i_1;
    var tmp_6 = tmp_5 == null ? null : new BaselineShift(tmp_5);
    var tmp_7 = other.o8i_1;
    if (!equals(tmp_6, tmp_7 == null ? null : new BaselineShift(tmp_7)))
      return false;
    if (!equals(this.p8i_1, other.p8i_1))
      return false;
    if (!equals(this.q8i_1, other.q8i_1))
      return false;
    if (!equals(this.r8i_1, other.r8i_1))
      return false;
    if (!equals(this.s8i_1, other.s8i_1))
      return false;
    var tmp_8 = this.t8i_1;
    var tmp_9 = tmp_8 == null ? null : new TextDecorationLineStyle(tmp_8);
    var tmp_10 = other.t8i_1;
    if (!equals(tmp_9, tmp_10 == null ? null : new TextDecorationLineStyle(tmp_10)))
      return false;
    if (!equals(this.u8i_1, other.u8i_1))
      return false;
    if (!equals(this.v8i_1, other.v8i_1))
      return false;
    if (!(this.w8i_1 === other.w8i_1))
      return false;
    if (!equals(this.x8i_1, other.x8i_1))
      return false;
    if (!equals(this.y8i_1, other.y8i_1))
      return false;
    return true;
  };
  function Mutable(textForegroundStyle, brushSize, fontSize, fontWeight, fontStyle, fontSynthesis, fontFamily, fontFeatureSettings, fontRasterizationSettings, letterSpacing, baselineShift, textGeometricTransform, localeList, background, textDecoration, textDecorationLineStyle, shadow, drawStyle, blendMode, lineHeight, topRatio) {
    fontRasterizationSettings = fontRasterizationSettings === VOID ? Companion_getInstance_51().z8f() : fontRasterizationSettings;
    this.k8j_1 = textForegroundStyle;
    this.l8j_1 = brushSize;
    this.m8j_1 = fontSize;
    this.n8j_1 = fontWeight;
    this.o8j_1 = fontStyle;
    this.p8j_1 = fontSynthesis;
    this.q8j_1 = fontFamily;
    this.r8j_1 = fontFeatureSettings;
    this.s8j_1 = fontRasterizationSettings;
    this.t8j_1 = letterSpacing;
    this.u8j_1 = baselineShift;
    this.v8j_1 = textGeometricTransform;
    this.w8j_1 = localeList;
    this.x8j_1 = background;
    this.y8j_1 = textDecoration;
    this.z8j_1 = textDecorationLineStyle;
    this.a8k_1 = shadow;
    this.b8k_1 = drawStyle;
    this.c8k_1 = blendMode;
    this.d8k_1 = lineHeight;
    this.e8k_1 = topRatio;
  }
  protoOf(Mutable).f82 = function () {
    return this.n8j_1;
  };
  protoOf(Mutable).g82 = function () {
    return this.o8j_1;
  };
  protoOf(Mutable).h82 = function () {
    return this.p8j_1;
  };
  protoOf(Mutable).i82 = function () {
    return this.q8j_1;
  };
  protoOf(Mutable).f8k = function (density, other) {
    var fontSize = toPx(other.o7w_1, density, this.m8j_1);
    this.k8j_1 = this.k8j_1.m7y(other.n7w_1);
    var tmp0_safe_receiver = other.s7w_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.q8j_1 = tmp0_safe_receiver;
    }
    this.m8j_1 = fontSize;
    var tmp1_safe_receiver = other.p7w_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.n8j_1 = tmp1_safe_receiver;
    }
    var tmp2_safe_receiver = other.q7w_1;
    var tmp = tmp2_safe_receiver;
    if ((tmp == null ? null : new FontStyle(tmp)) == null)
      null;
    else {
      var tmp_0 = tmp2_safe_receiver;
      // Inline function 'kotlin.let' call
      this.o8j_1 = (tmp_0 == null ? null : new FontStyle(tmp_0)).d7x_1;
    }
    var tmp3_safe_receiver = other.r7w_1;
    var tmp_1 = tmp3_safe_receiver;
    if ((tmp_1 == null ? null : new FontSynthesis(tmp_1)) == null)
      null;
    else {
      var tmp_2 = tmp3_safe_receiver;
      // Inline function 'kotlin.let' call
      this.p8j_1 = (tmp_2 == null ? null : new FontSynthesis(tmp_2)).e7x_1;
    }
    var tmp4_safe_receiver = other.t7w_1;
    if (tmp4_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.r8j_1 = tmp4_safe_receiver;
    }
    // Inline function 'androidx.compose.ui.unit.isUnspecified' call
    var this_0 = other.u7w_1;
    if (!equalsLong(_TextUnit___get_rawType__impl__tu8yq5(this_0), new Long(0, 0))) {
      this.t8j_1 = toPx(other.u7w_1, density, fontSize);
    }
    var tmp5_safe_receiver = other.v7w_1;
    var tmp_3 = tmp5_safe_receiver;
    if ((tmp_3 == null ? null : new BaselineShift(tmp_3)) == null)
      null;
    else {
      var tmp_4 = tmp5_safe_receiver;
      // Inline function 'kotlin.let' call
      this.u8j_1 = (tmp_4 == null ? null : new BaselineShift(tmp_4)).f7x_1;
    }
    var tmp6_safe_receiver = other.w7w_1;
    if (tmp6_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.v8j_1 = tmp6_safe_receiver;
    }
    var tmp7_safe_receiver = other.x7w_1;
    if (tmp7_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.w8j_1 = tmp7_safe_receiver;
    }
    // Inline function 'androidx.compose.ui.graphics.isSpecified' call
    var this_1 = other.y7w_1;
    if (!equals(_Color___get_value__impl__1pls5m(this_1), _ULong___init__impl__c78o9k(new Long(16, 0)))) {
      this.x8j_1 = other.y7w_1;
    }
    var tmp8_safe_receiver = other.z7w_1;
    if (tmp8_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.y8j_1 = tmp8_safe_receiver;
    }
    var tmp9_safe_receiver = other.a7x_1;
    if (tmp9_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.a8k_1 = tmp9_safe_receiver;
    }
    var tmp10_safe_receiver = other.c7x_1;
    if (tmp10_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.b8k_1 = tmp10_safe_receiver;
    }
    var tmp11_safe_receiver = other.b7x_1;
    if (tmp11_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = tmp11_safe_receiver.n7y_1;
      var tmp_5;
      var tmp_6 = tmp0_safe_receiver_0;
      if ((tmp_6 == null ? null : new TextDecorationLineStyle(tmp_6)) == null) {
        tmp_5 = null;
      } else {
        var tmp_7 = tmp0_safe_receiver_0;
        // Inline function 'kotlin.let' call
        this.z8j_1 = (tmp_7 == null ? null : new TextDecorationLineStyle(tmp_7)).u8h_1;
        tmp_5 = Unit_instance;
      }
    }
  };
  protoOf(Mutable).g8k = function () {
    return new Immutable_0(this.k8j_1, this.l8j_1, this.m8j_1, this.n8j_1, this.o8j_1, this.p8j_1, this.q8j_1, this.r8j_1, this.s8j_1, this.t8j_1, this.u8j_1, this.v8j_1, this.w8j_1, this.x8j_1, this.y8j_1, this.z8j_1, this.a8k_1, this.b8k_1, this.c8k_1, this.d8k_1, this.e8k_1);
  };
  function toSkFontStyle(_this__u8e3s4) {
    _init_properties_ParagraphBuilder_skiko_kt__fblzyk();
    return _this__u8e3s4 === Companion_getInstance_24().l7z_1 ? Companion_getInstance_9().e5p_1 : Companion_getInstance_9().c5p_1;
  }
  function toSkDecorationStyle(_this__u8e3s4, color, textDecorationLineStyle) {
    _init_properties_ParagraphBuilder_skiko_kt__fblzyk();
    var underline = _this__u8e3s4.l8e(Companion_getInstance_44().b80_1);
    var overline = false;
    var lineThrough = _this__u8e3s4.l8e(Companion_getInstance_44().c80_1);
    var gaps = false;
    var tmp;
    var tmp_0 = textDecorationLineStyle;
    if ((tmp_0 == null ? null : new TextDecorationLineStyle(tmp_0)) == null) {
      tmp = null;
    } else {
      tmp = toSkDecorationLineStyle(textDecorationLineStyle);
    }
    var tmp1_elvis_lhs = tmp;
    var lineStyle = tmp1_elvis_lhs == null ? DecorationLineStyle_SOLID_getInstance() : tmp1_elvis_lhs;
    var thicknessMultiplier = 1.0;
    return new DecorationStyle(underline, overline, lineThrough, gaps, toArgb(color), lineStyle, thicknessMultiplier);
  }
  function toSkShadow(_this__u8e3s4) {
    _init_properties_ParagraphBuilder_skiko_kt__fblzyk();
    var tmp = toArgb(_this__u8e3s4.n6j_1);
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    var this_0 = _this__u8e3s4.o6j_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(this_0);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp_0 = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    var this_1 = _this__u8e3s4.o6j_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(this_1);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var tmp$ret$4 = floatFromBits(bits_0);
    return new Shadow_0(tmp, tmp_0, tmp$ret$4, _this__u8e3s4.p6j_1);
  }
  function toPx(_this__u8e3s4, density, fontSize) {
    _init_properties_ParagraphBuilder_skiko_kt__fblzyk();
    var tmp;
    // Inline function 'androidx.compose.ui.unit.isUnspecified' call
    if (equalsLong(_TextUnit___get_rawType__impl__tu8yq5(_this__u8e3s4), new Long(0, 0))) {
      tmp = fontSize;
    } else {
      if (_TextUnit___get_isEm__impl__esrmtl(_this__u8e3s4)) {
        tmp = fontSize * _TextUnit___get_value__impl__hpbx0k(_this__u8e3s4);
      } else {
        if (_TextUnit___get_isSp__impl__8c3r6q(_this__u8e3s4)) {
          // Inline function 'kotlin.with' call
          tmp = density.x5e(_this__u8e3s4);
        } else {
          // Inline function 'kotlin.error' call
          var message = 'Unexpected size in TextUnit.toPx';
          throw IllegalStateException_init_$Create$_0(toString_0(message));
        }
      }
    }
    return tmp;
  }
  function toSkDecorationLineStyle(_this__u8e3s4) {
    _init_properties_ParagraphBuilder_skiko_kt__fblzyk();
    return _this__u8e3s4 === Companion_getInstance_52().p8h_1 ? DecorationLineStyle_SOLID_getInstance() : _this__u8e3s4 === Companion_getInstance_52().q8h_1 ? DecorationLineStyle_DOUBLE_getInstance() : _this__u8e3s4 === Companion_getInstance_52().r8h_1 ? DecorationLineStyle_DOTTED_getInstance() : _this__u8e3s4 === Companion_getInstance_52().s8h_1 ? DecorationLineStyle_DASHED_getInstance() : _this__u8e3s4 === Companion_getInstance_52().t8h_1 ? DecorationLineStyle_WAVY_getInstance() : DecorationLineStyle_SOLID_getInstance();
  }
  function cursorHorizontalPosition(_this__u8e3s4, opposite) {
    opposite = opposite === VOID ? false : opposite;
    _init_properties_ParagraphBuilder_skiko_kt__fblzyk();
    var tmp;
    switch (_this__u8e3s4.a64().a1_1) {
      case 1:
        tmp = opposite ? _this__u8e3s4.y63_1.k5k_1 : _this__u8e3s4.y63_1.m5k_1;
        break;
      case 0:
        tmp = opposite ? _this__u8e3s4.y63_1.m5k_1 : _this__u8e3s4.y63_1.k5k_1;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function ParagraphBuilder$Cut$PutPlaceholder$_get_position_$ref_jq6gk8(p0) {
    return constructCallableReference(function () {
      return p0.h8k_1;
    }, 0, 0, 38, VOID, [p0]);
  }
  function ParagraphBuilder$Op$PutPlaceholder$_get_position_$ref_n2s1fp() {
    return constructCallableReference(function (p0) {
      return p0.n8k();
    }, 1, 0, 39);
  }
  function ParagraphBuilder$Cut$EndPlaceholder$_get_position_$ref_bdxpek(p0) {
    return constructCallableReference(function () {
      return p0.o8k_1;
    }, 0, 0, 40, VOID, [p0]);
  }
  function ParagraphBuilder$Op$EndPlaceholder$_get_position_$ref_81c4j3() {
    return constructCallableReference(function (p0) {
      return p0.n8k();
    }, 1, 0, 41);
  }
  function StyleAdd(position, style) {
    Op.call(this);
    this.r8k_1 = position;
    this.s8k_1 = style;
  }
  protoOf(StyleAdd).n8k = function () {
    return this.r8k_1;
  };
  protoOf(StyleAdd).toString = function () {
    return 'StyleAdd(position=' + this.r8k_1 + ', style=' + toString_0(this.s8k_1) + ')';
  };
  protoOf(StyleAdd).hashCode = function () {
    var result = this.r8k_1;
    result = imul(result, 31) + hashCode(this.s8k_1) | 0;
    return result;
  };
  protoOf(StyleAdd).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof StyleAdd))
      return false;
    if (!(this.r8k_1 === other.r8k_1))
      return false;
    if (!equals(this.s8k_1, other.s8k_1))
      return false;
    return true;
  };
  function PutPlaceholder(cut, width, height) {
    Op.call(this);
    this.j8k_1 = cut;
    this.k8k_1 = width;
    this.l8k_1 = height;
    var tmp = this;
    var tmp_0 = KProperty0;
    tmp.m8k_1 = getPropertyCallableRef('position', 0, tmp_0, ParagraphBuilder$Cut$PutPlaceholder$_get_position_$ref_jq6gk8(this.j8k_1), null);
  }
  protoOf(PutPlaceholder).n8k = function () {
    var tmp0 = this.m8k_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('position', 1, tmp, ParagraphBuilder$Op$PutPlaceholder$_get_position_$ref_n2s1fp(), null);
    return tmp0.get();
  };
  protoOf(PutPlaceholder).toString = function () {
    return 'PutPlaceholder(cut=' + this.j8k_1.toString() + ', width=' + this.k8k_1 + ', height=' + this.l8k_1 + ')';
  };
  protoOf(PutPlaceholder).hashCode = function () {
    var result = this.j8k_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.k8k_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.l8k_1) | 0;
    return result;
  };
  protoOf(PutPlaceholder).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PutPlaceholder))
      return false;
    if (!this.j8k_1.equals(other.j8k_1))
      return false;
    if (!equals(this.k8k_1, other.k8k_1))
      return false;
    if (!equals(this.l8k_1, other.l8k_1))
      return false;
    return true;
  };
  function EndPlaceholder(cut) {
    Op.call(this);
    this.p8k_1 = cut;
    var tmp = this;
    var tmp_0 = KProperty0;
    tmp.q8k_1 = getPropertyCallableRef('position', 0, tmp_0, ParagraphBuilder$Cut$EndPlaceholder$_get_position_$ref_bdxpek(this.p8k_1), null);
  }
  protoOf(EndPlaceholder).n8k = function () {
    var tmp0 = this.q8k_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('position', 1, tmp, ParagraphBuilder$Op$EndPlaceholder$_get_position_$ref_81c4j3(), null);
    return tmp0.get();
  };
  protoOf(EndPlaceholder).toString = function () {
    return 'EndPlaceholder(cut=' + this.p8k_1.toString() + ')';
  };
  protoOf(EndPlaceholder).hashCode = function () {
    return this.p8k_1.hashCode();
  };
  protoOf(EndPlaceholder).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EndPlaceholder))
      return false;
    if (!this.p8k_1.equals(other.p8k_1))
      return false;
    return true;
  };
  function StyleAdd_0(position, style) {
    Cut.call(this);
    this.t8k_1 = position;
    this.u8k_1 = style;
  }
  protoOf(StyleAdd_0).n8k = function () {
    return this.t8k_1;
  };
  protoOf(StyleAdd_0).toString = function () {
    return 'StyleAdd(position=' + this.t8k_1 + ', style=' + this.u8k_1.toString() + ')';
  };
  protoOf(StyleAdd_0).hashCode = function () {
    var result = this.t8k_1;
    result = imul(result, 31) + this.u8k_1.hashCode() | 0;
    return result;
  };
  protoOf(StyleAdd_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof StyleAdd_0))
      return false;
    if (!(this.t8k_1 === other.t8k_1))
      return false;
    if (!this.u8k_1.equals(other.u8k_1))
      return false;
    return true;
  };
  function StyleRemove(position, style) {
    Cut.call(this);
    this.v8k_1 = position;
    this.w8k_1 = style;
  }
  protoOf(StyleRemove).n8k = function () {
    return this.v8k_1;
  };
  protoOf(StyleRemove).toString = function () {
    return 'StyleRemove(position=' + this.v8k_1 + ', style=' + this.w8k_1.toString() + ')';
  };
  protoOf(StyleRemove).hashCode = function () {
    var result = this.v8k_1;
    result = imul(result, 31) + this.w8k_1.hashCode() | 0;
    return result;
  };
  protoOf(StyleRemove).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof StyleRemove))
      return false;
    if (!(this.v8k_1 === other.v8k_1))
      return false;
    if (!this.w8k_1.equals(other.w8k_1))
      return false;
    return true;
  };
  function PutPlaceholder_0(position, placeholder) {
    Cut.call(this);
    this.h8k_1 = position;
    this.i8k_1 = placeholder;
  }
  protoOf(PutPlaceholder_0).n8k = function () {
    return this.h8k_1;
  };
  protoOf(PutPlaceholder_0).toString = function () {
    return 'PutPlaceholder(position=' + this.h8k_1 + ', placeholder=' + this.i8k_1.toString() + ')';
  };
  protoOf(PutPlaceholder_0).hashCode = function () {
    var result = this.h8k_1;
    result = imul(result, 31) + this.i8k_1.hashCode() | 0;
    return result;
  };
  protoOf(PutPlaceholder_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PutPlaceholder_0))
      return false;
    if (!(this.h8k_1 === other.h8k_1))
      return false;
    if (!this.i8k_1.equals(other.i8k_1))
      return false;
    return true;
  };
  function EndPlaceholder_0(position) {
    Cut.call(this);
    this.o8k_1 = position;
  }
  protoOf(EndPlaceholder_0).n8k = function () {
    return this.o8k_1;
  };
  protoOf(EndPlaceholder_0).toString = function () {
    return 'EndPlaceholder(position=' + this.o8k_1 + ')';
  };
  protoOf(EndPlaceholder_0).hashCode = function () {
    return this.o8k_1;
  };
  protoOf(EndPlaceholder_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EndPlaceholder_0))
      return false;
    if (!(this.o8k_1 === other.o8k_1))
      return false;
    return true;
  };
  function _get_initialStyle__6to25e($this) {
    var tmp = $this.k8l_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('initialStyle');
    }
  }
  function _get_ops__e6e97j($this) {
    var tmp = $this.l8l_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('ops');
    }
  }
  function prepareDefaultStyle($this) {
    $this.k8l_1 = copyWithDefaultFontSize($this.z8k_1.w81(), $this.h8l_1);
    $this.j8l_1 = ComputedStyle($this.f8l_1, _get_initialStyle__6to25e($this), $this.z8k_1.w7u_1.h7r_1, $this.a8l_1, $this.i8l_1, $this.z8k_1.r82(), $this.z8k_1.t82()).g8k();
  }
  function Op() {
  }
  function Cut() {
  }
  function makeOps($this, annotations, placeholders) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var cuts = ArrayList_init_$Create$();
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = annotations.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = annotations.l1(index);
        $l$block: {
          var tmp = item.m7p_1;
          if (!(tmp instanceof SpanStyle)) {
            break $l$block;
          }
          cuts.j1(new StyleAdd_0(item.n7p_1, item.m7p_1));
          cuts.j1(new StyleRemove(item.o7p_1, item.m7p_1));
        }
      }
       while (inductionVariable <= last);
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable_0 = 0;
    var last_0 = placeholders.n1() - 1 | 0;
    if (inductionVariable_0 <= last_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var item_0 = placeholders.l1(index_0);
        cuts.j1(new PutPlaceholder_0(item_0.n7p_1, item_0.m7p_1));
        cuts.j1(new EndPlaceholder_0(item_0.o7p_1));
      }
       while (inductionVariable_0 <= last_0);
    var ops = mutableListOf([new StyleAdd(0, $this.j8l_1.j8j())]);
    // Inline function 'kotlin.collections.sortBy' call
    if (cuts.n1() > 1) {
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp_0 = ParagraphBuilder$makeOps$lambda;
      var tmp$ret$6 = new sam$kotlin_Comparator$0_1(tmp_0);
      sortWith(cuts, tmp$ret$6);
    }
    var activeStyles = mutableListOf([_get_initialStyle__6to25e($this)]);
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable_1 = 0;
    var last_1 = cuts.n1() - 1 | 0;
    if (inductionVariable_1 <= last_1)
      do {
        var index_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var item_1 = cuts.l1(index_1);
        if (item_1 instanceof StyleAdd_0) {
          activeStyles.j1(item_1.u8k_1);
          var prev = previousStyleAddAtTheSamePosition($this, item_1.t8k_1, ops);
          if (prev == null) {
            // Inline function 'kotlin.also' call
            var this_0 = mergeStyles($this, activeStyles);
            this_0.f8k($this.f8l_1, item_1.u8k_1);
            ops.j1(new StyleAdd(item_1.t8k_1, this_0));
          } else {
            var tmp_1 = prev.s8k_1;
            var style = tmp_1 instanceof Mutable ? tmp_1 : THROW_CCE();
            style.f8k($this.f8l_1, item_1.u8k_1);
          }
        } else {
          if (item_1 instanceof StyleRemove) {
            activeStyles.d3(item_1.w8k_1);
            ops.j1(new StyleAdd(item_1.v8k_1, mergeStyles($this, activeStyles)));
          } else {
            if (item_1 instanceof PutPlaceholder_0) {
              var currentStyle = mergeStyles($this, activeStyles);
              var op = new PutPlaceholder(item_1, toPx(item_1.i8k_1.a7w_1, $this.f8l_1, currentStyle.m8j_1), toPx(item_1.i8k_1.b7w_1, $this.f8l_1, currentStyle.m8j_1));
              ops.j1(op);
            } else {
              if (item_1 instanceof EndPlaceholder_0)
                ops.j1(new EndPlaceholder(item_1));
              else {
                noWhenBranchMatchedException();
              }
            }
          }
        }
      }
       while (inductionVariable_1 <= last_1);
    return ops;
  }
  function mergeStyles($this, activeStyles) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.check' call
    if (!!activeStyles.r()) {
      var message = 'There should be at least one active style';
      throw IllegalStateException_init_$Create$_0(toString_0(message));
    }
    var style = ComputedStyle($this.f8l_1, activeStyles.l1(0), $this.z8k_1.w7u_1.h7r_1, $this.a8l_1, $this.i8l_1, $this.z8k_1.r82(), $this.z8k_1.t82());
    var inductionVariable = 1;
    var last = activeStyles.n1();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        style.f8k($this.f8l_1, activeStyles.l1(i));
      }
       while (inductionVariable < last);
    return style;
  }
  function previousStyleAddAtTheSamePosition($this, position, ops) {
    // Inline function 'androidx.compose.ui.util.fastForEachReversed' call
    var inductionVariable = ops.n1() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var item = ops.l1(index);
        if (item.n8k() < position)
          return null;
        if (item instanceof StyleAdd)
          return item;
      }
       while (0 <= inductionVariable);
    return null;
  }
  function textStyleToParagraphStyle($this, style, computedStyle) {
    var pStyle = new ParagraphStyle();
    pStyle.h63(true);
    pStyle.i63(makeSkTextStyle($this, computedStyle));
    // Inline function 'kotlin.let' call
    var it = style.p82();
    pStyle.k63(toSkAlignment(it));
    var lineHeight = computedStyle.x8i_1;
    if (!(lineHeight == null) && lineHeight > computedStyle.g8i_1) {
      var tmp0_elvis_lhs = style.t82();
      var lineHeightStyle = tmp0_elvis_lhs == null ? Companion_getInstance_42().i8e_1 : tmp0_elvis_lhs;
      pStyle.n63(toHeightMode(lineHeightStyle.w7x_1));
    } else {
      pStyle.n63(HeightMode_DISABLE_ALL_getInstance());
    }
    pStyle.j63(toSkDirection($this.g8l_1));
    var tmp1_safe_receiver = $this.z8k_1.s82();
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.run' call
      pStyle.o63(new TextIndent(toPx(tmp1_safe_receiver.n7x_1, $this.f8l_1, computedStyle.g8i_1), toPx(tmp1_safe_receiver.o7x_1, $this.f8l_1, computedStyle.g8i_1)));
    }
    return pStyle;
  }
  function makeSkTextStyle($this, style) {
    var tmp0 = get_skTextStylesCache();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.text.WeakKeysCache.getOrPut' call
      var weakKey = new Key_0(style);
      var existing = access$_get_cache__fo4c6p(tmp0).w2(weakKey);
      if (!(existing == null)) {
        tmp$ret$0 = existing;
        break $l$block;
      }
      var value = style.g8j($this.x8k_1);
      // Inline function 'kotlin.collections.set' call
      access$_get_cache__fo4c6p(tmp0).z2(weakKey, value);
      var tmp = access$_get_registry__6myjy(tmp0);
      // Inline function 'kotlin.js.toJsReference' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp_0 = style;
      // Inline function 'kotlin.js.toJsReference' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp.register(tmp_0, weakKey);
      tmp$ret$0 = value;
    }
    return tmp$ret$0;
  }
  function sam$kotlin_Comparator$0_1(function_0) {
    this.n8l_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_1).ze = function (a, b) {
    return this.n8l_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_1).compare = function (a, b) {
    return this.ze(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_1).q3 = function () {
    return this.n8l_1;
  };
  protoOf(sam$kotlin_Comparator$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0_1).hashCode = function () {
    return hashCode(this.q3());
  };
  function ParagraphBuilder$makeOps$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp = a.n8k();
    var tmp$ret$2 = b.n8k();
    return compareValues(tmp, tmp$ret$2);
  }
  function ParagraphBuilder$defaultFont$delegate$lambda(this$0) {
    return function () {
      var loadResult = resolveFontFamily(this$0.z8k_1, this$0.x8k_1);
      return Font_init_$Create$(loadResult == null ? null : loadResult.h8j_1, this$0.j8l_1.g8i_1);
    };
  }
  function ParagraphBuilder$_get_defaultFont_$ref_9jivqf() {
    return constructCallableReference(function (p0) {
      return p0.e8h();
    }, 1, 0, 42);
  }
  function ParagraphBuilder_0(fontFamilyResolver, text, textStyle, brushSize, ellipsis, maxLines, annotations, placeholders, density, textDirection, drawStyle, blendMode) {
    brushSize = brushSize === VOID ? Companion_getInstance_7().k5e_1 : brushSize;
    ellipsis = ellipsis === VOID ? '' : ellipsis;
    maxLines = maxLines === VOID ? 2147483647 : maxLines;
    drawStyle = drawStyle === VOID ? null : drawStyle;
    blendMode = blendMode === VOID ? Companion_getInstance_0().x6h_1 : blendMode;
    this.x8k_1 = fontFamilyResolver;
    this.y8k_1 = text;
    this.z8k_1 = textStyle;
    this.a8l_1 = brushSize;
    this.b8l_1 = ellipsis;
    this.c8l_1 = maxLines;
    this.d8l_1 = annotations;
    this.e8l_1 = placeholders;
    this.f8l_1 = density;
    this.g8l_1 = textDirection;
    this.h8l_1 = drawStyle;
    this.i8l_1 = blendMode;
    this.j8l_1 = new Immutable_0();
    var tmp = this;
    tmp.m8l_1 = lazy_0(ParagraphBuilder$defaultFont$delegate$lambda(this));
  }
  protoOf(ParagraphBuilder_0).o8l = function (paragraph) {
    if (paragraph == null)
      return Unit_instance;
    prepareDefaultStyle(this);
    var foregroundPaint = this.j8l_1.a8j();
    paragraph.p62(0, this.y8k_1.length, foregroundPaint);
  };
  protoOf(ParagraphBuilder_0).g3d = function () {
    prepareDefaultStyle(this);
    this.l8l_1 = makeOps(this, this.d8l_1, this.e8l_1);
    var pos = 0;
    var ps = textStyleToParagraphStyle(this, this.z8k_1, this.j8l_1);
    if (!(this.c8l_1 === 2147483647)) {
      ps.l63(this.c8l_1);
      ps.m63(this.b8l_1);
    }
    var tmp = this.x8k_1;
    var platformFontLoader = (tmp instanceof FontFamilyResolverImpl ? tmp : THROW_CCE()).h84_1;
    var tmp_0;
    if (platformFontLoader instanceof SkiaFontLoader) {
      tmp_0 = platformFontLoader.x8h();
    } else {
      throw IllegalStateException_init_$Create$_0('Unsupported font loader ' + toString_0(platformFontLoader));
    }
    var fontCollection = tmp_0;
    var pb = new ParagraphBuilder(ps, fontCollection);
    var addText = true;
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = _get_ops__e6e97j(this);
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        if (addText && pos < item.n8k()) {
          pb.v62(toString_0(substring(this.y8k_1, pos, item.n8k())));
        }
        if (item instanceof StyleAdd) {
          var tmp_1 = item.s8k_1.i82();
          var tmp1_elvis_lhs = item.s8k_1.f82();
          var tmp_2 = tmp1_elvis_lhs == null ? Companion_getInstance_26().b7z_1 : tmp1_elvis_lhs;
          var tmp2_elvis_lhs = item.s8k_1.g82();
          var tmp_3;
          var tmp_4 = tmp2_elvis_lhs;
          if ((tmp_4 == null ? null : new FontStyle(tmp_4)) == null) {
            tmp_3 = Companion_getInstance_24().k7z_1;
          } else {
            tmp_3 = tmp2_elvis_lhs;
          }
          var tmp_5 = tmp_3;
          var tmp3_elvis_lhs = item.s8k_1.h82();
          var tmp_6;
          var tmp_7 = tmp3_elvis_lhs;
          if ((tmp_7 == null ? null : new FontSynthesis(tmp_7)) == null) {
            tmp_6 = Companion_getInstance_25().p7z_1;
          } else {
            tmp_6 = tmp3_elvis_lhs;
          }
          this.x8k_1.r84(tmp_1, tmp_2, tmp_5, tmp_6);
          var tmp_8 = item.s8k_1;
          var style = (tmp_8 instanceof Mutable ? tmp_8 : THROW_CCE()).g8k();
          item.s8k_1 = style;
          pb.u62(makeSkTextStyle(this, style));
        } else {
          if (item instanceof PutPlaceholder) {
            var placeholderStyle = new PlaceholderStyle(item.k8k_1, item.l8k_1, toSkPlaceholderAlignment(item.j8k_1.i8k_1.c7w_1), BaselineMode_ALPHABETIC_getInstance(), 0.0);
            pb.w62(placeholderStyle);
            addText = false;
          } else {
            if (item instanceof EndPlaceholder) {
              addText = true;
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
        pos = item.n8k();
      }
       while (inductionVariable <= last);
    if (addText && pos < this.y8k_1.length) {
      pb.v62(toString_0(substring(this.y8k_1, pos, this.y8k_1.length)));
    }
    return pb.g3d();
  };
  protoOf(ParagraphBuilder_0).e8h = function () {
    var tmp0 = this.m8l_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('defaultFont', 1, tmp, ParagraphBuilder$_get_defaultFont_$ref_9jivqf(), null);
    return tmp0.u1();
  };
  protoOf(ParagraphBuilder_0).d8h = function (paragraph) {
    var metrics = this.e8h().l5n();
    var ascent = metrics.f5o_1;
    var descent = metrics.g5o_1;
    var baseline = paragraph.e62();
    var lineHeight = this.j8l_1.x8i_1;
    if (!(lineHeight == null)) {
      var topRatio = this.j8l_1.y8i_1;
      if (0.0 <= topRatio ? topRatio <= 1.0 : false) {
        var extraLeading = lineHeight - this.j8l_1.g8i_1;
        ascent = ascent - extraLeading * topRatio;
        descent = descent + extraLeading * (1.0 - topRatio);
      } else {
        var multiplier = lineHeight / this.j8l_1.g8i_1;
        ascent = ascent * multiplier;
        descent = descent * multiplier;
      }
    }
    var height = descent - ascent;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [new LineMetrics(0, 0, 0, 0, true, -ascent, descent, ascent, height, 0.0, 0.0, baseline, 0)];
  };
  function copyWithDefaultFontSize(_this__u8e3s4, drawStyle) {
    drawStyle = drawStyle === VOID ? null : drawStyle;
    _init_properties_ParagraphBuilder_skiko_kt__fblzyk();
    var fontSize = orDefaultFontSize(_this__u8e3s4.o7w_1);
    var tmp;
    if (_TextUnit___get_isEm__impl__esrmtl(_this__u8e3s4.u7w_1)) {
      // Inline function 'androidx.compose.ui.unit.TextUnit.times' call
      var other = _TextUnit___get_value__impl__hpbx0k(_this__u8e3s4.u7w_1);
      checkArithmetic(fontSize);
      tmp = pack(_TextUnit___get_rawType__impl__tu8yq5(fontSize), _TextUnit___get_value__impl__hpbx0k(fontSize) * other);
    } else {
      tmp = _this__u8e3s4.u7w_1;
    }
    var letterSpacing = tmp;
    return _this__u8e3s4.i7y(VOID, fontSize, VOID, VOID, VOID, VOID, VOID, letterSpacing, VOID, VOID, VOID, VOID, VOID, VOID, VOID, drawStyle);
  }
  function ComputedStyle(density, spanStyle, platformParagraphStyle, brushSize, blendMode, lineHeight, lineHeightStyle) {
    platformParagraphStyle = platformParagraphStyle === VOID ? null : platformParagraphStyle;
    brushSize = brushSize === VOID ? Companion_getInstance_7().k5e_1 : brushSize;
    blendMode = blendMode === VOID ? Companion_getInstance_0().x6h_1 : blendMode;
    _init_properties_ParagraphBuilder_skiko_kt__fblzyk();
    // Inline function 'kotlin.with' call
    var tmp = density.x5e(spanStyle.o7w_1);
    var tmp1_elvis_lhs = platformParagraphStyle == null ? null : platformParagraphStyle.q7v_1;
    var tmp_0 = tmp1_elvis_lhs == null ? Companion_getInstance_51().z8f() : tmp1_elvis_lhs;
    var tmp_1;
    // Inline function 'androidx.compose.ui.unit.isSpecified' call
    // Inline function 'androidx.compose.ui.unit.isUnspecified' call
    var this_0 = spanStyle.u7w_1;
    if (!equalsLong(_TextUnit___get_rawType__impl__tu8yq5(this_0), new Long(0, 0))) {
      // Inline function 'kotlin.with' call
      tmp_1 = density.x5e(spanStyle.u7w_1);
    } else {
      tmp_1 = null;
    }
    var tmp_2 = tmp_1;
    var tmp2_safe_receiver = spanStyle.b7x_1;
    var tmp_3 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.n7y_1;
    var tmp_4;
    // Inline function 'androidx.compose.ui.unit.isSpecified' call
    // Inline function 'androidx.compose.ui.unit.isUnspecified' call
    if (!equalsLong(_TextUnit___get_rawType__impl__tu8yq5(lineHeight), new Long(0, 0))) {
      tmp_4 = toPx_0(lineHeight, density, spanStyle.o7w_1);
    } else {
      tmp_4 = null;
    }
    var tmp_5 = tmp_4;
    var tmp4_elvis_lhs = lineHeightStyle == null ? null : lineHeightStyle.v7x_1;
    var tmp_6;
    var tmp_7 = tmp4_elvis_lhs;
    if ((tmp_7 == null ? null : new Alignment(tmp_7)) == null) {
      tmp_6 = Companion_getInstance_40().d8e_1;
    } else {
      tmp_6 = tmp4_elvis_lhs;
    }
    return new Mutable(spanStyle.n7w_1, brushSize, tmp, spanStyle.p7w_1, spanStyle.q7w_1, spanStyle.r7w_1, spanStyle.s7w_1, spanStyle.t7w_1, tmp_0, tmp_2, spanStyle.v7w_1, spanStyle.w7w_1, spanStyle.x7w_1, spanStyle.y7w_1, spanStyle.z7w_1, tmp_3, spanStyle.a7x_1, spanStyle.c7x_1, blendMode, tmp_5, _Alignment___get_topRatio__impl__gg7tir(tmp_6));
  }
  function toSkPlaceholderAlignment(_this__u8e3s4) {
    _init_properties_ParagraphBuilder_skiko_kt__fblzyk();
    var tmp;
    if (_this__u8e3s4 === Companion_getInstance_16().d7w_1) {
      tmp = PlaceholderAlignment_ABOVE_BASELINE_getInstance();
    } else if (_this__u8e3s4 === Companion_getInstance_16().h7w_1) {
      tmp = PlaceholderAlignment_TOP_getInstance();
    } else if (_this__u8e3s4 === Companion_getInstance_16().i7w_1) {
      tmp = PlaceholderAlignment_BOTTOM_getInstance();
    } else if (_this__u8e3s4 === Companion_getInstance_16().j7w_1) {
      tmp = PlaceholderAlignment_MIDDLE_getInstance();
    } else if (_this__u8e3s4 === Companion_getInstance_16().e7w_1) {
      tmp = PlaceholderAlignment_TOP_getInstance();
    } else if (_this__u8e3s4 === Companion_getInstance_16().f7w_1) {
      tmp = PlaceholderAlignment_BOTTOM_getInstance();
    } else if (_this__u8e3s4 === Companion_getInstance_16().g7w_1) {
      tmp = PlaceholderAlignment_MIDDLE_getInstance();
    } else {
      // Inline function 'kotlin.error' call
      var message = 'Invalid PlaceholderVerticalAlign.';
      throw IllegalStateException_init_$Create$_0(toString_0(message));
    }
    return tmp;
  }
  function toSkAlignment(_this__u8e3s4) {
    _init_properties_ParagraphBuilder_skiko_kt__fblzyk();
    return _this__u8e3s4 === Companion_getInstance_43().b7v_1 ? Alignment_LEFT_getInstance() : _this__u8e3s4 === Companion_getInstance_43().c7v_1 ? Alignment_RIGHT_getInstance() : _this__u8e3s4 === Companion_getInstance_43().d7v_1 ? Alignment_CENTER_getInstance() : _this__u8e3s4 === Companion_getInstance_43().e7v_1 ? Alignment_JUSTIFY_getInstance() : _this__u8e3s4 === Companion_getInstance_43().f7v_1 ? Alignment_START_getInstance() : _this__u8e3s4 === Companion_getInstance_43().g7v_1 ? Alignment_END_getInstance() : Alignment_START_getInstance();
  }
  function toHeightMode(_this__u8e3s4) {
    _init_properties_ParagraphBuilder_skiko_kt__fblzyk();
    return _this__u8e3s4 === Companion_getInstance_39().z8d_1 ? HeightMode_DISABLE_ALL_getInstance() : _this__u8e3s4 === Companion_getInstance_39().x8d_1 ? HeightMode_DISABLE_FIRST_ASCENT_getInstance() : _this__u8e3s4 === Companion_getInstance_39().y8d_1 ? HeightMode_DISABLE_LAST_DESCENT_getInstance() : _this__u8e3s4 === Companion_getInstance_39().a8e_1 ? HeightMode_ALL_getInstance() : HeightMode_DISABLE_ALL_getInstance();
  }
  function toSkDirection(_this__u8e3s4) {
    _init_properties_ParagraphBuilder_skiko_kt__fblzyk();
    var tmp;
    switch (_this__u8e3s4.a1_1) {
      case 0:
        tmp = Direction_LTR_getInstance();
        break;
      case 1:
        tmp = Direction_RTL_getInstance();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function resolveFontFamily(_this__u8e3s4, fontFamilyResolver) {
    _init_properties_ParagraphBuilder_skiko_kt__fblzyk();
    var tmp0_safe_receiver = _this__u8e3s4.i82();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp0_elvis_lhs = _this__u8e3s4.f82();
      var tmp_0 = tmp0_elvis_lhs == null ? Companion_getInstance_26().b7z_1 : tmp0_elvis_lhs;
      var tmp1_elvis_lhs = _this__u8e3s4.g82();
      var tmp_1;
      var tmp_2 = tmp1_elvis_lhs;
      if ((tmp_2 == null ? null : new FontStyle(tmp_2)) == null) {
        tmp_1 = Companion_getInstance_24().k7z_1;
      } else {
        tmp_1 = tmp1_elvis_lhs;
      }
      var tmp_3 = tmp_1;
      var tmp2_elvis_lhs = _this__u8e3s4.h82();
      var tmp_4;
      var tmp_5 = tmp2_elvis_lhs;
      if ((tmp_5 == null ? null : new FontSynthesis(tmp_5)) == null) {
        tmp_4 = Companion_getInstance_25().p7z_1;
      } else {
        tmp_4 = tmp2_elvis_lhs;
      }
      var tmp_6 = fontFamilyResolver.r84(tmp0_safe_receiver, tmp_0, tmp_3, tmp_4).u1();
      tmp = tmp_6 instanceof FontLoadResult ? tmp_6 : THROW_CCE();
    }
    return tmp;
  }
  function orDefaultFontSize(_this__u8e3s4) {
    _init_properties_ParagraphBuilder_skiko_kt__fblzyk();
    var tmp;
    // Inline function 'androidx.compose.ui.unit.isUnspecified' call
    if (equalsLong(_TextUnit___get_rawType__impl__tu8yq5(_this__u8e3s4), new Long(0, 0))) {
      tmp = get_DefaultFontSize_0();
    } else {
      if (_TextUnit___get_isEm__impl__esrmtl(_this__u8e3s4)) {
        var tmp0 = get_DefaultFontSize_0();
        // Inline function 'androidx.compose.ui.unit.TextUnit.times' call
        var other = _TextUnit___get_value__impl__hpbx0k(_this__u8e3s4);
        checkArithmetic(tmp0);
        tmp = pack(_TextUnit___get_rawType__impl__tu8yq5(tmp0), _TextUnit___get_value__impl__hpbx0k(tmp0) * other);
      } else {
        tmp = _this__u8e3s4;
      }
    }
    return tmp;
  }
  function toPx_0(_this__u8e3s4, density, fontSize) {
    _init_properties_ParagraphBuilder_skiko_kt__fblzyk();
    // Inline function 'kotlin.with' call
    var tmp$ret$0 = density.x5e(fontSize);
    return toPx(_this__u8e3s4, density, tmp$ret$0);
  }
  var properties_initialized_ParagraphBuilder_skiko_kt_5j6rti;
  function _init_properties_ParagraphBuilder_skiko_kt__fblzyk() {
    if (!properties_initialized_ParagraphBuilder_skiko_kt_5j6rti) {
      properties_initialized_ParagraphBuilder_skiko_kt_5j6rti = true;
      DefaultFontSize_0 = get_sp(16);
      skTextStylesCache = new WeakKeysCache();
      androidx_compose_ui_text_platform_ComputedStyle_Immutable$stable = 8;
      androidx_compose_ui_text_platform_ComputedStyle_Mutable$stable = 8;
      androidx_compose_ui_text_platform_ParagraphBuilder_Op_StyleAdd$stable = 8;
      androidx_compose_ui_text_platform_ParagraphBuilder_Op_PutPlaceholder$stable = 8;
      androidx_compose_ui_text_platform_ParagraphBuilder_Op_EndPlaceholder$stable = 8;
      androidx_compose_ui_text_platform_ParagraphBuilder_Cut_StyleAdd$stable = 0;
      androidx_compose_ui_text_platform_ParagraphBuilder_Cut_StyleRemove$stable = 0;
      androidx_compose_ui_text_platform_ParagraphBuilder_Cut_PutPlaceholder$stable = 0;
      androidx_compose_ui_text_platform_ParagraphBuilder_Cut_EndPlaceholder$stable = 0;
      androidx_compose_ui_text_platform_ParagraphBuilder$stable = 8;
    }
  }
  var androidx_compose_ui_text_platform_ParagraphLayouter$stable;
  function invalidateParagraph($this, onlyForeground) {
    onlyForeground = onlyForeground === VOID ? false : onlyForeground;
    if (onlyForeground && $this.y8g_1.d8l_1.r()) {
      $this.a8h_1 = true;
    } else {
      $this.z8g_1 = null;
    }
  }
  function ParagraphLayouter(text, textDirection, style, annotations, placeholders, density, fontFamilyResolver) {
    this.x8g_1 = text;
    this.y8g_1 = new ParagraphBuilder_0(fontFamilyResolver, this.x8g_1, style, VOID, VOID, VOID, annotations, placeholders, density, textDirection);
    this.z8g_1 = null;
    this.a8h_1 = false;
    this.b8h_1 = NaN;
  }
  protoOf(ParagraphLayouter).j8h = function () {
    return this.y8g_1.e8h();
  };
  protoOf(ParagraphLayouter).c8h = function () {
    return this.y8g_1.z8k_1;
  };
  protoOf(ParagraphLayouter).d8h = function (paragraph) {
    return this.y8g_1.d8h(paragraph);
  };
  protoOf(ParagraphLayouter).g8h = function (maxLines, ellipsis) {
    if (!(this.y8g_1.c8l_1 === maxLines) || !(this.y8g_1.b8l_1 === ellipsis)) {
      this.y8g_1.c8l_1 = maxLines;
      this.y8g_1.b8l_1 = ellipsis;
      invalidateParagraph(this);
    }
  };
  protoOf(ParagraphLayouter).k8h = function (color) {
    // Inline function 'androidx.compose.ui.graphics.takeOrElse' call
    var tmp;
    // Inline function 'androidx.compose.ui.graphics.isSpecified' call
    if (!equals(_Color___get_value__impl__1pls5m(color), _ULong___init__impl__c78o9k(new Long(16, 0)))) {
      tmp = color;
    } else {
      tmp = this.y8g_1.z8k_1.s6c();
    }
    var actualColor = tmp;
    if (!equals(this.y8g_1.z8k_1.s6c(), actualColor)) {
      this.y8g_1.z8k_1 = this.y8g_1.z8k_1.b82(actualColor);
      invalidateParagraph(this, true);
    }
  };
  protoOf(ParagraphLayouter).o8h = function (brush, brushSize, alpha) {
    var actualSize = this.y8g_1.a8l_1;
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (!equals(this.y8g_1.z8k_1.f7y(), brush)) {
      tmp_2 = true;
    } else {
      // Inline function 'androidx.compose.ui.geometry.isUnspecified' call
      tmp_2 = equalsLong(_Size___get_packedValue__impl__7rlt1o(actualSize), new Long(2143289344, 2143289344));
    }
    if (tmp_2) {
      tmp_1 = true;
    } else {
      // Inline function 'androidx.compose.ui.geometry.Size.width' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Size___get_packedValue__impl__7rlt1o(actualSize);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      var tmp_3 = floatFromBits(bits);
      // Inline function 'androidx.compose.ui.geometry.Size.width' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_0 = _Size___get_packedValue__impl__7rlt1o(brushSize);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(shiftRight(value_0, 32));
      var tmp$ret$5 = floatFromBits(bits_0);
      tmp_1 = !sameValueAs(tmp_3, tmp$ret$5);
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_1 = _Size___get_packedValue__impl__7rlt1o(actualSize);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_1 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
      var tmp_4 = floatFromBits(bits_1);
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_2 = _Size___get_packedValue__impl__7rlt1o(brushSize);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_2 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
      var tmp$ret$13 = floatFromBits(bits_2);
      tmp_0 = !sameValueAs(tmp_4, tmp$ret$13);
    }
    if (tmp_0) {
      tmp = true;
    } else {
      tmp = !sameValueAs(this.y8g_1.z8k_1.j68(), alpha);
    }
    if (tmp) {
      this.y8g_1.z8k_1 = this.y8g_1.z8k_1.d82(brush, alpha);
      this.y8g_1.a8l_1 = brushSize;
      invalidateParagraph(this, true);
    }
  };
  protoOf(ParagraphLayouter).i8h = function (brushSize) {
    if (!equals(this.y8g_1.a8l_1, brushSize)) {
      this.y8g_1.a8l_1 = brushSize;
      var tmp;
      var tmp_0 = this.y8g_1.z8k_1.f7y();
      if (tmp_0 instanceof ShaderBrush) {
        tmp = true;
      } else {
        var tmp0 = this.y8g_1.d8l_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'androidx.compose.ui.util.fastAny' call
          // Inline function 'androidx.compose.ui.util.fastForEach' call
          var inductionVariable = 0;
          var last = tmp0.n1() - 1 | 0;
          if (inductionVariable <= last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var item = tmp0.l1(index);
              var tmp_1;
              var tmp_2 = item.m7p_1;
              if (tmp_2 instanceof SpanStyle) {
                var tmp_3 = item.m7p_1.f7y();
                tmp_1 = tmp_3 instanceof ShaderBrush;
              } else {
                tmp_1 = false;
              }
              if (tmp_1) {
                tmp$ret$0 = true;
                break $l$block;
              }
            }
             while (inductionVariable <= last);
          tmp$ret$0 = false;
        }
        tmp = tmp$ret$0;
      }
      if (tmp) {
        invalidateParagraph(this, true);
      }
    }
  };
  protoOf(ParagraphLayouter).l8h = function (shadow, textDecoration) {
    if (!sameValueAs_0(this.y8g_1.z8k_1.q81(), shadow) || !sameValueAs_1(this.y8g_1.z8k_1.r81(), textDecoration)) {
      this.y8g_1.z8k_1 = this.y8g_1.z8k_1.b82(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, textDecoration, shadow);
      invalidateParagraph(this);
    }
  };
  protoOf(ParagraphLayouter).m8h = function (drawStyle) {
    if (!equals(this.y8g_1.h8l_1, drawStyle)) {
      this.y8g_1.h8l_1 = drawStyle;
      invalidateParagraph(this, true);
    }
  };
  protoOf(ParagraphLayouter).n8h = function (blendMode) {
    if (!(this.y8g_1.i8l_1 === blendMode)) {
      this.y8g_1.i8l_1 = blendMode;
      invalidateParagraph(this);
    }
  };
  protoOf(ParagraphLayouter).h8h = function (width) {
    var paragraph = this.z8g_1;
    var tmp;
    if (!(paragraph == null)) {
      var layoutRequired = false;
      if (this.a8h_1) {
        this.y8g_1.o8l(paragraph);
        this.a8h_1 = false;
        paragraph.o62();
        layoutRequired = true;
      }
      if (!sameValueAs(this.b8h_1, width)) {
        this.b8h_1 = width;
        layoutRequired = true;
      }
      if (layoutRequired) {
        paragraph.g62(width);
      }
      tmp = paragraph;
    } else {
      paragraph = this.y8g_1.g3d();
      paragraph.g62(width);
      this.z8g_1 = paragraph;
      this.a8h_1 = false;
      return paragraph;
    }
    return tmp;
  };
  function sameValueAs(_this__u8e3s4, other) {
    // Inline function 'kotlin.math.abs' call
    var x = _this__u8e3s4 - other;
    return Math.abs(x) < 1.0E-5;
  }
  function sameValueAs_0(_this__u8e3s4, other) {
    var tmp = _this__u8e3s4 == null ? Companion_getInstance_2().m6j_1 : _this__u8e3s4;
    return tmp.equals(other == null ? Companion_getInstance_2().m6j_1 : other);
  }
  function sameValueAs_1(_this__u8e3s4, other) {
    var tmp = _this__u8e3s4 == null ? Companion_getInstance_44().a80_1 : _this__u8e3s4;
    return tmp.equals(other == null ? Companion_getInstance_44().a80_1 : other);
  }
  function get_GenericFontFamiliesMapping() {
    _init_properties_PlatformFont_skiko_kt__1fvojb();
    var tmp0 = GenericFontFamiliesMapping$delegate;
    var tmp = KProperty0;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('GenericFontFamiliesMapping', 0, tmp, _get_GenericFontFamiliesMapping_$ref_opq6z8(), null);
    return tmp0.u1();
  }
  var GenericFontFamiliesMapping$delegate;
  var androidx_compose_ui_text_platform_SystemFont$stable;
  var androidx_compose_ui_text_platform_LoadedFont$stable;
  var androidx_compose_ui_text_platform_FontLoader$stable;
  var androidx_compose_ui_text_platform_FontLoadResult$stable;
  var androidx_compose_ui_text_platform_FontCache$stable;
  function SystemFont_init_$Init$(identity, weight, style, $this) {
    weight = weight === VOID ? Companion_getInstance_26().b7z_1 : weight;
    style = style === VOID ? Companion_getInstance_24().k7z_1 : style;
    SystemFont.call($this, identity, weight, style, new Settings([]));
    return $this;
  }
  function SystemFont_init_$Create$(identity, weight, style) {
    return SystemFont_init_$Init$(identity, weight, style, objectCreate(protoOf(SystemFont)));
  }
  function SystemFont(identity, weight, style, variationSettings) {
    weight = weight === VOID ? Companion_getInstance_26().b7z_1 : weight;
    style = style === VOID ? Companion_getInstance_24().k7z_1 : style;
    variationSettings = variationSettings === VOID ? FontVariation_instance.x88(weight, style, []) : variationSettings;
    PlatformFont.call(this);
    this.p8l_1 = identity;
    this.q8l_1 = weight;
    this.r8l_1 = style;
    this.s8l_1 = variationSettings;
  }
  protoOf(SystemFont).t8l = function () {
    return this.p8l_1;
  };
  protoOf(SystemFont).g5p = function () {
    return this.q8l_1;
  };
  protoOf(SystemFont).y82 = function () {
    return this.r8l_1;
  };
  protoOf(SystemFont).u8l = function () {
    return this.s8l_1;
  };
  protoOf(SystemFont).toString = function () {
    return "SystemFont(identity='" + this.p8l_1 + "', weight=" + this.q8l_1.toString() + ', style=' + FontStyle__toString_impl_thncxr(this.r8l_1) + ', variationSettings=' + toString_0(this.s8l_1.m88_1) + ')';
  };
  function _get_fontCache__rq14qm_0($this) {
    var tmp0 = $this.w8l_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('fontCache', 1, tmp, FontLoader$_get_fontCache_$ref_6slm39(), null);
    return tmp0.u1();
  }
  function FontLoader$fontCache$delegate$lambda() {
    return new FontCache();
  }
  function FontLoader$_get_fontCache_$ref_6slm39() {
    return constructCallableReference(function (p0) {
      return _get_fontCache__rq14qm_0(p0);
    }, 1, 0, 43);
  }
  function FontLoader$fontFamilyResolver$delegate$lambda(this$0) {
    return function () {
      return createFontFamilyResolver(_get_fontCache__rq14qm_0(this$0));
    };
  }
  function FontLoader() {
    var tmp = this;
    tmp.w8l_1 = lazy_0(FontLoader$fontCache$delegate$lambda);
    var tmp_0 = this;
    tmp_0.x8l_1 = lazy_0(FontLoader$fontFamilyResolver$delegate$lambda(this));
  }
  function FontLoadResult(typeface, aliases) {
    this.h8j_1 = typeface;
    this.i8j_1 = aliases;
  }
  var Platform_Unknown_instance;
  var Platform_Linux_instance;
  var Platform_Windows_instance;
  var Platform_MacOS_instance;
  var Platform_IOS_instance;
  var Platform_TvOS_instance;
  var Platform_WatchOS_instance;
  var Platform_Android_instance;
  var Platform_entriesInitialized;
  function Platform_initEntries() {
    if (Platform_entriesInitialized)
      return Unit_instance;
    Platform_entriesInitialized = true;
    Platform_Unknown_instance = new Platform('Unknown', 0);
    Platform_Linux_instance = new Platform('Linux', 1);
    Platform_Windows_instance = new Platform('Windows', 2);
    Platform_MacOS_instance = new Platform('MacOS', 3);
    Platform_IOS_instance = new Platform('IOS', 4);
    Platform_TvOS_instance = new Platform('TvOS', 5);
    Platform_WatchOS_instance = new Platform('WatchOS', 6);
    Platform_Android_instance = new Platform('Android', 7);
  }
  function Platform(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function ensureRegistered($this, typeface, key) {
    if (!$this.a8i_1.m1(key)) {
      $this.z8h_1.k65(typeface, key);
      $this.a8i_1.j1(key);
    }
  }
  function ensureRegistered_0($this, fontFamily) {
    var tmp;
    if (fontFamily instanceof FontListFontFamily) {
      // Inline function 'androidx.compose.ui.util.fastMapNotNull' call
      var this_0 = fontFamily.i83_1;
      var target = ArrayList_init_$Create$_0(this_0.n1());
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = this_0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = this_0.l1(index);
          var tmp_0;
          if (item instanceof SystemFont) {
            tmp_0 = item.p8l_1;
          } else {
            tmp_0 = null;
          }
          var tmp0_safe_receiver = tmp_0;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.collections.plusAssign' call
            target.j1(tmp0_safe_receiver);
          }
        }
         while (inductionVariable <= last);
      var fonts = target;
      var tmp_1;
      if (fonts.n1() === fontFamily.i83_1.n1()) {
        tmp_1 = fonts;
      } else {
        throw IllegalArgumentException_init_$Create$_0("Don't load FontListFontFamily through ensureRegistered: " + fontFamily.toString());
      }
      tmp = tmp_1;
    } else {
      if (fontFamily instanceof LoadedFontFamily) {
        var tmp_2 = fontFamily.z8l_1;
        var typeface = tmp_2 instanceof SkiaBackedTypeface ? tmp_2 : THROW_CCE();
        ensureRegistered($this, typeface.a8m_1, typeface.b8m_1);
        tmp = listOf_0(typeface.b8m_1);
      } else {
        if (fontFamily instanceof GenericFontFamily) {
          tmp = get_aliases(fontFamily);
        } else {
          if (fontFamily instanceof DefaultFontFamily) {
            tmp = get_aliases(Companion_getInstance_20().r7z_1);
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
    return tmp;
  }
  function FontCache() {
    this.y8h_1 = FontCollection_init_$Create$();
    this.z8h_1 = TypefaceFontProviderWithFallback_init_$Create$();
    this.a8i_1 = HashSet_init_$Create$();
    this.b8i_1 = new ExpireAfterAccessCache(new Long(-129542144, 13));
    this.y8h_1.b61(new FontMgrWithFallback(this.z8h_1));
    this.y8h_1.a61(this.z8h_1);
  }
  protoOf(FontCache).c8i = function (font) {
    var tmp0 = this.b8i_1;
    // Inline function 'androidx.compose.ui.text.ExpireAfterAccessCache.getOrPut' call
    var key = font.v8l();
    tmp0.x8e_1.a3(key);
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = tmp0.w8e_1;
    var value = this_0.w2(key);
    var tmp;
    if (value == null) {
      var answer = loadTypeface(font);
      this_0.z2(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    // Inline function 'kotlin.also' call
    var this_1 = tmp;
    var now = tmp0.v8e_1();
    // Inline function 'kotlin.collections.set' call
    tmp0.x8e_1.z2(key, now);
    access$checkEvicted(tmp0, now);
    var typeface = this_1;
    ensureRegistered(this, typeface, font.v8l());
    return new FontLoadResult(typeface, listOf_0(font.v8l()));
  };
  protoOf(FontCache).w8h = function (fontFamily, fontWeight, fontStyle) {
    var aliases = ensureRegistered_0(this, fontFamily);
    var style = toSkFontStyle(fontStyle).h5p(fontWeight.p7x_1);
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$0 = copyToArray(aliases);
    return new FontLoadResult(first_0(this.y8h_1.d61(tmp$ret$0, style)), aliases);
  };
  function SkiaBackedTypeface() {
  }
  function get_aliases(_this__u8e3s4) {
    _init_properties_PlatformFont_skiko_kt__1fvojb();
    var tmp0_elvis_lhs = get_GenericFontFamiliesMapping().w2(_this__u8e3s4.e83_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'Unknown generic font family ' + _this__u8e3s4.e83_1;
      throw IllegalStateException_init_$Create$_0(toString_0(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function cloneWithVariationSettings(_this__u8e3s4, variationSettings) {
    _init_properties_PlatformFont_skiko_kt__1fvojb();
    if (variationSettings.m88_1.r())
      return _this__u8e3s4;
    var variations = toSkiaFontVariationList(variationSettings);
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$0 = copyToArray(variations);
    return _this__u8e3s4.f5v(tmp$ret$0);
  }
  function LoadedFont(identity, getData, weight, style, variationSettings) {
    variationSettings = variationSettings === VOID ? FontVariation_instance.x88(weight, style, []) : variationSettings;
    PlatformFont.call(this);
    this.c8m_1 = identity;
    this.d8m_1 = getData;
    this.e8m_1 = weight;
    this.f8m_1 = style;
    this.g8m_1 = variationSettings;
    this.h8m_1 = Companion_getInstance_23().a83_1;
  }
  protoOf(LoadedFont).t8l = function () {
    return this.c8m_1;
  };
  protoOf(LoadedFont).g5p = function () {
    return this.e8m_1;
  };
  protoOf(LoadedFont).y82 = function () {
    return this.f8m_1;
  };
  protoOf(LoadedFont).u8l = function () {
    return this.g8m_1;
  };
  protoOf(LoadedFont).z82 = function () {
    return this.h8m_1;
  };
  protoOf(LoadedFont).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LoadedFont))
      return false;
    if (!(this.c8m_1 === other.c8m_1))
      return false;
    if (!this.e8m_1.equals(other.e8m_1))
      return false;
    if (!(this.f8m_1 === other.f8m_1))
      return false;
    return equals(this.g8m_1.m88_1, other.g8m_1.m88_1);
  };
  protoOf(LoadedFont).hashCode = function () {
    var result = getStringHashCode(this.c8m_1);
    result = imul(31, result) + this.e8m_1.hashCode() | 0;
    result = imul(31, result) + FontStyle__hashCode_impl_7qhg4w(this.f8m_1) | 0;
    result = imul(31, result) + hashCode(this.g8m_1.m88_1) | 0;
    return result;
  };
  protoOf(LoadedFont).toString = function () {
    return "LoadedFont(identity='" + this.c8m_1 + "', weight=" + this.e8m_1.toString() + ', style=' + FontStyle__toString_impl_thncxr(this.f8m_1) + ', variationSettings=' + toString_0(this.g8m_1.m88_1) + ')';
  };
  function toSkiaFontVariationList(_this__u8e3s4) {
    _init_properties_PlatformFont_skiko_kt__1fvojb();
    // Inline function 'androidx.compose.ui.util.fastMap' call
    var this_0 = _this__u8e3s4.m88_1;
    var target = ArrayList_init_$Create$_0(this_0.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        // Inline function 'kotlin.collections.plusAssign' call
        var element = FontVariation_init_$Create$(item.k88(), item.r88(null));
        target.j1(element);
      }
       while (inductionVariable <= last);
    return target;
  }
  function Font_0(identity, data, weight, style, variationSettings) {
    weight = weight === VOID ? Companion_getInstance_26().b7z_1 : weight;
    style = style === VOID ? Companion_getInstance_24().k7z_1 : style;
    variationSettings = variationSettings === VOID ? FontVariation_instance.x88(weight, style, []) : variationSettings;
    _init_properties_PlatformFont_skiko_kt__1fvojb();
    return Font_1(identity, Font$lambda(data), weight, style, variationSettings);
  }
  function Font_1(identity, getData, weight, style, variationSettings) {
    weight = weight === VOID ? Companion_getInstance_26().b7z_1 : weight;
    style = style === VOID ? Companion_getInstance_24().k7z_1 : style;
    variationSettings = variationSettings === VOID ? FontVariation_instance.x88(weight, style, []) : variationSettings;
    _init_properties_PlatformFont_skiko_kt__1fvojb();
    return new LoadedFont(identity, getData, weight, style, variationSettings);
  }
  function GenericFontFamiliesMapping$delegate$lambda() {
    _init_properties_PlatformFont_skiko_kt__1fvojb();
    var tmp;
    switch (currentPlatform().a1_1) {
      case 1:
        tmp = mapOf([to(Companion_getInstance_20().r7z_1.e83_1, listOf(['Noto Sans', 'DejaVu Sans', 'Arial'])), to(Companion_getInstance_20().s7z_1.e83_1, listOf(['Noto Serif', 'DejaVu Serif', 'Times New Roman'])), to(Companion_getInstance_20().t7z_1.e83_1, listOf(['Noto Sans Mono', 'DejaVu Sans Mono', 'Consolas'])), to(Companion_getInstance_20().u7z_1.e83_1, listOf_0('Comic Sans MS'))]);
        break;
      case 2:
        tmp = mapOf([to(Companion_getInstance_20().r7z_1.e83_1, listOf(['Segoe UI', 'Arial'])), to(Companion_getInstance_20().s7z_1.e83_1, listOf_0('Times New Roman')), to(Companion_getInstance_20().t7z_1.e83_1, listOf_0('Consolas')), to(Companion_getInstance_20().u7z_1.e83_1, listOf_0('Comic Sans MS'))]);
        break;
      case 3:
      case 4:
      case 5:
      case 6:
        tmp = mapOf([to(Companion_getInstance_20().r7z_1.e83_1, listOf(['.AppleSystemUIFont', 'Helvetica Neue', 'Helvetica'])), to(Companion_getInstance_20().s7z_1.e83_1, listOf(['.AppleSystemUIFontSerif', 'Times', 'Times New Roman'])), to(Companion_getInstance_20().t7z_1.e83_1, listOf(['.AppleSystemUIFontMonospaced', 'Menlo', 'Courier'])), to(Companion_getInstance_20().u7z_1.e83_1, listOf(['Apple Chancery', 'Snell Roundhand']))]);
        break;
      case 7:
        tmp = mapOf([to(Companion_getInstance_20().r7z_1.e83_1, listOf(['Roboto', 'Noto Sans'])), to(Companion_getInstance_20().s7z_1.e83_1, listOf(['Roboto Serif', 'Noto Serif'])), to(Companion_getInstance_20().t7z_1.e83_1, listOf(['Roboto Mono', 'Noto Sans Mono'])), to(Companion_getInstance_20().u7z_1.e83_1, listOf_0('Comic Sans MS'))]);
        break;
      case 0:
        tmp = mapOf([to(Companion_getInstance_20().r7z_1.e83_1, listOf_0('Arial')), to(Companion_getInstance_20().s7z_1.e83_1, listOf_0('Times New Roman')), to(Companion_getInstance_20().t7z_1.e83_1, listOf_0('Consolas')), to(Companion_getInstance_20().u7z_1.e83_1, listOf_0('Comic Sans MS'))]);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function _get_GenericFontFamiliesMapping_$ref_opq6z8() {
    return constructCallableReference(function () {
      return get_GenericFontFamiliesMapping();
    }, 0, 0, 44);
  }
  function Font$lambda($data) {
    return function () {
      return $data;
    };
  }
  function Platform_Unknown_getInstance() {
    Platform_initEntries();
    return Platform_Unknown_instance;
  }
  function Platform_Linux_getInstance() {
    Platform_initEntries();
    return Platform_Linux_instance;
  }
  function Platform_Windows_getInstance() {
    Platform_initEntries();
    return Platform_Windows_instance;
  }
  function Platform_MacOS_getInstance() {
    Platform_initEntries();
    return Platform_MacOS_instance;
  }
  function Platform_IOS_getInstance() {
    Platform_initEntries();
    return Platform_IOS_instance;
  }
  function Platform_Android_getInstance() {
    Platform_initEntries();
    return Platform_Android_instance;
  }
  var properties_initialized_PlatformFont_skiko_kt_pdb6wl;
  function _init_properties_PlatformFont_skiko_kt__1fvojb() {
    if (!properties_initialized_PlatformFont_skiko_kt_pdb6wl) {
      properties_initialized_PlatformFont_skiko_kt_pdb6wl = true;
      GenericFontFamiliesMapping$delegate = lazy_0(GenericFontFamiliesMapping$delegate$lambda);
      androidx_compose_ui_text_platform_SystemFont$stable = 0;
      androidx_compose_ui_text_platform_LoadedFont$stable = 0;
      androidx_compose_ui_text_platform_FontLoader$stable = 8;
      androidx_compose_ui_text_platform_FontLoadResult$stable = 8;
      androidx_compose_ui_text_platform_FontCache$stable = 8;
    }
  }
  function drawMultiParagraph(_this__u8e3s4, canvas, brush, alpha, shadow, decoration, drawStyle, blendMode) {
    alpha = alpha === VOID ? NaN : alpha;
    shadow = shadow === VOID ? null : shadow;
    decoration = decoration === VOID ? null : decoration;
    drawStyle = drawStyle === VOID ? null : drawStyle;
    blendMode = blendMode === VOID ? Companion_getInstance_10().b6a_1 : blendMode;
    canvas.t6d();
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = _this__u8e3s4.l7s_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        item.m7s_1.n7t(canvas, brush, alpha, shadow, decoration, drawStyle, blendMode);
        canvas.b5d(0.0, item.m7s_1.i5e());
      }
       while (inductionVariable <= last);
    canvas.u6d();
  }
  var androidx_compose_ui_text_platform_SkiaParagraphIntrinsics$stable;
  function ActualParagraphIntrinsics(text, style, annotations, placeholders, density, fontFamilyResolver) {
    return new SkiaParagraphIntrinsics(text, style, annotations, placeholders, density, fontFamilyResolver);
  }
  function newLayouter($this) {
    return new ParagraphLayouter($this.n8g_1, $this.t8g_1, $this.o8g_1, $this.p8g_1, $this.q8g_1, $this.r8g_1, $this.s8g_1);
  }
  function SkiaParagraphIntrinsics(text, style, annotations, placeholders, density, fontFamilyResolver) {
    this.n8g_1 = text;
    this.o8g_1 = style;
    this.p8g_1 = annotations;
    this.q8g_1 = placeholders;
    this.r8g_1 = density;
    this.s8g_1 = fontFamilyResolver;
    this.t8g_1 = resolveTextDirection_1(this.n8g_1, this.o8g_1.q82(), this.o8g_1.n82());
    this.u8g_1 = newLayouter(this);
    this.v8g_1 = 0.0;
    this.w8g_1 = 0.0;
    var para = ensureNotNull(this.u8g_1).h8h(Infinity);
    var tmp = this;
    // Inline function 'kotlin.math.ceil' call
    var x = para.c62();
    tmp.v8g_1 = Math.ceil(x);
    var tmp_0 = this;
    // Inline function 'kotlin.math.ceil' call
    var x_0 = para.d62();
    tmp_0.w8g_1 = Math.ceil(x_0);
  }
  protoOf(SkiaParagraphIntrinsics).f8h = function () {
    var tmp0_elvis_lhs = this.u8g_1;
    var layouter = tmp0_elvis_lhs == null ? newLayouter(this) : tmp0_elvis_lhs;
    this.u8g_1 = null;
    return layouter;
  };
  protoOf(SkiaParagraphIntrinsics).c62 = function () {
    return this.v8g_1;
  };
  protoOf(SkiaParagraphIntrinsics).d62 = function () {
    return this.w8g_1;
  };
  function resolveTextDirection_1(text, textDirection, localeList) {
    textDirection = textDirection === VOID ? null : textDirection;
    localeList = localeList === VOID ? null : localeList;
    var tmp;
    var tmp_0 = textDirection;
    if ((tmp_0 == null ? null : new TextDirection(tmp_0)) == null) {
      tmp = Companion_getInstance_45().r7u_1;
    } else {
      tmp = textDirection;
    }
    var tmp1_subject = tmp;
    var tmp_1;
    if (tmp1_subject === Companion_getInstance_45().p7u_1) {
      tmp_1 = ResolvedTextDirection_Ltr_getInstance();
    } else if (tmp1_subject === Companion_getInstance_45().q7u_1) {
      tmp_1 = ResolvedTextDirection_Rtl_getInstance();
    } else if (tmp1_subject === Companion_getInstance_45().r7u_1 || tmp1_subject === Companion_getInstance_45().u7u_1) {
      tmp_1 = contentBasedTextDirection(text, resolveTextDirection$lambda(localeList));
    } else if (tmp1_subject === Companion_getInstance_45().s7u_1) {
      tmp_1 = contentBasedTextDirection(text, resolveTextDirection$lambda_0);
    } else if (tmp1_subject === Companion_getInstance_45().t7u_1) {
      tmp_1 = contentBasedTextDirection(text, resolveTextDirection$lambda_1);
    } else {
      // Inline function 'kotlin.error' call
      var message = 'Invalid TextDirection.';
      throw IllegalStateException_init_$Create$_0(toString_0(message));
    }
    return tmp_1;
  }
  function contentBasedTextDirection(text, fallback) {
    var tmp0_subject = firstStrongDirectionType(text);
    return tmp0_subject === Companion_getInstance_50().s8e_1 ? ResolvedTextDirection_Ltr_getInstance() : tmp0_subject === Companion_getInstance_50().t8e_1 ? ResolvedTextDirection_Rtl_getInstance() : fallback();
  }
  function localeBasedTextDirection(locale) {
    var tmp;
    if (isRtl(locale == null ? Companion_instance_44.e2y() : locale)) {
      tmp = ResolvedTextDirection_Rtl_getInstance();
    } else {
      tmp = ResolvedTextDirection_Ltr_getInstance();
    }
    return tmp;
  }
  function resolveTextDirection$lambda($localeList) {
    return function () {
      var tmp0_safe_receiver = $localeList;
      return localeBasedTextDirection(tmp0_safe_receiver == null ? null : firstOrNull_0(tmp0_safe_receiver));
    };
  }
  function resolveTextDirection$lambda_0() {
    return ResolvedTextDirection_Ltr_getInstance();
  }
  function resolveTextDirection$lambda_1() {
    return ResolvedTextDirection_Rtl_getInstance();
  }
  var androidx_compose_ui_text_platform_SkiaTextPaint$stable;
  function clearShader($this) {
    $this.d8j_1 = null;
    $this.c8j_1 = null;
    $this.e8j_1 = null;
    $this.g6b(null);
  }
  function SkiaTextPaint$setBrush$lambda($brush, $size) {
    return function () {
      return $brush.n6c($size);
    };
  }
  function SkiaTextPaint(original) {
    original = original === VOID ? Paint() : original;
    this.b8j_1 = original;
    this.c8j_1 = null;
    this.d8j_1 = null;
    this.e8j_1 = null;
  }
  protoOf(SkiaTextPaint).f8j = function () {
    return get_skiaPaint(this.b8j_1);
  };
  protoOf(SkiaTextPaint).o8h = function (brush, size, alpha) {
    if (brush == null) {
      clearShader(this);
    } else {
      if (brush instanceof SolidColor) {
        // Inline function 'androidx.compose.ui.graphics.isSpecified' call
        var this_0 = this.s6c();
        if (!equals(_Color___get_value__impl__1pls5m(this_0), _ULong___init__impl__c78o9k(new Long(16, 0)))) {
          this.f6b(modulate(brush.d6b_1, alpha));
          clearShader(this);
        }
      } else {
        if (brush instanceof ShaderBrush) {
          var tmp;
          if (!equals(this.c8j_1, brush)) {
            tmp = true;
          } else {
            var tmp_0 = this.e8j_1;
            tmp = !equals(tmp_0 == null ? null : new Size(tmp_0), new Size(size));
          }
          if (tmp) {
            // Inline function 'androidx.compose.ui.geometry.isSpecified' call
            if (!equalsLong(_Size___get_packedValue__impl__7rlt1o(size), new Long(2143289344, 2143289344))) {
              this.c8j_1 = brush;
              this.e8j_1 = size;
              var tmp_1 = this;
              tmp_1.d8j_1 = derivedStateOf(SkiaTextPaint$setBrush$lambda(brush, size));
            }
          }
          var tmp1_safe_receiver = this.d8j_1;
          this.g6b(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.u1());
          this.v66(isNaN_0(alpha) ? 1.0 : coerceIn_0(alpha, 0.0, 1.0));
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
  };
  protoOf(SkiaTextPaint).m8h = function (drawStyle) {
    if (equals(drawStyle, Fill_getInstance()) || drawStyle == null) {
      this.l6o(Companion_getInstance_11().h6i_1);
    } else {
      if (drawStyle instanceof Stroke) {
        this.l6o(Companion_getInstance_11().i6i_1);
        this.e5r(drawStyle.m6o_1);
        this.t6o(drawStyle.n6o_1);
        this.v6o(drawStyle.p6o_1);
        this.r6o(drawStyle.o6o_1);
        this.x6o(drawStyle.q6o_1);
      } else {
        noWhenBranchMatchedException();
      }
    }
  };
  protoOf(SkiaTextPaint).v66 = function (_set____db54di) {
    this.b8j_1.v66(_set____db54di);
  };
  protoOf(SkiaTextPaint).j68 = function () {
    return this.b8j_1.j68();
  };
  protoOf(SkiaTextPaint).f6b = function (_set____db54di) {
    this.b8j_1.f6b(_set____db54di);
  };
  protoOf(SkiaTextPaint).s6c = function () {
    return this.b8j_1.s6c();
  };
  protoOf(SkiaTextPaint).b6p = function (_set____db54di) {
    this.b8j_1.b6p(_set____db54di);
  };
  protoOf(SkiaTextPaint).c6p = function () {
    return this.b8j_1.c6p();
  };
  protoOf(SkiaTextPaint).l6o = function (_set____db54di) {
    this.b8j_1.l6o(_set____db54di);
  };
  protoOf(SkiaTextPaint).e5r = function (_set____db54di) {
    this.b8j_1.e5r(_set____db54di);
  };
  protoOf(SkiaTextPaint).f5r = function () {
    return this.b8j_1.f5r();
  };
  protoOf(SkiaTextPaint).r6o = function (_set____db54di) {
    this.b8j_1.r6o(_set____db54di);
  };
  protoOf(SkiaTextPaint).s6o = function () {
    return this.b8j_1.s6o();
  };
  protoOf(SkiaTextPaint).v6o = function (_set____db54di) {
    this.b8j_1.v6o(_set____db54di);
  };
  protoOf(SkiaTextPaint).w6o = function () {
    return this.b8j_1.w6o();
  };
  protoOf(SkiaTextPaint).t6o = function (_set____db54di) {
    this.b8j_1.t6o(_set____db54di);
  };
  protoOf(SkiaTextPaint).u6o = function () {
    return this.b8j_1.u6o();
  };
  protoOf(SkiaTextPaint).d6p = function (_set____db54di) {
    this.b8j_1.d6p(_set____db54di);
  };
  protoOf(SkiaTextPaint).e6p = function () {
    return this.b8j_1.e6p();
  };
  protoOf(SkiaTextPaint).g6b = function (_set____db54di) {
    this.b8j_1.g6b(_set____db54di);
  };
  protoOf(SkiaTextPaint).k5r = function () {
    return this.b8j_1.k5r();
  };
  protoOf(SkiaTextPaint).z6o = function (_set____db54di) {
    this.b8j_1.z6o(_set____db54di);
  };
  protoOf(SkiaTextPaint).a6p = function () {
    return this.b8j_1.a6p();
  };
  protoOf(SkiaTextPaint).x6o = function (_set____db54di) {
    this.b8j_1.x6o(_set____db54di);
  };
  protoOf(SkiaTextPaint).y6o = function () {
    return this.b8j_1.y6o();
  };
  var androidx_compose_ui_text_platform_SynchronizedObject$stable;
  function SynchronizedObject() {
  }
  function _LineBreak___init__impl__o5i11q(mask) {
    return mask;
  }
  function _LineBreak___get_mask__impl__je2e1t($this) {
    return $this;
  }
  function Companion_40() {
    Companion_instance_42 = this;
    this.i7v_1 = _LineBreak___init__impl__o5i11q(1);
    this.j7v_1 = _LineBreak___init__impl__o5i11q(2);
    this.k7v_1 = _LineBreak___init__impl__o5i11q(3);
    this.l7v_1 = _LineBreak___init__impl__o5i11q(4);
  }
  var Companion_instance_42;
  function Companion_getInstance_55() {
    if (Companion_instance_42 == null)
      new Companion_40();
    return Companion_instance_42;
  }
  function LineBreak__toString_impl_mphhli($this) {
    return 'LineBreak(mask=' + $this + ')';
  }
  function LineBreak__hashCode_impl_ybksn($this) {
    return $this;
  }
  function LineBreak__equals_impl_1r98t9($this, other) {
    if (!(other instanceof LineBreak))
      return false;
    if (!($this === other.v7v_1))
      return false;
    return true;
  }
  function LineBreak(mask) {
    Companion_getInstance_55();
    this.v7v_1 = mask;
  }
  protoOf(LineBreak).toString = function () {
    return LineBreak__toString_impl_mphhli(this.v7v_1);
  };
  protoOf(LineBreak).hashCode = function () {
    return LineBreak__hashCode_impl_ybksn(this.v7v_1);
  };
  protoOf(LineBreak).equals = function (other) {
    return LineBreak__equals_impl_1r98t9(this.v7v_1, other);
  };
  var androidx_compose_ui_text_style_TextMotion$stable;
  function Companion_41() {
    Companion_instance_43 = this;
    this.x7v_1 = new TextMotion();
    this.y7v_1 = new TextMotion();
  }
  var Companion_instance_43;
  function Companion_getInstance_56() {
    if (Companion_instance_43 == null)
      new Companion_41();
    return Companion_instance_43;
  }
  function TextMotion() {
    Companion_getInstance_56();
  }
  var androidx_compose_ui_text_WeakKeysCache_Key$stable;
  var androidx_compose_ui_text_WeakKeysCache$stable;
  var androidx_compose_ui_text_FinalizationRegistry$stable;
  function Key_0(key) {
    this.i8m_1 = new WeakReference(key);
    this.j8m_1 = hashCode(key);
  }
  protoOf(Key_0).equals = function (other) {
    if (this === other)
      return true;
    if (other == null)
      return false;
    if (!(other instanceof Key_0))
      THROW_CCE();
    var a = this.i8m_1.f1i();
    var b = other.i8m_1.f1i();
    if (a == null || b == null) {
      return false;
    }
    return equals(a, b);
  };
  protoOf(Key_0).hashCode = function () {
    return this.j8m_1;
  };
  function access$_get_cache__fo4c6p($this) {
    return $this.l8m_1;
  }
  function access$_get_registry__6myjy($this) {
    return $this.m8m_1;
  }
  function WeakKeysCache$registry$lambda(this$0) {
    return function (keyJsReference) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.get' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var key = keyJsReference;
      this$0.l8m_1.a3(key);
      return Unit_instance;
    };
  }
  function WeakKeysCache() {
    this.l8m_1 = HashMap_init_$Create$();
    var tmp = this;
    tmp.m8m_1 = new FinalizationRegistry(WeakKeysCache$registry$lambda(this));
  }
  function WeakReference(reference) {
    var tmp = this;
    // Inline function 'kotlin.js.toJsReference' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k8m_1 = new WeakRef(reference);
  }
  protoOf(WeakReference).f1i = function () {
    var tmp0_safe_receiver = this.k8m_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.deref();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = tmp1_safe_receiver;
    }
    var tmp2_safe_receiver = tmp;
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.js.get' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_0 = tmp2_safe_receiver;
    }
    return tmp_0;
  };
  function createPlatformResolveInterceptor() {
    return Companion_getInstance_21().q84_1;
  }
  function synthesizeTypeface(_this__u8e3s4, typeface, font, requestedWeight, requestedStyle) {
    return typeface;
  }
  function get_rtlLanguagesSet() {
    _init_properties_PlatformLocale_web_kt__363p4j();
    return rtlLanguagesSet;
  }
  var rtlLanguagesSet;
  var androidx_compose_ui_text_intl_Locale$stable;
  var androidx_compose_ui_text_intl_IntlLocale$stable;
  function Companion_42() {
  }
  protoOf(Companion_42).e2y = function () {
    return get_platformLocaleDelegate().e2y().l1(0);
  };
  var Companion_instance_44;
  function Companion_getInstance_57() {
    return Companion_instance_44;
  }
  function Locale_init_$Init$(languageTag, $this) {
    Locale.call($this, toIntlLocale(languageTag));
    return $this;
  }
  function Locale_init_$Create$(languageTag) {
    return Locale_init_$Init$(languageTag, objectCreate(protoOf(Locale)));
  }
  function Locale(platformLocale) {
    this.s7x_1 = platformLocale;
    this.t7x_1 = this.s7x_1.baseName;
  }
  protoOf(Locale).n8m = function () {
    return this.s7x_1.language;
  };
  protoOf(Locale).o8m = function () {
    // Inline function 'kotlin.text.orEmpty' call
    var tmp0_elvis_lhs = this.s7x_1.region;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
  protoOf(Locale).u7x = function () {
    return this.t7x_1;
  };
  protoOf(Locale).equals = function (other) {
    if (other == null)
      return false;
    if (!(other instanceof Locale))
      return false;
    if (this === other)
      return true;
    return this.u7x() === other.u7x();
  };
  protoOf(Locale).hashCode = function () {
    return getStringHashCode(this.u7x());
  };
  protoOf(Locale).toString = function () {
    return this.u7x();
  };
  function createPlatformLocaleDelegate() {
    _init_properties_PlatformLocale_web_kt__363p4j();
    return new createPlatformLocaleDelegate$1();
  }
  function isRtl(_this__u8e3s4) {
    _init_properties_PlatformLocale_web_kt__363p4j();
    return get_rtlLanguagesSet().m1(_this__u8e3s4.n8m());
  }
  function toIntlLocale(_this__u8e3s4) {
    _init_properties_PlatformLocale_web_kt__363p4j();
    return parseLanguageTagToIntlLocale(_this__u8e3s4);
  }
  function parseLanguageTagToIntlLocale(languageTag) {
    _init_properties_PlatformLocale_web_kt__363p4j();
    return new Intl.Locale(languageTag);
  }
  function createPlatformLocaleDelegate$1() {
  }
  protoOf(createPlatformLocaleDelegate$1).e2y = function () {
    // Inline function 'androidx.compose.ui.util.fastMap' call
    var this_0 = userPreferredLanguages();
    var target = ArrayList_init_$Create$_0(this_0.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        // Inline function 'kotlin.collections.plusAssign' call
        var element = new Locale(toIntlLocale(item));
        target.j1(element);
      }
       while (inductionVariable <= last);
    return new LocaleList(target);
  };
  var properties_initialized_PlatformLocale_web_kt_9h93ez;
  function _init_properties_PlatformLocale_web_kt__363p4j() {
    if (!properties_initialized_PlatformLocale_web_kt_9h93ez) {
      properties_initialized_PlatformLocale_web_kt_9h93ez = true;
      rtlLanguagesSet = setOf(['ar', 'fa', 'he', 'iw', 'ji', 'ur', 'yi']);
      androidx_compose_ui_text_intl_Locale$stable = 0;
      androidx_compose_ui_text_intl_IntlLocale$stable = 0;
    }
  }
  var androidx_compose_ui_text_platform_PlatformFont$stable;
  function PlatformFont() {
  }
  protoOf(PlatformFont).v8l = function () {
    return '' + getKClassFromExpression(this).o() + '|' + this.t8l() + '|weight=' + this.g5p().p7x_1 + '|style=' + FontStyle__toString_impl_thncxr(this.y82()) + '|variationSettings=' + toString_0(this.u8l().m88_1);
  };
  function currentPlatform() {
    switch (get_hostOs().a1_1) {
      case 0:
        return Platform_Android_getInstance();
      case 4:
        return Platform_IOS_getInstance();
      case 3:
        return Platform_MacOS_getInstance();
      case 1:
        return Platform_Linux_getInstance();
      case 2:
        return Platform_Windows_getInstance();
      default:
        return Platform_Unknown_getInstance();
    }
  }
  function loadTypeface(font) {
    if (!(font instanceof PlatformFont)) {
      throw IllegalArgumentException_init_$Create$_0('Unsupported font type: ' + toString_0(font));
    }
    var tmp;
    if (font instanceof LoadedFont) {
      var tmp1_elvis_lhs = Companion_getInstance_12().v5o_1.z5o(Companion_getInstance_13().r5m(font.d8m_1()));
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        // Inline function 'kotlin.error' call
        var message = 'loadTypeface makeFromData failed';
        throw IllegalStateException_init_$Create$_0(toString_0(message));
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      if (font instanceof SystemFont) {
        var tmp2_elvis_lhs = Companion_getInstance_12().v5o_1.a5p(font.p8l_1, get_skFontStyle(font));
        var tmp_1;
        if (tmp2_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message_0 = 'loadTypeface legacyMakeTypeface failed';
          throw IllegalStateException_init_$Create$_0(toString_0(message_0));
        } else {
          tmp_1 = tmp2_elvis_lhs;
        }
        tmp = tmp_1;
      } else {
        noWhenBranchMatchedException();
      }
    }
    return cloneWithVariationSettings(tmp, font.u8l());
  }
  function get_skFontStyle(_this__u8e3s4) {
    return FontStyle_init_$Create$(_this__u8e3s4.g5p().p7x_1, 5, _this__u8e3s4.y82() === Companion_getInstance_24().l7z_1 ? FontSlant_ITALIC_getInstance() : FontSlant_UPRIGHT_getInstance());
  }
  var androidx_compose_ui_text_platform_JsStringDelegate$stable;
  //region block: post-declaration
  protoOf(PlatformResolveInterceptor$Companion$Default$1).s84 = interceptFontFamily;
  protoOf(PlatformResolveInterceptor$Companion$Default$1).t84 = interceptFontWeight;
  protoOf(PlatformResolveInterceptor$Companion$Default$1).u84 = interceptFontStyle;
  protoOf(PlatformResolveInterceptor$Companion$Default$1).v84 = interceptFontSynthesis;
  protoOf(Unspecified).m7y = merge;
  protoOf(Unspecified).j7z = takeOrElse;
  protoOf(BrushStyle).m7y = merge;
  protoOf(BrushStyle).j7z = takeOrElse;
  protoOf(ColorStyle).m7y = merge;
  protoOf(ColorStyle).j7z = takeOrElse;
  protoOf(SkiaParagraph).e8g = paint$default;
  protoOf(SkiaParagraph).f8g = paint$default_0;
  protoOf(PlatformFont).z82 = get_loadingStrategy;
  protoOf(SkiaParagraphIntrinsics).a7v = get_hasStaleResolvedFonts;
  //endregion
  //region block: init
  Companion_instance_1 = new Companion();
  androidx_compose_ui_text_ComposeUiTextFlags$stable = 8;
  ComposeUiTextFlags_instance = new ComposeUiTextFlags();
  androidx_compose_ui_text_LinkAnnotation_Url$stable = 8;
  androidx_compose_ui_text_LinkAnnotation_Clickable$stable = 8;
  androidx_compose_ui_text_LinkAnnotation$stable = 0;
  androidx_compose_ui_text_MultiParagraph$stable = 8;
  androidx_compose_ui_text_ParagraphInfo$stable = 8;
  androidx_compose_ui_text_MultiParagraphIntrinsics$stable = 8;
  androidx_compose_ui_text_ParagraphIntrinsicInfo$stable = 8;
  androidx_compose_ui_text_Placeholder$stable = 0;
  androidx_compose_ui_text_TextLayoutInput$stable = 8;
  androidx_compose_ui_text_TextLayoutResult$stable = 8;
  androidx_compose_ui_text_TextLinkStyles$stable = 0;
  androidx_compose_ui_text_TextMeasurer$stable = 0;
  androidx_compose_ui_text_TextLayoutCache$stable = 8;
  androidx_compose_ui_text_CacheTextLayoutInput$stable = 0;
  Companion_instance_4 = new Companion_2();
  androidx_compose_ui_text_TextPainter$stable = 0;
  TextPainter_instance = new TextPainter();
  androidx_compose_ui_text_TextStyle$stable = 0;
  androidx_compose_ui_text_TtsAnnotation$stable = 0;
  androidx_compose_ui_text_VerbatimTtsAnnotation$stable = 0;
  androidx_compose_ui_text_UrlAnnotation$stable = 0;
  androidx_compose_ui_text_font_ResourceFont$stable = 0;
  androidx_compose_ui_text_font_FontFamily$stable = 0;
  androidx_compose_ui_text_font_FileBasedFontFamily$stable = 0;
  androidx_compose_ui_text_font_SystemFontFamily$stable = 0;
  androidx_compose_ui_text_font_FontListFontFamily$stable = 0;
  androidx_compose_ui_text_font_GenericFontFamily$stable = 0;
  androidx_compose_ui_text_font_DefaultFontFamily$stable = 0;
  androidx_compose_ui_text_font_LoadedFontFamily$stable = 0;
  androidx_compose_ui_text_font_FontListFontFamilyTypefaceAdapter$stable = 8;
  androidx_compose_ui_text_font_AsyncFontListLoader$stable = 0;
  androidx_compose_ui_text_font_AsyncTypefaceCache_Key$stable = 8;
  androidx_compose_ui_text_font_AsyncTypefaceCache$stable = 8;
  androidx_compose_ui_text_font_FontMatcher$stable = 0;
  androidx_compose_ui_text_font_FontVariation_Settings$stable = 0;
  androidx_compose_ui_text_font_FontVariation$stable = 0;
  FontVariation_instance = new FontVariation();
  androidx_compose_ui_text_font_FontWeight$stable = 0;
  androidx_compose_ui_text_input_CommitTextCommand$stable = 0;
  androidx_compose_ui_text_input_SetComposingRegionCommand$stable = 0;
  androidx_compose_ui_text_input_SetComposingTextCommand$stable = 0;
  androidx_compose_ui_text_input_DeleteSurroundingTextCommand$stable = 0;
  androidx_compose_ui_text_input_DeleteSurroundingTextInCodePointsCommand$stable = 0;
  androidx_compose_ui_text_input_SetSelectionCommand$stable = 0;
  androidx_compose_ui_text_input_FinishComposingTextCommand$stable = 0;
  androidx_compose_ui_text_input_BackspaceCommand$stable = 0;
  androidx_compose_ui_text_input_MoveCursorCommand$stable = 0;
  androidx_compose_ui_text_input_DeleteAllCommand$stable = 0;
  androidx_compose_ui_text_input_EditProcessor$stable = 8;
  androidx_compose_ui_text_input_EditingBuffer$stable = 8;
  Companion_instance_14 = new Companion_12();
  androidx_compose_ui_text_input_PartialGapBuffer$stable = 8;
  Companion_instance_15 = new Companion_13();
  androidx_compose_ui_text_input_ImeOptions$stable = 0;
  androidx_compose_ui_text_input_TextFieldValue$stable = 0;
  androidx_compose_ui_text_input_TextInputService$stable = 8;
  androidx_compose_ui_text_input_TextInputSession$stable = 8;
  androidx_compose_ui_text_input_TransformedText$stable = 8;
  androidx_compose_ui_text_input_PasswordVisualTransformation$stable = 0;
  androidx_compose_ui_text_intl_LocaleList$stable = 0;
  androidx_compose_ui_text_style_LineHeightStyle$stable = 0;
  androidx_compose_ui_text_style_TextDecoration$stable = 0;
  androidx_compose_ui_text_style_TextForegroundStyle_Unspecified$stable = 0;
  Unspecified_instance = new Unspecified();
  Companion_instance_33 = new Companion_31();
  androidx_compose_ui_text_style_TextGeometricTransform$stable = 0;
  androidx_compose_ui_text_style_TextIndent$stable = 0;
  androidx_compose_ui_text_AtomicReference$stable = 8;
  androidx_compose_ui_text_ExpireAfterAccessCache$stable = 8;
  androidx_compose_ui_text_FontRasterizationSettings$stable = 0;
  androidx_compose_ui_text_SkiaParagraph$stable = 8;
  androidx_compose_ui_text_PlatformTextStyle$stable = 0;
  androidx_compose_ui_text_PlatformParagraphStyle$stable = 0;
  androidx_compose_ui_text_PlatformSpanStyle$stable = 0;
  androidx_compose_ui_text_font_PlatformFontFamilyTypefaceAdapter$stable = 0;
  androidx_compose_ui_text_font_SkiaFontLoader$stable = 8;
  androidx_compose_ui_text_input_PlatformImeOptions$stable = 0;
  androidx_compose_ui_text_platform_ParagraphLayouter$stable = 8;
  androidx_compose_ui_text_platform_SkiaParagraphIntrinsics$stable = 8;
  androidx_compose_ui_text_platform_SkiaTextPaint$stable = 8;
  androidx_compose_ui_text_platform_SynchronizedObject$stable = 0;
  androidx_compose_ui_text_style_TextMotion$stable = 0;
  androidx_compose_ui_text_WeakKeysCache_Key$stable = 8;
  androidx_compose_ui_text_WeakKeysCache$stable = 8;
  androidx_compose_ui_text_FinalizationRegistry$stable = 0;
  Companion_instance_44 = new Companion_42();
  androidx_compose_ui_text_platform_PlatformFont$stable = 0;
  androidx_compose_ui_text_platform_JsStringDelegate$stable = 0;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = FontFamily_0;
  _.$_$.b = FontStyle;
  _.$_$.c = FontSynthesis;
  _.$_$.d = FontWeight;
  _.$_$.e = createFontFamilyResolver_0;
  _.$_$.f = BackspaceCommand;
  _.$_$.g = CommitTextCommand;
  _.$_$.h = DeleteAllCommand;
  _.$_$.i = DeleteSurroundingTextCommand;
  _.$_$.j = EditProcessor;
  _.$_$.k = FinishComposingTextCommand;
  _.$_$.l = ImeAction;
  _.$_$.m = ImeOptions;
  _.$_$.n = KeyboardCapitalization;
  _.$_$.o = KeyboardType;
  _.$_$.p = PasswordVisualTransformation;
  _.$_$.q = notifyFocusedRect;
  _.$_$.r = startInput;
  _.$_$.s = updateTextLayoutResult;
  _.$_$.t = PlatformTextInputService;
  _.$_$.u = SetSelectionCommand;
  _.$_$.v = TextFieldValue;
  _.$_$.w = TextInputService;
  _.$_$.x = TransformedText;
  _.$_$.y = VisualTransformation;
  _.$_$.z = getSelectedText;
  _.$_$.a1 = getTextAfterSelection;
  _.$_$.b1 = getTextBeforeSelection;
  _.$_$.c1 = FontLoader;
  _.$_$.d1 = Font_0;
  _.$_$.e1 = TextAlign;
  _.$_$.f1 = TextOverflow;
  _.$_$.g1 = Builder;
  _.$_$.h1 = Range;
  _.$_$.i1 = Clickable;
  _.$_$.j1 = Url;
  _.$_$.k1 = LinkAnnotation;
  _.$_$.l1 = MultiParagraphIntrinsics;
  _.$_$.m1 = MultiParagraph;
  _.$_$.n1 = ParagraphIntrinsics_0;
  _.$_$.o1 = Paragraph_0;
  _.$_$.p1 = Paragraph;
  _.$_$.q1 = SpanStyle;
  _.$_$.r1 = TextLayoutResult;
  _.$_$.s1 = TextLinkStyles;
  _.$_$.t1 = TextMeasurer;
  _.$_$.u1 = TextRange_0;
  _.$_$.v1 = TextRange_1;
  _.$_$.w1 = TextRange;
  _.$_$.x1 = androidx_compose_ui_text_TextLayoutResult$stableprop_getter;
  _.$_$.y1 = drawText;
  _.$_$.z1 = lerp_6;
  _.$_$.a2 = resolveDefaults;
  _.$_$.b2 = _FontStyle___init__impl__jcnduf;
  _.$_$.c2 = FontStyle__toString_impl_thncxr;
  _.$_$.d2 = _FontStyle___get_value__impl__gx8aaz;
  _.$_$.e2 = _FontSynthesis___get_value__impl__xrueqg;
  _.$_$.f2 = ImeAction__hashCode_impl_m1mrob;
  _.$_$.g2 = ImeAction__toString_impl_r8bdhy;
  _.$_$.h2 = KeyboardCapitalization__hashCode_impl_6ibuz5;
  _.$_$.i2 = KeyboardCapitalization__toString_impl_f8u1tq;
  _.$_$.j2 = KeyboardType__hashCode_impl_mw6m33;
  _.$_$.k2 = KeyboardType__toString_impl_150pa8;
  _.$_$.l2 = _BaselineShift___get_multiplier__impl__qhmjek;
  _.$_$.m2 = _TextDirection___get_value__impl__ka7r45;
  _.$_$.n2 = _TextOverflow___init__impl__obguoe;
  _.$_$.o2 = TextOverflow__hashCode_impl_kqdwgt;
  _.$_$.p2 = _TextOverflow___get_value__impl__vugm5i;
  _.$_$.q2 = _TextRange___get_collapsed__impl__cilesp;
  _.$_$.r2 = _TextRange___get_end__impl__gcdxpp;
  _.$_$.s2 = _TextRange___get_length__impl__7qes3a;
  _.$_$.t2 = _TextRange___get_max__impl__owm8m;
  _.$_$.u2 = _TextRange___get_min__impl__uu95c4;
  _.$_$.v2 = _TextRange___get_reversed__impl__emhnbm;
  _.$_$.w2 = _TextRange___get_start__impl__ww4t90;
  _.$_$.x2 = Companion_getInstance_20;
  _.$_$.y2 = Companion_getInstance_24;
  _.$_$.z2 = Companion_getInstance_25;
  _.$_$.a3 = FontVariation_instance;
  _.$_$.b3 = Companion_getInstance_26;
  _.$_$.c3 = Companion_getInstance_29;
  _.$_$.d3 = Companion_getInstance_30;
  _.$_$.e3 = Companion_getInstance_31;
  _.$_$.f3 = Companion_getInstance_32;
  _.$_$.g3 = Companion_getInstance_33;
  _.$_$.h3 = Companion_getInstance_34;
  _.$_$.i3 = Companion_getInstance_35;
  _.$_$.j3 = Companion_instance_44;
  _.$_$.k3 = Companion_getInstance_36;
  _.$_$.l3 = Companion_getInstance_37;
  _.$_$.m3 = Companion_getInstance_38;
  _.$_$.n3 = Companion_getInstance_55;
  _.$_$.o3 = Companion_getInstance_40;
  _.$_$.p3 = Companion_getInstance_39;
  _.$_$.q3 = Companion_getInstance_43;
  _.$_$.r3 = Companion_getInstance_44;
  _.$_$.s3 = Companion_getInstance_45;
  _.$_$.t3 = Companion_getInstance_49;
  _.$_$.u3 = TextPainter_instance;
  _.$_$.v3 = Companion_getInstance_18;
  _.$_$.w3 = Companion_getInstance_19;
  _.$_$.x3 = ResolvedTextDirection_Ltr_getInstance;
  _.$_$.y3 = ResolvedTextDirection_Rtl_getInstance;
  _.$_$.z3 = CommitTextCommand_init_$Create$;
  _.$_$.a4 = SetComposingTextCommand_init_$Create$;
  _.$_$.b4 = TextFieldValue_init_$Create$;
  _.$_$.c4 = SystemFont_init_$Create$;
  _.$_$.d4 = LineHeightStyle_init_$Create$;
  _.$_$.e4 = AnnotatedString_init_$Create$;
  _.$_$.f4 = Builder_init_$Create$;
  _.$_$.g4 = Range_init_$Create$;
  _.$_$.h4 = SpanStyle_init_$Create$;
  _.$_$.i4 = TextLayoutInput_init_$Create$;
  _.$_$.j4 = TextStyle_init_$Create$_1;
  //endregion
  return _;
}));

//# sourceMappingURL=compose-multiplatform-core-compose-ui-ui-text.js.map
